import { CalendarDateString } from 'scalars';
import { CalendarDateTimeString } from 'scalars';
import { CalendarMonthString } from 'scalars';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** AccountBalanceID */
  AccountBalanceID: { input: any; output: any; }
  /** AccountID */
  AccountID: { input: any; output: any; }
  /** Banking account number is a string of 5 to 17 alphanumeric values for representing an generic account number */
  AccountNumber: { input: any; output: any; }
  /** AccountingConfigurationID */
  AccountingConfigurationID: { input: any; output: any; }
  /** AccountingConfigurationRuleEffectiveRangeID */
  AccountingConfigurationRuleEffectiveRangeID: { input: any; output: any; }
  /** AccountingConfigurationRuleID */
  AccountingConfigurationRuleID: { input: any; output: any; }
  /** AccountingPolicyID */
  AccountingPolicyID: { input: any; output: any; }
  /** AccrualEventID */
  AccrualEventID: { input: any; output: any; }
  /** AccuracyCheckConfigID */
  AccuracyCheckConfigID: { input: any; output: any; }
  /** AccuracyCheckID */
  AccuracyCheckID: { input: any; output: any; }
  /** AffiliateAttributionID */
  AffiliateAttributionID: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** BillID */
  BillID: { input: any; output: any; }
  /** BillLineID */
  BillLineID: { input: any; output: any; }
  /** The `Byte` scalar type represents byte value as a Buffer */
  Byte: { input: any; output: any; }
  /** CardID */
  CardID: { input: any; output: any; }
  /** CompanyID */
  CompanyID: { input: any; output: any; }
  /** CompanyPricingPlanID */
  CompanyPricingPlanID: { input: any; output: any; }
  /** CompanySquashingPolicyID */
  CompanySquashingPolicyID: { input: any; output: any; }
  /** CompanyVendorID */
  CompanyVendorID: { input: any; output: any; }
  /** ContractID */
  ContractID: { input: any; output: any; }
  /** ContractLineID */
  ContractLineID: { input: any; output: any; }
  /** ContractRevenueScheduleID */
  ContractRevenueScheduleID: { input: any; output: any; }
  /** ContractorID */
  ContractorID: { input: any; output: any; }
  /** A country code as defined by ISO 3166-1 alpha-2 */
  CountryCode: { input: any; output: any; }
  /** A field whose value is a Currency: https://en.wikipedia.org/wiki/ISO_4217. */
  Currency: { input: any; output: any; }
  /** CustomerBalanceMatchGroupID */
  CustomerBalanceMatchGroupID: { input: any; output: any; }
  /** CustomerBalanceMatchID */
  CustomerBalanceMatchID: { input: any; output: any; }
  /** CustomerBalanceTransactionID */
  CustomerBalanceTransactionID: { input: any; output: any; }
  /** CustomerID */
  CustomerID: { input: any; output: any; }
  /** A field whose value conforms to the standard DID format as specified in did-core: https://www.w3.org/TR/did-core/. */
  DID: { input: any; output: any; }
  /** DataAnomalyReviewId */
  DataAnomalyReviewId: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: CalendarDateString; output: CalendarDateString; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: CalendarDateTimeString; output: CalendarDateTimeString; }
  /** JavaScript Decimal object from decimal.js */
  Decimal: { input: string; output: string; }
  /** DetailID */
  DetailID: { input: any; output: any; }
  /** DirectIngestCoaKeyRowID */
  DirectIngestCoaKeyRowID: { input: any; output: any; }
  /** DirectIngestCoaMapperRowID */
  DirectIngestCoaMapperRowID: { input: any; output: any; }
  /** DirectIngestFileID */
  DirectIngestFileID: { input: any; output: any; }
  /** DirectIngestHistoryID */
  DirectIngestHistoryID: { input: any; output: any; }
  /** DirectIngestJournalEntryRowID */
  DirectIngestJournalEntryRowID: { input: any; output: any; }
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  Duration: { input: any; output: any; }
  /** A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/. */
  EmailAddress: { input: any; output: any; }
  /** EmployeeID */
  EmployeeID: { input: any; output: any; }
  /** ExclusiveDay (Day) scalar type - YYYY-MM-DD */
  ExclusiveDay: { input: CalendarDateString; output: CalendarDateString; }
  /** FirmCompanyID */
  FirmCompanyID: { input: any; output: any; }
  /** FirmGroupID */
  FirmGroupID: { input: any; output: any; }
  /** FirmGroupMembershipID */
  FirmGroupMembershipID: { input: any; output: any; }
  /** FirmID */
  FirmID: { input: any; output: any; }
  /** FirmMembershipID */
  FirmMembershipID: { input: any; output: any; }
  /** FixedAssetID */
  FixedAssetID: { input: any; output: any; }
  /** FixedAssetPieceID */
  FixedAssetPieceID: { input: any; output: any; }
  /** FixedAssetRuleCategoryID */
  FixedAssetRuleCategoryID: { input: any; output: any; }
  /** FixedAssetRuleID */
  FixedAssetRuleID: { input: any; output: any; }
  /** FixedAssetRuleVendorID */
  FixedAssetRuleVendorID: { input: any; output: any; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  GUID: { input: any; output: any; }
  /** A field whose value is a CSS HSL color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSL: { input: any; output: any; }
  /** A field whose value is a CSS HSLA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSLA: { input: any; output: any; }
  /** A field whose value is a hex color code: https://en.wikipedia.org/wiki/Web_colors. */
  HexColorCode: { input: any; output: any; }
  /** A field whose value is a hexadecimal: https://en.wikipedia.org/wiki/Hexadecimal. */
  Hexadecimal: { input: any; output: any; }
  /** A field whose value is an International Bank Account Number (IBAN): https://en.wikipedia.org/wiki/International_Bank_Account_Number. */
  IBAN: { input: any; output: any; }
  /** A field whose value is a IPv4 address: https://en.wikipedia.org/wiki/IPv4. */
  IPv4: { input: any; output: any; }
  /** A field whose value is a IPv6 address: https://en.wikipedia.org/wiki/IPv6. */
  IPv6: { input: any; output: any; }
  /** A field whose value is a ISBN-10 or ISBN-13 number: https://en.wikipedia.org/wiki/International_Standard_Book_Number. */
  ISBN: { input: any; output: any; }
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  ISO8601Duration: { input: any; output: any; }
  /** InclusiveDay (Day) scalar type - YYYY-MM-DD */
  InclusiveDay: { input: CalendarDateString; output: CalendarDateString; }
  /** InvoiceCouponID */
  InvoiceCouponID: { input: any; output: any; }
  /** InvoiceDiscountLineID */
  InvoiceDiscountLineID: { input: any; output: any; }
  /** InvoiceID */
  InvoiceID: { input: any; output: any; }
  /** InvoiceLineItemID */
  InvoiceLineItemID: { input: any; output: any; }
  /** InvoiceShippingLineID */
  InvoiceShippingLineID: { input: any; output: any; }
  /** InvoiceTaxLineID */
  InvoiceTaxLineID: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** A field whose value is a JSON Web Token (JWT): https://jwt.io/introduction. */
  JWT: { input: any; output: any; }
  /** A field whose value is a valid decimal degrees latitude number (53.471): https://en.wikipedia.org/wiki/Latitude */
  Latitude: { input: any; output: any; }
  /** LedgerCoaKey */
  LedgerCoaKey: { input: any; output: any; }
  /** LedgerHistoryID */
  LedgerHistoryID: { input: any; output: any; }
  /** LedgerReconciliationEntryID */
  LedgerReconciliationEntryID: { input: any; output: any; }
  /** LedgerReconciliationID */
  LedgerReconciliationID: { input: any; output: any; }
  /** LocalDate (Day) scalar type - YYYY-MM-DD */
  LocalDate: { input: CalendarDateString; output: CalendarDateString; }
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`.  This scalar is very similar to the `LocalTime`, with the only difference being that `LocalEndTime` also allows `24:00` as a valid value to indicate midnight of the following day.  This is useful when using the scalar to represent the exclusive upper bound of a time block. */
  LocalEndTime: { input: any; output: any; }
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`. */
  LocalTime: { input: any; output: any; }
  /** The locale in the format of a BCP 47 (RFC 5646) standard string */
  Locale: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: { input: any; output: any; }
  /** A field whose value is a valid decimal degrees longitude number (53.471): https://en.wikipedia.org/wiki/Longitude */
  Longitude: { input: any; output: any; }
  /** A field whose value is a IEEE 802 48-bit MAC address: https://en.wikipedia.org/wiki/MAC_address. */
  MAC: { input: any; output: any; }
  /** ManualJournalEntryGroupID */
  ManualJournalEntryGroupID: { input: any; output: any; }
  /** ManualJournalEntryID */
  ManualJournalEntryID: { input: any; output: any; }
  /** ManualRevenueScheduleEntryID */
  ManualRevenueScheduleEntryID: { input: any; output: any; }
  /** MergedContractorMergedID */
  MergedContractorMergedID: { input: any; output: any; }
  /** MergedEmployeeMergedID */
  MergedEmployeeMergedID: { input: any; output: any; }
  /** Month scalar type - YYYY-MM */
  Month: { input: CalendarMonthString; output: CalendarMonthString; }
  /** Floats that will have a value less than 0. */
  NegativeFloat: { input: any; output: any; }
  /** Integers that will have a value less than 0. */
  NegativeInt: { input: any; output: any; }
  /** A string that cannot be passed as an empty value */
  NonEmptyString: { input: any; output: any; }
  /** Floats that will have a value of 0 or more. */
  NonNegativeFloat: { input: any; output: any; }
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: { input: any; output: any; }
  /** Floats that will have a value of 0 or less. */
  NonPositiveFloat: { input: any; output: any; }
  /** Integers that will have a value of 0 or less. */
  NonPositiveInt: { input: any; output: any; }
  /** A field whose value conforms with the standard mongodb object ID as described here: https://docs.mongodb.com/manual/reference/method/ObjectId/#ObjectId. Example: 5e5677d71bdc2ae76344968c */
  ObjectID: { input: any; output: any; }
  /** PartnerAdBookkeepingCriteriaID */
  PartnerAdBookkeepingCriteriaID: { input: any; output: any; }
  /** PartnerAdID */
  PartnerAdID: { input: any; output: any; }
  /** Accounting Period scalar */
  Period: { input: string; output: string; }
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: { input: any; output: any; }
  /** A field whose value is a valid TCP port within the range of 0 to 65535: https://en.wikipedia.org/wiki/Transmission_Control_Protocol#TCP_ports */
  Port: { input: any; output: any; }
  /** Floats that will have a value greater than 0. */
  PositiveFloat: { input: any; output: any; }
  /** Integers that will have a value greater than 0. */
  PositiveInt: { input: any; output: any; }
  /** A field whose value conforms to the standard postal code formats for United States, United Kingdom, Germany, Canada, France, Italy, Australia, Netherlands, Spain, Denmark, Sweden, Belgium, India, Austria, Portugal, Switzerland or Luxembourg. */
  PostalCode: { input: any; output: any; }
  /** PrepaidID */
  PrepaidID: { input: any; output: any; }
  /** ProductID */
  ProductID: { input: any; output: any; }
  /** PuzzlePriceID */
  PuzzlePriceID: { input: any; output: any; }
  /** PuzzlePricingPlanID */
  PuzzlePricingPlanID: { input: any; output: any; }
  /** A field whose value is a CSS RGB color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGB: { input: any; output: any; }
  /** A field whose value is a CSS RGBA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGBA: { input: any; output: any; }
  /** RecurringTemplateID */
  RecurringTemplateID: { input: any; output: any; }
  /** ReimbursementID */
  ReimbursementID: { input: any; output: any; }
  /** ReportID */
  ReportID: { input: any; output: any; }
  /** ReportPackageID */
  ReportPackageID: { input: any; output: any; }
  /** In the US, an ABA routing transit number (`ABA RTN`) is a nine-digit code to identify the financial institution. */
  RoutingNumber: { input: any; output: any; }
  /** The `SafeInt` scalar type represents non-fractional signed whole numeric values that are considered safe as defined by the ECMAScript specification. */
  SafeInt: { input: any; output: any; }
  /** SquashBucketID */
  SquashBucketID: { input: any; output: any; }
  /** StoredFileID */
  StoredFileID: { input: any; output: any; }
  /** StripeValidationRunID */
  StripeValidationRunID: { input: any; output: any; }
  /** SyncRunID */
  SyncRunID: { input: any; output: any; }
  /** TagNameDisplayName */
  TagNameDisplayName: { input: any; output: any; }
  /** TagNameID */
  TagNameID: { input: any; output: any; }
  /** TagValueDisplayName */
  TagValueDisplayName: { input: any; output: any; }
  /** TagValueID */
  TagValueID: { input: any; output: any; }
  /** TaggableEntityID */
  TaggableEntityID: { input: any; output: any; }
  /** TaxRateID */
  TaxRateID: { input: any; output: any; }
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: { input: any; output: any; }
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: { input: any; output: any; }
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: any; output: any; }
  /** TransactionID */
  TransactionID: { input: any; output: any; }
  /** TransactionLinkBundleID */
  TransactionLinkBundleID: { input: any; output: any; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: any; output: any; }
  /** A currency string, such as $21.25 */
  USCurrency: { input: any; output: any; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: any; output: any; }
  /** Floats that will have a value of 0 or more. */
  UnsignedFloat: { input: any; output: any; }
  /** Integers that will have a value of 0 or more. */
  UnsignedInt: { input: any; output: any; }
  /** UserID */
  UserID: { input: any; output: any; }
  /** A field whose value is a UTC Offset: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones */
  UtcOffset: { input: any; output: any; }
  /** VendorBalanceMatchGroupID */
  VendorBalanceMatchGroupID: { input: any; output: any; }
  /** VendorBalanceMatchID */
  VendorBalanceMatchID: { input: any; output: any; }
  /** VendorBalanceTransactionID */
  VendorBalanceTransactionID: { input: any; output: any; }
  /** VendorPermaName */
  VendorPermaName: { input: any; output: any; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
};

export type AiPrompt = {
  __typename?: 'AIPrompt';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AiPromptsInput = {
  templateType?: InputMaybe<TemplateType>;
};

export type AiPromptsResult = {
  __typename?: 'AIPromptsResult';
  prompts: Array<AiPrompt>;
};

export type ApAgingBillLineRecord = {
  __typename?: 'APAgingBillLineRecord';
  bill: Bill;
  values: Array<ApAgingValue>;
};

export type ApAgingBillLinesFilterBy = {
  asOf?: InputMaybe<Scalars['InclusiveDay']['input']>;
  buckets: Array<ApAgingBucket>;
  vendorId: Scalars['CompanyVendorID']['input'];
};

export type ApAgingBillLinesResult = {
  __typename?: 'APAgingBillLinesResult';
  items: Array<ApAgingBillLineRecord>;
  pageInfo: PageInfo;
};

export type ApAgingBucket = {
  key: Scalars['String']['input'];
  maxAmount?: InputMaybe<Scalars['Decimal']['input']>;
  minAmount?: InputMaybe<Scalars['Decimal']['input']>;
  range: OpenEndedDateRangeInput;
};

export type ApAgingExportOptions = {
  asOf?: InputMaybe<Scalars['LocalDate']['input']>;
  expanded: Scalars['Boolean']['input'];
  filterBy: ApAgingFilterBy;
  reportFormat: ReportFormat;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ApAgingFilterBy = {
  asOf?: InputMaybe<Scalars['InclusiveDay']['input']>;
  buckets: Array<ApAgingBucket>;
  vendorIds?: InputMaybe<Array<Scalars['CompanyVendorID']['input']>>;
};

export type ApAgingRecord = {
  __typename?: 'APAgingRecord';
  total: ApAgingValue;
  unapplied: ApAgingValue;
  values: Array<ApAgingValue>;
  vendor?: Maybe<Vendor>;
};

export type ApAgingResult = {
  __typename?: 'APAgingResult';
  items: Array<ApAgingRecord>;
  pageInfo: PageInfo;
  total: ApAgingRecord;
};

export type ApAgingValue = {
  __typename?: 'APAgingValue';
  amount: Money;
  bucketKey: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type ArAgingBucket = {
  key: Scalars['String']['input'];
  range: OpenEndedDateRangeInput;
};

export type ArAgingFilterBy = {
  asOf?: InputMaybe<Scalars['InclusiveDay']['input']>;
  buckets: Array<ArAgingBucket>;
  customerIds?: InputMaybe<Array<Scalars['CustomerID']['input']>>;
};

export type ArAgingLineRecord = {
  __typename?: 'ARAgingLineRecord';
  description: Scalars['String']['output'];
  invoice: Invoice;
  values: Array<ArAgingValue>;
};

export type ArAgingLinesFilterBy = {
  asOf?: InputMaybe<Scalars['InclusiveDay']['input']>;
  buckets: Array<ArAgingBucket>;
  customerId: Scalars['CustomerID']['input'];
};

export type ArAgingLinesResult = {
  __typename?: 'ARAgingLinesResult';
  items: Array<ArAgingLineRecord>;
  pageInfo: PageInfo;
};

export type ArAgingRecord = {
  __typename?: 'ARAgingRecord';
  customer?: Maybe<Customer>;
  total: ArAgingValue;
  unapplied: ArAgingValue;
  values: Array<ArAgingValue>;
};

export type ArAgingResult = {
  __typename?: 'ARAgingResult';
  items: Array<ArAgingRecord>;
  pageInfo: PageInfo;
  total: ArAgingRecord;
};

export type ArAgingValue = {
  __typename?: 'ARAgingValue';
  amount: Money;
  bucketKey: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type AcceptInvitationsResult = {
  __typename?: 'AcceptInvitationsResult';
  errorMessages?: Maybe<Array<Scalars['String']['output']>>;
  successCount: Scalars['Int']['output'];
};

export enum AccessEntity {
  Account = 'Account',
  AccountingConfiguration = 'AccountingConfiguration',
  AccountingConfigurationRule = 'AccountingConfigurationRule',
  AccuracyCheck = 'AccuracyCheck',
  Bill = 'Bill',
  ChecklistItem = 'ChecklistItem',
  Company = 'Company',
  CompanyInvitation = 'CompanyInvitation',
  CompanyMembership = 'CompanyMembership',
  CompanyVendor = 'CompanyVendor',
  Contract = 'Contract',
  ContractLine = 'ContractLine',
  ContractRevenueSchedule = 'ContractRevenueSchedule',
  Customer = 'Customer',
  DirectIngestFile = 'DirectIngestFile',
  Firm = 'Firm',
  FixedAsset = 'FixedAsset',
  FixedAssetRule = 'FixedAssetRule',
  IntegrationConnection = 'IntegrationConnection',
  Invoice = 'Invoice',
  LedgerReconciliation = 'LedgerReconciliation',
  ManualCategorizationRule = 'ManualCategorizationRule',
  ManualJournalEntry = 'ManualJournalEntry',
  ManualJournalEntryGroup = 'ManualJournalEntryGroup',
  PartnerAd = 'PartnerAd',
  Payroll = 'Payroll',
  Prepaid = 'Prepaid',
  Reconciliation = 'Reconciliation',
  RecurringTemplate = 'RecurringTemplate',
  Report = 'Report',
  ReportPackage = 'ReportPackage',
  SquashBucket = 'SquashBucket',
  StoredFile = 'StoredFile',
  StripeValidationRun = 'StripeValidationRun',
  Transaction = 'Transaction',
  User = 'User',
  Vendor = 'Vendor'
}

export type Account = {
  __typename?: 'Account';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use todaysBalance instead */
  balance: Balance;
  /** @deprecated Use todaysBalance instead */
  balanceDate: Scalars['DateTime']['output'];
  connection?: Maybe<IntegrationConnection>;
  connectionStatus: IntegrationConnectionStatus;
  connections: Array<IntegrationConnection>;
  epoch?: Maybe<AccountEpoch>;
  epochs: Array<AccountEpoch>;
  financialInstitution: FinancialInstitution;
  id: Scalars['ID']['output'];
  initialAccountBalance: AccountBalance;
  /** @deprecated Use initialAccountBalance instead */
  initialBalance: InitialBalance;
  isMerged: Scalars['Boolean']['output'];
  lastImportedAt?: Maybe<Scalars['DateTime']['output']>;
  ledgerAccount?: Maybe<LedgerAccount>;
  manuallyAdded: Scalars['Boolean']['output'];
  mask?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  squashingPolicies: Array<CompanySquashingPolicy>;
  status: IntegrationConnectionStatus;
  subType?: Maybe<AccountSubType>;
  todaysBalance: AccountBalance;
  type: AccountType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AccountBalance = {
  __typename?: 'AccountBalance';
  actor?: Maybe<Actor>;
  balance: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  dataSource?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  isAutomated: Scalars['Boolean']['output'];
  isInitialBalanceSet: Scalars['Boolean']['output'];
  setByActorType?: Maybe<ActorType>;
  splits: Array<AccountBalanceSplit>;
};

export enum AccountBalanceDerivedFrom {
  Calculated = 'Calculated',
  OfficialInstitutionBalance = 'OfficialInstitutionBalance'
}

export enum AccountBalancePeriod {
  Beginning = 'Beginning',
  Ending = 'Ending'
}

export type AccountBalanceSplit = {
  __typename?: 'AccountBalanceSplit';
  amount: Scalars['Decimal']['output'];
  category: Category;
  description: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type AccountChecklistItem = ChecklistItem & MonthlyChecklistItem & {
  __typename?: 'AccountChecklistItem';
  account: Account;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<User>;
  dataAnomalyReview: DataAnomalyReview;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<ChecklistItemKey>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<User>;
  month: Scalars['Month']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  removedBy?: Maybe<User>;
};

export type AccountEndingBalanceReview = DataAnomalyReview & {
  __typename?: 'AccountEndingBalanceReview';
  context: AccountEndingBalanceReviewContext;
  grade: DataAnomalyReviewGrade;
  id: Scalars['DataAnomalyReviewId']['output'];
  name: DataAnomalyReviewName;
};

export type AccountEndingBalanceReviewContext = {
  __typename?: 'AccountEndingBalanceReviewContext';
  ledgerMinusBestGuessBalance: Money;
  reconciledThrough?: Maybe<Scalars['LocalDate']['output']>;
};

export type AccountEpoch = {
  __typename?: 'AccountEpoch';
  cutoffAtOrAfter?: Maybe<Scalars['LocalDate']['output']>;
  cutoffBefore?: Maybe<Scalars['LocalDate']['output']>;
  shouldCorrectHistory: Scalars['Boolean']['output'];
};

export type AccountFilterInput = {
  companyId: Scalars['String']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<AccountType>>;
};

export enum AccountIngestStatus {
  IngestingHistorical = 'IngestingHistorical',
  IngestingNewest = 'IngestingNewest',
  New = 'New',
  UpToDate = 'UpToDate'
}

export enum AccountSubType {
  Annuity = 'Annuity',
  Brokerage = 'Brokerage',
  BrokerageForMinors = 'BrokerageForMinors',
  Cd = 'CD',
  CashLike = 'CashLike',
  Checking = 'Checking',
  CreditCard = 'CreditCard',
  EducationSavingsAccount = 'EducationSavingsAccount',
  Hsa = 'HSA',
  Investment = 'Investment',
  LineOfCredit = 'LineOfCredit',
  Loan = 'Loan',
  MoneyMarket = 'MoneyMarket',
  Mortgage = 'Mortgage',
  Other = 'Other',
  PayPal = 'PayPal',
  Prepaid = 'Prepaid',
  ProfitSharingPlan = 'ProfitSharingPlan',
  Retirement = 'Retirement',
  Savings = 'Savings',
  StockPlan = 'StockPlan',
  Stripe = 'Stripe',
  TaxAdvantagedInvestment = 'TaxAdvantagedInvestment',
  Trust = 'Trust',
  Unknown = 'Unknown'
}

export type AccountTransactionDetail = {
  __typename?: 'AccountTransactionDetail';
  accountId?: Maybe<Scalars['ID']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['ID']['output'];
  correctionEvent?: Maybe<LedgerEvent>;
  correctionEventId?: Maybe<Scalars['ID']['output']>;
  counterpartyId?: Maybe<Scalars['ID']['output']>;
  counterpartyType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  departmentId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  effectiveAt?: Maybe<Scalars['DateTime']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  entryDescription?: Maybe<Scalars['String']['output']>;
  event: LedgerEvent;
  eventId: Scalars['ID']['output'];
  extraMetadata?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['ID']['output'];
  journal: LedgerJournal;
  journalId: Scalars['ID']['output'];
  ledger?: Maybe<LedgerType>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  reconciled: Scalars['Boolean']['output'];
  reconciliationId?: Maybe<Scalars['LedgerReconciliationID']['output']>;
  related: EventRelations;
  reversedEntry?: Maybe<LedgerEntry>;
  reversedEntryId?: Maybe<Scalars['ID']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  transaction?: Maybe<Transaction>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  view?: Maybe<View>;
};

export type AccountTransactionDetailInput = {
  accountTransactionDetailParams?: InputMaybe<AccountTransactionDetailParams>;
  companyId: Scalars['CompanyID']['input'];
  entityId: Scalars['ID']['input'];
  isRollforward?: InputMaybe<Scalars['Boolean']['input']>;
  isSimple?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountTransactionDetailParams = {
  accounts?: InputMaybe<AccountsById>;
  counterpartyFilter?: InputMaybe<CounterpartyFilter>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtToExclusive?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveAtCompanyDateFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  effectiveAtCompanyDateTo?: InputMaybe<Scalars['LocalDate']['input']>;
  effectiveAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveAtToExclusive?: InputMaybe<Scalars['DateTime']['input']>;
  eventIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeReconciled?: InputMaybe<Scalars['Boolean']['input']>;
  highWatermarkToken?: InputMaybe<Scalars['String']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  ledger?: InputMaybe<LedgerType>;
  /** @deprecated No longer supported */
  postedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated No longer supported */
  postedAtToExclusive?: InputMaybe<Scalars['DateTime']['input']>;
  postingPeriodFrom?: InputMaybe<Scalars['Period']['input']>;
  postingPeriodTo?: InputMaybe<Scalars['Period']['input']>;
  postingPeriods?: InputMaybe<Array<Scalars['Period']['input']>>;
  reconciliationIds?: InputMaybe<Array<Scalars['LedgerReconciliationID']['input']>>;
  updatedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAtToExclusive?: InputMaybe<Scalars['DateTime']['input']>;
  view: Scalars['String']['input'];
};

export type AccountTransactionDetails = {
  __typename?: 'AccountTransactionDetails';
  accountTransactionDetails: Array<AccountTransactionDetail>;
};

export enum AccountType {
  Credit = 'Credit',
  Depository = 'Depository',
  /** @deprecated No longer supported */
  Fintech = 'Fintech',
  Investment = 'Investment',
  Invoice = 'Invoice',
  Loan = 'Loan',
  Other = 'Other',
  PaymentProcessing = 'PaymentProcessing',
  Payroll = 'Payroll',
  /** @deprecated No longer supported */
  Sweep = 'Sweep'
}

export enum AccountingBasis {
  AccrualBasis = 'ACCRUAL_BASIS',
  CashBasis = 'CASH_BASIS',
  TaxBasis = 'TAX_BASIS'
}

export type AccountingConfiguration = {
  config?: Maybe<RevenueRecognitionConfigurationConfig>;
  description: Scalars['String']['output'];
  hasBeenApplied: Scalars['Boolean']['output'];
  id: Scalars['AccountingConfigurationID']['output'];
  name: Scalars['String']['output'];
  status: AccountingConfigurationStatus;
  type: AccountingConfigurationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AccountingConfigurationFilterBy = {
  status?: InputMaybe<AccountingConfigurationStatus>;
};

export type AccountingConfigurationResponse = {
  __typename?: 'AccountingConfigurationResponse';
  configurations: Array<RevenueRecognitionConfiguration>;
};

export type AccountingConfigurationRule = {
  __typename?: 'AccountingConfigurationRule';
  accountingConfiguration: AccountingConfiguration;
  criteria: AccountingConfigurationRuleCriteria;
  effectiveRanges: Array<AccountingConfigurationRuleEffectiveRange>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['AccountingConfigurationRuleID']['output'];
  isAutoConfirm: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
};

export enum AccountingConfigurationRuleComparator {
  Equal = 'Equal',
  GreaterThan = 'GreaterThan',
  LessThan = 'LessThan'
}

export type AccountingConfigurationRuleCriteria = {
  __typename?: 'AccountingConfigurationRuleCriteria';
  amountFilter?: Maybe<AccountingConfigurationRuleCriteriaAmountFilter>;
  /** @deprecated Use subscriptionDurationFilter instead */
  categories: Array<Scalars['LedgerCoaKey']['output']>;
  dataSourceTypeFilter?: Maybe<Array<DataSourceType>>;
  subscriptionDurationFilter?: Maybe<AccountingConfigurationRuleCriteriaSubscriptionDurationFilter>;
};

export type AccountingConfigurationRuleCriteriaAmountFilter = {
  __typename?: 'AccountingConfigurationRuleCriteriaAmountFilter';
  comparator: AccountingConfigurationRuleComparator;
  currency: Scalars['Currency']['output'];
  operand1: Scalars['Decimal']['output'];
};

export type AccountingConfigurationRuleCriteriaAmountFilterInput = {
  comparator: AccountingConfigurationRuleComparator;
  currency: Scalars['Currency']['input'];
  operand1: Scalars['Decimal']['input'];
};

export type AccountingConfigurationRuleCriteriaInput = {
  amountFilter?: InputMaybe<AccountingConfigurationRuleCriteriaAmountFilterInput>;
  dataSourceTypeFilter?: InputMaybe<Array<Scalars['Int']['input']>>;
  subscriptionDurationFilter?: InputMaybe<AccountingConfigurationRuleCriteriaSubscriptionDurationFilterInput>;
};

export type AccountingConfigurationRuleCriteriaSubscriptionDurationFilter = {
  __typename?: 'AccountingConfigurationRuleCriteriaSubscriptionDurationFilter';
  comparator: AccountingConfigurationRuleComparator;
  operand1: Scalars['Int']['output'];
  unit: AccountingConfigurationRuleSubscriptionDurationFilterUnit;
};

export type AccountingConfigurationRuleCriteriaSubscriptionDurationFilterInput = {
  comparator: AccountingConfigurationRuleComparator;
  operand1: Scalars['Int']['input'];
  unit: AccountingConfigurationRuleSubscriptionDurationFilterUnit;
};

export type AccountingConfigurationRuleEffectiveRange = {
  __typename?: 'AccountingConfigurationRuleEffectiveRange';
  accountingConfigurationRule: AccountingConfigurationRule;
  effectiveRange: OpenEndedDateTimeRange;
  id: Scalars['AccountingConfigurationRuleEffectiveRangeID']['output'];
};

export type AccountingConfigurationRuleFilterBy = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountingConfigurationRulePaginator = {
  __typename?: 'AccountingConfigurationRulePaginator';
  items: Array<AccountingConfigurationRule>;
  pageInfo: PageInfo;
};

export enum AccountingConfigurationRuleSortOrder {
  PriorityOrderAsc = 'PRIORITY_ORDER_ASC',
  PriorityOrderDesc = 'PRIORITY_ORDER_DESC'
}

export enum AccountingConfigurationRuleSubscriptionDurationFilterUnit {
  Days = 'Days'
}

export enum AccountingConfigurationStatus {
  Active = 'Active',
  Archived = 'Archived'
}

export enum AccountingConfigurationType {
  RevenueRecognition = 'RevenueRecognition'
}

export type AccountingConfigurationsQueryInput = {
  companyId: Scalars['CompanyID']['input'];
  filterBy?: InputMaybe<AccountingConfigurationFilterBy>;
};

export type AccountingPolicy = {
  effectiveRange: OpenEndedInclusiveDateRange;
  id: Scalars['AccountingPolicyID']['output'];
};

export enum AccountingRecognitionCalculation {
  Days360 = 'Days360',
  DaysActual = 'DaysActual',
  Manual = 'Manual',
  PercentageBased = 'PercentageBased',
  StraightLineByPeriod = 'StraightLineByPeriod',
  /** @deprecated Use StraightLineByPeriod instead */
  StraightLineDaily = 'StraightLineDaily',
  /** @deprecated Use StraightLineByPeriod instead */
  StraightLineMonthly = 'StraightLineMonthly'
}

export enum AccountingRecognitionTiming {
  OverTime = 'OverTime',
  PointInTime = 'PointInTime'
}

export type AccountingRecordActivity = {
  accountingRecordType: AccountingRecordType;
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  type: AccountingRecordActivityType;
};

export enum AccountingRecordActivityType {
  FileDeleted = 'FILE_DELETED',
  FileUploaded = 'FILE_UPLOADED',
  Message = 'MESSAGE'
}

export enum AccountingRecordActorType {
  AdminActor = 'ADMIN_ACTOR',
  AiActor = 'AI_ACTOR',
  SystemActor = 'SYSTEM_ACTOR',
  TrainActor = 'TRAIN_ACTOR',
  UserActor = 'USER_ACTOR'
}

export type AccountingRecordComment = AccountingRecordActivity & {
  __typename?: 'AccountingRecordComment';
  accountingRecordType: AccountingRecordType;
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  type: AccountingRecordActivityType;
};

export type AccountingRecordDocument = {
  __typename?: 'AccountingRecordDocument';
  file: File;
  uploadActorType: AccountingRecordActorType;
};

export type AccountingRecordFileDeleted = AccountingRecordActivity & {
  __typename?: 'AccountingRecordFileDeleted';
  accountingRecordType: AccountingRecordType;
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  file: File;
  id: Scalars['ID']['output'];
  type: AccountingRecordActivityType;
};

export type AccountingRecordFileUploaded = AccountingRecordActivity & {
  __typename?: 'AccountingRecordFileUploaded';
  accountingRecordType: AccountingRecordType;
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  file: File;
  id: Scalars['ID']['output'];
  type: AccountingRecordActivityType;
};

export enum AccountingRecordType {
  Bill = 'BILL',
  ManualJournalEntry = 'MANUAL_JOURNAL_ENTRY',
  Transaction = 'TRANSACTION'
}

export type AccountsById = {
  ids: Array<Scalars['ID']['input']>;
};

export type AccountsPayable = {
  __typename?: 'AccountsPayable';
  amount: Money;
  month: Scalars['Month']['output'];
};

export type AccountsReceivable = {
  __typename?: 'AccountsReceivable';
  amount: Money;
  month: Scalars['Month']['output'];
};

export type AccrualEvent = {
  __typename?: 'AccrualEvent';
  amount: Money;
  effectiveAt: Scalars['DateTime']['output'];
  eventId: Scalars['ID']['output'];
  externalId: Scalars['ID']['output'];
  id: Scalars['AccrualEventID']['output'];
  ledgerEvents: Array<LedgerEvent>;
  removedAt: Scalars['DateTime']['output'];
  subledgerEventSummary: SubledgerEventSummary;
  type: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type AccrualEventFilterBy = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccrualEventPaginator = {
  __typename?: 'AccrualEventPaginator';
  events: Array<AccrualEvent>;
  pageInfo: PageInfo;
};

export type AccrualRevenueAnalysis = {
  __typename?: 'AccrualRevenueAnalysis';
  periodMetrics?: Maybe<Array<AccrualRevenueAnalysisByPeriod>>;
  totals: AccrualRevenueAnalysisMetrics;
};

export type AccrualRevenueAnalysisByCoaKeyInput = {
  filter: AccrualRevenueAnalysisFilter;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<AccrualRevenueAnalysisSortOrder>;
};

export type AccrualRevenueAnalysisByCoaKeyResult = {
  __typename?: 'AccrualRevenueAnalysisByCoaKeyResult';
  coaKeyMetrics: Array<CoaKeyAccrualRevenueAnalysisMetric>;
  pageInfo: PageInfo;
};

export type AccrualRevenueAnalysisByCustomerInput = {
  filter: AccrualRevenueAnalysisFilter;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<AccrualRevenueAnalysisSortOrder>;
};

export type AccrualRevenueAnalysisByCustomerResult = {
  __typename?: 'AccrualRevenueAnalysisByCustomerResult';
  customers: Array<Customer>;
  pageInfo: PageInfo;
};

export type AccrualRevenueAnalysisByPeriod = {
  __typename?: 'AccrualRevenueAnalysisByPeriod';
  deferred: Money;
  period: Scalars['Period']['output'];
  recognized: Money;
};

export type AccrualRevenueAnalysisFilter = {
  coaKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRange: InclusiveLocalDateRangeInput;
};

export type AccrualRevenueAnalysisInput = {
  filter: AccrualRevenueAnalysisFilter;
};

export type AccrualRevenueAnalysisMetrics = {
  __typename?: 'AccrualRevenueAnalysisMetrics';
  closingDeferredNet: Money;
  openingDeferredNet: Money;
  revenueDeferred: Money;
  revenueRecognized: Money;
};

export type AccrualRevenueAnalysisResult = {
  __typename?: 'AccrualRevenueAnalysisResult';
  accrualRevenueAnalysis: AccrualRevenueAnalysis;
};

export enum AccrualRevenueAnalysisSortOrder {
  ClosingDeferredAsc = 'CLOSING_DEFERRED_ASC',
  ClosingDeferredDesc = 'CLOSING_DEFERRED_DESC',
  DeferredRevenueAsc = 'DEFERRED_REVENUE_ASC',
  DeferredRevenueDesc = 'DEFERRED_REVENUE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OpeningDeferredAsc = 'OPENING_DEFERRED_ASC',
  OpeningDeferredDesc = 'OPENING_DEFERRED_DESC',
  RecognizedRevenueAsc = 'RECOGNIZED_REVENUE_ASC',
  RecognizedRevenueDesc = 'RECOGNIZED_REVENUE_DESC'
}

export enum AccrualRevenueGroupBy {
  CoaKey = 'CoaKey',
  Company = 'Company',
  Customer = 'Customer'
}

export type AccrualRevenueReportInput = {
  companyId: Scalars['ID']['input'];
  range: ReportTimePeriodInput;
};

export type AccuracyCheck = {
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  displayMetadata?: Maybe<AccuracyCheckDisplayMetadata>;
  group: AccuracyCheckGroup;
  id: Scalars['AccuracyCheckID']['output'];
  status: AccuracyCheckStatus;
  type: AccuracyCheckType;
  uniqueKey: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AccuracyCheckConfig = {
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['AccuracyCheckID']['output'];
  type: AccuracyCheckType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AccuracyCheckConfigFilterBy = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['AccuracyCheckConfigID']['input']>>;
  types?: InputMaybe<Array<AccuracyCheckType>>;
};

export type AccuracyCheckConfigPaginator = {
  __typename?: 'AccuracyCheckConfigPaginator';
  items: Array<AccuracyCheckConfig>;
  pageInfo: PageInfo;
};

export enum AccuracyCheckConfigSort {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC'
}

export type AccuracyCheckDisplayMetadata = {
  __typename?: 'AccuracyCheckDisplayMetadata';
  actionButtonName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  header: Scalars['String']['output'];
};

export type AccuracyCheckFilterBy = {
  groups?: InputMaybe<Array<AccuracyCheckGroup>>;
  ids?: InputMaybe<Array<Scalars['AccuracyCheckID']['input']>>;
  statuses?: InputMaybe<Array<AccuracyCheckStatus>>;
  types?: InputMaybe<Array<AccuracyCheckType>>;
};

export enum AccuracyCheckGroup {
  Invoice = 'INVOICE',
  Transaction = 'TRANSACTION'
}

export type AccuracyCheckPaginator = {
  __typename?: 'AccuracyCheckPaginator';
  items: Array<AccuracyCheck>;
  pageInfo: PageInfo;
};

export enum AccuracyCheckSort {
  MagnitudeAsc = 'MAGNITUDE_ASC',
  MagnitudeDesc = 'MAGNITUDE_DESC',
  RecencyAsc = 'RECENCY_ASC',
  RecencyDesc = 'RECENCY_DESC',
  RelevanceAsc = 'RELEVANCE_ASC',
  RelevanceDesc = 'RELEVANCE_DESC'
}

export enum AccuracyCheckStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Dismissed = 'DISMISSED',
  Processing = 'PROCESSING'
}

export enum AccuracyCheckType {
  KnownIssue = 'KNOWN_ISSUE',
  TransactionDescriptorMultipleVendors = 'TRANSACTION_DESCRIPTOR_MULTIPLE_VENDORS',
  TransactionVendorMultipleCategories = 'TRANSACTION_VENDOR_MULTIPLE_CATEGORIES'
}

export type ActivateContractRevenueScheduleInput = {
  contractRevenueScheduleId: Scalars['ContractRevenueScheduleID']['input'];
};

export type Actor = {
  __typename?: 'Actor';
  name?: Maybe<Scalars['String']['output']>;
  type: ActorType;
  user?: Maybe<User>;
};

export enum ActorType {
  AdminActor = 'ADMIN_ACTOR',
  AiActor = 'AI_ACTOR',
  SystemActor = 'SYSTEM_ACTOR',
  TrainActor = 'TRAIN_ACTOR',
  UserActor = 'USER_ACTOR'
}

export type AddAccountingRecordCommentInput = {
  accountingRecordId: Scalars['ID']['input'];
  accountingRecordType: AccountingRecordType;
  companyId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type AddClientToFirmInput = {
  companyId: Scalars['CompanyID']['input'];
  firmId: Scalars['FirmID']['input'];
  maxRole: MembershipRole;
};

export type AddClientToFirmResult = {
  __typename?: 'AddClientToFirmResult';
  firmClient: FirmClient;
};

export type AddFirmInput = {
  name: Scalars['String']['input'];
};

export type AddFirmResult = {
  __typename?: 'AddFirmResult';
  firm: Firm;
};

export type AddGroupToFirmInput = {
  alias: Scalars['String']['input'];
  firmId: Scalars['FirmID']['input'];
  isAnonymized: Scalars['Boolean']['input'];
  userIds: Array<Scalars['UserID']['input']>;
};

export type AddGroupToFirmResult = {
  __typename?: 'AddGroupToFirmResult';
  firmGroup: FirmGroup;
};

export type AddItemsToStripeSubscriptionInput = {
  companyId: Scalars['CompanyID']['input'];
  stripePriceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AddOAuthSupportToApiConnectionInput = {
  callbackUris: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type AddTransactionMessageInput = {
  targetUserId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
  transactionId: Scalars['ID']['input'];
};

export type AddUserToFirmGroupInput = {
  firmGroupId: Scalars['FirmGroupID']['input'];
  firmId: Scalars['FirmID']['input'];
  userId: Scalars['UserID']['input'];
};

export type AddUserToFirmGroupResult = {
  __typename?: 'AddUserToFirmGroupResult';
  firmGroupMembership: FirmGroupMembership;
};

export type AddUserToFirmInput = {
  firmId: Scalars['FirmID']['input'];
  role: FirmMembershipRole;
  userId: Scalars['UserID']['input'];
};

export type AddUserToFirmResult = {
  __typename?: 'AddUserToFirmResult';
  firmMembership: FirmMembership;
};

export enum AdditionalServices {
  Bookkeeping = 'Bookkeeping'
}

export type AdditionalServicesInput = {
  companyId: Scalars['CompanyID']['input'];
  services: Array<AdditionalServices>;
};

export type AdjustManualJournalEntryResult = {
  __typename?: 'AdjustManualJournalEntryResult';
  adjustmentMje: ManualJournalEntry;
};

export type AdminCategorizationRule = CategorizationRule & {
  __typename?: 'AdminCategorizationRule';
  appliesTo?: Maybe<Array<CategorizationRuleApplicationType>>;
  category: Category;
  confidence: CategoryConfidence;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  matchEntireString: Scalars['Boolean']['output'];
  maxAmountInclusive?: Maybe<Scalars['Decimal']['output']>;
  minAmountInclusive?: Maybe<Scalars['Decimal']['output']>;
  numTransactionsCategorizedBy: Scalars['Int']['output'];
  rule: Scalars['String']['output'];
  type: CategorizationRuleType;
  vendor?: Maybe<Vendor>;
};

export type AdminCategorizationRulesInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminCategorizationRulesPaginator = {
  __typename?: 'AdminCategorizationRulesPaginator';
  pageInfo: PageInfo;
  rules: Array<AdminCategorizationRule>;
};

export type AffiliateAttribution = {
  __typename?: 'AffiliateAttribution';
  companyId: Scalars['CompanyID']['output'];
  id: Scalars['AffiliateAttributionID']['output'];
  name: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type AffiliateAttributionQueryInput = {
  companyId: Scalars['CompanyID']['input'];
};

export type AffiliateAttributionsResponse = {
  __typename?: 'AffiliateAttributionsResponse';
  attributions: Array<AffiliateAttribution>;
};

export type AiLastMilePreferencesResult = {
  __typename?: 'AiLastMilePreferencesResult';
  company: Company;
  lastMilePreference: LastMilePreference;
};

export type AiWorkflowSettingsResult = {
  __typename?: 'AiWorkflowSettingsResult';
  company: Company;
  lastMilePreference?: Maybe<LastMilePreference>;
};

export enum AlertMetric {
  Burn = 'BURN',
  CashBalance = 'CASH_BALANCE',
  ExpensesInCategory = 'EXPENSES_IN_CATEGORY',
  Investment = 'INVESTMENT',
  Revenue = 'REVENUE',
  RevenueRunRate = 'REVENUE_RUN_RATE',
  RunwayMonths = 'RUNWAY_MONTHS',
  StartupFundingWindow = 'STARTUP_FUNDING_WINDOW',
  TotalExpenses = 'TOTAL_EXPENSES'
}

export type AllCompaniesPaginator = {
  __typename?: 'AllCompaniesPaginator';
  items: Array<Company>;
  pageInfo: PageInfo;
};

export type AmountChecklistItemData = {
  __typename?: 'AmountChecklistItemData';
  amount: Money;
  type: AmountChecklistItemDataType;
};

export enum AmountChecklistItemDataType {
  FixedAssetsAmount = 'FixedAssetsAmount',
  InvestmentDistributions = 'InvestmentDistributions',
  Investments = 'Investments',
  LoanPayments = 'LoanPayments',
  Loans = 'Loans',
  UncategorizedExpensesAmount = 'UncategorizedExpensesAmount',
  UncategorizedReimbursementsAmount = 'UncategorizedReimbursementsAmount',
  UncategorizedRevenueAmount = 'UncategorizedRevenueAmount'
}

export type AmountOnDateMetric = {
  __typename?: 'AmountOnDateMetric';
  date: Scalars['InclusiveDay']['output'];
  totalCash: Money;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AmountsChecklistItem = ChecklistItem & MonthlyChecklistItem & {
  __typename?: 'AmountsChecklistItem';
  amounts: Array<AmountChecklistItemData>;
  amountsType: AmountsChecklistItemType;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<ChecklistItemKey>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<User>;
  month: Scalars['Month']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  removedBy?: Maybe<User>;
};

export enum AmountsChecklistItemType {
  FixedAssetAmounts = 'FixedAssetAmounts',
  InvestmentAmounts = 'InvestmentAmounts',
  LoanAmounts = 'LoanAmounts',
  UncategorizedExpenseAmounts = 'UncategorizedExpenseAmounts',
  UncategorizedReimbursementAmounts = 'UncategorizedReimbursementAmounts',
  UncategorizedRevenueAmounts = 'UncategorizedRevenueAmounts'
}

export type Amplitude = {
  __typename?: 'Amplitude';
  apiKey: Scalars['String']['output'];
};

export type AnnualEmployeeCost = {
  __typename?: 'AnnualEmployeeCost';
  fullyLoadedCostMultiplier: Scalars['Float']['output'];
};

export type ApiConnection = {
  __typename?: 'ApiConnection';
  dataSourceType?: Maybe<DataSourceType>;
  externalId: Scalars['String']['output'];
  hasWebhooksEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  loginKey?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  requiresFitTest: Scalars['Boolean']['output'];
  supportsOAuth: Scalars['Boolean']['output'];
  supportsRedirect: Scalars['Boolean']['output'];
};

export type ApiConnectionConfig = {
  __typename?: 'ApiConnectionConfig';
  hasWebhooksEnabled: Scalars['Boolean']['output'];
  loginKey?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  requiresFitTest: Scalars['Boolean']['output'];
  supportsOAuth: Scalars['Boolean']['output'];
  supportsRedirect: Scalars['Boolean']['output'];
};

export type ApiConnectionCredentialsResult = {
  __typename?: 'ApiConnectionCredentialsResult';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export type ApiConnectionPaginator = {
  __typename?: 'ApiConnectionPaginator';
  items: Array<ApiConnection>;
  pageInfo: PageInfo;
};

export type ApiPartner = {
  __typename?: 'ApiPartner';
  name?: Maybe<Scalars['String']['output']>;
};

export type ApiUser = {
  __typename?: 'ApiUser';
  externalId: Scalars['ID']['output'];
};

export type AppliedBalance = {
  __typename?: 'AppliedBalance';
  appliedBalance: Money;
};

export type ApplyClassToEntityInput = {
  companyId: Scalars['CompanyID']['input'];
  entityId: Scalars['TaggableEntityID']['input'];
  entityType: ClassAwareType;
  reportingClassSegmentId: Scalars['TagValueID']['input'];
};

export type ApplyRevenueRecognitionConfigurationInput = {
  accountingConfigurationId: Scalars['AccountingConfigurationID']['input'];
  /** @deprecated unused */
  companyId?: InputMaybe<Scalars['CompanyID']['input']>;
  invoiceLineItemIds?: InputMaybe<Array<Scalars['InvoiceLineItemID']['input']>>;
};

export type ApplyRevenueRecognitionConfigurationResponse = {
  __typename?: 'ApplyRevenueRecognitionConfigurationResponse';
  configuration: RevenueRecognitionConfiguration;
  updatedInvoiceLines: Array<InvoiceLine>;
};

export type ApproveLedgerReconciliationInput = {
  id: Scalars['LedgerReconciliationID']['input'];
};

export type AskAiFreeformPromptInput = {
  companyId: Scalars['ID']['input'];
  prompt: Scalars['String']['input'];
  view: LedgerView;
};

export type AskAiPromptInput = {
  companyId: Scalars['ID']['input'];
  forceJson?: InputMaybe<Scalars['Boolean']['input']>;
  promptName: Scalars['String']['input'];
  promptSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type AskAiPromptResponse = {
  __typename?: 'AskAIPromptResponse';
  response: Scalars['String']['output'];
  threadId: Scalars['String']['output'];
};

export type AssignMeToDemoCompanyResult = {
  __typename?: 'AssignMeToDemoCompanyResult';
  company: Company;
};

export type AssignUserToTransactionInput = {
  assignmentType?: InputMaybe<TransactionMemoAssignmentType>;
  targetUserId: Scalars['ID']['input'];
  /** @deprecated use assignmentType */
  text?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['ID']['input'];
};

export enum AssociatedEntity {
  Bill = 'Bill',
  Customer = 'Customer',
  DirectIngest = 'DirectIngest',
  LedgerReconciliation = 'LedgerReconciliation',
  ManualJournalEntry = 'ManualJournalEntry',
  Reconciliation = 'Reconciliation',
  Transaction = 'Transaction',
  Vendor = 'Vendor'
}

export type AsyncReportResult = {
  __typename?: 'AsyncReportResult';
  report: Report;
};

export type AuditLog = {
  __typename?: 'AuditLog';
  activityType?: Maybe<AuditLogActivityType>;
  actorType: TransactionDetailActorType;
  company: Company;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemDescription?: Maybe<Scalars['String']['output']>;
  itemType: AuditLogItemType;
  mjeId?: Maybe<Scalars['ID']['output']>;
  transactionId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum AuditLogActivityType {
  AccountEpochChange = 'AccountEpochChange',
  AccountRemove = 'AccountRemove',
  AccountReset = 'AccountReset',
  AccountingConfigurationChanges = 'AccountingConfigurationChanges',
  BillChange = 'BillChange',
  CategoryAssigned = 'CategoryAssigned',
  CoaAdditions = 'CoaAdditions',
  CompanyUpdates = 'CompanyUpdates',
  ConsentToShareData = 'ConsentToShareData',
  CustomerChange = 'CustomerChange',
  InvoiceChange = 'InvoiceChange',
  LedgerReconciliationChange = 'LedgerReconciliationChange',
  MjeChange = 'MjeChange',
  PaymentProcessorSubLedgerSettingChange = 'PaymentProcessorSubLedgerSettingChange',
  RuleUpdate = 'RuleUpdate',
  TransactionLink = 'TransactionLink',
  TransactionRemove = 'TransactionRemove',
  TransactionSplit = 'TransactionSplit',
  TransactionUpdate = 'TransactionUpdate',
  TwoFactorAuth = 'TwoFactorAuth',
  UserImport = 'UserImport',
  UserInvitesRolesRevocations = 'UserInvitesRolesRevocations',
  VendorChange = 'VendorChange'
}

export type AuditLogFilterBy = {
  activityTypes?: InputMaybe<Array<AuditLogActivityType>>;
  actorTypes?: InputMaybe<Array<TransactionDetailActorType>>;
  endDate: Scalars['String']['input'];
  itemTypes?: InputMaybe<Array<AuditLogItemType>>;
  startDate: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum AuditLogItemType {
  AccountEpochCreated = 'AccountEpochCreated',
  AccountEpochUpdated = 'AccountEpochUpdated',
  AccountRemove = 'AccountRemove',
  AccountReset = 'AccountReset',
  AccountingConfigurationApplied = 'AccountingConfigurationApplied',
  AccountingConfigurationCreated = 'AccountingConfigurationCreated',
  AccountingConfigurationRuleUpdated = 'AccountingConfigurationRuleUpdated',
  AccountingConfigurationStatusChange = 'AccountingConfigurationStatusChange',
  AccountingConfigurationUpdated = 'AccountingConfigurationUpdated',
  ApplyAccountingConfigurationRule = 'ApplyAccountingConfigurationRule',
  BillCreate = 'BillCreate',
  BillCreatedByUser = 'BillCreatedByUser',
  BillPaid = 'BillPaid',
  BillRecategorized = 'BillRecategorized',
  BillRemove = 'BillRemove',
  BillUpdate = 'BillUpdate',
  BillVoid = 'BillVoid',
  CoaParentAccountCreate = 'CoaParentAccountCreate',
  CoaRequest = 'CoaRequest',
  CoaSubAccountCreate = 'CoaSubAccountCreate',
  CompanyNameUpdate = 'CompanyNameUpdate',
  CompanyRevenueModelUpdate = 'CompanyRevenueModelUpdate',
  CompanyStartIngestionDateUpdate = 'CompanyStartIngestionDateUpdate',
  CompanyTimezoneUpdate = 'CompanyTimezoneUpdate',
  CompanyUserProposedStartIngestionDateUpdate = 'CompanyUserProposedStartIngestionDateUpdate',
  ConfirmContractLine = 'ConfirmContractLine',
  ConfirmContractLines = 'ConfirmContractLines',
  ConsentToShareDataWithOpenAi = 'ConsentToShareDataWithOpenAi',
  CustomerUpdate = 'CustomerUpdate',
  InvoiceCreate = 'InvoiceCreate',
  InvoiceRecategorize = 'InvoiceRecategorize',
  InvoiceRemove = 'InvoiceRemove',
  InvoiceUpdate = 'InvoiceUpdate',
  InvoiceVoid = 'InvoiceVoid',
  LedgerReconciliationApprove = 'LedgerReconciliationApprove',
  LedgerReconciliationCreate = 'LedgerReconciliationCreate',
  LedgerReconciliationDeleted = 'LedgerReconciliationDeleted',
  LedgerReconciliationReset = 'LedgerReconciliationReset',
  LedgerReconciliationUnapprove = 'LedgerReconciliationUnapprove',
  LedgerReconciliationUpdateEntries = 'LedgerReconciliationUpdateEntries',
  MfaDisable = 'MfaDisable',
  MfaEnable = 'MfaEnable',
  MjeDraftDelete = 'MjeDraftDelete',
  MjeDraftSave = 'MjeDraftSave',
  MjeDraftUpdate = 'MjeDraftUpdate',
  MjePost = 'MjePost',
  MjeReverse = 'MjeReverse',
  MjeVoid = 'MjeVoid',
  PaymentProcessorSubLedgerDisabled = 'PaymentProcessorSubLedgerDisabled',
  PaymentProcessorSubLedgerEnabled = 'PaymentProcessorSubLedgerEnabled',
  RuleCreate = 'RuleCreate',
  RuleDelete = 'RuleDelete',
  RuleUpdate = 'RuleUpdate',
  TransactionCategorize = 'TransactionCategorize',
  TransactionCreatedByUser = 'TransactionCreatedByUser',
  TransactionEditMemo = 'TransactionEditMemo',
  TransactionLink = 'TransactionLink',
  TransactionMoveDate = 'TransactionMoveDate',
  TransactionRemove = 'TransactionRemove',
  TransactionRestore = 'TransactionRestore',
  TransactionSplit = 'TransactionSplit',
  TransactionUnlink = 'TransactionUnlink',
  UnconfirmContractLines = 'UnconfirmContractLines',
  UserInformationUpdated = 'UserInformationUpdated',
  UserInvite = 'UserInvite',
  UserRevoked = 'UserRevoked',
  UserRoleUpdate = 'UserRoleUpdate',
  VendorMerge = 'VendorMerge',
  VendorUpdate = 'VendorUpdate'
}

export type AuditLogPaginator = {
  __typename?: 'AuditLogPaginator';
  nodes: Array<AuditLog>;
  pageInfo: PageInfo;
};

export enum AuditLogSortOrder {
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC'
}

export type AuthenticateWithTokenInput = {
  token: Scalars['String']['input'];
};

export type AuthenticateWithTokenResult = {
  __typename?: 'AuthenticateWithTokenResult';
  apiUser?: Maybe<ApiUser>;
  companyId?: Maybe<Scalars['ID']['output']>;
  error?: Maybe<AuthenticationError>;
  isUpdate?: Maybe<Scalars['Boolean']['output']>;
  needsAuthentication?: Maybe<Scalars['Boolean']['output']>;
  self?: Maybe<User>;
};

export enum AuthenticationError {
  CodeAlreadyActivated = 'CodeAlreadyActivated',
  CodeExpired = 'CodeExpired',
  InvalidCode = 'InvalidCode'
}

export enum AutoGenerateDepreciationEntriesValue {
  AutoPostEntries = 'AutoPostEntries',
  EntriesDisabled = 'EntriesDisabled',
  ManuallyPostEntries = 'ManuallyPostEntries'
}

export type AvailableClassSegment = {
  __typename?: 'AvailableClassSegment';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['TagValueID']['output'];
  name: Scalars['TagValueDisplayName']['output'];
  removable: Scalars['Boolean']['output'];
  reportingClass: AvailableReportingClass;
};

export type AvailableClassesResult = {
  __typename?: 'AvailableClassesResult';
  departments: AvailableReportingClass;
  locations: AvailableReportingClass;
  userCreated: Array<AvailableReportingClass>;
};

export type AvailableReportingClass = {
  __typename?: 'AvailableReportingClass';
  availableValues: Array<AvailableClassSegment>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['TagNameID']['output'];
  name: Scalars['TagNameDisplayName']['output'];
  type: ReportingClassType;
};

export type Balance = {
  __typename?: 'Balance';
  availableAmount?: Maybe<Scalars['Decimal']['output']>;
  currentAmount: Scalars['Decimal']['output'];
};

export type BalanceByReportColumn = {
  __typename?: 'BalanceByReportColumn';
  balance: Money;
  columnKey: Scalars['String']['output'];
  dateRange: OpenEndedInclusiveDateRange;
  pathToken?: Maybe<Scalars['String']['output']>;
};

export type BalanceChecklistItem = ChecklistItem & MonthlyChecklistItem & {
  __typename?: 'BalanceChecklistItem';
  balance: Money;
  balanceType: BalanceChecklistItemType;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<ChecklistItemKey>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<User>;
  month: Scalars['Month']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  removedBy?: Maybe<User>;
};

export enum BalanceChecklistItemType {
  BankTransferBalance = 'BankTransferBalance',
  CreditCardPaymentBalance = 'CreditCardPaymentBalance',
  PayrollClearingBalance = 'PayrollClearingBalance'
}

export type BalanceData = {
  __typename?: 'BalanceData';
  balance: Scalars['Decimal']['output'];
  balanceUpdatedAt?: Maybe<Scalars['String']['output']>;
  runRateBalanceEstimate: Array<DateAmount>;
};

export type BalanceSplitInput = {
  amount: Scalars['Decimal']['input'];
  description: Scalars['String']['input'];
  ledgerCoaKey: Scalars['String']['input'];
  timestamp: Scalars['Date']['input'];
};

export type BalancesInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  companyId: Scalars['ID']['input'];
  dates: Array<Scalars['String']['input']>;
};

export type BalancesResult = {
  __typename?: 'BalancesResult';
  balancesByDate: Array<InstitutionAccountBalancesOnDate>;
};

export type BasicChecklistItem = ChecklistItem & {
  __typename?: 'BasicChecklistItem';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<ChecklistItemKey>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<User>;
  /** @deprecated Use `month` from `MonthlyChecklistItem`. */
  month?: Maybe<Scalars['Month']['output']>;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  removedBy?: Maybe<User>;
};

export type BenefitDetail = {
  __typename?: 'BenefitDetail';
  employeePortion: Scalars['Decimal']['output'];
  employerPortion: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BenefitInput = {
  amount: Scalars['Decimal']['input'];
  id: Scalars['ID']['input'];
  kind: PayrollJournalMapItemCategory;
  name: Scalars['String']['input'];
};

export type Bill = {
  __typename?: 'Bill';
  activity: Array<AccountingRecordActivity>;
  amount: Money;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  currentness?: Maybe<BillCurrentness>;
  description?: Maybe<Scalars['String']['output']>;
  displayStatus: Scalars['String']['output'];
  documents: Array<AccountingRecordDocument>;
  dueDate?: Maybe<Scalars['LocalDate']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  events: Array<LedgerEvent>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integrationType: IntegrationType;
  issueDate: Scalars['LocalDate']['output'];
  lines: Array<BillLine>;
  linkedTransactions: Array<Transaction>;
  links: Array<TransactionLink>;
  matches: Array<VendorBalanceMatch>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  payableBalance: PayableBalance;
  provider?: Maybe<Scalars['String']['output']>;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  shortId: Scalars['String']['output'];
  status: BillStatus;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userEdited?: Maybe<Scalars['Boolean']['output']>;
  vendor?: Maybe<Vendor>;
  voidedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum BillCurrentness {
  Current = 'Current',
  Overdue = 'Overdue'
}

export type BillDotComIntegration = {
  __typename?: 'BillDotComIntegration';
  connection?: Maybe<IntegrationConnection>;
  connections?: Maybe<Array<IntegrationConnection>>;
};


export type BillDotComIntegrationConnectionArgs = {
  companyId: Scalars['ID']['input'];
};


export type BillDotComIntegrationConnectionsArgs = {
  companyId: Scalars['ID']['input'];
};

export type BillFilterBy = {
  dateRange?: InputMaybe<LocalDateRangeInput>;
  dueDateRange?: InputMaybe<LocalDateRangeInput>;
  isLinked?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  isSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  isVoided?: InputMaybe<Scalars['Boolean']['input']>;
  matchContext?: InputMaybe<BillMatchContext>;
  maxAmount?: InputMaybe<Scalars['Decimal']['input']>;
  minAmount?: InputMaybe<Scalars['Decimal']['input']>;
  statuses?: InputMaybe<Array<BillFilterStatus>>;
  /** @deprecated use vendorIds */
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum BillFilterStatus {
  Current = 'Current',
  Draft = 'Draft',
  Overdue = 'Overdue',
  Paid = 'Paid',
  Unpaid = 'Unpaid',
  Voided = 'Voided'
}

export type BillLine = WithReportingClasses & {
  __typename?: 'BillLine';
  amount: Money;
  bill: Bill;
  classAwareType: ClassAwareType;
  classSegments: Array<AvailableClassSegment>;
  coaKey?: Maybe<Scalars['String']['output']>;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fixedAsset?: Maybe<FixedAsset>;
  id: Scalars['BillLineID']['output'];
  prepaid?: Maybe<Prepaid>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BillListExportOptions = {
  asOf?: InputMaybe<Scalars['LocalDate']['input']>;
  filterBy: BillFilterBy;
  reportFormat: ReportFormat;
  sortBy: BillSortOrder;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BillMatchContext = {
  amount: Scalars['Decimal']['input'];
  date: Scalars['LocalDate']['input'];
};

export type BillPaginator = {
  __typename?: 'BillPaginator';
  items: Array<Bill>;
  pageInfo: PageInfo;
  total: Money;
};

export enum BillSortOrder {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  DescriptorAsc = 'DESCRIPTOR_ASC',
  DescriptorDesc = 'DESCRIPTOR_DESC',
  DueDateAsc = 'DUE_DATE_ASC',
  DueDateDesc = 'DUE_DATE_DESC',
  IssueDateAsc = 'ISSUE_DATE_ASC',
  IssueDateDesc = 'ISSUE_DATE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC'
}

export enum BillStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  Paid = 'Paid',
  Posted = 'Posted',
  Voided = 'Voided'
}

export enum BookkeeperPlan {
  DoItMyself = 'DoItMyself',
  HasBookkeeper = 'HasBookkeeper',
  Unknown = 'Unknown',
  WantsBookkeeper = 'WantsBookkeeper'
}

export type BrexInitializationInfo = {
  __typename?: 'BrexInitializationInfo';
  connectUrl: Scalars['String']['output'];
};


export type BrexInitializationInfoConnectUrlArgs = {
  companyId: Scalars['ID']['input'];
};

export type BrexIntegration = {
  __typename?: 'BrexIntegration';
  connection?: Maybe<IntegrationConnection>;
  connections?: Maybe<Array<IntegrationConnection>>;
  initializationInfo: BrexInitializationInfo;
};


export type BrexIntegrationConnectionArgs = {
  companyId: Scalars['ID']['input'];
};


export type BrexIntegrationConnectionsArgs = {
  companyId: Scalars['ID']['input'];
};

export type Bugsnag = {
  __typename?: 'Bugsnag';
  apiKey: Scalars['String']['output'];
};

export type BulkApplyClassificationInput = {
  companyId: Scalars['CompanyID']['input'];
  entityIds: Array<Scalars['TaggableEntityID']['input']>;
  entityType: ClassAwareType;
  reportingClassSegmentId: Scalars['TagValueID']['input'];
};

export type BulkApplyClassificationResult = {
  __typename?: 'BulkApplyClassificationResult';
  numCreated: Scalars['Int']['output'];
};

export type BulkTransactionsResult = {
  __typename?: 'BulkTransactionsResult';
  transactions: Array<UserTransaction>;
};

export type BulkUpdateFinalizedStateByFiltersInput = {
  companyId: Scalars['ID']['input'];
  filterBy: TransactionFilterBy;
  finalize: Scalars['Boolean']['input'];
};

export type BulkUpdateFinalizedStateInput = {
  finalize: Scalars['Boolean']['input'];
  transactionIds: Array<Scalars['TransactionID']['input']>;
};

export type BulkUpdateFinalizedStateResult = {
  __typename?: 'BulkUpdateFinalizedStateResult';
  failedIds: Array<Scalars['TransactionID']['output']>;
  updatedIds: Array<Scalars['TransactionID']['output']>;
};

export type BulkUpdateTransactionCategoryInput = {
  ledgerCoaKey: Scalars['LedgerCoaKey']['input'];
};

export type BulkUpdateTransactionFieldInput = {
  categories?: InputMaybe<BulkUpdateTransactionCategoryInput>;
  finalized?: InputMaybe<BulkUpdateFinalizedStateInput>;
  vendors?: InputMaybe<BulkUpdateTransactionVendorInput>;
};

export type BulkUpdateTransactionTarget = {
  filterBy?: InputMaybe<TransactionFilterBy>;
  transactionIds?: InputMaybe<Array<Scalars['TransactionID']['input']>>;
};

export type BulkUpdateTransactionVendorInput = {
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type BulkUpdateTransactionsInput = {
  companyId: Scalars['CompanyID']['input'];
  field: BulkUpdateTransactionFieldInput;
  target: BulkUpdateTransactionTarget;
};

export type BulkUpdateTransactionsRestricted = {
  __typename?: 'BulkUpdateTransactionsRestricted';
  customerPayments?: Maybe<Scalars['Int']['output']>;
  finalized: Scalars['Int']['output'];
  linked?: Maybe<Scalars['Int']['output']>;
  locked: Scalars['Int']['output'];
  split: Scalars['Int']['output'];
  vendorPayments?: Maybe<Scalars['Int']['output']>;
};

export type BulkUpdateTransactionsResult = {
  __typename?: 'BulkUpdateTransactionsResult';
  failedIds: Array<Scalars['TransactionID']['output']>;
  updatedIds: Array<Scalars['TransactionID']['output']>;
};

export type BulkUpsertUserTransactionsInput = {
  transactions: Array<UpsertUserTransactionInput>;
};

export type BurnAverage = {
  __typename?: 'BurnAverage';
  amount: Scalars['Decimal']['output'];
  months: Scalars['Int']['output'];
};

export enum BurnFormula {
  OperatingBurn = 'OperatingBurn',
  OperatingIncome = 'OperatingIncome',
  TotalBurn = 'TotalBurn'
}

export type CachedPrefilledOnboardingData = {
  __typename?: 'CachedPrefilledOnboardingData';
  companyName: Scalars['String']['output'];
  hasConnectionInfo: Scalars['Boolean']['output'];
  integrationType?: Maybe<IntegrationType>;
};

export type CalIdInput = {
  companyId: Scalars['ID']['input'];
};

export type CanBulkUpdateTransactionsResult = {
  __typename?: 'CanBulkUpdateTransactionsResult';
  restricted: BulkUpdateTransactionsRestricted;
  total: Scalars['Int']['output'];
};

export type CanLockPeriodResult = {
  __typename?: 'CanLockPeriodResult';
  able: Scalars['Boolean']['output'];
  period?: Maybe<Scalars['String']['output']>;
  warnings: Array<LockWarning>;
};

export type CancelAssignmentInput = {
  assignmentId: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
};

export enum Capitalizable {
  False = 'FALSE',
  NotSet = 'NOT_SET',
  True = 'TRUE'
}

export type Card = {
  __typename?: 'Card';
  accountId: Scalars['AccountID']['output'];
  companyId: Scalars['CompanyID']['output'];
  holderName: Scalars['String']['output'];
  id: Scalars['CardID']['output'];
  lastFour: Scalars['String']['output'];
};

export type CardFilterBy = {
  accountId?: InputMaybe<Scalars['AccountID']['input']>;
  holderName?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['CardID']['input']>>;
};

export type CardPaginator = {
  __typename?: 'CardPaginator';
  items: Array<Card>;
  pageInfo: PageInfo;
};

export enum CardSortOrder {
  InsertOrderAsc = 'INSERT_ORDER_ASC',
  InsertOrderDesc = 'INSERT_ORDER_DESC',
  NameNumberAsc = 'NAME_NUMBER_ASC',
  NameNumberDesc = 'NAME_NUMBER_DESC'
}

export enum CashFlow {
  MoneyIn = 'MONEY_IN',
  MoneyOut = 'MONEY_OUT'
}

export enum Cashlike {
  Expense = 'EXPENSE',
  Ignore = 'IGNORE',
  Investment = 'INVESTMENT',
  Revenue = 'REVENUE'
}

export type CashlikeAmount = {
  __typename?: 'CashlikeAmount';
  expenses: Scalars['Decimal']['output'];
  investments: Scalars['Decimal']['output'];
  revenues: Scalars['Decimal']['output'];
};

export type CashlikeBalances = {
  __typename?: 'CashlikeBalances';
  balance: Scalars['Decimal']['output'];
  balanceUpdatedAt?: Maybe<Scalars['String']['output']>;
};

export type CategoriesReportInput = {
  companyId: Scalars['CompanyID']['input'];
  context?: InputMaybe<CategoryQueryContext>;
};

export type CategorizationMetadata = {
  __typename?: 'CategorizationMetadata';
  dataCompletenessLevel: DataCompletenessLevel;
  uncategorized: CategorizationStats;
  unfinalized: CategorizationStats;
};

export type CategorizationModelMetrics = {
  __typename?: 'CategorizationModelMetrics';
  totalDollarsInTransactions?: Maybe<Scalars['Decimal']['output']>;
  totalNumberOfTransactions?: Maybe<Scalars['Float']['output']>;
};

export type CategorizationModelMetricsInput = {
  actorType?: InputMaybe<TransactionDetailActorType>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ledgerCoaKey?: InputMaybe<Scalars['String']['input']>;
  whereCorrect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategorizationReportInput = {
  actorType?: InputMaybe<TransactionDetailActorType>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  containingPhrase?: InputMaybe<Scalars['String']['input']>;
  dataSourceName?: InputMaybe<Scalars['String']['input']>;
  ledgerCoaKey?: InputMaybe<Scalars['String']['input']>;
  timePeriod?: InputMaybe<ReportTimePeriodInput>;
  vendorPermaName?: InputMaybe<Scalars['String']['input']>;
};

export type CategorizationRule = {
  category: Category;
  id: Scalars['ID']['output'];
  type: CategorizationRuleType;
  vendor?: Maybe<Vendor>;
};

export enum CategorizationRuleApplicationType {
  Invoice = 'Invoice',
  Transaction = 'Transaction'
}

export type CategorizationRuleClass = {
  __typename?: 'CategorizationRuleClass';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['TagNameID']['output'];
  name: Scalars['TagNameDisplayName']['output'];
  type: ReportingClassType;
};

export type CategorizationRuleClassSegment = {
  __typename?: 'CategorizationRuleClassSegment';
  class?: Maybe<CategorizationRuleClass>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['TagValueID']['output'];
  name: Scalars['TagValueDisplayName']['output'];
};

export type CategorizationRuleConflict = {
  __typename?: 'CategorizationRuleConflict';
  category: Category;
  confidence: CategoryConfidence;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  matchEntireString: Scalars['Boolean']['output'];
  rule: Scalars['String']['output'];
  type?: Maybe<CategorizationRuleType>;
  vendor?: Maybe<Vendor>;
};

export type CategorizationRuleConflictsResult = {
  __typename?: 'CategorizationRuleConflictsResult';
  conflictingRules: Array<CategorizationRuleConflict>;
};

export enum CategorizationRuleType {
  Admin = 'Admin',
  System = 'System',
  User = 'User'
}

export type CategorizationStats = {
  __typename?: 'CategorizationStats';
  amount: Scalars['Decimal']['output'];
  inAmount: Scalars['Decimal']['output'];
  outAmount: Scalars['Decimal']['output'];
  percentComplete: Scalars['Int']['output'];
  total: Scalars['Decimal']['output'];
};

export type CategorizationSummaryReportInput = {
  ltseOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Category = {
  coaDisplayId?: Maybe<Scalars['String']['output']>;
  coaKey?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['ID']['output']>;
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  examples?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  permaKey: Scalars['String']['output'];
  ruleType?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum CategoryConfidence {
  Flag = 'FLAG',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type CategoryInput = {
  id: Scalars['String']['input'];
};

export type CategoryMetric = {
  __typename?: 'CategoryMetric';
  amount: Money;
  count: Scalars['Int']['output'];
  ledgerCoaKey: Scalars['String']['output'];
};

export enum CategoryQueryContext {
  Extended = 'EXTENDED',
  Historical = 'HISTORICAL',
  OpeningBalance = 'OPENING_BALANCE',
  Reconciliation = 'RECONCILIATION'
}

export type CategoryQueryInput = {
  companyId: Scalars['ID']['input'];
  context?: InputMaybe<CategoryQueryContext>;
};

export type CategorySpendingTrend = {
  __typename?: 'CategorySpendingTrend';
  amount: Money;
  ledgerCoaKey: Scalars['String']['output'];
  period: Scalars['Period']['output'];
  periodRange: InclusiveDateRange;
};

export type ChartDatePoint = {
  __typename?: 'ChartDatePoint';
  breakdowns?: Maybe<Array<Maybe<ChartPoint>>>;
  date: Scalars['Date']['output'];
  values: Array<ChartPoint>;
};

export type ChartPoint = {
  __typename?: 'ChartPoint';
  key: Scalars['String']['output'];
  value: Scalars['Decimal']['output'];
};

export type Charts = {
  __typename?: 'Charts';
  cashBalance: Array<ChartDatePoint>;
  expenses?: Maybe<Array<ChartDatePoint>>;
  revenue: Array<ChartDatePoint>;
  spending: Array<ChartDatePoint>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Checklist = {
  __typename?: 'Checklist';
  /** @deprecated Use MonthlyChecklist instead */
  id: Scalars['ID']['output'];
  /** @deprecated Use MonthlyChecklist instead */
  items: Array<ChecklistItem>;
  /** @deprecated Use MonthlyChecklist instead */
  month: Scalars['Month']['output'];
};

export type ChecklistInfo = {
  __typename?: 'ChecklistInfo';
  /** @deprecated Use MonthlyChecklistInfo instead */
  latestChecklist: Checklist;
  /** @deprecated Use MonthlyChecklistInfo instead */
  months: Array<Scalars['Month']['output']>;
};

export type ChecklistItem = {
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<ChecklistItemKey>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<User>;
  /** @deprecated Use `month` from `MonthlyChecklistItem`. */
  month?: Maybe<Scalars['Month']['output']>;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  removedBy?: Maybe<User>;
};

export type ChecklistItemInput = {
  companyId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  month: Scalars['Month']['input'];
  repeat?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ChecklistItemKey {
  Account = 'account',
  AdjustHistoricalFinancials = 'adjust_historical_financials',
  BankTransferBalance = 'bank_transfer_balance',
  CheckQuickbooksReports = 'check_quickbooks_reports',
  ConnectToQuickbooks = 'connect_to_quickbooks',
  CreditCardPaymentBalance = 'credit_card_payment_balance',
  Custom = 'custom',
  EstablishHistoricalPeriod = 'establish_historical_period',
  FixedAssetAmounts = 'fixed_asset_amounts',
  InvestmentAmounts = 'investment_amounts',
  LoanAmounts = 'loan_amounts',
  MapFinancials = 'map_financials',
  ModifyCoa = 'modify_coa',
  PayrollClearingBalance = 'payroll_clearing_balance',
  ProgressTransactionsCategorized = 'progress_transactions_categorized',
  ProgressTransactionsFinalized = 'progress_transactions_finalized',
  ReviewBankAndCcBalances = 'review_bank_and_cc_balances',
  ReviewFinancialStatements = 'review_financial_statements',
  ReviewHjes = 'review_hjes',
  ReviewLockedPeriod = 'review_locked_period',
  ReviewNewVendors = 'review_new_vendors',
  SetupCallWithPuzzle = 'setup_call_with_puzzle',
  StatementBalanceSheet = 'statement_balance_sheet',
  StatementProfitAndLoss = 'statement_profit_and_loss',
  UncategorizedExpenseAmounts = 'uncategorized_expense_amounts',
  UncategorizedReimbursementAmounts = 'uncategorized_reimbursement_amounts',
  UncategorizedRevenueAmounts = 'uncategorized_revenue_amounts',
  UploadHjeTemplate = 'upload_hje_template'
}

export type ChecklistV2 = {
  id: Scalars['ID']['output'];
  items: Array<ChecklistItem>;
};

export enum ClassAwareType {
  BillLine = 'BillLine',
  InvoiceDiscountLine = 'InvoiceDiscountLine',
  InvoiceLine = 'InvoiceLine',
  InvoiceShippingLine = 'InvoiceShippingLine',
  InvoiceTaxLine = 'InvoiceTaxLine',
  ManualJournalEntryItem = 'ManualJournalEntryItem',
  TransactionDetail = 'TransactionDetail'
}

export type ClearCookiesResult = {
  __typename?: 'ClearCookiesResult';
  error?: Maybe<Scalars['String']['output']>;
};

export type ClientFileInput = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  path: Scalars['String']['input'];
  size: Scalars['Int']['input'];
};

export type CloseContractRevenueScheduleInput = {
  closedDay: Scalars['LocalDate']['input'];
  contractRevenueScheduleId: Scalars['ContractRevenueScheduleID']['input'];
  recordClosingEntry?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CoaAccountTypeQueryInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};

export type CoaKeyAccrualRevenueAnalysisMetric = {
  __typename?: 'CoaKeyAccrualRevenueAnalysisMetric';
  accrualRevenueAnalysis?: Maybe<AccrualRevenueAnalysis>;
  coaKey: Scalars['String']['output'];
};

export type CoaMapperResult = {
  __typename?: 'CoaMapperResult';
  fileDownloadInfo?: Maybe<FileDownloadInfo>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CoaReportInput = {
  companyId: Scalars['CompanyID']['input'];
  integration?: InputMaybe<IntegrationType>;
};

export enum CoaType {
  Decimal = 'decimal',
  Ecommerce = 'ecommerce',
  Every = 'every',
  Fondo = 'fondo',
  Saas = 'saas'
}

export enum CommunicationMedium {
  Dashboard = 'Dashboard',
  Email = 'Email',
  Slack = 'Slack'
}

export type Company = {
  __typename?: 'Company';
  accountingConfigurationRules: AccountingConfigurationRulePaginator;
  accrualRevenueAnalysis: AccrualRevenueAnalysisResult;
  accrualRevenueAnalysisByCoaKey: AccrualRevenueAnalysisByCoaKeyResult;
  accrualRevenueAnalysisByCustomer: AccrualRevenueAnalysisByCustomerResult;
  accuracyCheckConfigs: AccuracyCheckConfigPaginator;
  accuracyChecks: AccuracyCheckPaginator;
  address?: Maybe<Scalars['JSON']['output']>;
  apAging: ApAgingResult;
  apAgingBillLines: ApAgingBillLinesResult;
  apAgingExport: AsyncReportResult;
  arAging: ArAgingResult;
  arAgingExport: AsyncReportResult;
  arAgingLines: ArAgingLinesResult;
  arr?: Maybe<CompanyArr>;
  attributes?: Maybe<CompanyAttributes>;
  availableClasses: AvailableClassesResult;
  billListExport: AsyncReportResult;
  bills: BillPaginator;
  bookkeeperPlan?: Maybe<BookkeeperPlan>;
  canLockPeriod: CanLockPeriodResult;
  categorizationMetadata: CategorizationMetadata;
  chartOfAccounts: Array<LedgerAccount>;
  charts?: Maybe<Charts>;
  coaType?: Maybe<CoaType>;
  companyBenefits: Array<CompanyBenefit>;
  consentsToAI: Scalars['Boolean']['output'];
  contractLines: ContractLinePaginator;
  contractLinesGroupedBy: ContractLinesGroupByPaginator;
  contractRevenueSchedules: ContractRevenueSchedulePaginator;
  createdAt: Scalars['DateTime']['output'];
  createdByApiPartnerName?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  currentPuzzlePlanSubscription?: Maybe<CompanyPricingPlan>;
  customerBalanceTransactions: CustomerBalanceTransactionListResult;
  directIngestFile: DirectIngestFile;
  directIngestFiles: DirectIngestFilesPaginator;
  email?: Maybe<Scalars['String']['output']>;
  features: CompanyFeatures;
  financialSummary?: Maybe<CompanyFinancialSummary>;
  fixedAssets: FixedAssetPaginator;
  hasBookkeeperInPuzzle?: Maybe<Scalars['Boolean']['output']>;
  hasHistoricalData?: Maybe<Scalars['Boolean']['output']>;
  hasManualJournalEntries: Scalars['Boolean']['output'];
  hasPartnersJournalEntries: Scalars['Boolean']['output'];
  hasRevenueTransactions: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  howDidYouHearAboutUs?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  howDidYouHearAboutUsOther?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  howDidYouHearAboutUsReferer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialIngestDate?: Maybe<Scalars['DateTime']['output']>;
  initialIngestStatus?: Maybe<CompanyIngestStatus>;
  initialUpToDate?: Maybe<Scalars['DateTime']['output']>;
  integrationConnections?: Maybe<Array<IntegrationConnection>>;
  invoiceLineItems: InvoiceLineItemPaginator;
  invoiceListExport: AsyncReportResult;
  invoices: InvoicePaginator;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isFreshStart?: Maybe<Scalars['Boolean']['output']>;
  isSimulated: Scalars['Boolean']['output'];
  isTest: Scalars['Boolean']['output'];
  journal: LedgerJournal;
  ledgerEntriesForReconciliation: LedgerEntriesForReconciliationPaginator;
  ledgerReconciliationBasis: LedgerView;
  ledgerReconciliations: LedgerReconciliationPaginator;
  lockedPeriod?: Maybe<LockedPeriod>;
  manualJournalEntries: ManualJournalEntryPaginator;
  manualJournalEntryGroups: ManualJournalEntryGroupPaginator;
  memberships: Array<CompanyMembership>;
  mfaRequired: Scalars['Boolean']['output'];
  mostRecentPublishedLedgerHistory?: Maybe<LedgerHistory>;
  name: Scalars['String']['output'];
  onboardingCompletedDate?: Maybe<Scalars['InclusiveDay']['output']>;
  onboardingStage: OnboardingStage;
  orgType?: Maybe<CompanyOrgType>;
  owner?: Maybe<User>;
  payrollProviders: Array<PayrollProvider>;
  payrolls?: Maybe<PayrollPaginator>;
  pendingInvitations: Array<CompanyInvitation>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  prepaids: PrepaidPaginator;
  /** @deprecated No longer supported */
  puzzleAddonSubscriptions: Array<CompanyPricingPlan>;
  puzzlePlanModalVersion?: Maybe<PuzzlePlanModalVersion>;
  /** @deprecated No longer supported */
  puzzlePlanSubscriptions: Array<CompanyPricingPlan>;
  puzzlePremiumFreeTrialStartDate?: Maybe<Scalars['DateTime']['output']>;
  puzzleSubscriptionState: CompanySubscriptionState;
  recurringTemplates: RecurringTemplatePaginator;
  referBookkeeper?: Maybe<Scalars['Boolean']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  referralUrl?: Maybe<Scalars['String']['output']>;
  revenue: CompanyRevenuePaginator;
  revenueModel?: Maybe<RevenueModel>;
  showExpenseLimits: Scalars['Boolean']['output'];
  slackChannels: Array<CompanySlackChannel>;
  slackConnectUrl: Scalars['String']['output'];
  squashJournals: Array<LedgerJournal>;
  squashSummaries: SquashSummariesResult;
  squashSummariesCsv: AsyncReportResult;
  squashingPolicies: SubLedgerSquashingPoliciesResult;
  startIngestionDate?: Maybe<Scalars['InclusiveDay']['output']>;
  stripeCustomerCount?: Maybe<Scalars['Int']['output']>;
  stripeTransactionCount?: Maybe<Scalars['Int']['output']>;
  stripeValidationRuns?: Maybe<StripeValidationRunPaginator>;
  stripeValidationRunsForAdmin?: Maybe<StripeValidationRunPaginator>;
  subLedgers: SubLedgerPaginator;
  taxPreparerPlan?: Maybe<TaxPreparerPlan>;
  timeZone?: Maybe<Scalars['String']['output']>;
  trackingId?: Maybe<Scalars['String']['output']>;
  transactions: CompanyTransactionPaginator;
  type: CompanyType;
  uniquePathname: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userProposedStartIngestionDate?: Maybe<Scalars['InclusiveDay']['output']>;
  vendorBalanceTransactions: VendorBalanceTransactionListResult;
  vendors: VendorPaginator;
  views?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  website?: Maybe<Scalars['String']['output']>;
};


export type CompanyAccountingConfigurationRulesArgs = {
  filterBy?: InputMaybe<AccountingConfigurationRuleFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<AccountingConfigurationRuleSortOrder>;
};


export type CompanyAccrualRevenueAnalysisArgs = {
  input: AccrualRevenueAnalysisInput;
};


export type CompanyAccrualRevenueAnalysisByCoaKeyArgs = {
  input: AccrualRevenueAnalysisByCoaKeyInput;
};


export type CompanyAccrualRevenueAnalysisByCustomerArgs = {
  input: AccrualRevenueAnalysisByCustomerInput;
};


export type CompanyAccuracyCheckConfigsArgs = {
  filterBy?: InputMaybe<AccuracyCheckConfigFilterBy>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<AccuracyCheckConfigSort>;
};


export type CompanyAccuracyChecksArgs = {
  filterBy?: InputMaybe<AccuracyCheckFilterBy>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<AccuracyCheckSort>;
};


export type CompanyApAgingArgs = {
  filterBy: ApAgingFilterBy;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyApAgingBillLinesArgs = {
  filterBy: ApAgingBillLinesFilterBy;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyApAgingExportArgs = {
  options: ApAgingExportOptions;
};


export type CompanyArAgingArgs = {
  filterBy: ArAgingFilterBy;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyArAgingExportArgs = {
  filterBy: ArAgingFilterBy;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyArAgingLinesArgs = {
  filterBy: ArAgingLinesFilterBy;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyBillListExportArgs = {
  options: BillListExportOptions;
};


export type CompanyBillsArgs = {
  filterBy?: InputMaybe<BillFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<BillSortOrder>;
};


export type CompanyCanLockPeriodArgs = {
  period?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyContractLinesArgs = {
  filterBy?: InputMaybe<ContractLineFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<ContractLineSortOrder>;
};


export type CompanyContractLinesGroupedByArgs = {
  options: ContractLinesGroupedByOptions;
};


export type CompanyContractRevenueSchedulesArgs = {
  filterBy?: InputMaybe<ContractRevenueScheduleFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<ContractRevenueScheduleSortOrder>;
};


export type CompanyCustomerBalanceTransactionsArgs = {
  filter?: InputMaybe<CustomerBalanceTransactionFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<CustomerBalanceTransactionSort>;
};


export type CompanyDirectIngestFileArgs = {
  id: Scalars['DirectIngestFileID']['input'];
};


export type CompanyDirectIngestFilesArgs = {
  filterBy?: InputMaybe<DirectIngestFileFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<DirectIngestFileSortOrder>;
};


export type CompanyFixedAssetsArgs = {
  filterBy?: InputMaybe<FixedAssetFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<FixedAssetSortOrder>;
};


export type CompanyInvoiceLineItemsArgs = {
  filterBy?: InputMaybe<InvoiceLineItemFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<InvoiceLineItemSortOrder>;
};


export type CompanyInvoiceListExportArgs = {
  options: InvoiceListExportOptions;
};


export type CompanyInvoicesArgs = {
  filterBy?: InputMaybe<InvoiceFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<InvoiceSortOrder>;
};


export type CompanyJournalArgs = {
  id: Scalars['ID']['input'];
};


export type CompanyLedgerEntriesForReconciliationArgs = {
  input: LedgerEntriesForReconciliationInput;
};


export type CompanyLedgerReconciliationsArgs = {
  filterBy?: InputMaybe<LedgerReconciliationFilterBy>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<ReconciliationSortOrder>;
};


export type CompanyManualJournalEntriesArgs = {
  filterBy?: InputMaybe<ManualJournalEntryFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<ManualJournalEntrySortOrder>;
};


export type CompanyManualJournalEntryGroupsArgs = {
  filterBy: ManualJournalEntryGroupFilterBy;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<ManualJournalEntryGroupSortOrder>;
};


export type CompanyPayrollsArgs = {
  filterBy?: InputMaybe<PayrollFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<PayrollSortOrder>;
};


export type CompanyPrepaidsArgs = {
  filterBy?: InputMaybe<PrepaidFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<PrepaidSortOrder>;
};


export type CompanyRecurringTemplatesArgs = {
  filterBy?: InputMaybe<RecurringTemplateFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<RecurringTemplateSortOrder>;
};


export type CompanyRevenueArgs = {
  input: CompanyRevenueInput;
};


export type CompanySquashJournalsArgs = {
  filterBy: SquashJournalsFilterBy;
};


export type CompanySquashSummariesArgs = {
  filterBy: SquashSummariesFilterBy;
};


export type CompanySquashSummariesCsvArgs = {
  filterBy: SquashSummariesFilterBy;
};


export type CompanySquashingPoliciesArgs = {
  input: SubLedgerSquashingPoliciesInput;
};


export type CompanyStripeValidationRunsArgs = {
  filterBy?: InputMaybe<StripeValidationRunFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<StripeValidationRunSortOrder>;
};


export type CompanyStripeValidationRunsForAdminArgs = {
  filterBy?: InputMaybe<StripeValidationRunFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<StripeValidationRunSortOrder>;
};


export type CompanySubLedgersArgs = {
  filterBy?: InputMaybe<SubLedgerFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<SubLedgerSortOrder>;
};


export type CompanyTransactionsArgs = {
  filterBy?: InputMaybe<TransactionFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<TransactionSortOrder>;
};


export type CompanyVendorBalanceTransactionsArgs = {
  filter?: InputMaybe<VendorBalanceTransactionFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<VendorBalanceTransactionSort>;
};


export type CompanyVendorsArgs = {
  filterBy?: InputMaybe<VendorFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<VendorSortOrder>;
};

export type CompanyArr = {
  __typename?: 'CompanyArr';
  id: Scalars['CompanyID']['output'];
  metrics?: Maybe<CompanyArrMetrics>;
  status: CompanyFinancialMetricsStatus;
};

export type CompanyArrInput = {
  asOf?: InputMaybe<Scalars['Month']['input']>;
  companyId: Scalars['CompanyID']['input'];
};

export type CompanyArrMetrics = {
  __typename?: 'CompanyArrMetrics';
  annualizedAccrualRevenue: Metric;
  annualizedRevenue: Metric;
  stripeAnnualizedRevenue: Metric;
};

export type CompanyAttributes = {
  __typename?: 'CompanyAttributes';
  howDidYouHearAboutUs?: Maybe<Scalars['String']['output']>;
  howDidYouHearAboutUsAIToolsInput?: Maybe<Scalars['String']['output']>;
  howDidYouHearAboutUsAcceleratorInput?: Maybe<Scalars['String']['output']>;
  howDidYouHearAboutUsCategory?: Maybe<HowDidYouHearAboutUsCategory>;
  howDidYouHearAboutUsEventInput?: Maybe<Scalars['String']['output']>;
  howDidYouHearAboutUsFirmInput?: Maybe<Scalars['String']['output']>;
  howDidYouHearAboutUsOther?: Maybe<Scalars['String']['output']>;
  howDidYouHearAboutUsReferer?: Maybe<Scalars['String']['output']>;
  howDidYouHearAboutUsVCInput?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  monthlyExpenses?: Maybe<MonthlyExpenses>;
  numberOfEmployees?: Maybe<NumberOfEmployees>;
  onboardingProgress?: Maybe<OnboardingProgress>;
  otherPayrollProvider?: Maybe<Scalars['String']['output']>;
  payrollProvider?: Maybe<PayrollProviderType>;
  skippedTrial?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanyAttributesInput = {
  howDidYouHearAboutUs?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearAboutUsAIToolsInput?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearAboutUsAcceleratorInput?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearAboutUsCategory?: InputMaybe<HowDidYouHearAboutUsCategory>;
  howDidYouHearAboutUsEventInput?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearAboutUsFirmInput?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearAboutUsOther?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearAboutUsReferer?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearAboutUsVCInput?: InputMaybe<Scalars['String']['input']>;
  monthlyExpenses?: InputMaybe<MonthlyExpenses>;
  numberOfEmployees?: InputMaybe<NumberOfEmployees>;
  otherPayrollProvider?: InputMaybe<Scalars['String']['input']>;
  payrollProvider?: InputMaybe<PayrollProviderType>;
  skippedTrial?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyBenefit = {
  __typename?: 'CompanyBenefit';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  postTax?: Maybe<Scalars['Boolean']['output']>;
  preTax?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanyFeatures = {
  __typename?: 'CompanyFeatures';
  accountsPayableEnabled: Scalars['Boolean']['output'];
  accrualEventsEnabled: Scalars['Boolean']['output'];
  accrualRevenueEnabled: Scalars['Boolean']['output'];
  accrualRevenueEventsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  accuracyReviewEnabled?: Maybe<Scalars['Boolean']['output']>;
  accuracyReviewEnabledUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  aiAutocategorizer?: Maybe<Scalars['Boolean']['output']>;
  aiAutocategorizerUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  aiInsightsEnabled?: Maybe<Scalars['Boolean']['output']>;
  aiInsightsEnabledUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  apPaymentsEnabled: Scalars['Boolean']['output'];
  arPaymentsEnabled: Scalars['Boolean']['output'];
  assistedCategorizationEnabled: Scalars['Boolean']['output'];
  autoConfirmContractLinesEnabled?: Maybe<Scalars['Boolean']['output']>;
  autoConfirmContractLinesUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  autoGenerateFixedAssetsEnabled: Scalars['Boolean']['output'];
  autoGenerateFixedAssetsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  autoGeneratePrepaidsEnabled: Scalars['Boolean']['output'];
  autoGeneratePrepaidsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  automaticAssignmentEnabled: Scalars['Boolean']['output'];
  automaticAssignmentUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  autonomousAccountingEnabled: Scalars['Boolean']['output'];
  billDotComSyncBillsEnabled?: Maybe<Scalars['Boolean']['output']>;
  billDotComSyncBillsEnabledUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  billDotComSyncInvoicesEnabled?: Maybe<Scalars['Boolean']['output']>;
  billDotComSyncInvoicesEnabledUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  ccReconciliationsEnabled: Scalars['Boolean']['output'];
  centralEnabled: Scalars['Boolean']['output'];
  classesAndDepartmentsEnabled: Scalars['Boolean']['output'];
  createCoaEnabled: Scalars['Boolean']['output'];
  creditCardAccuracyEnabled: Scalars['Boolean']['output'];
  detailedBenefitsEnabled: Scalars['Boolean']['output'];
  fixedAssetManualApprovalEnabled: Scalars['Boolean']['output'];
  fixedAssetManualApprovalUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  hideIntegrationsPage: Scalars['Boolean']['output'];
  hideUsersPage: Scalars['Boolean']['output'];
  ledgerReconciliationCashView: Scalars['Boolean']['output'];
  ledgerReconciliationsEnabled: Scalars['Boolean']['output'];
  lockedPeriodsEnabled: Scalars['Boolean']['output'];
  mercuryEnabled: Scalars['Boolean']['output'];
  metricCardsAdditional?: Maybe<Scalars['Boolean']['output']>;
  metricCardsCore?: Maybe<Scalars['Boolean']['output']>;
  notificationsEnabled: Scalars['Boolean']['output'];
  plaidSyncInvestmentTransactionsEnabled?: Maybe<Scalars['Boolean']['output']>;
  plaidSyncInvestmentTransactionsEnabledUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  quickBooksOnlineEnabled: Scalars['Boolean']['output'];
  rampEnabled: Scalars['Boolean']['output'];
  reconciliationEnabled: Scalars['Boolean']['output'];
  removeAccountsEnabled: Scalars['Boolean']['output'];
  reportingViewsEnabled: Scalars['Boolean']['output'];
  resetAccountsEnabled: Scalars['Boolean']['output'];
  revenueBoxEnabled: Scalars['Boolean']['output'];
  revenueRecognitionConfigurationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  ripplingAddOnSelected?: Maybe<Scalars['Boolean']['output']>;
  ripplingAddOnSelectedUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  ripplingLegacyApi: Scalars['Boolean']['output'];
  ripplingLegacyApiUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  setBalanceEnabledUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  setBalanceEventsEnabled: Scalars['Boolean']['output'];
  skipSetupChecklist: Scalars['Boolean']['output'];
  splitsEnabled: Scalars['Boolean']['output'];
  squashingEnabled: Scalars['Boolean']['output'];
  svbOfxEnabled: Scalars['Boolean']['output'];
  userMatchRulesEnabled: Scalars['Boolean']['output'];
  viewPreference?: Maybe<LedgerView>;
};

export type CompanyFilterInput = {
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CompanyFinancialMetricsStatus {
  Failed = 'Failed',
  InProgress = 'InProgress',
  Ready = 'Ready'
}

export type CompanyFinancialSummary = {
  __typename?: 'CompanyFinancialSummary';
  errors: Array<Error>;
  metrics?: Maybe<CompanyFinancialSummaryMetrics>;
  status: CompanyFinancialMetricsStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanyFinancialSummaryInput = {
  asOf?: InputMaybe<Scalars['Month']['input']>;
  companyId: Scalars['CompanyID']['input'];
};

export type CompanyFinancialSummaryMetrics = {
  __typename?: 'CompanyFinancialSummaryMetrics';
  annualAvgFullyLoadedSalaryCostPerEmployee: Money;
  annualAvgSalaryCostPerEmployee: Money;
  /** @deprecated GRO-565 No longer shown in Dashboard, these data are fake, use separate ARR endpoint */
  annualizedRevenue?: Maybe<Metric>;
  cashOutDate?: Maybe<Scalars['String']['output']>;
  cashOutDateUsingLastMonthAccrualOperatingIncomeBurn?: Maybe<Scalars['LocalDate']['output']>;
  cashOutDateUsingLastMonthBankBurn?: Maybe<Scalars['LocalDate']['output']>;
  cashOutDateUsingThreeMonthAverageAccrualOperatingIncomeBurn?: Maybe<Scalars['LocalDate']['output']>;
  cashOutDateUsingThreeMonthAverageBankBurn?: Maybe<Scalars['LocalDate']['output']>;
  cashOutDateUsingThreeMonthAverageTotalBurn?: Maybe<Scalars['String']['output']>;
  dailyTotalCash: CompanyTotalCashByDay;
  dailyTotalCashV2: CompanyTotalCashByDay;
  fundraiseDate?: Maybe<Scalars['String']['output']>;
  fundraiseDateUsingLastMonthAccrualOperatingIncomeBurn?: Maybe<Scalars['LocalDate']['output']>;
  fundraiseDateUsingLastMonthBankBurn?: Maybe<Scalars['LocalDate']['output']>;
  fundraiseDateUsingThreeMonthAverageAccrualOperatingIncomeBurn?: Maybe<Scalars['LocalDate']['output']>;
  fundraiseDateUsingThreeMonthAverageBankBurn?: Maybe<Scalars['LocalDate']['output']>;
  fundraiseDateUsingThreeMonthAverageTotalBurn?: Maybe<Scalars['LocalDate']['output']>;
  lastMonthAccrualOperatingIncomeBurn: Money;
  lastMonthAvgFullyLoadedSalaryCostPerEmployee: Money;
  lastMonthAvgSalaryCostPerEmployee: Money;
  lastMonthBankBurn: Money;
  lastMonthOperatingBurn: Money;
  lastMonthTotalBurn: Money;
  monthlyBankBurn: MetricsByMonth;
  mtdBankBurn: MtdBankBurnMetrics;
  runway?: Maybe<Scalars['Int']['output']>;
  runwayUsingLastMonthAccrualOperatingIncomeBurn?: Maybe<Scalars['Int']['output']>;
  runwayUsingLastMonthBankBurn?: Maybe<Scalars['Int']['output']>;
  runwayUsingThreeMonthAverageAccrualOperatingIncomeBurn?: Maybe<Scalars['Int']['output']>;
  runwayUsingThreeMonthAverageBankBurn?: Maybe<Scalars['Int']['output']>;
  runwayUsingThreeMonthAverageTotalBurn?: Maybe<Scalars['Int']['output']>;
  sixMonthsAccountsPayable: Array<AccountsPayable>;
  sixMonthsAccountsReceivable: Array<AccountsReceivable>;
  sixMonthsGrossMargin: Array<GrossMargin>;
  sixMonthsNetMargin: Array<NetMargin>;
  /** @deprecated GRO-565 No longer shown in Dashboard, these data are fake, use separate ARR endpoint */
  stripeAnnualizedRevenue?: Maybe<Metric>;
  threeMonthAverageAccrualOperatingIncomeBurn: Money;
  threeMonthAverageBankBurn: Money;
  threeMonthAverageOperatingBurn: Money;
  threeMonthAverageTotalBurn: Money;
  totalCash: Money;
};

export type CompanyHealthCheckResult = {
  __typename?: 'CompanyHealthCheckResult';
  accountStatuses?: Maybe<Array<HealthCheckAccountStatus>>;
  company: Company;
  events: HealthCheckEvents;
  plaid: HealthCheckPlaidStatus;
  transactions: HealthCheckTransactions;
};

export enum CompanyIngestStatus {
  Initiated = 'Initiated',
  New = 'New',
  UpToDate = 'UpToDate'
}

export type CompanyInvitation = {
  __typename?: 'CompanyInvitation';
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mfaRequired?: Maybe<Scalars['Boolean']['output']>;
  role: MembershipRole;
  updatedAt: Scalars['DateTime']['output'];
};

export enum CompanyKnockChannelKey {
  WeeklyUpdates = 'WeeklyUpdates'
}

export type CompanyMembership = {
  __typename?: 'CompanyMembership';
  company: Company;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  firm?: Maybe<Firm>;
  firmGroup?: Maybe<FirmGroup>;
  firmGroupId?: Maybe<Scalars['FirmGroupID']['output']>;
  firmId?: Maybe<Scalars['FirmID']['output']>;
  id: Scalars['ID']['output'];
  isOwner: Scalars['Boolean']['output'];
  mfaRequired?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<UserPosition>;
  role: MembershipRole;
  status: MembershipStatus;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export enum CompanyMetricsStatus {
  Error = 'Error',
  InProgress = 'InProgress',
  Ok = 'Ok'
}

export type CompanyOnboardingProgress = {
  __typename?: 'CompanyOnboardingProgress';
  configureAccountSettings?: Maybe<OnboardingStepStatus>;
  configureAutomationSettings?: Maybe<OnboardingStepStatus>;
  createCustomRules?: Maybe<OnboardingStepStatus>;
  createRevenueRecognitionPolicies?: Maybe<OnboardingStepStatus>;
  customizeChartOfAccounts?: Maybe<OnboardingStepStatus>;
  inviteTeam?: Maybe<OnboardingStepStatus>;
  setBookkeepingPlan?: Maybe<OnboardingStepStatus>;
  startHistoricalTransferProcess?: Maybe<OnboardingStepStatus>;
  verifyBankBalances?: Maybe<OnboardingStepStatus>;
};

export enum CompanyOrgType {
  CCorporation = 'CCorporation',
  Llc = 'LLC',
  Nonprofit = 'Nonprofit',
  Partnership = 'Partnership',
  ProfessionalServicesCorp = 'ProfessionalServicesCorp',
  SCorporation = 'SCorporation',
  SoleProprietorship = 'SoleProprietorship'
}

export type CompanyPricingPlan = {
  __typename?: 'CompanyPricingPlan';
  endDate: Scalars['Date']['output'];
  id: Scalars['CompanyPricingPlanID']['output'];
  plan: PuzzlePricingPlan;
  price: PuzzlePrice;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type CompanyRevenueInput = {
  facet: RevenueFacet;
  page?: InputMaybe<PageInput>;
  periods: Array<ReportTimePeriodInput>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyRevenuePaginator = {
  __typename?: 'CompanyRevenuePaginator';
  annualizedRevenue: Scalars['Decimal']['output'];
  items: Array<RevenueItem>;
  pageInfo: PageInfo;
  periods: Array<RevenuePeriod>;
  periodsTotal: Scalars['Decimal']['output'];
};

export enum CompanySetting {
  IntegrationConnectionDisabled = 'integration_connection_disabled',
  InviteUserDisabled = 'invite_user_disabled',
  SquashingEnabled = 'squashing_enabled'
}

export enum CompanySettingFeatureName {
  AccrualRevenueEventsEnabled = 'AccrualRevenueEventsEnabled',
  AccuracyReviewEnabled = 'AccuracyReviewEnabled',
  AiAutocategorizer = 'AiAutocategorizer',
  AiInsightsEnabled = 'AiInsightsEnabled',
  AutoConfirmContractLinesEnabled = 'AutoConfirmContractLinesEnabled',
  AutoGenerateFixedAssetsEnabled = 'AutoGenerateFixedAssetsEnabled',
  AutoGeneratePrepaidsEnabled = 'AutoGeneratePrepaidsEnabled',
  AutomaticAssignmentEnabled = 'AutomaticAssignmentEnabled',
  BillDotComSyncBillsEnabled = 'BillDotComSyncBillsEnabled',
  BillDotComSyncInvoicesEnabled = 'BillDotComSyncInvoicesEnabled',
  FixedAssetManualApprovalEnabled = 'FixedAssetManualApprovalEnabled',
  PlaidSyncInvestmentTransactionsEnabled = 'PlaidSyncInvestmentTransactionsEnabled',
  RipplingAddOnSelected = 'RipplingAddOnSelected',
  RipplingLegacyApi = 'RipplingLegacyApi',
  SetBalanceEventsEnabled = 'SetBalanceEventsEnabled'
}

export type CompanySlackChannel = {
  __typename?: 'CompanySlackChannel';
  channelId?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  knockChannelKey: CompanyKnockChannelKey;
  subscribed: Scalars['Boolean']['output'];
};

export type CompanySquashingPolicy = {
  __typename?: 'CompanySquashingPolicy';
  account?: Maybe<Account>;
  effectiveFromInclusive?: Maybe<Scalars['InclusiveDay']['output']>;
  effectiveToInclusive?: Maybe<Scalars['InclusiveDay']['output']>;
  id: Scalars['CompanySquashingPolicyID']['output'];
  subLedgerType: SubLedgerType;
};

export type CompanyStats = {
  __typename?: 'CompanyStats';
  averageCostPerEmployee: Scalars['Decimal']['output'];
  averageRevenuePerEmployee: Scalars['Decimal']['output'];
  currentToFutureEmployeeRatio: Scalars['String']['output'];
  employeeCostAsPercentageOfExpense: Scalars['Decimal']['output'];
  lastMonthEmployeeCosts: Scalars['Decimal']['output'];
  lastMonthExpenses: Scalars['Decimal']['output'];
  lastMonthRevenue: Scalars['Decimal']['output'];
};

export type CompanySubscriptionState = {
  __typename?: 'CompanySubscriptionState';
  activePlan?: Maybe<PuzzleSubscription>;
  billedPlan?: Maybe<PuzzleSubscription>;
  downgrades: Array<PuzzlePlan>;
  id?: Maybe<Scalars['CompanyID']['output']>;
  upgrades: Array<PuzzlePlan>;
};

export type CompanyTotalCashByDay = {
  __typename?: 'CompanyTotalCashByDay';
  metrics: Array<AmountOnDateMetric>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanyTransactionPaginator = {
  __typename?: 'CompanyTransactionPaginator';
  assignedToMeCount: Scalars['Int']['output'];
  metadata: CompanyTransactionPaginatorMetadata;
  nodes: Array<Transaction>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyTransactionPaginatorMetadata = {
  __typename?: 'CompanyTransactionPaginatorMetadata';
  absoluteValueTotal: Scalars['Decimal']['output'];
  gain: Scalars['Decimal']['output'];
  loss: Scalars['Decimal']['output'];
  sum: Scalars['Decimal']['output'];
};

export enum CompanyType {
  Advertising = 'ADVERTISING',
  AgricultureAndFarming = 'AGRICULTURE_AND_FARMING',
  Construction = 'CONSTRUCTION',
  /** @deprecated No longer supported */
  Consumer = 'CONSUMER',
  Ecommerce = 'ECOMMERCE',
  /** @deprecated No longer supported */
  Enterprise = 'ENTERPRISE',
  Fintech = 'FINTECH',
  FintechCrypto = 'FINTECH_CRYPTO',
  Healthcare = 'HEALTHCARE',
  HomeServices = 'HOME_SERVICES',
  Legal = 'LEGAL',
  Manufacturing = 'MANUFACTURING',
  /** @deprecated No longer supported */
  Marketplace = 'MARKETPLACE',
  MediaAndEntertainment = 'MEDIA_AND_ENTERTAINMENT',
  NotSure = 'NOT_SURE',
  Other = 'OTHER',
  ProfessionalServices = 'PROFESSIONAL_SERVICES',
  RealEstate = 'REAL_ESTATE',
  Restaurant = 'RESTAURANT',
  Retail = 'RETAIL',
  Saas = 'SAAS',
  /** @deprecated No longer supported */
  Services = 'SERVICES',
  Transportation = 'TRANSPORTATION',
  VirtualGoods = 'VIRTUAL_GOODS',
  WholesaleTrade = 'WHOLESALE_TRADE'
}

export type Comparator = {
  __typename?: 'Comparator';
  operand1: Scalars['Int']['output'];
  operand2?: Maybe<Scalars['Int']['output']>;
  operandType: CompareOperandType;
  operator: CompareOperator;
  percentageDenominator?: Maybe<PercentageDenominator>;
};

export type ComparatorInput = {
  operand1: Scalars['Int']['input'];
  operand2?: InputMaybe<Scalars['Int']['input']>;
  operandType: CompareOperandType;
  operator: CompareOperator;
  percentageDenominator?: InputMaybe<PercentageDenominator>;
};

export enum CompareOperandType {
  Count = 'COUNT',
  Dollars = 'DOLLARS',
  NumberOfMonths = 'NUMBER_OF_MONTHS',
  Percentage = 'PERCENTAGE'
}

export enum CompareOperator {
  GreaterThan = 'GREATER_THAN',
  IsBetween = 'IS_BETWEEN',
  IsNotBetween = 'IS_NOT_BETWEEN',
  LessThan = 'LESS_THAN'
}

export type Config = {
  __typename?: 'Config';
  amplitude: Amplitude;
  bugsnag: Bugsnag;
  gatewayEnv: GatewayEnvironment;
  googleClientId: Scalars['String']['output'];
  hireExpenseDefaults: HireExpenseDefaults;
  plaidPublicKey: Scalars['String']['output'];
  plaidWebhookUrl: Scalars['String']['output'];
};

export type ConfigsInputs = {
  transaction?: InputMaybe<TransactionConfigInput>;
};

export type ConfirmContractLineAccountingOptions = {
  calculation?: InputMaybe<AccountingRecognitionCalculation>;
  category?: InputMaybe<Scalars['LedgerCoaKey']['input']>;
  firstPeriodAllocation?: InputMaybe<FirstPeriodAllocation>;
  timing: AccountingRecognitionTiming;
};

export type ConfirmContractLineInput = {
  accountingConfigurationId?: InputMaybe<Scalars['AccountingConfigurationID']['input']>;
  accountingOptions?: InputMaybe<ConfirmContractLineAccountingOptions>;
  contractLineId: Scalars['ContractLineID']['input'];
  updateOptions?: InputMaybe<ConfirmContractLineUpdateOptions>;
};

export type ConfirmContractLineUpdateOptions = {
  customerId?: InputMaybe<Scalars['CustomerID']['input']>;
  dateRange?: InputMaybe<InclusiveLocalDateRangeInput>;
  manualEntries?: InputMaybe<Array<ManualRevenueScheduleEntryInput>>;
  productId?: InputMaybe<Scalars['ProductID']['input']>;
};

export type ConfirmContractLinesConfiguration = {
  accountingConfigurationId?: InputMaybe<Scalars['AccountingConfigurationID']['input']>;
  /** @deprecated accountingOptions not supported with confirm contract lines in bulk. Use accountingConfigurationId instead */
  accountingOptions?: InputMaybe<ConfirmContractLineAccountingOptions>;
};

export type ConfirmContractLinesError = {
  __typename?: 'ConfirmContractLinesError';
  contractLineId: Scalars['ContractLineID']['output'];
  errorMessage: Scalars['String']['output'];
};

export type ConfirmContractLinesInput = {
  companyId: Scalars['CompanyID']['input'];
  configuration?: InputMaybe<ConfirmContractLinesConfiguration>;
  criteria: ContractLinesFilter;
  recognitionPeriod?: InputMaybe<ContractLineRecognitionPeriod>;
};

export type ConfirmContractLinesResult = {
  __typename?: 'ConfirmContractLinesResult';
  /** @deprecated Processed async - so errors unknown when responding */
  errors?: Maybe<Array<ConfirmContractLinesError>>;
  /** @deprecated Processed async - so success unknown when responding */
  successIds?: Maybe<Array<Scalars['ContractLineID']['output']>>;
};

export enum ConfirmEmailVerificationError {
  CodeExpired = 'CODE_EXPIRED',
  CodeInvalid = 'CODE_INVALID'
}

export type ConfirmEmailVerificationInput = {
  code: Scalars['String']['input'];
};

export type ConfirmEmailVerificationResult = {
  __typename?: 'ConfirmEmailVerificationResult';
  error?: Maybe<ConfirmEmailVerificationError>;
  success: Scalars['Boolean']['output'];
};

export type ConfirmMergedWorkersInput = {
  companyId: Scalars['CompanyID']['input'];
  contractorsToConfirm?: InputMaybe<Array<MergedContractorsToConfirm>>;
  employeesToConfirm?: InputMaybe<Array<MergedEmployeesToConfirm>>;
};

export type ConfirmMergedWorkersResult = {
  __typename?: 'ConfirmMergedWorkersResult';
  success: Scalars['Boolean']['output'];
};

export type ConnectBillDotComInput = {
  companyId: Scalars['ID']['input'];
  condition?: InputMaybe<IntegrationConnectionCondition>;
  connectionName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type ConnectBillDotComResult = {
  __typename?: 'ConnectBillDotComResult';
  connection: IntegrationConnection;
};

export type ConnectBrexInput = {
  code: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  condition?: InputMaybe<IntegrationConnectionCondition>;
  connectionName?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type ConnectBrexResult = {
  __typename?: 'ConnectBrexResult';
  connection: IntegrationConnection;
};

export type ConnectDeelInput = {
  code: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  condition?: InputMaybe<IntegrationConnectionCondition>;
  connectionName?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type ConnectDeelResult = {
  __typename?: 'ConnectDeelResult';
  connection: IntegrationConnection;
};

export type ConnectFinicityInput = {
  companyId: Scalars['ID']['input'];
  condition?: InputMaybe<IntegrationConnectionCondition>;
  customerId: Scalars['String']['input'];
  institutionName: Scalars['String']['input'];
};

export type ConnectFinicityResult = {
  __typename?: 'ConnectFinicityResult';
  connection: IntegrationConnection;
  financialInstitution: FinancialInstitution;
};

export type ConnectGustoInput = {
  code: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  condition?: InputMaybe<IntegrationConnectionCondition>;
  connectionName?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectGustoResult = {
  __typename?: 'ConnectGustoResult';
  connection: IntegrationConnection;
};

export type ConnectMeowInput = {
  code: Scalars['String']['input'];
  companyId: Scalars['CompanyID']['input'];
  condition?: InputMaybe<IntegrationConnectionCondition>;
  connectionName?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type ConnectMeowResult = {
  __typename?: 'ConnectMeowResult';
  connection: IntegrationConnection;
};

export type ConnectMercuryInput = {
  code: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  condition?: InputMaybe<IntegrationConnectionCondition>;
  connectionName?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type ConnectMercuryResult = {
  __typename?: 'ConnectMercuryResult';
  connection: IntegrationConnection;
};

export type ConnectPartnerUserToPuzzleUserInput = {
  companyId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ConnectPartnerUserToPuzzleUserResult = {
  __typename?: 'ConnectPartnerUserToPuzzleUserResult';
  apiUser: ApiUser;
};

export type ConnectPlaidInput = {
  companyId: Scalars['ID']['input'];
  condition?: InputMaybe<IntegrationConnectionCondition>;
  institutionId: Scalars['String']['input'];
  institutionName: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
};

export type ConnectPlaidResult = {
  __typename?: 'ConnectPlaidResult';
  connection: IntegrationConnection;
  financialInstitution: FinancialInstitution;
};

export type ConnectQuickbooksInput = {
  code: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  connectionName?: InputMaybe<Scalars['String']['input']>;
  realmId: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type ConnectQuickbooksResult = {
  __typename?: 'ConnectQuickbooksResult';
  connection: IntegrationConnection;
};

export type ConnectRampInput = {
  code: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  condition?: InputMaybe<IntegrationConnectionCondition>;
  connectionName?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type ConnectRampResult = {
  __typename?: 'ConnectRampResult';
  connection: IntegrationConnection;
};

export type ConnectRipplingInput = {
  code: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  condition?: InputMaybe<IntegrationConnectionCondition>;
  connectionName?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectRipplingResult = {
  __typename?: 'ConnectRipplingResult';
  connection: IntegrationConnection;
};

export type ConnectStripeInput = {
  code: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  condition?: InputMaybe<IntegrationConnectionCondition>;
  connectionName?: InputMaybe<Scalars['String']['input']>;
  enableAccruals?: InputMaybe<Scalars['Boolean']['input']>;
  state: Scalars['String']['input'];
};

export type ConnectStripeResult = {
  __typename?: 'ConnectStripeResult';
  connection: IntegrationConnection;
};

export type ConnectSvbOfxInput = {
  companyId: Scalars['ID']['input'];
  condition?: InputMaybe<IntegrationConnectionCondition>;
  pin: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type ConnectSvbOfxResult = {
  __typename?: 'ConnectSvbOfxResult';
  connection: IntegrationConnection;
};

export type ConnectToPuzzleSlackAppInput = {
  code: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
};

export type ConnectToPuzzleSlackAppResponse = {
  __typename?: 'ConnectToPuzzleSlackAppResponse';
  success: Scalars['Boolean']['output'];
};

export type ConnectTrinetInput = {
  companyId: Scalars['ID']['input'];
  triNetCompanyId: Scalars['String']['input'];
};

export type ConnectTrinetResult = {
  __typename?: 'ConnectTrinetResult';
  connection: IntegrationConnection;
};

export type Connection = {
  __typename?: 'Connection';
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: ConnectionStatus;
};

export type ConnectionRequestContextInput = {
  requestId: Scalars['ID']['input'];
};

export type ConnectionRequestContextResult = {
  __typename?: 'ConnectionRequestContextResult';
  partner: ApiPartner;
  scopes: Array<ExternalApiScopeInfo>;
};

export enum ConnectionStatus {
  Error = 'ERROR',
  Initializing = 'INITIALIZING',
  Ok = 'OK',
  Warning = 'WARNING'
}

export type ConsentToAiInput = {
  companyId: Scalars['ID']['input'];
  consent: Scalars['Boolean']['input'];
};

export type Contract = {
  __typename?: 'Contract';
  contractDate?: Maybe<Scalars['LocalDate']['output']>;
  contractLines?: Maybe<Array<ContractLine>>;
  customer?: Maybe<Customer>;
  id: Scalars['ContractID']['output'];
  status: ContractStatus;
};

export type ContractFilterBy = {
  createdAtRange?: InputMaybe<InclusiveLocalDateRangeInput>;
  statuses?: InputMaybe<Array<ContractStatus>>;
};

export type ContractLine = {
  __typename?: 'ContractLine';
  accountingConfiguration?: Maybe<RevenueRecognitionConfiguration>;
  accountingConfigurationId?: Maybe<Scalars['AccountingConfigurationID']['output']>;
  amount: Money;
  contract: Contract;
  description?: Maybe<Scalars['String']['output']>;
  endDay?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['ContractLineID']['output'];
  invoiceDiscountLines?: Maybe<Array<InvoiceDiscountLine>>;
  invoiceLines?: Maybe<Array<InvoiceLine>>;
  ledgerCategory?: Maybe<LedgerCategory>;
  product?: Maybe<Product>;
  schedule?: Maybe<ContractRevenueSchedule>;
  startDay?: Maybe<Scalars['LocalDate']['output']>;
  userConfirmationStatus: ContractLineUserConfirmationStatus;
};

export type ContractLineFilterBy = {
  accountingConfigurations?: InputMaybe<Array<InputMaybe<Scalars['AccountingConfigurationID']['input']>>>;
  coaKeys?: InputMaybe<Array<Scalars['LedgerCoaKey']['input']>>;
  contractDayRange?: InputMaybe<InclusiveLocalDateRangeInput>;
  maxAmount?: InputMaybe<Scalars['Decimal']['input']>;
  minAmount?: InputMaybe<Scalars['Decimal']['input']>;
  recognitionPeriodDayRange?: InputMaybe<InclusiveLocalDateRangeInput>;
  statuses?: InputMaybe<Array<ContractStatus>>;
  userConfirmationStatuses?: InputMaybe<Array<ContractLineUserConfirmationStatus>>;
};

export type ContractLineGroup = {
  __typename?: 'ContractLineGroup';
  accountingConfiguration?: Maybe<RevenueRecognitionConfiguration>;
  contractDate?: Maybe<Scalars['LocalDate']['output']>;
  count: Scalars['Int']['output'];
  customer?: Maybe<Customer>;
  ledgerCategory?: Maybe<LedgerCategory>;
  period?: Maybe<Scalars['Period']['output']>;
  product?: Maybe<Product>;
  total: Money;
};

export type ContractLineInput = {
  amount: MoneyInput;
  coaKey: Scalars['LedgerCoaKey']['input'];
  description: Scalars['String']['input'];
  endDay: Scalars['LocalDate']['input'];
  productId: Scalars['ProductID']['input'];
  startDay: Scalars['LocalDate']['input'];
};

export type ContractLineItemAmounts = {
  __typename?: 'ContractLineItemAmounts';
  deferred: Money;
  recognized: Money;
  total: Money;
};

export type ContractLinePaginator = {
  __typename?: 'ContractLinePaginator';
  amounts: ContractLineItemAmounts;
  contractLines: Array<ContractLine>;
  pageInfo: PageInfo;
};

export type ContractLineRecognitionDate = {
  customDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type ContractLineRecognitionDateRange = {
  customDateRange?: InputMaybe<InclusiveLocalDateRangeInput>;
};

export type ContractLineRecognitionPeriod = {
  recognitionDate?: InputMaybe<ContractLineRecognitionDate>;
  recognitionDateRange?: InputMaybe<ContractLineRecognitionDateRange>;
};

export enum ContractLineSortOrder {
  ContractDateAsc = 'CONTRACT_DATE_ASC',
  ContractDateDesc = 'CONTRACT_DATE_DESC'
}

export enum ContractLineUserConfirmationStatus {
  AutoConfirmed = 'autoConfirmed',
  Confirmed = 'confirmed',
  Draft = 'draft',
  Unconfirmed = 'unconfirmed',
  Voided = 'voided'
}

export type ContractLinesFilter = {
  contractLineIds: Array<Scalars['ContractLineID']['input']>;
};

export enum ContractLinesGroupBy {
  Category = 'CATEGORY',
  Customer = 'CUSTOMER',
  Day = 'DAY',
  Month = 'MONTH',
  Policy = 'POLICY',
  Product = 'PRODUCT',
  Quarter = 'QUARTER',
  Year = 'YEAR'
}

export type ContractLinesGroupByPaginator = {
  __typename?: 'ContractLinesGroupByPaginator';
  amounts: ContractLineItemAmounts;
  contractLineGroups: Array<ContractLineGroup>;
  pageInfo: PageInfo;
};

export enum ContractLinesGroupBySortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type ContractLinesGroupedByOptions = {
  filterBy?: InputMaybe<ContractLineFilterBy>;
  groupBy: ContractLinesGroupBy;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<ContractLinesGroupBySortOrder>;
};

export type ContractRevenueSchedule = {
  __typename?: 'ContractRevenueSchedule';
  accruedRevenue: ContractRevenueScheduleAccruedRevenue;
  amortizationMethod: ContractRevenueScheduleAmortizationMethod;
  companyId: Scalars['CompanyID']['output'];
  contractLine: ContractLine;
  endDay?: Maybe<Scalars['LocalDate']['output']>;
  firstPeriodConvention?: Maybe<ContractRevenueScheduleAmortizationFirstPeriodConvention>;
  id: Scalars['ContractRevenueScheduleID']['output'];
  /** @deprecated Use contractLine->invoiceLines instead */
  invoiceLine?: Maybe<InvoiceLine>;
  manualEntries?: Maybe<Array<ManualRevenueScheduleEntry>>;
  periods?: Maybe<Array<RevenueSchedulePeriod>>;
  postingMethod?: Maybe<ContractRevenueSchedulePostingMethod>;
  startDay?: Maybe<Scalars['LocalDate']['output']>;
  status: ContractRevenueScheduleStatus;
};

export type ContractRevenueScheduleAccruedRevenue = {
  __typename?: 'ContractRevenueScheduleAccruedRevenue';
  deferred: Money;
  recognized: Money;
};

export enum ContractRevenueScheduleAmortizationFirstPeriodConvention {
  Full = 'FULL',
  Half = 'HALF',
  Mid = 'MID',
  Zero = 'ZERO'
}

export enum ContractRevenueScheduleAmortizationMethod {
  Days360 = 'days360',
  DaysActual = 'daysActual',
  Manual = 'manual',
  StraightLineDaily = 'straightLineDaily'
}

export type ContractRevenueScheduleFilterBy = {
  coaKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  customerIds?: InputMaybe<Array<Scalars['CustomerID']['input']>>;
  searchDayRange?: InputMaybe<InclusiveLocalDateRangeInput>;
  statuses?: InputMaybe<Array<ContractRevenueScheduleStatus>>;
};

export type ContractRevenueSchedulePaginator = {
  __typename?: 'ContractRevenueSchedulePaginator';
  items: Array<ContractRevenueSchedule>;
  pageInfo: PageInfo;
  total: Money;
};

export enum ContractRevenueSchedulePostingMethod {
  Automatically = 'automatically',
  UserConfirm = 'userConfirm'
}

export enum ContractRevenueScheduleSortOrder {
  StartDayOrderAsc = 'START_DAY_ORDER_ASC',
  StartDayOrderDesc = 'START_DAY_ORDER_DESC'
}

export enum ContractRevenueScheduleStatus {
  Active = 'active',
  Closed = 'closed',
  Draft = 'draft',
  Paused = 'paused'
}

export enum ContractSortOrder {
  InsertOrderAsc = 'INSERT_ORDER_ASC',
  InsertOrderDesc = 'INSERT_ORDER_DESC'
}

export enum ContractStatus {
  Active = 'active',
  Closed = 'closed',
  Draft = 'draft',
  Paused = 'paused'
}

export type Contractor = {
  __typename?: 'Contractor';
  businessName?: Maybe<Scalars['String']['output']>;
  contractorCompensations: Array<ContractorCompensation>;
  dataSourceType: DataSourceType;
  department?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  hourlyRate?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  mergeInfo?: Maybe<MergedContractor>;
  payRate: Scalars['Decimal']['output'];
  startDate: Scalars['LocalDate']['output'];
  type: ContractorType;
  wageType: ContractorWageType;
};

export type ContractorCompensation = {
  __typename?: 'ContractorCompensation';
  grossPay: Scalars['Decimal']['output'];
  netPay: Scalars['Decimal']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  payroll: Payroll;
};

export enum ContractorContractType {
  Commission = 'Commission',
  Employee = 'Employee',
  EmployerOfRecord = 'EmployerOfRecord',
  GlobalPayroll = 'GlobalPayroll',
  HrisDirectEmployee = 'HRISDirectEmployee',
  Milestones = 'Milestones',
  OngoingTimeBased = 'OngoingTimeBased',
  PayAsYouGoMilestones = 'PayAsYouGoMilestones',
  PayAsYouGoTasks = 'PayAsYouGoTasks',
  PayAsYouGoTimeBased = 'PayAsYouGoTimeBased',
  ShieldMsa = 'ShieldMSA',
  TimeBased = 'TimeBased',
  Unknown = 'Unknown'
}

export enum ContractorType {
  Business = 'Business',
  Individual = 'Individual'
}

export enum ContractorWageType {
  Annually = 'Annually',
  Biweekly = 'Biweekly',
  Custom = 'Custom',
  Daily = 'Daily',
  Fixed = 'Fixed',
  Hourly = 'Hourly',
  Monthly = 'Monthly',
  Semimonthly = 'Semimonthly',
  Weekly = 'Weekly'
}

export enum CorporateEntityType {
  CCorporation = 'CCorporation',
  Llc = 'LLC',
  NonProfit = 'NonProfit',
  SCorporation = 'SCorporation',
  SoleProprietor = 'SoleProprietor'
}

export type CounterpartyFilter = {
  id: Scalars['ID']['input'];
  type: CounterpartyType;
};

export enum CounterpartyType {
  Contractor = 'contractor',
  Customer = 'customer',
  Employee = 'employee',
  Vendor = 'vendor'
}

export type CreateAccountingConfigurationRuleInput = {
  accountingConfigurationId: Scalars['AccountingConfigurationID']['input'];
  companyId: Scalars['CompanyID']['input'];
  criteria: AccountingConfigurationRuleCriteriaInput;
  enabled: Scalars['Boolean']['input'];
  isAutoConfirm: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateAdminCategorizationRuleInput = {
  appliesTo?: InputMaybe<Array<CategorizationRuleApplicationType>>;
  confidence: CategoryConfidence;
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  ledgerCoaKey?: InputMaybe<Scalars['String']['input']>;
  matchEntireString?: InputMaybe<Scalars['Boolean']['input']>;
  maxAmountInclusive?: InputMaybe<Scalars['Decimal']['input']>;
  minAmountInclusive?: InputMaybe<Scalars['Decimal']['input']>;
  rule: Scalars['String']['input'];
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdminCategorizationRuleResult = {
  __typename?: 'CreateAdminCategorizationRuleResult';
  matchRule: AdminCategorizationRule;
};

export type CreateAffiliateAttributionInput = {
  companyId: Scalars['CompanyID']['input'];
  name: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type CreateAffiliateAttributionResponse = {
  __typename?: 'CreateAffiliateAttributionResponse';
  attribution: AffiliateAttribution;
};

export type CreateApiConnectionInput = {
  callbackUris: Array<Scalars['String']['input']>;
  dataSourceTypeId?: InputMaybe<Scalars['Int']['input']>;
  hasWebhooksEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  loginKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
  requiresFitTest?: InputMaybe<Scalars['Boolean']['input']>;
  supportsRedirect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateClassSegmentInput = {
  companyId: Scalars['CompanyID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['TagValueDisplayName']['input'];
  reportingClassId: Scalars['TagNameID']['input'];
};

export type CreateCoaInput = {
  accountNumber: Scalars['String']['input'];
  accountType: Scalars['String']['input'];
  category: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  currentness?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  entityId?: InputMaybe<Scalars['ID']['input']>;
  examples?: InputMaybe<Scalars['String']['input']>;
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  parentAccountId?: InputMaybe<Scalars['ID']['input']>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  tertiaryCategory?: InputMaybe<Scalars['String']['input']>;
  views: Array<Scalars['String']['input']>;
};

export type CreateCoaResult = {
  __typename?: 'CreateCoaResult';
  coaKey: Scalars['String']['output'];
  displayId: Scalars['String']['output'];
};

export type CreateCompanyFromPrefilledDataInput = {
  prefilledOnboardingId: Scalars['ID']['input'];
};

export type CreateCompanyFromPrefilledDataResult = {
  __typename?: 'CreateCompanyFromPrefilledDataResult';
  company: Company;
  errors: Array<Error>;
};

export type CreateCompanyInput = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  attributes?: InputMaybe<CompanyAttributesInput>;
  coaType?: InputMaybe<CoaType>;
  currentUserRole?: InputMaybe<UserPosition>;
  e2eHighPriority?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hasHistoricalData?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated No longer supported */
  howDidYouHearAboutUs?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated No longer supported */
  howDidYouHearAboutUsOther?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated No longer supported */
  howDidYouHearAboutUsReferer?: InputMaybe<Scalars['String']['input']>;
  isFreshStart?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  orgType?: InputMaybe<CompanyOrgType>;
  partnerConnectionRequestId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  referringPartner?: InputMaybe<Scalars['String']['input']>;
  revenueModel: RevenueModel;
  skipOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  startIngestionDate?: InputMaybe<Scalars['InclusiveDay']['input']>;
  timeZone: Scalars['String']['input'];
  type: CompanyType;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompanyResult = {
  __typename?: 'CreateCompanyResult';
  company: Company;
};

export type CreateCompanyRoleResult = {
  __typename?: 'CreateCompanyRoleResult';
  company: Company;
};

export type CreateCompanySpendingResetInput = {
  companyId: Scalars['CompanyID']['input'];
  resetDate?: InputMaybe<Scalars['InclusiveDay']['input']>;
};

export type CreateCompanySpendingResetResult = {
  __typename?: 'CreateCompanySpendingResetResult';
  success: Scalars['Boolean']['output'];
};

export type CreateContractInput = {
  companyId: Scalars['CompanyID']['input'];
  contractDate: Scalars['LocalDate']['input'];
  contractLineInputs: Array<ContractLineInput>;
  customerId: Scalars['CustomerID']['input'];
  status: ContractStatus;
};

export type CreateContractLinesInput = {
  contractId: Scalars['ContractID']['input'];
  contractLines: Array<ContractLineInput>;
};

export type CreateContractLinesResult = {
  __typename?: 'CreateContractLinesResult';
  contractLines: Array<ContractLine>;
};

export type CreateContractRevenueScheduleInput = {
  accountingConfigurationId?: InputMaybe<Scalars['AccountingConfigurationID']['input']>;
  /** @deprecated typo; Use accountingConfigurationId */
  accoutingConfigurationId?: InputMaybe<Scalars['AccountingConfigurationID']['input']>;
  amortizationMethod?: InputMaybe<ContractRevenueScheduleAmortizationMethod>;
  companyId: Scalars['CompanyID']['input'];
  dateRange?: InputMaybe<InclusiveLocalDateRangeInput>;
  firstPeriodConvention?: InputMaybe<ContractRevenueScheduleAmortizationFirstPeriodConvention>;
  initialAmortizationPeriod?: InputMaybe<Scalars['Period']['input']>;
  invoiceDiscountLineId?: InputMaybe<Scalars['InvoiceDiscountLineID']['input']>;
  invoiceLineItemId?: InputMaybe<Scalars['InvoiceLineItemID']['input']>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  manualEntries?: InputMaybe<Array<ManualRevenueScheduleEntryInput>>;
  postingMethod?: InputMaybe<ContractRevenueSchedulePostingMethod>;
};

export type CreateCustomerInput = {
  billingAddressJson?: InputMaybe<Scalars['JSON']['input']>;
  companyId: Scalars['ID']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CustomerStatus>;
  type?: InputMaybe<CustomerType>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerResult = {
  __typename?: 'CreateCustomerResult';
  customer: Customer;
};

export type CreateDirectIngestFileCoaKeysInput = {
  companyId: Scalars['CompanyID']['input'];
  file: ClientFileInput;
  headerMapping?: InputMaybe<DirectIngestFileCoaKeysHeaderMapping>;
};

export type CreateDirectIngestFileCoaKeysResult = {
  __typename?: 'CreateDirectIngestFileCoaKeysResult';
  directIngestFile: DirectIngestFileCoaKeys;
};

export type CreateDirectIngestFileCoaMapperInput = {
  companyId: Scalars['CompanyID']['input'];
  file: ClientFileInput;
  headerMapping?: InputMaybe<DirectIngestFileCoaMapperHeaderMapping>;
};

export type CreateDirectIngestFileCoaMapperResult = {
  __typename?: 'CreateDirectIngestFileCoaMapperResult';
  directIngestFile: DirectIngestFileCoaMapper;
};

export type CreateDirectIngestFileManualJournalEntriesInput = {
  companyId: Scalars['CompanyID']['input'];
  file: ClientFileInput;
  headerMapping?: InputMaybe<DirectIngestFileJournalEntryHeaderMapping>;
  isHistorical: Scalars['Boolean']['input'];
  view: LedgerView;
};

export type CreateDirectIngestFileManualJournalEntriesResult = {
  __typename?: 'CreateDirectIngestFileManualJournalEntriesResult';
  directIngestFile: DirectIngestFileManualJournalEntries;
};

export type CreateFixedAssetInput = {
  capitalizedAt?: InputMaybe<Scalars['LocalDate']['input']>;
  companyId: Scalars['CompanyID']['input'];
  currency?: InputMaybe<Scalars['Currency']['input']>;
  depreciationMethod?: InputMaybe<FixedAssetDepreciationMethod>;
  description?: InputMaybe<Scalars['String']['input']>;
  inServiceAt?: InputMaybe<Scalars['LocalDate']['input']>;
  originalValue?: InputMaybe<Scalars['Decimal']['input']>;
  salvageValue?: InputMaybe<Scalars['Decimal']['input']>;
  status?: InputMaybe<FixedAssetStatus>;
  type?: InputMaybe<FixedAssetType>;
  usefulLifeMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateFixedAssetRuleCategoryInput = {
  coaKey: Scalars['String']['input'];
};

export type CreateFixedAssetRuleInput = {
  categories?: InputMaybe<Array<CreateFixedAssetRuleCategoryInput>>;
  companyId: Scalars['CompanyID']['input'];
  depreciationMethod: FixedAssetDepreciationMethod;
  firstMonthConvention: FirstMonthConvention;
  minimumQualifyingAmount: MoneyInput;
  type: FixedAssetType;
  usefulLifeMonths: Scalars['Int']['input'];
  vendors?: InputMaybe<Array<CreateFixedAssetRuleVendorInput>>;
};

export type CreateFixedAssetRuleVendorInput = {
  vendorId: Scalars['CompanyVendorID']['input'];
};

export type CreateFixedAssetsInput = {
  companyId: Scalars['CompanyID']['input'];
  inputs: Array<CreateFixedAssetInput>;
};

export type CreateFixedAssetsResult = {
  __typename?: 'CreateFixedAssetsResult';
  error?: Maybe<Scalars['String']['output']>;
  fixedAssets?: Maybe<Array<FixedAsset>>;
};

export type CreateInvoiceInput = {
  accountId?: InputMaybe<Scalars['AccountID']['input']>;
  companyId: Scalars['CompanyID']['input'];
  customerId: Scalars['CustomerID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  issueDate: Scalars['LocalDate']['input'];
  lines: Array<CreateInvoiceLineInput>;
  status?: InputMaybe<InvoiceStatus>;
};

export type CreateInvoiceLineInput = {
  amount: Scalars['Decimal']['input'];
  coaKey: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ProductID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  revRecOptions?: InputMaybe<InvoiceLineRevRecOptionsInput>;
  schedule?: InputMaybe<CreateInvoiceLineSchedule>;
  segments?: InputMaybe<Array<UpsertClassSegmentInput>>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateInvoiceLineSchedule = {
  dateRange: InclusiveLocalDateRangeInput;
  postingMethod?: InputMaybe<ContractRevenueSchedulePostingMethod>;
};

export enum CreateManualAccountError {
  DuplicateAccount = 'DUPLICATE_ACCOUNT'
}

export type CreateManualAccountInput = {
  balance: Scalars['Decimal']['input'];
  companyId: Scalars['ID']['input'];
  institutionName: Scalars['String']['input'];
  mask: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subType?: InputMaybe<AccountSubType>;
  type: AccountType;
};

export type CreateManualAccountResult = {
  __typename?: 'CreateManualAccountResult';
  account?: Maybe<Account>;
  error?: Maybe<CreateManualAccountError>;
};

export type CreateManualTransactionsInput = {
  accountId: Scalars['AccountID']['input'];
  companyId: Scalars['CompanyID']['input'];
  transactions: Array<ManualTransactionInput>;
};

export type CreateNewTestCompanyInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<SeedWithTestDataOptions>;
  replaceCompanyId: Scalars['CompanyID']['input'];
};

export type CreatePartnerAdBookkeepingCriteriaInput = {
  maxCashBalance?: InputMaybe<Scalars['Int']['input']>;
  maxMonthlyExpenses?: InputMaybe<Scalars['Int']['input']>;
  maxMonthlyRevenue?: InputMaybe<Scalars['Int']['input']>;
  minCashBalance?: InputMaybe<Scalars['Int']['input']>;
  minMonthlyExpenses?: InputMaybe<Scalars['Int']['input']>;
  minMonthlyRevenue?: InputMaybe<Scalars['Int']['input']>;
  orgType?: InputMaybe<CompanyOrgType>;
};

export type CreatePartnerAdInput = {
  affiliateUrl?: InputMaybe<Scalars['String']['input']>;
  bookkeepingCriteria?: InputMaybe<CreatePartnerAdBookkeepingCriteriaInput>;
  calendarUrl?: InputMaybe<Scalars['String']['input']>;
  displayOrder: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isFeatured: Scalars['Boolean']['input'];
  logoDarkId: Scalars['ID']['input'];
  logoDarkUrl: Scalars['String']['input'];
  logoLightId: Scalars['ID']['input'];
  logoLightUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: PartnerAdType;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePayrollInput = {
  accountId: Scalars['AccountID']['input'];
  benefits: Array<BenefitInput>;
  checkDate: Scalars['LocalDate']['input'];
  companyId: Scalars['CompanyID']['input'];
  contractorPaymentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  employeeTaxes: Scalars['Decimal']['input'];
  employerTaxes: Scalars['Decimal']['input'];
  grossPay: Scalars['Decimal']['input'];
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  netPay: Scalars['Decimal']['input'];
  payPeriod?: InputMaybe<InclusiveLocalDateRangeInput>;
  withdrawalDate: Scalars['LocalDate']['input'];
};

export type CreatePrepaidInput = {
  companyId: Scalars['CompanyID']['input'];
  date: Scalars['LocalDate']['input'];
  description: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  expenseRecognitionMethod: ExpenseRecognitionMethod;
  ledgerCoaKey: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<PrepaidStatus>;
  total: MoneyInput;
  vendorId?: InputMaybe<Scalars['CompanyVendorID']['input']>;
};

export type CreateProductInput = {
  companyId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  priceRate?: InputMaybe<Scalars['Decimal']['input']>;
  serviceType?: InputMaybe<ProductServiceType>;
  sku?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductStatus>;
};

export type CreateProductResult = {
  __typename?: 'CreateProductResult';
  product: Product;
};

export type CreatePuzzleAdminUserInput = {
  email: Scalars['String']['input'];
};

export type CreatePuzzleAdminUserResult = {
  __typename?: 'CreatePuzzleAdminUserResult';
  puzzleAdminUser: PuzzleAdminUser;
};

export type CreateRecurringForFixedAssetInput = {
  companyId: Scalars['CompanyID']['input'];
  currency: Scalars['Currency']['input'];
  depreciationAmount: Scalars['Decimal']['input'];
  endAfterOccurrences: Scalars['Int']['input'];
  fixedAssetId: Scalars['FixedAssetID']['input'];
  intervalUnit: RecurringTemplateIntervalUnit;
  post?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['LocalDate']['input'];
};

export type CreateRecurringManualJournalEntryTemplateInput = {
  companyId: Scalars['CompanyID']['input'];
  manualJournalEntryInput: UpsertManualJournalEntryInput;
  recurringTemplateInput: CreateRecurringTemplateInput;
};

export type CreateRecurringTemplateInput = {
  companyId: Scalars['CompanyID']['input'];
  endAfterOccurrences?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  intervalCount: Scalars['Int']['input'];
  intervalDay?: InputMaybe<Scalars['Int']['input']>;
  intervalMonth?: InputMaybe<Scalars['Int']['input']>;
  intervalUnit: RecurringTemplateIntervalUnit;
  intervalWeek?: InputMaybe<Scalars['Int']['input']>;
  intervalWeekday?: InputMaybe<Scalars['Int']['input']>;
  linkedId?: InputMaybe<Scalars['ID']['input']>;
  linkedType?: InputMaybe<RecurringTemplateLinkedType>;
  name: Scalars['String']['input'];
  post?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['LocalDate']['input'];
};

export type CreateReportingClassInput = {
  companyId: Scalars['CompanyID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['TagNameDisplayName']['input'];
};

export type CreateStripeCheckoutSessionInput = {
  applyFirstMonthCoupon?: InputMaybe<Scalars['Boolean']['input']>;
  cancelUrl: Scalars['String']['input'];
  companyId: Scalars['CompanyID']['input'];
  facebookClickId?: InputMaybe<Scalars['String']['input']>;
  facebookPixelId?: InputMaybe<Scalars['String']['input']>;
  googleClickId?: InputMaybe<Scalars['String']['input']>;
  stripePriceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  successUrl: Scalars['String']['input'];
};

export type CreateUserCategorizationRuleInput = {
  accountTypes?: InputMaybe<Array<AccountType>>;
  accounts?: InputMaybe<Array<Scalars['AccountID']['input']>>;
  appliesTo?: InputMaybe<Array<CategorizationRuleApplicationType>>;
  companyId: Scalars['CompanyID']['input'];
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  ledgerCoaKey?: InputMaybe<Scalars['String']['input']>;
  matchEntireString?: InputMaybe<Scalars['Boolean']['input']>;
  maxAmountInclusive?: InputMaybe<Scalars['Decimal']['input']>;
  minAmountInclusive?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  replaceRuleId?: InputMaybe<Scalars['ID']['input']>;
  rule: Scalars['String']['input'];
  segmentIds?: InputMaybe<Array<Scalars['TagValueID']['input']>>;
  vendorPermaName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserCategorizationRuleResult = {
  __typename?: 'CreateUserCategorizationRuleResult';
  matchRule: UserCategorizationRule;
};

export type CreateVendorInput = {
  addressJson?: InputMaybe<Scalars['JSON']['input']>;
  companyId: Scalars['ID']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['Currency']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  is1099Vendor?: InputMaybe<YesNoUnknown>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<VendorStatus>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxIdType?: InputMaybe<TaxIdType>;
  type?: InputMaybe<VendorType>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVendorResult = {
  __typename?: 'CreateVendorResult';
  vendor: Vendor;
};

export type CreditCardAccuracyStatus = LedgerAccountStatus & {
  __typename?: 'CreditCardAccuracyStatus';
  difference: Scalars['Decimal']['output'];
  providerBalance: Scalars['Decimal']['output'];
  puzzleBalance: Scalars['Decimal']['output'];
  since: Scalars['DateTime']['output'];
  type: LedgerAccountStatusType;
  value: LedgerAccountStatusValue;
};

export type CustomChecklistItem = ChecklistItem & MonthlyChecklistItem & {
  __typename?: 'CustomChecklistItem';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<User>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key?: Maybe<ChecklistItemKey>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<User>;
  month: Scalars['Month']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  removedBy?: Maybe<User>;
  repeat: Scalars['Boolean']['output'];
};

export type CustomChecklistItemInput = {
  companyId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  month: Scalars['Month']['input'];
  repeat?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Customer = {
  __typename?: 'Customer';
  accrualRevenueAnalysis?: Maybe<AccrualRevenueAnalysis>;
  billingAddressJson?: Maybe<Scalars['JSON']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<CustomerDocument>>>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceStats: InvoiceStatsResult;
  /** @deprecated No longer supported */
  invoices?: Maybe<InvoicePaginator>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  receivableBalance: ReceivableBalance;
  status?: Maybe<CustomerStatus>;
  type?: Maybe<CustomerType>;
  website?: Maybe<Scalars['String']['output']>;
};


export type CustomerInvoiceStatsArgs = {
  filterBy?: InputMaybe<InvoiceFilterBy>;
};

export type CustomerBalanceMatch = {
  __typename?: 'CustomerBalanceMatch';
  amount: Money;
  customerBalanceTransaction?: Maybe<CustomerBalanceTransaction>;
  groupId: Scalars['CustomerBalanceMatchGroupID']['output'];
  id: Scalars['CustomerBalanceMatchID']['output'];
  invoice?: Maybe<Invoice>;
};

export type CustomerBalanceTransaction = {
  __typename?: 'CustomerBalanceTransaction';
  amount: Money;
  appliedBalance: AppliedBalance;
  customer?: Maybe<Customer>;
  date: Scalars['LocalDate']['output'];
  description: Scalars['String']['output'];
  events: Array<LedgerEvent>;
  id: Scalars['CustomerBalanceTransactionID']['output'];
  matches: Array<CustomerBalanceMatch>;
  method: CustomerBalanceTransactionMethod;
  /** @deprecated Use appliedBalance instead */
  receivableBalance: ReceivableBalance;
  transaction?: Maybe<Transaction>;
  type: CustomerBalanceTransactionType;
};

export type CustomerBalanceTransactionFilter = {
  amountMax?: InputMaybe<Scalars['Decimal']['input']>;
  amountMin?: InputMaybe<Scalars['Decimal']['input']>;
  currency?: InputMaybe<Scalars['Currency']['input']>;
  dateRange?: InputMaybe<OpenEndedDateRangeInput>;
  isCleared?: InputMaybe<Scalars['Boolean']['input']>;
  methods?: InputMaybe<Array<CustomerBalanceTransactionMethod>>;
  types?: InputMaybe<Array<CustomerBalanceTransactionType>>;
};

export type CustomerBalanceTransactionListResult = {
  __typename?: 'CustomerBalanceTransactionListResult';
  items: Array<CustomerBalanceTransaction>;
  pageInfo: PageInfo;
};

export type CustomerBalanceTransactionMatchInput = {
  id: Scalars['CustomerBalanceTransactionID']['input'];
  transactionId?: InputMaybe<Scalars['TransactionID']['input']>;
};

export enum CustomerBalanceTransactionMatchType {
  Invoice = 'INVOICE'
}

export type CustomerBalanceTransactionMatchesInput = {
  amount: Scalars['Decimal']['input'];
  relatedId: Scalars['ID']['input'];
  relatedType: CustomerBalanceTransactionMatchType;
};

export enum CustomerBalanceTransactionMethod {
  BankPayment = 'BANK_PAYMENT',
  Cash = 'CASH',
  Check = 'CHECK',
  CreditCard = 'CREDIT_CARD',
  Other = 'OTHER',
  PaymentProcessor = 'PAYMENT_PROCESSOR'
}

export enum CustomerBalanceTransactionSort {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC'
}

export enum CustomerBalanceTransactionType {
  Payment = 'PAYMENT'
}

export type CustomerBalanceTransactionsToMatchesInput = {
  balanceTransactions: Array<CustomerBalanceTransactionMatchInput>;
  matches: Array<CustomerBalanceTransactionMatchesInput>;
};

export type CustomerDocument = {
  __typename?: 'CustomerDocument';
  file: File;
};

export type CustomerFilterBy = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<CustomerSource>;
  status?: InputMaybe<CustomerStatus>;
  type?: InputMaybe<CustomerType>;
};

export type CustomerMappingResult = {
  __typename?: 'CustomerMappingResult';
  id: Scalars['CompanyID']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
};

export type CustomerPaginator = {
  __typename?: 'CustomerPaginator';
  items: Array<Customer>;
  pageInfo: PageInfo;
};

export type CustomerQueryInput = {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export enum CustomerSortOrder {
  InsertOrderAsc = 'INSERT_ORDER_ASC',
  InsertOrderDesc = 'INSERT_ORDER_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum CustomerSource {
  System = 'System',
  User = 'User'
}

export enum CustomerStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Unknown = 'Unknown'
}

export enum CustomerType {
  Business = 'Business',
  Individual = 'Individual',
  Unknown = 'Unknown'
}

export type DataAnomalyReview = {
  grade: DataAnomalyReviewGrade;
  id: Scalars['DataAnomalyReviewId']['output'];
  name: DataAnomalyReviewName;
};

export enum DataAnomalyReviewGrade {
  Fail = 'fail',
  Pass = 'pass'
}

export type DataAnomalyReviewInput = {
  accountId?: InputMaybe<Scalars['AccountID']['input']>;
  companyId: Scalars['CompanyID']['input'];
  name: DataAnomalyReviewName;
  period?: InputMaybe<Scalars['Period']['input']>;
};

export enum DataAnomalyReviewName {
  AccountEndingBalanceReview = 'account_ending_balance_review',
  PayrollClearingBalance = 'payroll_clearing_balance',
  UncategorizedExpenses = 'uncategorized_expenses',
  UncategorizedReimbursements = 'uncategorized_reimbursements',
  UncategorizedRevenue = 'uncategorized_revenue',
  UnlinkedCcPayments = 'unlinked_cc_payments',
  UnlinkedTransfers = 'unlinked_transfers'
}

export type DataAnomalyReviewResult = {
  __typename?: 'DataAnomalyReviewResult';
  review: DataAnomalyReview;
};

export enum DataCompletenessLevel {
  Complete = 'Complete',
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export type DataSourceType = {
  __typename?: 'DataSourceType';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** @deprecated No longer supported */
  kind?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type DataSourceTypeAccountStats = {
  __typename?: 'DataSourceTypeAccountStats';
  activeCount: Scalars['Int']['output'];
  archivedCount: Scalars['Int']['output'];
  deletedCount: Scalars['Int']['output'];
  hiddenCount: Scalars['Int']['output'];
};

export type DateAmount = {
  __typename?: 'DateAmount';
  amount: Scalars['Decimal']['output'];
  date: Scalars['String']['output'];
};

export type DateCashlikeAmount = {
  __typename?: 'DateCashlikeAmount';
  amount: CashlikeAmount;
  date: Scalars['String']['output'];
};

export type DateRange = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type DateTimeRangeInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type DeactivateCategorizationRuleInput = {
  id: Scalars['ID']['input'];
};

export type DeactivateCategorizationRuleResult = {
  __typename?: 'DeactivateCategorizationRuleResult';
  matchRule: ManualCategorizationRule;
};

export type DeelInitializationInfo = {
  __typename?: 'DeelInitializationInfo';
  connectUrl: Scalars['String']['output'];
};


export type DeelInitializationInfoConnectUrlArgs = {
  companyId: Scalars['ID']['input'];
};

export type DeelIntegration = {
  __typename?: 'DeelIntegration';
  connection?: Maybe<IntegrationConnection>;
  connections?: Maybe<Array<IntegrationConnection>>;
  initializationInfo: DeelInitializationInfo;
};


export type DeelIntegrationConnectionArgs = {
  companyId: Scalars['ID']['input'];
};


export type DeelIntegrationConnectionsArgs = {
  companyId: Scalars['ID']['input'];
};

export type DeleteBillLinkInput = {
  billId: Scalars['BillID']['input'];
  bundleId: Scalars['TransactionLinkBundleID']['input'];
};

export type DeleteBillLinkResult = {
  __typename?: 'DeleteBillLinkResult';
  bill: Bill;
};

export type DeleteCompanyDataResult = {
  __typename?: 'DeleteCompanyDataResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteContractRevenueScheduleInput = {
  contractRevenueScheduleId: Scalars['ContractRevenueScheduleID']['input'];
};

export type DeleteContractRevenueScheduleResult = {
  __typename?: 'DeleteContractRevenueScheduleResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteContractRevenueSchedulesInput = {
  companyId: Scalars['CompanyID']['input'];
  contractRevenueScheduleIds: Array<Scalars['ContractRevenueScheduleID']['input']>;
};

export type DeleteContractRevenueSchedulesResult = {
  __typename?: 'DeleteContractRevenueSchedulesResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteFileInput = {
  entityType: AssociatedEntity;
  fileId: Scalars['ID']['input'];
};

export type DeleteFileResult = {
  __typename?: 'DeleteFileResult';
  entityType: AssociatedEntity;
  fileId: Scalars['ID']['output'];
};

export type DeleteFixedAssetInput = {
  companyId: Scalars['CompanyID']['input'];
  id: Scalars['FixedAssetID']['input'];
};

export type DeleteFixedAssetResult = {
  __typename?: 'DeleteFixedAssetResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteFixedAssetRuleInput = {
  companyId: Scalars['CompanyID']['input'];
  id: Scalars['FixedAssetRuleID']['input'];
};

export type DeleteFixedAssetRuleResult = {
  __typename?: 'DeleteFixedAssetRuleResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteInvoiceInput = {
  invoiceId: Scalars['InvoiceID']['input'];
};

export type DeleteLedgerReconciliationInput = {
  companyId: Scalars['ID']['input'];
  ledgerReconciliationId: Scalars['LedgerReconciliationID']['input'];
};

export type DeleteLedgerReconciliationResult = {
  __typename?: 'DeleteLedgerReconciliationResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteLinkInput = {
  bundleId?: InputMaybe<Scalars['TransactionLinkBundleID']['input']>;
  companyId: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
};

export type DeleteLinkResult = {
  __typename?: 'DeleteLinkResult';
  link: TransactionLink;
};

export type DeletePayrollInput = {
  companyId: Scalars['ID']['input'];
  payrollId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type DeletePayrollResult = {
  __typename?: 'DeletePayrollResult';
  success: Scalars['Boolean']['output'];
};

export type DeletePrepaidInput = {
  companyId: Scalars['CompanyID']['input'];
  id: Scalars['PrepaidID']['input'];
};

export type DeletePrepaidResult = {
  __typename?: 'DeletePrepaidResult';
  success: Scalars['Boolean']['output'];
};

export type DeletePuzzleAdminUserInput = {
  email: Scalars['String']['input'];
};

export type DeletePuzzleAdminUserResult = {
  __typename?: 'DeletePuzzleAdminUserResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteSplitInput = {
  transactionId: Scalars['ID']['input'];
};

export type DeleteSplitResult = {
  __typename?: 'DeleteSplitResult';
  transaction: Transaction;
};

export type DeleteTransactionInput = {
  companyId: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
  unposted: Scalars['Boolean']['input'];
};

export type DeleteTransactionResult = {
  __typename?: 'DeleteTransactionResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteTransactionsInput = {
  companyId: Scalars['ID']['input'];
  transactionIds: Array<Scalars['ID']['input']>;
  unposted: Scalars['Boolean']['input'];
};

export type DeleteTransactionsResult = {
  __typename?: 'DeleteTransactionsResult';
  failedIds: Array<Maybe<Scalars['ID']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteUserTransactionInput = {
  id: Scalars['ID']['input'];
};

export type DepartmentCount = {
  __typename?: 'DepartmentCount';
  count: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DepartmentMetric = {
  __typename?: 'DepartmentMetric';
  amount: Money;
  headCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum DetailConfirmedState {
  AiAssigned = 'AI_ASSIGNED',
  Automated = 'AUTOMATED',
  Finalized = 'FINALIZED',
  Locked = 'LOCKED',
  UserAssigned = 'USER_ASSIGNED',
  UserRuleAssigned = 'USER_RULE_ASSIGNED'
}

export type DirectIngestBillInput = {
  amount: Scalars['Decimal']['input'];
  currency?: InputMaybe<Scalars['Currency']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['LocalDate']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  groupingId: Scalars['Int']['input'];
  issueDate: Scalars['LocalDate']['input'];
  lineAmount?: InputMaybe<Scalars['Decimal']['input']>;
  lineCoaKey?: InputMaybe<Scalars['String']['input']>;
  lineCurrency?: InputMaybe<Scalars['Currency']['input']>;
  lineDescription?: InputMaybe<Scalars['String']['input']>;
  lineQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  lineUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  vendor: Scalars['String']['input'];
};

export type DirectIngestBillsInput = {
  bills: Array<DirectIngestBillInput>;
  companyId: Scalars['ID']['input'];
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
};

export type DirectIngestBillsResult = {
  __typename?: 'DirectIngestBillsResult';
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  savedCount: Scalars['Int']['output'];
};

export type DirectIngestCoaKeyRow = {
  __typename?: 'DirectIngestCoaKeyRow';
  accountNumber?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  currentness?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  errors: Array<RowError>;
  examples?: Maybe<Scalars['String']['output']>;
  financialAccountBalance?: Maybe<Scalars['String']['output']>;
  financialAccountMask?: Maybe<Scalars['String']['output']>;
  financialAccountName?: Maybe<Scalars['String']['output']>;
  financialAccountSubType?: Maybe<Scalars['String']['output']>;
  financialAccountType?: Maybe<Scalars['String']['output']>;
  financialInstitutionName?: Maybe<Scalars['String']['output']>;
  id: Scalars['DirectIngestCoaKeyRowID']['output'];
  isParent?: Maybe<Scalars['String']['output']>;
  parentAccountId?: Maybe<Scalars['String']['output']>;
  rowNumber: Scalars['Int']['output'];
  rowType?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  tertiaryCategory?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Scalars['String']['output']>;
};

export type DirectIngestCoaKeyRowInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  currentness?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  examples?: InputMaybe<Scalars['String']['input']>;
  financialAccountBalance?: InputMaybe<Scalars['String']['input']>;
  financialAccountMask?: InputMaybe<Scalars['String']['input']>;
  financialAccountName?: InputMaybe<Scalars['String']['input']>;
  financialAccountSubType?: InputMaybe<Scalars['String']['input']>;
  financialAccountType?: InputMaybe<Scalars['String']['input']>;
  financialInstitutionName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['DirectIngestCoaKeyRowID']['input']>;
  isParent?: InputMaybe<Scalars['String']['input']>;
  parentAccountId?: InputMaybe<Scalars['String']['input']>;
  rowType?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  tertiaryCategory?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['String']['input']>;
};

export type DirectIngestCoaKeyRowPaginator = {
  __typename?: 'DirectIngestCoaKeyRowPaginator';
  nodes: Array<DirectIngestCoaKeyRow>;
  pageInfo: PageInfo;
};

export type DirectIngestCoaKeyRowsInput = {
  rows: Array<DirectIngestCoaKeyRowInput>;
};

export type DirectIngestCoaKeyRowsResult = {
  __typename?: 'DirectIngestCoaKeyRowsResult';
  rows: Array<DirectIngestCoaKeyRow>;
};

export type DirectIngestCoaMapperRow = {
  __typename?: 'DirectIngestCoaMapperRow';
  accountCategory?: Maybe<Scalars['String']['output']>;
  accountDescription?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<Scalars['String']['output']>;
  displayId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  errors: Array<RowError>;
  examples?: Maybe<Scalars['String']['output']>;
  id: Scalars['DirectIngestCoaMapperRowID']['output'];
  keywords?: Maybe<Scalars['String']['output']>;
  rowNumber: Scalars['Int']['output'];
};

export type DirectIngestCoaMapperRowPaginator = {
  __typename?: 'DirectIngestCoaMapperRowPaginator';
  nodes: Array<DirectIngestCoaMapperRow>;
  pageInfo: PageInfo;
};

export type DirectIngestFile = DirectIngestFileCoaKeys | DirectIngestFileCoaMapper | DirectIngestFileCustomers | DirectIngestFileManualJournalEntries | DirectIngestFileVendors;

export type DirectIngestFileCoaKeys = {
  __typename?: 'DirectIngestFileCoaKeys';
  createdAt: Scalars['DateTime']['output'];
  errors?: Maybe<Array<Scalars['String']['output']>>;
  file: File;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['DirectIngestFileID']['output'];
  rowErrors?: Maybe<Array<RowErrors>>;
  rows: DirectIngestCoaKeyRowPaginator;
  status: DirectIngestFileStatus;
  type: DirectIngestFileType;
};

export type DirectIngestFileCoaKeysHeaderMapping = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  currentness?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  examples?: InputMaybe<Scalars['String']['input']>;
  financialAccountBalance?: InputMaybe<Scalars['String']['input']>;
  financialAccountMask?: InputMaybe<Scalars['String']['input']>;
  financialAccountName?: InputMaybe<Scalars['String']['input']>;
  financialAccountSubType?: InputMaybe<Scalars['String']['input']>;
  financialAccountType?: InputMaybe<Scalars['String']['input']>;
  financialInstitutionName?: InputMaybe<Scalars['String']['input']>;
  isParent?: InputMaybe<Scalars['String']['input']>;
  parentAccountId?: InputMaybe<Scalars['String']['input']>;
  rowType?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  tertiaryCategory?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['String']['input']>;
};

export type DirectIngestFileCoaMapper = {
  __typename?: 'DirectIngestFileCoaMapper';
  createdAt: Scalars['DateTime']['output'];
  errors?: Maybe<Array<Scalars['String']['output']>>;
  file: File;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['DirectIngestFileID']['output'];
  resultInfo?: Maybe<CoaMapperResult>;
  rowErrors?: Maybe<Array<RowErrors>>;
  rows: DirectIngestCoaMapperRowPaginator;
  status: DirectIngestFileStatus;
  type: DirectIngestFileType;
};

export type DirectIngestFileCoaMapperHeaderMapping = {
  accountCategory?: InputMaybe<Scalars['String']['input']>;
  accountDescription?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<Scalars['String']['input']>;
  displayId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  examples?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
};

export type DirectIngestFileCustomers = {
  __typename?: 'DirectIngestFileCustomers';
  createdAt: Scalars['DateTime']['output'];
  errors?: Maybe<Array<Scalars['String']['output']>>;
  file: File;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['DirectIngestFileID']['output'];
  rowErrors?: Maybe<Array<RowErrors>>;
  status: DirectIngestFileStatus;
  type: DirectIngestFileType;
};

export type DirectIngestFileFilterBy = {
  statuses?: InputMaybe<Array<DirectIngestFileStatus>>;
  types?: InputMaybe<Array<DirectIngestFileType>>;
};

export type DirectIngestFileJournalEntryHeaderMapping = {
  groupingId?: InputMaybe<Scalars['String']['input']>;
  itemAccountDisplayId?: InputMaybe<Scalars['String']['input']>;
  itemAmount?: InputMaybe<Scalars['String']['input']>;
  itemClasses?: InputMaybe<Scalars['String']['input']>;
  itemCurrency?: InputMaybe<Scalars['String']['input']>;
  itemCustomer?: InputMaybe<Scalars['String']['input']>;
  itemDescription?: InputMaybe<Scalars['String']['input']>;
  itemEmployee?: InputMaybe<Scalars['String']['input']>;
  itemLocation?: InputMaybe<Scalars['String']['input']>;
  itemProductOrService?: InputMaybe<Scalars['String']['input']>;
  itemTransactionType?: InputMaybe<Scalars['String']['input']>;
  itemVendor?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  postingDate?: InputMaybe<Scalars['String']['input']>;
  rowType?: InputMaybe<Scalars['String']['input']>;
};

export type DirectIngestFileManualJournalEntries = {
  __typename?: 'DirectIngestFileManualJournalEntries';
  createdAt: Scalars['DateTime']['output'];
  errors?: Maybe<Array<Scalars['String']['output']>>;
  file: File;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['DirectIngestFileID']['output'];
  isHistorical: Scalars['Boolean']['output'];
  rowErrors?: Maybe<Array<RowErrors>>;
  rows: DirectIngestJournalEntryRowPaginator;
  status: DirectIngestFileStatus;
  type: DirectIngestFileType;
  view: LedgerView;
};


export type DirectIngestFileManualJournalEntriesRowsArgs = {
  pageInput?: InputMaybe<PageInput>;
};

export type DirectIngestFileRowInput = {
  coaKeys?: InputMaybe<DirectIngestCoaKeyRowsInput>;
  journalEntries?: InputMaybe<DirectIngestJournalEntryRowsInput>;
};

export enum DirectIngestFileSortOrder {
  InsertOrderAsc = 'INSERT_ORDER_ASC',
  InsertOrderDesc = 'INSERT_ORDER_DESC'
}

export enum DirectIngestFileStatus {
  Error = 'ERROR',
  Ingested = 'INGESTED',
  Ingesting = 'INGESTING',
  New = 'NEW',
  ParsedFailed = 'PARSED_FAILED',
  ParsedPassed = 'PARSED_PASSED',
  Parsing = 'PARSING',
  Validating = 'VALIDATING',
  ValidationFailed = 'VALIDATION_FAILED',
  ValidationPassed = 'VALIDATION_PASSED'
}

export enum DirectIngestFileType {
  CoaKeys = 'COA_KEYS',
  CoaMapper = 'COA_MAPPER',
  Customers = 'CUSTOMERS',
  ManualJournalEntries = 'MANUAL_JOURNAL_ENTRIES',
  Vendors = 'VENDORS'
}

export type DirectIngestFileVendors = {
  __typename?: 'DirectIngestFileVendors';
  createdAt: Scalars['DateTime']['output'];
  errors?: Maybe<Array<Scalars['String']['output']>>;
  file: File;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['DirectIngestFileID']['output'];
  rowErrors?: Maybe<Array<RowErrors>>;
  status: DirectIngestFileStatus;
  type: DirectIngestFileType;
};

export type DirectIngestFilesPaginator = {
  __typename?: 'DirectIngestFilesPaginator';
  nodes: Array<DirectIngestFile>;
  pageInfo: PageInfo;
};

export type DirectIngestJournalEntryRow = {
  __typename?: 'DirectIngestJournalEntryRow';
  errors: Array<RowError>;
  groupingId?: Maybe<Scalars['String']['output']>;
  id: Scalars['DirectIngestJournalEntryRowID']['output'];
  itemAccountDisplayId?: Maybe<Scalars['String']['output']>;
  itemAmount?: Maybe<Scalars['String']['output']>;
  itemClasses?: Maybe<Scalars['String']['output']>;
  itemCurrency?: Maybe<Scalars['String']['output']>;
  itemCustomer?: Maybe<Scalars['String']['output']>;
  itemDescription?: Maybe<Scalars['String']['output']>;
  itemEmployee?: Maybe<Scalars['String']['output']>;
  itemLocation?: Maybe<Scalars['String']['output']>;
  itemProductOrService?: Maybe<Scalars['String']['output']>;
  itemTransactionType?: Maybe<Scalars['String']['output']>;
  itemVendor?: Maybe<Scalars['String']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  postingDate?: Maybe<Scalars['String']['output']>;
  rowNumber: Scalars['Int']['output'];
  rowType?: Maybe<Scalars['String']['output']>;
};

export type DirectIngestJournalEntryRowInput = {
  groupingId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['DirectIngestJournalEntryRowID']['input']>;
  itemAccountDisplayId?: InputMaybe<Scalars['String']['input']>;
  itemAmount?: InputMaybe<Scalars['String']['input']>;
  itemClasses?: InputMaybe<Scalars['String']['input']>;
  itemCurrency?: InputMaybe<Scalars['String']['input']>;
  itemCustomer?: InputMaybe<Scalars['String']['input']>;
  itemDescription?: InputMaybe<Scalars['String']['input']>;
  itemEmployee?: InputMaybe<Scalars['String']['input']>;
  itemLocation?: InputMaybe<Scalars['String']['input']>;
  itemProductOrService?: InputMaybe<Scalars['String']['input']>;
  itemTransactionType?: InputMaybe<Scalars['String']['input']>;
  itemVendor?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  postingDate?: InputMaybe<Scalars['String']['input']>;
  rowNumber?: InputMaybe<Scalars['Int']['input']>;
  rowType?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type DirectIngestJournalEntryRowPaginator = {
  __typename?: 'DirectIngestJournalEntryRowPaginator';
  nodes: Array<DirectIngestJournalEntryRow>;
  pageInfo: PageInfo;
};

export type DirectIngestJournalEntryRowsInput = {
  rows: Array<DirectIngestJournalEntryRowInput>;
  view: LedgerView;
};

export type DirectIngestJournalEntryRowsResult = {
  __typename?: 'DirectIngestJournalEntryRowsResult';
  rows: Array<DirectIngestJournalEntryRow>;
};

export type DirectIngestLedgerHistoryBalanceInput = {
  endingDate: Scalars['LocalDate']['input'];
  lines: Array<DirectIngestLedgerHistoryBalanceLineInput>;
};

export type DirectIngestLedgerHistoryBalanceLineInput = {
  accountDisplayId: Scalars['String']['input'];
  amount: Scalars['Decimal']['input'];
  currency?: InputMaybe<Scalars['Currency']['input']>;
  ledgerCoaKey: Scalars['String']['input'];
};

export type DirectIngestLedgerHistoryInput = {
  balances: Array<DirectIngestLedgerHistoryBalanceInput>;
  companyId: Scalars['CompanyID']['input'];
  contentType: Scalars['String']['input'];
  currency?: InputMaybe<Scalars['Currency']['input']>;
  filename: Scalars['String']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  views: Array<LedgerView>;
};

export type DirectIngestLedgerHistoryResult = {
  __typename?: 'DirectIngestLedgerHistoryResult';
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ledgerHistory?: Maybe<LedgerHistory>;
  savedCount: Scalars['Int']['output'];
};

export type DirectIngestManualJournalEntriesInput = {
  companyId: Scalars['CompanyID']['input'];
  contentType: Scalars['String']['input'];
  directIngestManualJournalEntries: Array<DirectIngestManualJournalEntryInput>;
  filename: Scalars['String']['input'];
  isHistorical: Scalars['Boolean']['input'];
  path: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  view: LedgerView;
};

export type DirectIngestManualJournalEntriesResult = {
  __typename?: 'DirectIngestManualJournalEntriesResult';
  id: Scalars['DirectIngestHistoryID']['output'];
  savedCount: Scalars['Int']['output'];
};

export type DirectIngestManualJournalEntryInput = {
  groupingId: Scalars['String']['input'];
  itemAccountDisplayId: Scalars['String']['input'];
  itemAmount: Scalars['Decimal']['input'];
  itemCurrency?: InputMaybe<Scalars['Currency']['input']>;
  itemCustomer?: InputMaybe<Scalars['String']['input']>;
  itemDescription?: InputMaybe<Scalars['String']['input']>;
  itemEmployee?: InputMaybe<Scalars['String']['input']>;
  itemProductOrService?: InputMaybe<Scalars['String']['input']>;
  itemSegments?: InputMaybe<Array<UpsertClassSegmentInput>>;
  itemTransactionType?: InputMaybe<Scalars['String']['input']>;
  itemVendor?: InputMaybe<Scalars['String']['input']>;
  memo: Scalars['String']['input'];
  postingDate: Scalars['LocalDate']['input'];
};

export type DirectIngestResult = {
  __typename?: 'DirectIngestResult';
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  savedCount: Scalars['Int']['output'];
};

export type DirectIngestTransactionInput = {
  amount: Scalars['Decimal']['input'];
  date: Scalars['String']['input'];
  description: Scalars['String']['input'];
};

export type DirectIngestTransactionsInput = {
  accountId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  transactions: Array<DirectIngestTransactionInput>;
};

export type DisconnectIntegrationInput = {
  connectionId: Scalars['ID']['input'];
};

export type DisconnectResult = {
  __typename?: 'DisconnectResult';
  disconnected: Scalars['Boolean']['output'];
};

export enum DisconnectionErrorCode {
  AddOnPaymentNotCompleted = 'AddOnPaymentNotCompleted',
  ExternalError = 'ExternalError',
  InsufficientPermissions = 'InsufficientPermissions',
  InternalError = 'InternalError',
  InvalidMfa = 'InvalidMfa',
  ItemLocked = 'ItemLocked',
  ItemNotSupported = 'ItemNotSupported',
  LoginRequired = 'LoginRequired',
  MfaNotSupported = 'MfaNotSupported',
  NativeSourceAvailable = 'NativeSourceAvailable',
  NoAccounts = 'NoAccounts',
  TooMuchData = 'TooMuchData'
}

export type DisposeFixedAssetInput = {
  disposedAt: Scalars['LocalDate']['input'];
  id: Scalars['FixedAssetID']['input'];
  proceeds?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum DynamicReportType {
  BalanceSheet = 'BalanceSheet',
  CashActivityReport = 'CashActivityReport',
  FsTrialBalance = 'FsTrialBalance',
  ProfitAndLoss = 'ProfitAndLoss',
  TrialBalance = 'TrialBalance'
}

export type EditManualJournalEntryGroupInput = {
  groupId: Scalars['ManualJournalEntryGroupID']['input'];
  items: Array<UpsertManualJournalEntryItemInput>;
  manualJournalEntryGroupEditType: ManualJournalEntryGroupEditType;
  memo?: InputMaybe<Scalars['String']['input']>;
};

export type Employee = {
  __typename?: 'Employee';
  companyBenefitContribution: Scalars['Decimal']['output'];
  dataSourceType: DataSourceType;
  department?: Maybe<Scalars['String']['output']>;
  employeeBenefitContribution: Scalars['Decimal']['output'];
  employeeCompensations: Array<EmployeeCompensation>;
  employeeTerminations: Array<EmployeeTermination>;
  employmentType: EmploymentType;
  firstName: Scalars['String']['output'];
  flsaStatus?: Maybe<FlsaStatus>;
  id: Scalars['ID']['output'];
  jobTitle: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  mergeInfo?: Maybe<MergedEmployee>;
  officeLocation: OfficeLocation;
  payFrequency: PayFrequency;
  payRate: Scalars['Decimal']['output'];
  startDate: Scalars['LocalDate']['output'];
  terminated: Scalars['Boolean']['output'];
  yearlyCost?: Maybe<Scalars['Decimal']['output']>;
};

export type EmployeeCompensation = {
  __typename?: 'EmployeeCompensation';
  employeeBenefits: Scalars['Decimal']['output'];
  employeeTaxes: Scalars['Decimal']['output'];
  employerBenefits: Scalars['Decimal']['output'];
  employerTaxes: Scalars['Decimal']['output'];
  fixed: Scalars['Decimal']['output'];
  grossPay: Scalars['Decimal']['output'];
  hourly: Scalars['Decimal']['output'];
  isOffCycle: Scalars['Boolean']['output'];
  netPay: Scalars['Decimal']['output'];
  paymentMethod: PaymentMethod;
  payroll: Payroll;
};

export type EmployeeRatio = {
  __typename?: 'EmployeeRatio';
  currentHeadcount: Scalars['Int']['output'];
  projectedHeadcount: Scalars['Int']['output'];
};

export type EmployeeTermination = {
  __typename?: 'EmployeeTermination';
  terminationDate: Scalars['Date']['output'];
};

export enum EmploymentType {
  Contractor = 'Contractor',
  FullTime = 'FullTime',
  PartTime = 'PartTime'
}

export type EnableRevenueRecognitionInput = {
  companyId: Scalars['CompanyID']['input'];
};

export type EnableRevenueRecognitionResponse = {
  __typename?: 'EnableRevenueRecognitionResponse';
  configurations?: Maybe<Array<Maybe<AccountingConfiguration>>>;
};

export type EndExclusiveLocalDateRangeInput = {
  fromInclusive: Scalars['InclusiveDay']['input'];
  key: Scalars['String']['input'];
  toExclusive: Scalars['ExclusiveDay']['input'];
};

export type Error = {
  __typename?: 'Error';
  message: Scalars['String']['output'];
};

export type ErrorDetail = {
  __typename?: 'ErrorDetail';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type EventCount = {
  __typename?: 'EventCount';
  count: Scalars['Int']['output'];
  eventSchemaType: Scalars['String']['output'];
};

export type EventRelations = {
  __typename?: 'EventRelations';
  bill?: Maybe<Bill>;
  fixedAsset?: Maybe<FixedAsset>;
  invoice?: Maybe<Invoice>;
  prepaidExpense?: Maybe<Prepaid>;
  transaction?: Maybe<Transaction>;
};

export enum EventType {
  Create = 'Create',
  Delete = 'Delete',
  Update = 'Update'
}

export type EveryInitializationInfo = {
  __typename?: 'EveryInitializationInfo';
  connectUrl: Scalars['String']['output'];
};

export type EveryIntegration = {
  __typename?: 'EveryIntegration';
  connection?: Maybe<IntegrationConnection>;
  connections?: Maybe<Array<IntegrationConnection>>;
  initializationInfo: EveryInitializationInfo;
};


export type EveryIntegrationConnectionArgs = {
  companyId: Scalars['ID']['input'];
};


export type EveryIntegrationConnectionsArgs = {
  companyId: Scalars['ID']['input'];
};

export enum ExpenseCategory {
  CostOfSales = 'COST_OF_SALES',
  Facilities = 'FACILITIES',
  GeneralAndAdministrative = 'GENERAL_AND_ADMINISTRATIVE',
  Insurance = 'INSURANCE',
  Other = 'OTHER',
  ProfessionalServices = 'PROFESSIONAL_SERVICES',
  SalesAndMarketing = 'SALES_AND_MARKETING',
  TechnologyAndSoftware = 'TECHNOLOGY_AND_SOFTWARE',
  TravelAndEntertainment = 'TRAVEL_AND_ENTERTAINMENT'
}

export enum ExpenseRecognitionMethod {
  Automatic = 'automatic',
  Manual = 'manual'
}

export type ExternalApiScopeInfo = {
  __typename?: 'ExternalApiScopeInfo';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FdicCoverage = {
  __typename?: 'FdicCoverage';
  depositoryTotal: Money;
  estimatedInsuranceCoverage: Money;
  status?: Maybe<FdicCoverageStatus>;
};

export enum FdicCoverageStatus {
  AtRisk = 'AtRisk',
  Covered = 'Covered',
  Review = 'Review'
}

/**
 * A subset of the Notion database's metadata.
 * This is used to populate fields like radio/checkbox options without relying on redeployments.
 */
export type FeedbackForm = {
  __typename?: 'FeedbackForm';
  properties: Scalars['JSON']['output'];
};

/**
 * The friendly name for a customer support Notion database.
 * You need to share the database with an integration before it can write to one.
 * This further restricts which databases the mutation can update.
 */
export enum FeedbackFormName {
  ChartOfAccounts = 'ChartOfAccounts',
  General = 'General',
  Ltse = 'LTSE',
  Reconciliation = 'Reconciliation',
  Transaction = 'Transaction'
}

export type FeedbackInput = {
  /** The names of the properties to include in the initial email. */
  emailFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The friendly name for a customer support Notion database. */
  form: FeedbackFormName;
  /** The Notion property values to use for the new database page. */
  properties: Scalars['JSON']['input'];
  /** Whether or not to start an email thread with the customer. */
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeedbackResponse = {
  __typename?: 'FeedbackResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type File = {
  __typename?: 'File';
  contentType: Scalars['String']['output'];
  downloadInfo: FileDownloadInfo;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  size: Scalars['Int']['output'];
};

/**
 * Provides a temporarily signed URL for file downloads.
 * Use urlExpiresAt to determine if it needs to be updated.
 */
export type FileDownloadInfo = {
  __typename?: 'FileDownloadInfo';
  signedUrl: Scalars['String']['output'];
  urlExpiresAt: Scalars['DateTime']['output'];
};

export type FilterByClassesInput = {
  withNoneOfClassIds?: InputMaybe<Array<Scalars['TagNameID']['input']>>;
  withSomeOfClassSegmentIds?: InputMaybe<Array<Scalars['TagValueID']['input']>>;
};

export type FinancialInsightsFromAiResult = {
  __typename?: 'FinancialInsightsFromAIResult';
  responseMessage: Scalars['String']['output'];
};

export type FinancialInstitution = {
  __typename?: 'FinancialInstitution';
  accounts: Array<Account>;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  fdicCoverage?: Maybe<FdicCoverage>;
  id: Scalars['ID']['output'];
  linkedByUser: User;
  name: Scalars['String']['output'];
  nativeInstitutionId?: Maybe<Scalars['String']['output']>;
};

export type FinicityConnectInfo = {
  __typename?: 'FinicityConnectInfo';
  connectUrl: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
};

export type FinicityInitializationInfo = {
  __typename?: 'FinicityInitializationInfo';
  connectInfo: FinicityConnectInfo;
};


export type FinicityInitializationInfoConnectInfoArgs = {
  companyId: Scalars['ID']['input'];
  institutionName?: InputMaybe<Scalars['String']['input']>;
};

export type FinicityIntegration = {
  __typename?: 'FinicityIntegration';
  connection?: Maybe<IntegrationConnection>;
  connections?: Maybe<Array<IntegrationConnection>>;
  initializationInfo: FinicityInitializationInfo;
};


export type FinicityIntegrationConnectionArgs = {
  companyId: Scalars['ID']['input'];
  institutionName?: InputMaybe<Scalars['String']['input']>;
};


export type FinicityIntegrationConnectionsArgs = {
  companyId: Scalars['ID']['input'];
  institutionName?: InputMaybe<Scalars['String']['input']>;
};

export type Firm = {
  __typename?: 'Firm';
  clients: Array<FirmClient>;
  companyMemberships: Array<CompanyMembership>;
  createdAt: Scalars['DateTime']['output'];
  firmMemberships: Array<FirmMembership>;
  groupMemberships: Array<FirmGroupMembership>;
  groups: Array<FirmGroup>;
  id: Scalars['FirmID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FirmClient = {
  __typename?: 'FirmClient';
  company: Company;
  companyId: Scalars['CompanyID']['output'];
  createdAt: Scalars['DateTime']['output'];
  firm: Firm;
  firmId: Scalars['FirmID']['output'];
  id: Scalars['FirmCompanyID']['output'];
  lastModifiedBy: Scalars['UserID']['output'];
  lastModifiedByUser: User;
  maxRole: MembershipRole;
  updatedAt: Scalars['DateTime']['output'];
};

export type FirmGroup = {
  __typename?: 'FirmGroup';
  alias: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  firmId: Scalars['FirmID']['output'];
  id: Scalars['FirmGroupID']['output'];
  isAnonymized: Scalars['Boolean']['output'];
  lastModifiedBy: Scalars['UserID']['output'];
  memberships: Array<FirmMembership>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FirmGroupMembership = {
  __typename?: 'FirmGroupMembership';
  createdAt: Scalars['DateTime']['output'];
  firm: Firm;
  firmGroup: FirmGroup;
  firmGroupId: Scalars['FirmGroupID']['output'];
  firmId: Scalars['FirmID']['output'];
  id: Scalars['FirmGroupMembershipID']['output'];
  lastModifiedBy: Scalars['UserID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['UserID']['output'];
};

export type FirmMembership = {
  __typename?: 'FirmMembership';
  createdAt: Scalars['DateTime']['output'];
  firm: Firm;
  firmId?: Maybe<Scalars['FirmID']['output']>;
  id: Scalars['FirmMembershipID']['output'];
  isOwner: Scalars['Boolean']['output'];
  lastModifiedBy: Scalars['UserID']['output'];
  role: FirmMembershipRole;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['UserID']['output'];
};

export enum FirmMembershipRole {
  AccountExecutive = 'AccountExecutive',
  Bookkeeper = 'Bookkeeper',
  None = 'None',
  Owner = 'Owner'
}

export enum FirstMonthConvention {
  Actual = 'Actual',
  Full = 'Full',
  MidMonth = 'MidMonth'
}

export enum FirstPeriodAllocation {
  /** @deprecated Not supported */
  DayBased = 'DayBased',
  FullMonth = 'FullMonth',
  HalfMonth = 'HalfMonth',
  Mid = 'Mid',
  Zero = 'Zero'
}

export type FixedAsset = {
  __typename?: 'FixedAsset';
  capitalizedAt?: Maybe<Scalars['LocalDate']['output']>;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  depreciationMethod?: Maybe<FixedAssetDepreciationMethod>;
  description?: Maybe<Scalars['String']['output']>;
  disposedAt?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['ID']['output'];
  inServiceAt?: Maybe<Scalars['LocalDate']['output']>;
  originalValue?: Maybe<Scalars['Decimal']['output']>;
  pieces: Array<FixedAssetPiece>;
  proceeds?: Maybe<Scalars['Decimal']['output']>;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  salvageValue?: Maybe<Scalars['Decimal']['output']>;
  status: FixedAssetStatus;
  type?: Maybe<FixedAssetType>;
  updatedAt: Scalars['DateTime']['output'];
  usefulLifeMonths?: Maybe<Scalars['Int']['output']>;
  user: User;
};

export type FixedAssetAutomationSettings = {
  __typename?: 'FixedAssetAutomationSettings';
  autoDraftFixedAssetsEffectiveDate: Scalars['LocalDate']['output'];
  autoDraftFixedAssetsValue: Scalars['Boolean']['output'];
  autoGenerateDepreciationEntriesEffectiveDate: Scalars['LocalDate']['output'];
  autoGenerateDepreciationEntriesValue: AutoGenerateDepreciationEntriesValue;
};

export type FixedAssetCapitalization = {
  __typename?: 'FixedAssetCapitalization';
  capitalizationData: FixedAssetCapitalizationTotals;
  fixedAsset: FixedAsset;
};

export type FixedAssetCapitalizationAccumulatedDepreciation = {
  __typename?: 'FixedAssetCapitalizationAccumulatedDepreciation';
  closing: Money;
  disposals: Money;
  expense: Money;
  opening: Money;
};

export type FixedAssetCapitalizationCost = {
  __typename?: 'FixedAssetCapitalizationCost';
  additions: Money;
  closing: Money;
  disposals: Money;
  opening: Money;
};

export type FixedAssetCapitalizationDataInput = {
  companyId: Scalars['CompanyID']['input'];
  filterBy: FixedAssetCapitalizationFilterBy;
};

export type FixedAssetCapitalizationDepreciation = {
  __typename?: 'FixedAssetCapitalizationDepreciation';
  current: FixedAssetCapitalizationPeriod;
  residual: Money;
};

export type FixedAssetCapitalizationFilterBy = {
  periodRange: InclusivePeriodRangeInput;
  types?: InputMaybe<Array<FixedAssetType>>;
};

export type FixedAssetCapitalizationNetBookValue = {
  __typename?: 'FixedAssetCapitalizationNetBookValue';
  closing: Money;
  opening: Money;
};

export type FixedAssetCapitalizationPaginator = {
  __typename?: 'FixedAssetCapitalizationPaginator';
  items: Array<FixedAssetCapitalization>;
  totals: FixedAssetCapitalizationTotals;
  typeTotals: Array<Maybe<FixedAssetTypeCapitalization>>;
};

export type FixedAssetCapitalizationPeriod = {
  __typename?: 'FixedAssetCapitalizationPeriod';
  key: Scalars['String']['output'];
  total: Money;
};

export type FixedAssetCapitalizationTotals = {
  __typename?: 'FixedAssetCapitalizationTotals';
  accumulatedDepreciation: FixedAssetCapitalizationAccumulatedDepreciation;
  cost: FixedAssetCapitalizationCost;
  depreciation: FixedAssetCapitalizationDepreciation;
  netBookValue: FixedAssetCapitalizationNetBookValue;
};

export enum FixedAssetDepreciationMethod {
  StraightLine = 'StraightLine'
}

export enum FixedAssetDepreciationScheduleEntryStatus {
  Draft = 'Draft',
  Future = 'Future',
  InProcess = 'InProcess',
  Posted = 'Posted'
}

export type FixedAssetDepreciationSchedulePreviewInput = {
  firstMonthConvention?: InputMaybe<FirstMonthConvention>;
  id: Scalars['ID']['input'];
  inServiceAt?: InputMaybe<Scalars['LocalDate']['input']>;
  method?: InputMaybe<FixedAssetDepreciationMethod>;
  usefulLifeMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type FixedAssetFilterBy = {
  statuses?: InputMaybe<Array<FixedAssetStatus>>;
};

export type FixedAssetPaginator = {
  __typename?: 'FixedAssetPaginator';
  items: Array<FixedAsset>;
  pageInfo: PageInfo;
};

export type FixedAssetPiece = {
  __typename?: 'FixedAssetPiece';
  billLine?: Maybe<BillLine>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<TransactionDetail>;
  id: Scalars['FixedAssetPieceID']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  status: FixedAssetStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type FixedAssetRegistryReportInput = {
  companyId: Scalars['ID']['input'];
  range: InclusivePeriodRangeInput;
};

export type FixedAssetRule = {
  __typename?: 'FixedAssetRule';
  categories: Array<FixedAssetRuleCategory>;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  depreciationMethod: FixedAssetDepreciationMethod;
  firstMonthConvention: FirstMonthConvention;
  id: Scalars['FixedAssetRuleID']['output'];
  minimumQualifyingAmount: Money;
  type: FixedAssetType;
  updatedAt: Scalars['DateTime']['output'];
  usefulLifeMonths: Scalars['Int']['output'];
  user: User;
  vendors: Array<FixedAssetRuleVendor>;
};

export type FixedAssetRuleCategory = {
  __typename?: 'FixedAssetRuleCategory';
  coaKey: Scalars['String']['output'];
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['FixedAssetRuleCategoryID']['output'];
  rule: FixedAssetRule;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type FixedAssetRuleVendor = {
  __typename?: 'FixedAssetRuleVendor';
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['FixedAssetRuleVendorID']['output'];
  rule: FixedAssetRule;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  vendor: Vendor;
};

export enum FixedAssetSortOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC'
}

export enum FixedAssetStatus {
  Capitalized = 'Capitalized',
  Deleted = 'Deleted',
  Disposed = 'Disposed',
  Draft = 'Draft',
  InService = 'InService',
  Manual = 'Manual',
  OnHold = 'OnHold',
  OutOfService = 'OutOfService',
  Void = 'Void'
}

export enum FixedAssetType {
  ComputersAndHardware = 'ComputersAndHardware',
  Furniture = 'Furniture',
  Other = 'Other',
  Software = 'Software'
}

export type FixedAssetTypeCapitalization = {
  __typename?: 'FixedAssetTypeCapitalization';
  totals: FixedAssetCapitalizationTotals;
  type: FixedAssetType;
};

export enum FixedCompensationTag {
  Bonus = 'Bonus',
  Reimbursement = 'Reimbursement'
}

export enum FlsaStatus {
  Exempt = 'Exempt',
  Nonexempt = 'Nonexempt',
  Owner = 'Owner',
  SalariedNonexempt = 'SalariedNonexempt'
}

export type GatewayCategory = Category & {
  __typename?: 'GatewayCategory';
  coaDisplayId?: Maybe<Scalars['String']['output']>;
  coaKey?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['ID']['output']>;
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  examples?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  permaKey: Scalars['String']['output'];
  ruleType?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum GatewayEnvironment {
  Development = 'DEVELOPMENT',
  Production = 'PRODUCTION',
  Staging = 'STAGING'
}

export type GenerateYearEndTaxPackageInput = {
  companyId: Scalars['CompanyID']['input'];
  view: LedgerView;
  year: Scalars['Period']['input'];
};

export type Get1099EligibleVendorsInput = {
  companyId: Scalars['CompanyID']['input'];
  year: Scalars['Period']['input'];
};

export type Get1099EligibleVendorsResult = {
  __typename?: 'Get1099EligibleVendorsResult';
  vendors: Array<VendorWith1099Spending>;
};

export type GetCachedPrefilledOnboardingDataInput = {
  prefilledOnboardingId: Scalars['ID']['input'];
};

export type GetCoaMapperFileInput = {
  id: Scalars['DirectIngestFileID']['input'];
};

export type GetCoaMapperFileResult = {
  __typename?: 'GetCoaMapperFileResult';
  directIngestFile: DirectIngestFileCoaMapper;
};

export type GetDownloadInfoInput = {
  fileId: Scalars['ID']['input'];
};

export type GetEmailFromSecretInput = {
  secret: Scalars['String']['input'];
};

export type GetEmailFromSecretResult = {
  __typename?: 'GetEmailFromSecretResult';
  email: Scalars['String']['output'];
};

export type GetFileUploadInfoInput = {
  contentType: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
  entityType: AssociatedEntity;
  filename: Scalars['String']['input'];
};

export type GetFirmClientsInput = {
  firmId: Scalars['FirmID']['input'];
};

export type GetFirmCompanyUsersInput = {
  firmId: Scalars['FirmID']['input'];
  role?: InputMaybe<MembershipRole>;
};

export type GetMetricCardPreferencesInput = {
  companyId: Scalars['CompanyID']['input'];
};

export type GetNewPlaidPublicTokenResult = {
  __typename?: 'GetNewPlaidPublicTokenResult';
  publicToken?: Maybe<Scalars['String']['output']>;
};

export type GetNotificationsInput = {
  secret: Scalars['String']['input'];
};

export type GetProvisionGustoAccountUrlInput = {
  companyId: Scalars['CompanyID']['input'];
};

export type GetSpendingPayrollSummaryInput = {
  companyId: Scalars['CompanyID']['input'];
  period: Scalars['Period']['input'];
};

export type GetSpendingPayrollSummaryResult = {
  __typename?: 'GetSpendingPayrollSummaryResult';
  departments: Array<Maybe<DepartmentMetric>>;
  numericSummary?: Maybe<PayrollNumericSummary>;
};

export type GetSpendingTrendsInput = {
  baseMonth: Scalars['Month']['input'];
  companyId: Scalars['CompanyID']['input'];
  ledgerCoaKey?: InputMaybe<Scalars['String']['input']>;
  vendorPermaName?: InputMaybe<Scalars['String']['input']>;
};

export type GetSpendingTrendsResult = {
  __typename?: 'GetSpendingTrendsResult';
  categories?: Maybe<Array<CategorySpendingTrend>>;
  latestTransactions?: Maybe<LatestTransactionsSpendingTrends>;
  totals?: Maybe<Array<NonPayrollSpendingTrend>>;
  vendors?: Maybe<Array<VendorSpendingTrend>>;
};

export type GetStatementBalancesInput = {
  accountId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  dateRange: InclusiveLocalDateRangeInput;
};

export type GetStatementsInput = {
  accountId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type GetTopSpendingInput = {
  companyId: Scalars['CompanyID']['input'];
  period?: InputMaybe<Scalars['Period']['input']>;
};

export type GetTopSpendingResult = {
  __typename?: 'GetTopSpendingResult';
  allOtherCategories: Money;
  allOtherVendors: Money;
  payrollAmount: Money;
  previousPeriod: PreviousPeriodSpendingMetric;
  previousPeriodToDate: PreviousPeriodSpendingMetric;
  range: InclusiveDateRange;
  recurrenceSummary: Array<RecurrenceMetric>;
  topCategories: Array<Maybe<CategoryMetric>>;
  topRecurringTransactions: Array<TransactionMetric>;
  topTransactions: Array<TransactionMetric>;
  topVendors: Array<Maybe<VendorMetric>>;
  totalAmount: Money;
  totalTransactionsCount: Scalars['Int']['output'];
};

export type GetUnconfirmedMergedWorkersInput = {
  companyId: Scalars['CompanyID']['input'];
};

export type GetUploadInfoInput = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  transactionId: Scalars['ID']['input'];
};

export type GetUploadInfoResult = {
  __typename?: 'GetUploadInfoResult';
  path: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type GetVendorSecretsInput = {
  id: Scalars['ID']['input'];
};

export type GetVendorSecretsResult = {
  __typename?: 'GetVendorSecretsResult';
  secrets?: Maybe<VendorSecrets>;
};

export type GlobalConfigResult = {
  __typename?: 'GlobalConfigResult';
  settings: Array<GlobalSetting>;
};

export type GlobalSetting = {
  __typename?: 'GlobalSetting';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum GoldDataDateCalculationMethod {
  Frozen = 'Frozen',
  ShiftByMonth = 'ShiftByMonth',
  ShiftToDay = 'ShiftToDay'
}

export enum GoldDataModule {
  DemoV3 = 'demoV3',
  UhvStripe = 'uhvStripe'
}

export type GrantFirmUserCompanyAccessInput = {
  companyId: Scalars['CompanyID']['input'];
  firmGroupId?: InputMaybe<Scalars['FirmGroupID']['input']>;
  firmId: Scalars['FirmID']['input'];
  role: MembershipRole;
  userId: Scalars['UserID']['input'];
};

export type GrantFirmUserCompanyAccessResult = {
  __typename?: 'GrantFirmUserCompanyAccessResult';
  companyMembership: CompanyMembership;
};

export type GrossMargin = {
  __typename?: 'GrossMargin';
  amount?: Maybe<Scalars['Decimal']['output']>;
  month: Scalars['Month']['output'];
};

export enum GrowthShape {
  MonthOverMonth = 'MONTH_OVER_MONTH',
  YearOverYear = 'YEAR_OVER_YEAR'
}

export type GustoAccountClaimUrl = {
  __typename?: 'GustoAccountClaimUrl';
  accountClaimUrl: Scalars['String']['output'];
};

export type GustoInitializationInfo = {
  __typename?: 'GustoInitializationInfo';
  connectUrl: Scalars['String']['output'];
};

export type GustoIntegration = {
  __typename?: 'GustoIntegration';
  connections?: Maybe<Array<IntegrationConnection>>;
  initializationInfo: GustoInitializationInfo;
};


export type GustoIntegrationConnectionsArgs = {
  companyId: Scalars['ID']['input'];
};

export type HandleCompanyCompletedOnboardingResult = {
  __typename?: 'HandleCompanyCompletedOnboardingResult';
  company: Company;
};

export type HandleFileUploadedInput = {
  contentType: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
  entityType: AssociatedEntity;
  filename: Scalars['String']['input'];
  path: Scalars['String']['input'];
  size: Scalars['Int']['input'];
};

export type HandleFileUploadedResult = {
  __typename?: 'HandleFileUploadedResult';
  entityId: Scalars['ID']['output'];
  entityType: AssociatedEntity;
  file: File;
};

export type HealthCheckAccountStatus = {
  __typename?: 'HealthCheckAccountStatus';
  dataSourceTypeId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  ingestStatus: AccountIngestStatus;
  name: Scalars['String']['output'];
};

export type HealthCheckEvents = {
  __typename?: 'HealthCheckEvents';
  batchResultsCount: Scalars['Int']['output'];
  batchesCount: Scalars['Int']['output'];
  eventAckCounts?: Maybe<Array<EventCount>>;
  eventAcksFailedCount: Scalars['Int']['output'];
  eventCounts?: Maybe<Array<EventCount>>;
  lastEvent: HealthCheckLastEvent;
  lastEventAck?: Maybe<HealthCheckLastEventAck>;
};

export type HealthCheckLastEvent = {
  __typename?: 'HealthCheckLastEvent';
  companyId: Scalars['CompanyID']['output'];
  createdAt: Scalars['DateTime']['output'];
  eventSchemaType: Scalars['String']['output'];
  externalUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  highPriority: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

export type HealthCheckLastEventAck = {
  __typename?: 'HealthCheckLastEventAck';
  ackedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  eventSchemaType: Scalars['String']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type HealthCheckPlaidStatus = {
  __typename?: 'HealthCheckPlaidStatus';
  historicalStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  nativeId?: Maybe<Scalars['ID']['output']>;
};

export type HealthCheckTransactions = {
  __typename?: 'HealthCheckTransactions';
  rawPlaidCount: Scalars['Int']['output'];
  sourceCounts?: Maybe<Array<HealthCheckTxnCounts>>;
  txnCounts?: Maybe<Array<HealthCheckTxnCounts>>;
};

export type HealthCheckTxnCounts = {
  __typename?: 'HealthCheckTxnCounts';
  count: Scalars['Int']['output'];
  dataSourceTypeId: Scalars['Int']['output'];
};

export type HireExpenseDefaults = {
  __typename?: 'HireExpenseDefaults';
  hiringBonusAmount: Scalars['Decimal']['output'];
  hiringBonusType: HireExpenseType;
  monthlyBenefitsAmount: Scalars['Decimal']['output'];
  monthlyBenefitsType: HireExpenseType;
  monthlyPayrollTaxAmount: Scalars['Decimal']['output'];
  monthlyPayrollTaxType: HireExpenseType;
  recruiterFeeAmount: Scalars['Decimal']['output'];
  recruiterFeeType: HireExpenseType;
  setupCostAmount: Scalars['Decimal']['output'];
  setupCostType: HireExpenseType;
};

export enum HireExpenseType {
  FlatAmount = 'FLAT_AMOUNT',
  PercentOfBase = 'PERCENT_OF_BASE'
}

export enum HireLevel {
  Junior = 'JUNIOR',
  Mid = 'MID',
  Senior = 'SENIOR'
}

export enum HireRole {
  BusinessDevelopment = 'BUSINESS_DEVELOPMENT',
  CustomerSuccess = 'CUSTOMER_SUCCESS',
  CustomerSupport = 'CUSTOMER_SUPPORT',
  DataScience = 'DATA_SCIENCE',
  Design = 'DESIGN',
  Engineering = 'ENGINEERING',
  Executive = 'EXECUTIVE',
  Facilities = 'FACILITIES',
  Finance = 'FINANCE',
  Hr = 'HR',
  Legal = 'LEGAL',
  Marketing = 'MARKETING',
  Other = 'OTHER',
  Product = 'PRODUCT',
  Sales = 'SALES'
}

export type HistoricalBooksChecklist = ChecklistV2 & {
  __typename?: 'HistoricalBooksChecklist';
  id: Scalars['ID']['output'];
  isFinished: Scalars['Boolean']['output'];
  items: Array<BasicChecklistItem>;
};

export enum HistoricalStatus {
  Completed = 'COMPLETED',
  InitialUpdate = 'INITIAL_UPDATE',
  None = 'NONE'
}

export type HoldFixedAssetInput = {
  id: Scalars['FixedAssetID']['input'];
};

export type HowDidYouHearAboutUs = {
  __typename?: 'HowDidYouHearAboutUs';
  howDidYouHearAboutUs?: Maybe<Scalars['String']['output']>;
  howDidYouHearAboutUsAIToolsInput?: Maybe<Scalars['String']['output']>;
  howDidYouHearAboutUsAcceleratorInput?: Maybe<Scalars['String']['output']>;
  howDidYouHearAboutUsCategory?: Maybe<HowDidYouHearAboutUsCategory>;
  howDidYouHearAboutUsEventInput?: Maybe<Scalars['String']['output']>;
  howDidYouHearAboutUsFirmInput?: Maybe<Scalars['String']['output']>;
  howDidYouHearAboutUsOther?: Maybe<Scalars['String']['output']>;
  howDidYouHearAboutUsReferer?: Maybe<Scalars['String']['output']>;
  howDidYouHearAboutUsVCInput?: Maybe<Scalars['String']['output']>;
};

export enum HowDidYouHearAboutUsCategory {
  AiTools = 'AITools',
  Accelerator = 'Accelerator',
  AccountingFirm = 'AccountingFirm',
  Event = 'Event',
  Google = 'Google',
  Other = 'Other',
  Partner = 'Partner',
  Referral = 'Referral',
  SocialMedia = 'SocialMedia',
  Vc = 'VC'
}

export type HowDidYouHearAboutUsInput = {
  howDidYouHearAboutUs?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearAboutUsAIToolsInput?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearAboutUsAcceleratorInput?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearAboutUsCategory?: InputMaybe<HowDidYouHearAboutUsCategory>;
  howDidYouHearAboutUsEventInput?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearAboutUsFirmInput?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearAboutUsOther?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearAboutUsReferer?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearAboutUsVCInput?: InputMaybe<Scalars['String']['input']>;
};

export type ITransaction = {
  account: Account;
  activity: TransactionActivityDetails;
  amount: Scalars['Decimal']['output'];
  basis?: Maybe<AccountingBasis>;
  company: Company;
  date: Scalars['LocalDate']['output'];
  descriptor: Scalars['String']['output'];
  detail: TransactionDetail;
  documentation: Array<TransactionDocument>;
  hasDocumentation: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  integrationType: IntegrationType;
  /** @deprecated Use vendorPayment instead */
  linkedBills: Array<Bill>;
  links: Array<TransactionLink>;
  parent?: Maybe<Transaction>;
  payment?: Maybe<CustomerBalanceTransaction>;
  pending: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  revenue?: Maybe<TransactionRevenue>;
  splits: Array<TransactionDetail>;
  vendorPayment?: Maybe<VendorBalanceTransaction>;
};

export type ImplicitRule = {
  __typename?: 'ImplicitRule';
  descriptor: Scalars['String']['output'];
  ledgerCategory: LedgerCategory;
  vendor?: Maybe<Vendor>;
};

export type ImplicitRuleFilterBy = {
  ledgerCoaKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ImplicitRuleInput = {
  companyId: Scalars['ID']['input'];
  filterBy?: InputMaybe<ImplicitRuleFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<ImplicitRuleSortOrder>;
};

export type ImplicitRulePaginator = {
  __typename?: 'ImplicitRulePaginator';
  nodes: Array<ImplicitRule>;
  pageInfo: PageInfo;
};

export enum ImplicitRuleSortOrder {
  CategoryNameAsc = 'CATEGORY_NAME_ASC',
  CategoryNameDesc = 'CATEGORY_NAME_DESC',
  DescriptorAsc = 'DESCRIPTOR_ASC',
  DescriptorDesc = 'DESCRIPTOR_DESC'
}

export type InclusiveDateRange = {
  __typename?: 'InclusiveDateRange';
  /** @deprecated No longer supported */
  from?: Maybe<Scalars['LocalDate']['output']>;
  fromInclusive: Scalars['InclusiveDay']['output'];
  /** @deprecated No longer supported */
  to?: Maybe<Scalars['LocalDate']['output']>;
  toInclusive: Scalars['InclusiveDay']['output'];
};

export type InclusiveExclusiveDateTimeRangeInput = {
  fromInclusive: Scalars['DateTime']['input'];
  toExclusive: Scalars['DateTime']['input'];
};

export type InclusiveLocalDateRangeInput = {
  fromInclusive: Scalars['InclusiveDay']['input'];
  toInclusive: Scalars['InclusiveDay']['input'];
};

export type InclusivePeriodRangeInput = {
  fromInclusive: Scalars['Period']['input'];
  toInclusive: Scalars['Period']['input'];
};

export type IngestDirectIngestFileInput = {
  id: Scalars['DirectIngestFileID']['input'];
};

export type IngestDirectIngestFileResult = {
  __typename?: 'IngestDirectIngestFileResult';
  /** @deprecated Use ingestFile instead */
  directIngestFile: DirectIngestFileManualJournalEntries;
  ingestFile: DirectIngestFile;
};

export enum IngressType {
  Pull = 'pull',
  Push = 'push'
}

export type InitialBalance = {
  __typename?: 'InitialBalance';
  balance: Scalars['Decimal']['output'];
  date: Scalars['DateTime']['output'];
};

export type InlineReport = {
  __typename?: 'InlineReport';
  data: Scalars['String']['output'];
  timePeriod?: Maybe<ReportTimePeriod>;
  title: Scalars['String']['output'];
};

export type InstitutionAccountBalance = {
  __typename?: 'InstitutionAccountBalance';
  balance: Money;
  date: Scalars['String']['output'];
  derivedFrom: AccountBalanceDerivedFrom;
};

export type InstitutionAccountBalancesOnDate = {
  __typename?: 'InstitutionAccountBalancesOnDate';
  balances: Array<InstitutionAccountBalance>;
  date: Scalars['String']['output'];
  totalCash: Money;
};

export type IntegrationConnection = {
  __typename?: 'IntegrationConnection';
  accountStats: DataSourceTypeAccountStats;
  company: Company;
  condition?: Maybe<IntegrationConnectionCondition>;
  conditionExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  connectionName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  errorCode?: Maybe<DisconnectionErrorCode>;
  id: Scalars['ID']['output'];
  ingressType: IngressType;
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  latestSync?: Maybe<SyncRun>;
  message?: Maybe<Scalars['String']['output']>;
  nativeError?: Maybe<IntegrationConnectionError>;
  status: IntegrationConnectionStatus;
  type: IntegrationType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum IntegrationConnectionCondition {
  WaitingForAddOnPayment = 'WaitingForAddOnPayment',
  WaitingForUserEpoch = 'WaitingForUserEpoch'
}

export type IntegrationConnectionError = {
  __typename?: 'IntegrationConnectionError';
  displayMessage?: Maybe<Scalars['String']['output']>;
  errorCode: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType: Scalars['String']['output'];
  requestId: Scalars['ID']['output'];
  suggestedAction?: Maybe<Scalars['String']['output']>;
};

export enum IntegrationConnectionErrorCode {
  ExternalError = 'ExternalError',
  InsufficientPermissions = 'InsufficientPermissions',
  InternalError = 'InternalError',
  InvalidMfa = 'InvalidMfa',
  ItemLocked = 'ItemLocked',
  ItemNotSupported = 'ItemNotSupported',
  LoginRequired = 'LoginRequired',
  MfaNotSupported = 'MfaNotSupported'
}

export enum IntegrationConnectionStatus {
  Disconnected = 'Disconnected',
  Error = 'Error',
  Ok = 'OK'
}

export enum IntegrationType {
  BillDotCom = 'BillDotCom',
  Brex = 'Brex',
  Captable = 'Captable',
  Carta = 'Carta',
  Central = 'Central',
  Deel = 'Deel',
  DirectIngest = 'DirectIngest',
  Every = 'Every',
  Expensify = 'Expensify',
  Finicity = 'Finicity',
  Gusto = 'Gusto',
  Human = 'Human',
  Meow = 'Meow',
  Mercury = 'Mercury',
  Plaid = 'Plaid',
  QuickBooks = 'QuickBooks',
  Ramp = 'Ramp',
  Rippling = 'Rippling',
  Salesforce = 'Salesforce',
  Slack = 'Slack',
  Stripe = 'Stripe',
  SvbOfx = 'SvbOfx',
  TriNet = 'TriNet',
  Zaprite = 'Zaprite'
}

export type Integrations = {
  __typename?: 'Integrations';
  billDotCom: BillDotComIntegration;
  brex: BrexIntegration;
  deel: DeelIntegration;
  every: EveryIntegration;
  finicity: FinicityIntegration;
  gusto: GustoIntegration;
  meow: MeowIntegration;
  mercury: MercuryIntegration;
  plaid: PlaidIntegration;
  pushIntegrations: Array<PushIntegration>;
  quickbooks: QuickbooksIntegration;
  ramp: RampIntegration;
  rippling: RipplingIntegration;
  stripe: StripeIntegration;
  svbOfx: SvbOfxIntegration;
  trinet: TrinetIntegration;
};

export enum IntroStep {
  AngelList = 'AngelList',
  ConnectAccounts = 'ConnectAccounts',
  ConnectFinancialInstitution = 'ConnectFinancialInstitution',
  CreateCompany = 'CreateCompany',
  Ltse = 'LTSE',
  ReviewData = 'ReviewData',
  ScheduleInterview = 'ScheduleInterview'
}

export enum InvestmentCategory {
  Debt = 'DEBT',
  Equity = 'EQUITY'
}

export type InviteToCompanyInput = {
  companyId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']>;
  mfaRequired: Scalars['Boolean']['input'];
  position?: InputMaybe<UserPosition>;
  role: MembershipRole;
};

export type InviteToCompanyResult = {
  __typename?: 'InviteToCompanyResult';
  errorMessages?: Maybe<Array<Scalars['String']['output']>>;
  successEmails?: Maybe<Array<Scalars['String']['output']>>;
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Money;
  company: Company;
  contract?: Maybe<Contract>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  description?: Maybe<Scalars['String']['output']>;
  discountLines: Array<InvoiceDiscountLine>;
  dueDate?: Maybe<Scalars['LocalDate']['output']>;
  events: Array<LedgerEvent>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalNativeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['InvoiceID']['output'];
  integrationType: IntegrationType;
  issueDate: Scalars['LocalDate']['output'];
  lines: Array<InvoiceLine>;
  matches: Array<CustomerBalanceMatch>;
  receivableBalance: ReceivableBalance;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  shippingLines: Array<InvoiceShippingLine>;
  shortId: Scalars['String']['output'];
  status: InvoiceStatus;
  taxLines: Array<InvoiceTaxLine>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userEdited?: Maybe<Scalars['Boolean']['output']>;
};

export type InvoiceAccuracyCheck = AccuracyCheck & {
  __typename?: 'InvoiceAccuracyCheck';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  displayMetadata?: Maybe<AccuracyCheckDisplayMetadata>;
  group: AccuracyCheckGroup;
  id: Scalars['AccuracyCheckID']['output'];
  query: InvoiceQuery;
  status: AccuracyCheckStatus;
  type: AccuracyCheckType;
  uniqueKey: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceCoupon = {
  __typename?: 'InvoiceCoupon';
  amountOff?: Maybe<Scalars['Decimal']['output']>;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['InvoiceCouponID']['output'];
  name: Scalars['String']['output'];
  percentageOff?: Maybe<Scalars['Decimal']['output']>;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceDiscountLine = WithReportingClasses & {
  __typename?: 'InvoiceDiscountLine';
  amount: Money;
  classAwareType: ClassAwareType;
  classSegments: Array<AvailableClassSegment>;
  company: Company;
  contractLine?: Maybe<ContractLine>;
  coupon?: Maybe<InvoiceCoupon>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['InvoiceDiscountLineID']['output'];
  invoice: Invoice;
  ledgerCategory?: Maybe<LedgerCategory>;
  parentInvoiceLine?: Maybe<InvoiceLine>;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  schedule?: Maybe<ContractRevenueSchedule>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceEvent = {
  __typename?: 'InvoiceEvent';
  accountId: Scalars['ID']['output'];
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceInvoice?: Maybe<Scalars['JSONObject']['output']>;
  subtotal: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  total: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InvoiceFilterBy = {
  accuracyCheckId?: InputMaybe<Scalars['AccuracyCheckID']['input']>;
  coaKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  customerIds?: InputMaybe<Array<Scalars['CustomerID']['input']>>;
  dataSourceTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  dateRange?: InputMaybe<EndExclusiveLocalDateRangeInput>;
  hasIssuedEvent?: InputMaybe<Scalars['Boolean']['input']>;
  hasNonZeroLines?: InputMaybe<Scalars['Boolean']['input']>;
  hasSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  hasVoidedEvent?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  isUserControlled?: InputMaybe<Scalars['Boolean']['input']>;
  matchContext?: InputMaybe<InvoiceMatchContext>;
  productIds?: InputMaybe<Array<Scalars['ProductID']['input']>>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
};

export type InvoiceLine = WithReportingClasses & {
  __typename?: 'InvoiceLine';
  amount: Money;
  classAwareType: ClassAwareType;
  classSegments: Array<AvailableClassSegment>;
  /** @deprecated Use ledgerCategory */
  coaKey?: Maybe<Scalars['String']['output']>;
  company: Company;
  contractLine?: Maybe<ContractLine>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountLines: Array<InvoiceDiscountLine>;
  id: Scalars['InvoiceLineItemID']['output'];
  invoice: Invoice;
  ledgerCategory?: Maybe<LedgerCategory>;
  product?: Maybe<Product>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  schedule?: Maybe<ContractRevenueSchedule>;
  taxLines?: Maybe<Array<InvoiceTaxLine>>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceLineItemAmounts = {
  __typename?: 'InvoiceLineItemAmounts';
  deferred: Money;
  recognized: Money;
  total: Money;
};

export type InvoiceLineItemFilterBy = {
  isAccountingConfigurationApplied?: InputMaybe<Scalars['Boolean']['input']>;
  recognitionDateRange?: InputMaybe<EndExclusiveLocalDateRangeInput>;
};

export type InvoiceLineItemPaginator = {
  __typename?: 'InvoiceLineItemPaginator';
  amounts: InvoiceLineItemAmounts;
  invoiceLineItems: Array<InvoiceLine>;
  pageInfo: PageInfo;
};

export enum InvoiceLineItemSortOrder {
  RecognitionDateAsc = 'RECOGNITION_DATE_ASC',
  RecognitionDateDesc = 'RECOGNITION_DATE_DESC'
}

export type InvoiceLineRevRecOptionsInput = {
  accountingConfigurationId?: InputMaybe<Scalars['AccountingConfigurationID']['input']>;
  accountingOptions?: InputMaybe<ConfirmContractLineAccountingOptions>;
};

export type InvoiceListExportOptions = {
  asOf?: InputMaybe<Scalars['LocalDate']['input']>;
  filterBy?: InputMaybe<InvoiceFilterBy>;
  reportFormat: ReportFormat;
  sortBy: InvoiceSortOrder;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceMatchContext = {
  amount: Scalars['Decimal']['input'];
  date: Scalars['LocalDate']['input'];
};

export type InvoicePaginator = {
  __typename?: 'InvoicePaginator';
  items: Array<Invoice>;
  pageInfo: PageInfo;
  total: Money;
};

export type InvoiceQuery = {
  __typename?: 'InvoiceQuery';
  accuracyCheckId?: Maybe<Scalars['AccuracyCheckID']['output']>;
  /** @deprecated No longer supported */
  hasIssuedEvent?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer supported */
  hasNonZeroLines?: Maybe<Scalars['Boolean']['output']>;
  hasSchedule?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer supported */
  hasVoidedEvent?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer supported */
  isRemoved?: Maybe<Scalars['Boolean']['output']>;
  statuses?: Maybe<Array<InvoiceStatus>>;
};

export type InvoiceShippingLine = WithReportingClasses & {
  __typename?: 'InvoiceShippingLine';
  classAwareType: ClassAwareType;
  classSegments: Array<AvailableClassSegment>;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['InvoiceShippingLineID']['output'];
  invoice: Invoice;
  ledgerCategory?: Maybe<LedgerCategory>;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  subtotal: Money;
  taxAmount: Money;
  taxLines: Array<InvoiceTaxLine>;
  total: Money;
  updatedAt: Scalars['DateTime']['output'];
};

export enum InvoiceSortOrder {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  CustomerAsc = 'CUSTOMER_ASC',
  CustomerDesc = 'CUSTOMER_DESC',
  DescriptorAsc = 'DESCRIPTOR_ASC',
  DescriptorDesc = 'DESCRIPTOR_DESC',
  DueDateAsc = 'DUE_DATE_ASC',
  DueDateDesc = 'DUE_DATE_DESC',
  IssueDateAsc = 'ISSUE_DATE_ASC',
  IssueDateDesc = 'ISSUE_DATE_DESC'
}

export type InvoiceStatsResult = {
  __typename?: 'InvoiceStatsResult';
  total: Scalars['Int']['output'];
};

export enum InvoiceStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  Paid = 'Paid',
  Posted = 'Posted',
  Voided = 'Voided'
}

export type InvoiceTaxLine = WithReportingClasses & {
  __typename?: 'InvoiceTaxLine';
  amount: Money;
  classAwareType: ClassAwareType;
  classSegments: Array<AvailableClassSegment>;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['InvoiceTaxLineID']['output'];
  invoice: Invoice;
  ledgerCategory?: Maybe<LedgerCategory>;
  parentInvoiceLine?: Maybe<InvoiceLine>;
  parentInvoiceShippingLine?: Maybe<InvoiceShippingLine>;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  taxRate: TaxRate;
  taxableAmount: Money;
  updatedAt: Scalars['DateTime']['output'];
};

export enum JournalEntryType {
  Manual = 'MANUAL',
  Partner = 'PARTNER'
}

export type KickCompanyIngestionInput = {
  id: Scalars['ID']['input'];
};

export type KickCompanyIngestionResult = {
  __typename?: 'KickCompanyIngestionResult';
  company: Company;
};

export enum LastMileChannelType {
  Email = 'email',
  InApp = 'in_app',
  Slack = 'slack'
}

export type LastMilePreference = {
  __typename?: 'LastMilePreference';
  absAmountGreaterThan: Scalars['Decimal']['output'];
  companyId: Scalars['ID']['output'];
  emailCountCap: Scalars['Int']['output'];
  enableCategorySuggestions: Scalars['Boolean']['output'];
  sources: Array<Scalars['AccountID']['output']>;
};

export type LastMilePreferenceInput = {
  absAmountGreaterThan: Scalars['Decimal']['input'];
  emailCountCap: Scalars['Int']['input'];
  enableCategorySuggestions: Scalars['Boolean']['input'];
  sources: Array<Scalars['AccountID']['input']>;
};

export type LastRunEntry = {
  __typename?: 'LastRunEntry';
  check: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type LatestTransactionsSpendingTrends = {
  __typename?: 'LatestTransactionsSpendingTrends';
  categoryTransactions?: Maybe<Array<TransactionMetric>>;
  ledgerCategory?: Maybe<LedgerCategory>;
  range: InclusiveDateRange;
  vendor?: Maybe<Vendor>;
  vendorTransactions?: Maybe<Array<TransactionMetric>>;
};

export type LedgerAccount = {
  __typename?: 'LedgerAccount';
  category: LedgerAccountCategory;
  coaKeys: Array<Scalars['String']['output']>;
  companyId: Scalars['ID']['output'];
  currentness?: Maybe<Scalars['String']['output']>;
  deprecatedCoaKeys: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  entityId: Scalars['ID']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  info: LedgerAccountInfo;
  keywords: Array<Scalars['String']['output']>;
  ledgerReconciliationSummary?: Maybe<LedgerReconciliationSummary>;
  parentDisplayId?: Maybe<Scalars['String']['output']>;
  subCategory?: Maybe<LedgerAccountSubCategory>;
  systemOwned: Scalars['Boolean']['output'];
  tags: Array<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  tertiaryCategory?: Maybe<LedgerAccountTertiaryCategory>;
  type: LedgerAccountType;
  views: Array<Scalars['String']['output']>;
};

export type LedgerAccountBalance = {
  __typename?: 'LedgerAccountBalance';
  accountId: Scalars['String']['output'];
  balance: Scalars['Decimal']['output'];
  displayId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
};

export enum LedgerAccountCategory {
  AccountsPayable = 'accounts_payable',
  AccountsReceivable = 'accounts_receivable',
  AccruedExpenses = 'accrued_expenses',
  AccruedRevenue = 'accrued_revenue',
  Bank = 'bank',
  CommonStock = 'common_stock',
  ConvertibleDebt = 'convertible_debt',
  CostOfRevenue = 'cost_of_revenue',
  CreditCard = 'credit_card',
  Debt = 'debt',
  Deposits = 'deposits',
  Inventory = 'inventory',
  Investments = 'investments',
  NonOperatingExpenses = 'non_operating_expenses',
  NonOperatingIncome = 'non_operating_income',
  NotesPayable = 'notes_payable',
  OperatingExpenses = 'operating_expenses',
  OperatingIncome = 'operating_income',
  OtherAssets = 'other_assets',
  OtherEquity = 'other_equity',
  OtherLiabilities = 'other_liabilities',
  PreferredStock = 'preferred_stock',
  PrepaidExpenses = 'prepaid_expenses',
  RetainedEarnings = 'retained_earnings',
  SalesTax = 'sales_tax',
  Suspense = 'suspense',
  UnbilledReceivables = 'unbilled_receivables'
}

export enum LedgerAccountCurrentness {
  Current = 'current',
  Noncurrent = 'noncurrent'
}

export type LedgerAccountInfo = {
  __typename?: 'LedgerAccountInfo';
  accountId: Scalars['String']['output'];
  categories: Array<Category>;
  displayId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  externalAccountId?: Maybe<Scalars['String']['output']>;
  financialInstitutionAccount?: Maybe<Account>;
  integrationCounterpartyId?: Maybe<Scalars['String']['output']>;
  integrationType?: Maybe<Scalars['String']['output']>;
  statuses: Array<LedgerAccountStatus>;
};

export enum LedgerAccountReconciliationStatus {
  InProgress = 'InProgress',
  Reconciled = 'Reconciled',
  Unstarted = 'Unstarted'
}

export type LedgerAccountStatus = {
  type: LedgerAccountStatusType;
  value: LedgerAccountStatusValue;
};

export enum LedgerAccountStatusType {
  CreditCardAccuracy = 'CreditCardAccuracy'
}

export enum LedgerAccountStatusValue {
  Error = 'Error'
}

export enum LedgerAccountSubCategory {
  AdvertisingAndPromotional = 'advertising_and_promotional',
  Amortization = 'amortization',
  BadDebt = 'bad_debt',
  CashOnHand = 'cash_on_hand',
  Checking = 'checking',
  Clearing = 'clearing',
  Depreciation = 'depreciation',
  Facilities = 'facilities',
  GeneralAdministrative = 'general_administrative',
  Interest = 'interest',
  InterestAndDividendIncome = 'interest_and_dividend_income',
  MealsAndEntertainment = 'meals_and_entertainment',
  Other = 'other',
  OtherEmployee = 'other_employee',
  PaymentProcessor = 'payment_processor',
  Payroll = 'payroll',
  PenaltiesAndSettlements = 'penalties_and_settlements',
  ProfessionalServices = 'professional_services',
  Savings = 'savings',
  Suspense = 'suspense',
  Taxes = 'taxes',
  TechnologyAndSoftware = 'technology_and_software',
  Travel = 'travel'
}

export enum LedgerAccountTertiaryCategory {
  Accounting = 'accounting',
  Benefits = 'benefits',
  Bonuses = 'bonuses',
  Clearing = 'clearing',
  Commissions = 'commissions',
  Insurance = 'insurance',
  Legal = 'legal',
  PayrollClearing = 'payroll_clearing',
  PayrollFees = 'payroll_fees',
  PayrollTaxes = 'payroll_taxes',
  Rent = 'rent',
  RepairAndMaintenance = 'repair_and_maintenance',
  Retirement = 'retirement',
  Salaries = 'salaries',
  Utilities = 'utilities'
}

export enum LedgerAccountType {
  Asset = 'asset',
  ContraAsset = 'contra_asset',
  ContraEquity = 'contra_equity',
  ContraExpense = 'contra_expense',
  ContraLiability = 'contra_liability',
  ContraRevenue = 'contra_revenue',
  Equity = 'equity',
  Expense = 'expense',
  GainOrLoss = 'gain_or_loss',
  Liability = 'liability',
  Revenue = 'revenue'
}

export type LedgerAccountingPeriodInterval = {
  __typename?: 'LedgerAccountingPeriodInterval';
  /** This key determines the user-supplied accounting period's friendly name. */
  key: Scalars['String']['output'];
  periods: Array<Scalars['Period']['output']>;
};

export type LedgerAccountingPeriodIntervalInput = {
  /**
   * This key with be returned as a `columnKey` in BalanceByReportColumn
   * If `columnBy` = "Interval"
   */
  key: Scalars['String']['input'];
  periods: Array<Scalars['Period']['input']>;
};

export type LedgerCategory = Category & {
  __typename?: 'LedgerCategory';
  accountType?: Maybe<LedgerAccountType>;
  /** @deprecated No longer supported */
  coaDisplayId?: Maybe<Scalars['String']['output']>;
  coaKey: Scalars['String']['output'];
  companyId: Scalars['ID']['output'];
  defaultCashlike: Cashlike;
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ID']['output']>;
  examples?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated No longer supported */
  name: Scalars['String']['output'];
  /** @deprecated No longer supported */
  permaKey: Scalars['String']['output'];
  ruleType?: Maybe<Scalars['String']['output']>;
  shortName: Scalars['String']['output'];
  templateId?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LedgerCoaKeyMapping = {
  from: Scalars['LedgerCoaKey']['input'];
  to?: InputMaybe<Scalars['LedgerCoaKey']['input']>;
};

export type LedgerCompanyEvent = {
  __typename?: 'LedgerCompanyEvent';
  amount: Scalars['Decimal']['output'];
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  effectiveAt: Scalars['DateTime']['output'];
  entityId: Scalars['ID']['output'];
  extraMetadata?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['ID']['output'];
  journals?: Maybe<Array<LedgerJournal>>;
  schemaVersion?: Maybe<Scalars['Decimal']['output']>;
  sequenceId?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Decimal']['output']>;
};

export type LedgerDateRangeInterval = {
  __typename?: 'LedgerDateRangeInterval';
  /**
   * This key with be returned as a `columnKey` in BalanceByReportColumn
   * if `columnBy` = "Interval"
   */
  key: Scalars['String']['output'];
  range: InclusiveDateRange;
};

export type LedgerDateRangeIntervalInput = {
  /**
   * This key with be returned as a `columnKey` in BalanceByReportColumn
   * if `columnBy` = "Interval"
   */
  key: Scalars['String']['input'];
  range: InclusiveLocalDateRangeInput;
};

export type LedgerEntriesForReconciliation = {
  __typename?: 'LedgerEntriesForReconciliation';
  amount: Money;
  effectiveAt: Scalars['DateTime']['output'];
  entryType?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  ledgerReconciliationEntry?: Maybe<LedgerReconciliationEntry>;
  ledgerReconciliationId: Scalars['LedgerReconciliationID']['output'];
  transaction?: Maybe<Transaction>;
  version: Scalars['Int']['output'];
};

export type LedgerEntriesForReconciliationInput = {
  effectiveDateTo: Scalars['InclusiveDay']['input'];
  excludeReconciled: Scalars['Boolean']['input'];
  ledgerAccountId: Scalars['ID']['input'];
  reconciliationId?: InputMaybe<Scalars['LedgerReconciliationID']['input']>;
  view: LedgerView;
};

export type LedgerEntriesForReconciliationPaginator = {
  __typename?: 'LedgerEntriesForReconciliationPaginator';
  items: Array<LedgerEntriesForReconciliation>;
};

export type LedgerEntry = {
  __typename?: 'LedgerEntry';
  account: LedgerAccount;
  accountId: Scalars['ID']['output'];
  amount?: Maybe<Scalars['Decimal']['output']>;
  companyId: Scalars['ID']['output'];
  counterpartyId?: Maybe<Scalars['ID']['output']>;
  counterpartyType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  departmentId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveAt: Scalars['DateTime']['output'];
  entityId: Scalars['ID']['output'];
  event: LedgerEvent;
  eventId: Scalars['ID']['output'];
  extraMetadata?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['ID']['output'];
  journal: LedgerJournal;
  journalId: Scalars['ID']['output'];
  ledger?: Maybe<Scalars['String']['output']>;
  postedAt: Scalars['DateTime']['output'];
  productId?: Maybe<Scalars['ID']['output']>;
  reversedEntry?: Maybe<LedgerEntry>;
  reversedEntryId?: Maybe<Scalars['ID']['output']>;
  sequenceId?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  view?: Maybe<LedgerView>;
};

export type LedgerEvent = {
  __typename?: 'LedgerEvent';
  amount: Scalars['Decimal']['output'];
  bill?: Maybe<Bill>;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  effectiveAt: Scalars['DateTime']['output'];
  entityId: Scalars['ID']['output'];
  entries?: Maybe<Array<LedgerEntry>>;
  externalId: Scalars['ID']['output'];
  extraMetadata?: Maybe<Scalars['JSONObject']['output']>;
  fixedAsset?: Maybe<FixedAsset>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<Invoice>;
  journals?: Maybe<Array<LedgerJournal>>;
  prepaidExpense?: Maybe<Prepaid>;
  schemaVersion?: Maybe<Scalars['Int']['output']>;
  sequenceId?: Maybe<Scalars['Int']['output']>;
  shortExternalId: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  transaction?: Maybe<Transaction>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type LedgerEventParams = {
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtToExclusive?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveAtToExclusive?: InputMaybe<Scalars['DateTime']['input']>;
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  highWatermarkToken?: InputMaybe<Scalars['String']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  includeJournals?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Decimal']['input']>;
  offset?: InputMaybe<Scalars['Decimal']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAtToExclusive?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum LedgerEventStatus {
  Failed = 'Failed',
  NotApplicable = 'NotApplicable',
  Pending = 'Pending',
  Processing = 'Processing',
  Success = 'Success'
}

export type LedgerExcelMultiReportDownloadByPeriodInput = {
  companyId: Scalars['CompanyID']['input'];
  config: LedgerReportConfigInput;
  decimalTruncate?: InputMaybe<Scalars['Boolean']['input']>;
  highWatermarkToken?: InputMaybe<Scalars['ID']['input']>;
  includeAccountNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<LedgerReportLevel>;
  reports: Array<DynamicReportType>;
  summaryColumn?: InputMaybe<SummaryColumn>;
  view?: InputMaybe<LedgerView>;
};

export type LedgerExcelReportDownloadByPeriod = {
  __typename?: 'LedgerExcelReportDownloadByPeriod';
  file: File;
  intervals: Array<LedgerAccountingPeriodInterval>;
  title: Scalars['String']['output'];
};

export type LedgerExcelReportDownloadByPeriodInput = {
  companyId: Scalars['CompanyID']['input'];
  config: LedgerReportConfigInput;
  decimalTruncate?: InputMaybe<Scalars['Boolean']['input']>;
  highWatermarkToken?: InputMaybe<Scalars['ID']['input']>;
  includeAccountNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<LedgerReportLevel>;
  summaryColumn?: InputMaybe<SummaryColumn>;
  type: DynamicReportType;
  view?: InputMaybe<LedgerView>;
};

export type LedgerFooterConfig = {
  __typename?: 'LedgerFooterConfig';
  modifiers: Array<LedgerHeaderModifier>;
  prefix?: Maybe<Scalars['String']['output']>;
  type: LedgerFooterType;
};

export enum LedgerFooterType {
  None = 'none',
  Total = 'total'
}

export type LedgerHeaderConfig = {
  __typename?: 'LedgerHeaderConfig';
  modifiers: Array<LedgerHeaderModifier>;
  prefix?: Maybe<Scalars['String']['output']>;
  type: LedgerHeaderType;
};

export enum LedgerHeaderModifier {
  BottomSpacingBuffer = 'bottom_spacing_buffer',
  OnlyIfChildrenPresent = 'only_if_children_present',
  TopSpacingBuffer = 'top_spacing_buffer'
}

export enum LedgerHeaderType {
  None = 'none',
  Title = 'title'
}

export type LedgerHistory = {
  __typename?: 'LedgerHistory';
  balances?: Maybe<Array<LedgerHistoryBalance>>;
  company?: Maybe<Company>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['LedgerHistoryID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status: LedgerHistoryStatus;
  storedFile: File;
  views: Array<LedgerView>;
};

export type LedgerHistoryBalance = {
  __typename?: 'LedgerHistoryBalance';
  endingDate: Scalars['LocalDate']['output'];
  id: Scalars['ID']['output'];
  lines?: Maybe<Array<LedgerHistoryBalanceLine>>;
};

export type LedgerHistoryBalanceLine = {
  __typename?: 'LedgerHistoryBalanceLine';
  accountDisplayId: Scalars['String']['output'];
  amount: Money;
  id: Scalars['ID']['output'];
  ledgerCategory: LedgerCategory;
};

export enum LedgerHistoryStatus {
  Draft = 'Draft',
  Published = 'Published'
}

export type LedgerJournal = {
  __typename?: 'LedgerJournal';
  companyId: Scalars['ID']['output'];
  correctionEvent?: Maybe<LedgerEvent>;
  correctionEventId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  effectiveAt: Scalars['DateTime']['output'];
  entityId: Scalars['ID']['output'];
  entries: Array<LedgerEntry>;
  event: LedgerEvent;
  eventId: Scalars['ID']['output'];
  extraMetadata?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['ID']['output'];
  ledger?: Maybe<Scalars['String']['output']>;
  postedAt: Scalars['DateTime']['output'];
  postingPeriod: Scalars['String']['output'];
  reversedJournal?: Maybe<LedgerJournal>;
  reversedJournalId?: Maybe<Scalars['ID']['output']>;
  sequenceId?: Maybe<Scalars['Int']['output']>;
  shortId: Scalars['String']['output'];
  totalCredit: Scalars['Decimal']['output'];
  totalDebit: Scalars['Decimal']['output'];
  view?: Maybe<LedgerView>;
};

export type LedgerReconciliation = {
  __typename?: 'LedgerReconciliation';
  balanceSummary?: Maybe<LedgerReconciliationBalanceSummary>;
  companyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastLedgerReconciliation?: Maybe<LedgerReconciliation>;
  ledgerAccountId: Scalars['ID']['output'];
  ledgerReconciliationEntries: Array<LedgerReconciliationEntry>;
  statementBalance?: Maybe<Scalars['Decimal']['output']>;
  statementDate?: Maybe<Scalars['LocalDate']['output']>;
  status: ReconciliationStatus;
  storedFiles?: Maybe<Array<File>>;
  view: LedgerView;
};

export type LedgerReconciliationBalanceSummary = {
  __typename?: 'LedgerReconciliationBalanceSummary';
  totalDeposits: Money;
  totalPayments: Money;
};

export type LedgerReconciliationCompanySettingsResult = {
  __typename?: 'LedgerReconciliationCompanySettingsResult';
  company: Company;
};

export type LedgerReconciliationEntry = {
  __typename?: 'LedgerReconciliationEntry';
  amount: Money;
  effectiveAt: Scalars['DateTime']['output'];
  eventSchemaType: Scalars['String']['output'];
  externalId: Scalars['ID']['output'];
  id: Scalars['LedgerReconciliationEntryID']['output'];
  ledgerEntryId: Scalars['ID']['output'];
  ledgerReconciliationId: Scalars['LedgerReconciliationID']['output'];
  selected: Scalars['Boolean']['output'];
  transaction?: Maybe<Transaction>;
  version: Scalars['Int']['output'];
};

export type LedgerReconciliationFilterBy = {
  ledgerAccountId?: InputMaybe<Scalars['ID']['input']>;
  statementDayRange?: InputMaybe<EndExclusiveLocalDateRangeInput>;
  statuses?: InputMaybe<Array<ReconciliationStatus>>;
  views?: InputMaybe<Array<InputMaybe<LedgerView>>>;
};

export type LedgerReconciliationPaginator = {
  __typename?: 'LedgerReconciliationPaginator';
  items: Array<LedgerReconciliation>;
  pageInfo: PageInfo;
};

export type LedgerReconciliationResult = {
  __typename?: 'LedgerReconciliationResult';
  ledgerReconciliation: LedgerReconciliation;
};

export type LedgerReconciliationSummary = {
  __typename?: 'LedgerReconciliationSummary';
  accrualLedgerReconciliationViewSummary?: Maybe<LedgerReconciliationViewSummary>;
  active?: Maybe<LedgerReconciliation>;
  cashLedgerReconciliationViewSummary?: Maybe<LedgerReconciliationViewSummary>;
  lastReconciled?: Maybe<LedgerReconciliation>;
  status: LedgerAccountReconciliationStatus;
};

export type LedgerReconciliationViewSummary = {
  __typename?: 'LedgerReconciliationViewSummary';
  active?: Maybe<LedgerReconciliation>;
  lastReconciled?: Maybe<LedgerReconciliation>;
  status: LedgerAccountReconciliationStatus;
};

export type LedgerReport = {
  accounts: Array<LedgerAccountInfo>;
  columnBy: LedgerReportColumnBy;
  highWatermarkToken?: Maybe<Scalars['ID']['output']>;
  lines: Array<LedgerReportLine>;
  timestamp: Scalars['DateTime']['output'];
};

export type LedgerReportAccountingIntervalMetadata = {
  __typename?: 'LedgerReportAccountingIntervalMetadata';
  checklist: Checklist;
  key: Scalars['String']['output'];
  periods: Array<Scalars['Period']['output']>;
  uncategorized: CategorizationStats;
  unfinalized: CategorizationStats;
};

export type LedgerReportBreakoutByPeriod = {
  __typename?: 'LedgerReportBreakoutByPeriod';
  hasMore: Scalars['Boolean']['output'];
  highWatermarkToken?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  lines: Array<ReportBreakoutLine>;
  nextPageStartingAfter?: Maybe<Scalars['ID']['output']>;
  periods: Array<Scalars['Period']['output']>;
};

export type LedgerReportBreakoutByPeriodInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['CompanyID']['input'];
  interval: LedgerAccountingPeriodIntervalInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pathToken: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DynamicReportType;
};

export type LedgerReportByInterval = LedgerReport & {
  __typename?: 'LedgerReportByInterval';
  accounts: Array<LedgerAccountInfo>;
  columnBy: LedgerReportColumnBy;
  highWatermarkToken?: Maybe<Scalars['ID']['output']>;
  intervalMetadata: Array<LedgerReportIntervalMetadata>;
  lines: Array<LedgerReportLine>;
  timestamp: Scalars['DateTime']['output'];
};

export type LedgerReportBySegment = LedgerReport & {
  __typename?: 'LedgerReportBySegment';
  accounts: Array<LedgerAccountInfo>;
  columnBy: LedgerReportColumnBy;
  highWatermarkToken?: Maybe<Scalars['ID']['output']>;
  lines: Array<LedgerReportLine>;
  timestamp: Scalars['DateTime']['output'];
};

export enum LedgerReportColumnBy {
  Interval = 'Interval',
  Segment = 'Segment'
}

export type LedgerReportColumnsInput = {
  segments?: InputMaybe<LedgerReportSegmentFilterInput>;
};

export type LedgerReportConfigInput = {
  columnBy: LedgerReportColumnBy;
  columns?: InputMaybe<LedgerReportColumnsInput>;
  expansionOptions?: InputMaybe<LedgerReportExpansionOptions>;
  filter?: InputMaybe<LedgerReportFilterInput>;
  intervals: LedgerReportIntervalInput;
};

export enum LedgerReportCounterpartyType {
  Contractor = 'contractor',
  Customer = 'customer',
  Employee = 'employee',
  Vendor = 'vendor'
}

export type LedgerReportDownloadByPeriod = {
  __typename?: 'LedgerReportDownloadByPeriod';
  csvReport: Scalars['String']['output'];
  file: File;
  intervals: Array<LedgerAccountingPeriodInterval>;
  title: Scalars['String']['output'];
};

export type LedgerReportDownloadByPeriodInput = {
  companyId: Scalars['CompanyID']['input'];
  config: LedgerReportConfigInput;
  highWatermarkToken?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<LedgerReportLevel>;
  type: DynamicReportType;
  view?: InputMaybe<LedgerView>;
};

export type LedgerReportEventMetadata = {
  __typename?: 'LedgerReportEventMetadata';
  effectiveAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Scalars['String']['output']>;
  externalAccountId?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['ID']['output']>;
};

export type LedgerReportExpansionOptions = {
  expandRevenueSources?: InputMaybe<Scalars['Boolean']['input']>;
  expandVendors?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LedgerReportFilterInput = {
  segments?: InputMaybe<LedgerReportSegmentFilterInput>;
};

export type LedgerReportFormatting = {
  __typename?: 'LedgerReportFormatting';
  footer: LedgerFooterConfig;
  header: LedgerHeaderConfig;
  indentChildren: Scalars['Boolean']['output'];
};

export type LedgerReportInput = {
  companyId: Scalars['CompanyID']['input'];
  config: LedgerReportConfigInput;
  type: DynamicReportType;
  view: LedgerView;
};

export type LedgerReportIntervalInput = {
  byDate?: InputMaybe<Array<LedgerDateRangeIntervalInput>>;
  byPeriod?: InputMaybe<Array<LedgerAccountingPeriodIntervalInput>>;
};

export type LedgerReportIntervalMetadata = {
  __typename?: 'LedgerReportIntervalMetadata';
  checklist?: Maybe<Checklist>;
  interval: LedgerReportTemporalInterval;
  uncategorized: CategorizationStats;
  unfinalized: CategorizationStats;
};

export enum LedgerReportLevel {
  Compact = 'Compact',
  Detailed = 'Detailed',
  Summary = 'Summary'
}

export type LedgerReportLine = {
  __typename?: 'LedgerReportLine';
  accountNumber?: Maybe<Scalars['String']['output']>;
  balanceByColumn: Array<BalanceByReportColumn>;
  childIds: Array<Scalars['ID']['output']>;
  /** @deprecated No longer supported */
  children: Array<Scalars['ID']['output']>;
  formatting: LedgerReportFormatting;
  id: Scalars['ID']['output'];
  lineType: LedgerReportLineType;
  metadata?: Maybe<LedgerReportLineMetadata>;
  nodeTags: Array<ReportLineTag>;
  parentId?: Maybe<Scalars['ID']['output']>;
  relatedObjectId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

export type LedgerReportLineMetadata = {
  __typename?: 'LedgerReportLineMetadata';
  counterpartyName?: Maybe<Scalars['String']['output']>;
  counterpartyType?: Maybe<LedgerReportCounterpartyType>;
  revenueSourceType?: Maybe<LedgerReportRevenueSourceType>;
};

export enum LedgerReportLineType {
  Account = 'account',
  AccrualRevenueSource = 'accrual_revenue_source',
  Counterparty = 'counterparty',
  Department = 'department',
  Event = 'event',
  ParentAccountGroup = 'parent_account_group',
  RevenueSource = 'revenue_source',
  Rollup = 'rollup'
}

export type LedgerReportPeriodMetadata = {
  __typename?: 'LedgerReportPeriodMetadata';
  end: Scalars['Date']['output'];
  start: Scalars['Date']['output'];
  timePeriodKey: Scalars['String']['output'];
  uncategorized: CategorizationStats;
  unfinalized: CategorizationStats;
};

export enum LedgerReportRevenueSourceType {
  Invoice = 'invoice',
  Mje = 'mje',
  Other = 'other',
  Schedule = 'schedule',
  Subledger = 'subledger',
  Transaction = 'transaction'
}

export type LedgerReportSegmentFilterInput = {
  reportingClassId: Scalars['TagNameID']['input'];
  reportingClassType: ReportingClassType;
  segmentIds: Array<Scalars['TagValueID']['input']>;
};

export type LedgerReportTemporalInterval = LedgerAccountingPeriodInterval | LedgerDateRangeInterval;

export enum LedgerType {
  AccountsPayable = 'accounts_payable',
  AccountsReceivable = 'accounts_receivable',
  Bank = 'bank',
  CreditCard = 'credit_card',
  FixedAssets = 'fixed_assets',
  General = 'general',
  Inventory = 'inventory',
  Investment = 'investment',
  PaymentProcessor = 'payment_processor',
  PayrollByDepartment = 'payroll_by_department',
  PayrollByEmployee = 'payroll_by_employee'
}

export enum LedgerView {
  Accrual = 'accrual',
  Cash = 'cash'
}

export type LinkBillsToTransactionInput = {
  billIds: Array<Scalars['BillID']['input']>;
  companyId: Scalars['CompanyID']['input'];
  transactionId: Scalars['TransactionID']['input'];
  unmatchedAmountCoaKey?: InputMaybe<Scalars['String']['input']>;
  unmatchedSplitDescription?: InputMaybe<Scalars['String']['input']>;
};

export type LinkBillsToTransactionResult = {
  __typename?: 'LinkBillsToTransactionResult';
  transaction: Transaction;
};

export enum LinkExistingAccountError {
  EmailNotVerified = 'EmailNotVerified',
  HasMultipleCompanies = 'HasMultipleCompanies',
  HasZeroCompanies = 'HasZeroCompanies'
}

export type LinkExistingAccountInput = {
  token: Scalars['String']['input'];
};

export type LinkExistingAccountResult = {
  __typename?: 'LinkExistingAccountResult';
  apiUser?: Maybe<ApiUser>;
  error?: Maybe<LinkExistingAccountError>;
  self?: Maybe<User>;
};

export type LinkPlaidItemInput = {
  institutionName: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
};

export type LinkPlaidItemResult = {
  __typename?: 'LinkPlaidItemResult';
  plaidItem?: Maybe<PlaidItem>;
};

export type LinkStoredFileToEntityInput = {
  entityId: Scalars['ID']['input'];
  entityType: AssociatedEntity;
  fileId: Scalars['StoredFileID']['input'];
};

export type LinkStoredFileToEntityResult = {
  __typename?: 'LinkStoredFileToEntityResult';
  entityId: Scalars['ID']['output'];
  entityType: AssociatedEntity;
  file: File;
};

export enum LlmMessageActor {
  Gpt = 'Gpt',
  User = 'User'
}

export type LlmMessageThread = {
  __typename?: 'LlmMessageThread';
  id: Scalars['ID']['output'];
};

export type LocalDateRange = {
  __typename?: 'LocalDateRange';
  from: Scalars['LocalDate']['output'];
  to: Scalars['LocalDate']['output'];
};

export type LocalDateRangeInput = {
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
};

export enum LockWarning {
  PeriodInProcessing = 'PeriodInProcessing',
  UncategorizedTransactions = 'UncategorizedTransactions',
  UnreconciledPeriods = 'UnreconciledPeriods'
}

export type LockedPeriod = {
  __typename?: 'LockedPeriod';
  period?: Maybe<Scalars['Month']['output']>;
};

export type LockedPeriodInput = {
  companyId: Scalars['ID']['input'];
  period?: InputMaybe<Scalars['Month']['input']>;
};

export type LogoutResult = {
  __typename?: 'LogoutResult';
  error?: Maybe<Scalars['String']['output']>;
};

export type ManualCategorizationRule = AdminCategorizationRule | UserCategorizationRule;

export type ManualCreditCardOffsetTransactionInput = {
  destinationAccountId: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
};

export type ManualJournalEntry = {
  __typename?: 'ManualJournalEntry';
  activity: Array<AccountingRecordActivity>;
  autoReversalDate?: Maybe<Scalars['LocalDate']['output']>;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdFor?: Maybe<Scalars['String']['output']>;
  credit: Scalars['Decimal']['output'];
  currency: Scalars['Currency']['output'];
  debit: Scalars['Decimal']['output'];
  documents: Array<AccountingRecordDocument>;
  error?: Maybe<Scalars['String']['output']>;
  group?: Maybe<ManualJournalEntryGroup>;
  id: Scalars['ManualJournalEntryID']['output'];
  isAutoReversal: Scalars['Boolean']['output'];
  isHistorical: Scalars['Boolean']['output'];
  isTemplate: Scalars['Boolean']['output'];
  /** @deprecated Use `isVoiding`. */
  isVoid: Scalars['Boolean']['output'];
  isVoided?: Maybe<Scalars['Boolean']['output']>;
  isVoiding?: Maybe<Scalars['Boolean']['output']>;
  items: Array<ManualJournalEntryItem>;
  memo: Scalars['String']['output'];
  postingDate: Scalars['LocalDate']['output'];
  previousJournal?: Maybe<ManualJournalEntry>;
  recurringTemplate?: Maybe<RecurringTemplate>;
  /** @deprecated Use `recurringTemplate.id`. */
  recurringTemplateId?: Maybe<Scalars['RecurringTemplateID']['output']>;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  reverseJournal?: Maybe<ManualJournalEntry>;
  reversedByJournal?: Maybe<ManualJournalEntry>;
  /** @deprecated Use `reverseByJournal`. */
  reversedByJournals: Array<ManualJournalEntry>;
  shortId: Scalars['String']['output'];
  status: ManualJournalEntryStatus;
  submittedAt?: Maybe<Scalars['LocalDate']['output']>;
  type?: Maybe<JournalEntryType>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
  views: Array<Scalars['String']['output']>;
};

export type ManualJournalEntryFilterBy = {
  containsCoaKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRange: LocalDateRangeInput;
  entryType?: InputMaybe<JournalEntryType>;
  isHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  recurringTemplateFilter?: InputMaybe<ManualJournalEntryRecurringTemplateFilter>;
  status?: InputMaybe<ManualJournalEntryStatus>;
  view?: InputMaybe<ManualJournalEntryViewFilter>;
};

export type ManualJournalEntryGroup = {
  __typename?: 'ManualJournalEntryGroup';
  createdAt: Scalars['DateTime']['output'];
  dataSourceType: DataSourceType;
  entries: Array<ManualJournalEntry>;
  id: Scalars['ID']['output'];
  memo: Scalars['String']['output'];
  netImpact: ManualJournalEntryGroupNetImpact;
  postingDate: Scalars['LocalDate']['output'];
  shortId: Scalars['String']['output'];
  status: ManualJournalEntryGroupStatus;
  total: Money;
  type?: Maybe<JournalEntryType>;
  updatedAt: Scalars['DateTime']['output'];
  views: Array<Scalars['String']['output']>;
};

export type ManualJournalEntryGroupEditPreview = {
  __typename?: 'ManualJournalEntryGroupEditPreview';
  items?: Maybe<Array<ManualJournalEntryGroupEditPreviewItem>>;
};

export type ManualJournalEntryGroupEditPreviewInput = {
  /** Manual Journal Entry Group ID */
  groupId: Scalars['ID']['input'];
  /**
   * Items is the intended end state of the MJE group.
   * This should be undefined if the edit type is Void.
   */
  items?: InputMaybe<Array<UpsertManualJournalEntryItemInput>>;
  manualJournalEntryGroupEditType: ManualJournalEntryGroupEditType;
};

export type ManualJournalEntryGroupEditPreviewItem = {
  __typename?: 'ManualJournalEntryGroupEditPreviewItem';
  lines: Array<ManualJournalEntryItemPreviewItem>;
  type: ManualJournalEntryGroupEditPreviewItemType;
};

export enum ManualJournalEntryGroupEditPreviewItemType {
  Adjustment = 'Adjustment',
  Current = 'Current',
  Net = 'Net',
  Replacement = 'Replacement',
  Voiding = 'Voiding'
}

export enum ManualJournalEntryGroupEditType {
  PostAdjustment = 'PostAdjustment',
  Void = 'Void',
  VoidAndReplace = 'VoidAndReplace'
}

export type ManualJournalEntryGroupFilterBy = {
  containsCoaKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRange?: InputMaybe<InclusiveLocalDateRangeInput>;
  journalType?: InputMaybe<JournalEntryType>;
  statuses?: InputMaybe<Array<ManualJournalEntryGroupStatus>>;
  view?: InputMaybe<ManualJournalEntryViewFilter>;
};

export type ManualJournalEntryGroupNetImpact = {
  __typename?: 'ManualJournalEntryGroupNetImpact';
  lines: Array<ManualJournalEntryGroupNetImpactLine>;
};

export type ManualJournalEntryGroupNetImpactLine = {
  __typename?: 'ManualJournalEntryGroupNetImpactLine';
  amounts: ManualJournalEntryGroupNetImpactLineAmounts;
  classSegments: Array<AvailableClassSegment>;
  customer?: Maybe<Customer>;
  description: Scalars['String']['output'];
  ledgerCategory: LedgerCategory;
  vendor?: Maybe<Vendor>;
};

export type ManualJournalEntryGroupNetImpactLineAmounts = {
  __typename?: 'ManualJournalEntryGroupNetImpactLineAmounts';
  draft: Money;
  posted: Money;
};

export type ManualJournalEntryGroupPaginator = {
  __typename?: 'ManualJournalEntryGroupPaginator';
  items: Array<ManualJournalEntryGroup>;
  pageInfo: PageInfo;
};

export enum ManualJournalEntryGroupSortOrder {
  PostingDateAsc = 'POSTING_DATE_ASC',
  PostingDateDesc = 'POSTING_DATE_DESC'
}

export enum ManualJournalEntryGroupStatus {
  Draft = 'Draft',
  Posted = 'Posted',
  PostedEdited = 'PostedEdited',
  Void = 'Void'
}

export type ManualJournalEntryItem = WithReportingClasses & {
  __typename?: 'ManualJournalEntryItem';
  amount: Scalars['Decimal']['output'];
  classAwareType: ClassAwareType;
  classSegments: Array<AvailableClassSegment>;
  /** @deprecated Use ledgerCategory */
  coaKey: Scalars['String']['output'];
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['Currency']['output'];
  customer?: Maybe<Customer>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ledgerCategory: LedgerCategory;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userDefinedMetadata?: Maybe<Scalars['JSONObject']['output']>;
  vendor?: Maybe<Vendor>;
};

export type ManualJournalEntryItemPreviewClassification = {
  __typename?: 'ManualJournalEntryItemPreviewClassification';
  class: Scalars['TagNameDisplayName']['output'];
  segment: Scalars['TagValueDisplayName']['output'];
};

/**
 * Same as ManualJournalEntryItem but without a company field.
 * Also currently does not have classifications.
 */
export type ManualJournalEntryItemPreviewItem = {
  __typename?: 'ManualJournalEntryItemPreviewItem';
  amount: Scalars['Decimal']['output'];
  classifications: Array<ManualJournalEntryItemPreviewClassification>;
  currency: Scalars['Currency']['output'];
  customer?: Maybe<Customer>;
  description: Scalars['String']['output'];
  ledgerCategory: LedgerCategory;
  vendor?: Maybe<Vendor>;
};

export type ManualJournalEntryPaginator = {
  __typename?: 'ManualJournalEntryPaginator';
  items: Array<ManualJournalEntry>;
  pageInfo: PageInfo;
};

export enum ManualJournalEntryRecurringTemplateFilter {
  All = 'All',
  NoTemplates = 'NoTemplates',
  OnlyTemplates = 'OnlyTemplates'
}

export enum ManualJournalEntrySortOrder {
  InsertOrderAsc = 'INSERT_ORDER_ASC',
  InsertOrderDesc = 'INSERT_ORDER_DESC',
  PostingDateAsc = 'POSTING_DATE_ASC',
  PostingDateDesc = 'POSTING_DATE_DESC'
}

export enum ManualJournalEntryStatus {
  Draft = 'Draft',
  Posted = 'Posted',
  Reversed = 'Reversed',
  Reversing = 'Reversing',
  Voided = 'Voided',
  Voiding = 'Voiding'
}

export enum ManualJournalEntryViewFilter {
  Accrual = 'Accrual',
  Cash = 'Cash'
}

export type ManualRevenueScheduleEntry = {
  __typename?: 'ManualRevenueScheduleEntry';
  amount: Money;
  canEdit: Scalars['Boolean']['output'];
  effectiveDate: Scalars['LocalDate']['output'];
  id: Scalars['ManualRevenueScheduleEntryID']['output'];
};

export type ManualRevenueScheduleEntryInput = {
  amount: MoneyInput;
  effectiveDate: Scalars['LocalDate']['input'];
  id?: InputMaybe<Scalars['ManualRevenueScheduleEntryID']['input']>;
  postImmediately?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ManualTransactionInput = {
  amount: Scalars['Decimal']['input'];
  date: Scalars['LocalDate']['input'];
  descriptor: Scalars['String']['input'];
  ledgerCoaKey: Scalars['String']['input'];
  vendorName: Scalars['String']['input'];
};

export type ManuallyMergeContractorsInput = {
  companyId: Scalars['CompanyID']['input'];
  contractorIds: Array<Scalars['ContractorID']['input']>;
};

export type ManuallyMergeContractorsResult = {
  __typename?: 'ManuallyMergeContractorsResult';
  success: Scalars['Boolean']['output'];
};

export type ManuallyMergeEmployeesInput = {
  companyId: Scalars['CompanyID']['input'];
  employeeIds: Array<Scalars['EmployeeID']['input']>;
};

export type ManuallyMergeEmployeesResult = {
  __typename?: 'ManuallyMergeEmployeesResult';
  success: Scalars['Boolean']['output'];
};

export type MarkAssignmentAsCompleteInput = {
  assignmentId: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
};

export type MatchCustomerBalanceTransactionResult = {
  __typename?: 'MatchCustomerBalanceTransactionResult';
  customerBalanceTransactions: Array<CustomerBalanceTransaction>;
};

export type MatchCustomerBalanceTransactionsInput = {
  companyId: Scalars['CompanyID']['input'];
  match: CustomerBalanceTransactionsToMatchesInput;
};

export type MatchRulesFilter = {
  appliesTo?: InputMaybe<Array<CategorizationRuleApplicationType>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerCoaKey?: InputMaybe<Scalars['String']['input']>;
  vendorPermaName?: InputMaybe<Scalars['String']['input']>;
};

export type MatchVendorBalanceTransactionResult = {
  __typename?: 'MatchVendorBalanceTransactionResult';
  vendorBalanceTransactions: Array<VendorBalanceTransaction>;
};

export type MatchVendorBalanceTransactionsInput = {
  companyId: Scalars['CompanyID']['input'];
  match: VendorBalanceTransactionsToMatchesInput;
};

export enum MembershipRole {
  Admin = 'Admin',
  Bookkeeper = 'Bookkeeper',
  ClientViewer = 'ClientViewer',
  FirmGroup = 'FirmGroup',
  None = 'None',
  Viewer = 'Viewer'
}

export enum MembershipStatus {
  Active = 'Active',
  /** @deprecated No longer supported */
  Pending = 'Pending',
  Revoked = 'Revoked'
}

export type MeowInitializationInfo = {
  __typename?: 'MeowInitializationInfo';
  connectUrl: Scalars['String']['output'];
};


export type MeowInitializationInfoConnectUrlArgs = {
  companyId: Scalars['ID']['input'];
};

export type MeowIntegration = {
  __typename?: 'MeowIntegration';
  connection?: Maybe<IntegrationConnection>;
  connections?: Maybe<Array<IntegrationConnection>>;
  initializationInfo: MeowInitializationInfo;
};


export type MeowIntegrationConnectionArgs = {
  companyId: Scalars['ID']['input'];
};


export type MeowIntegrationConnectionsArgs = {
  companyId: Scalars['ID']['input'];
};

export type MercuryInitializationInfo = {
  __typename?: 'MercuryInitializationInfo';
  connectUrl: Scalars['String']['output'];
};


export type MercuryInitializationInfoConnectUrlArgs = {
  companyId: Scalars['ID']['input'];
};

export type MercuryIntegration = {
  __typename?: 'MercuryIntegration';
  connection?: Maybe<IntegrationConnection>;
  connections?: Maybe<Array<IntegrationConnection>>;
  initializationInfo: MercuryInitializationInfo;
};


export type MercuryIntegrationConnectionArgs = {
  companyId: Scalars['ID']['input'];
};


export type MercuryIntegrationConnectionsArgs = {
  companyId: Scalars['ID']['input'];
};

export type MergeAccountInput = {
  activeAccountId: Scalars['AccountID']['input'];
  cutoffAt?: InputMaybe<Scalars['ExclusiveDay']['input']>;
  inactiveAccountId: Scalars['AccountID']['input'];
  shouldCorrectHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MergeAccountsInput = {
  companyId: Scalars['CompanyID']['input'];
  inputs: Array<MergeAccountInput>;
};

export type MergeAccountsResult = {
  __typename?: 'MergeAccountsResult';
  success: Scalars['Boolean']['output'];
};

export type MergeVendorInput = {
  companyId: Scalars['CompanyID']['input'];
  duplicateVendorId: Scalars['ID']['input'];
  primaryVendorId: Scalars['ID']['input'];
};

export type MergeVendorResult = {
  __typename?: 'MergeVendorResult';
  success: Scalars['Boolean']['output'];
};

export type MergeableAccountsInput = {
  companyId: Scalars['CompanyID']['input'];
  types: Array<AccountType>;
};

export type MergeableAccountsResult = {
  __typename?: 'MergeableAccountsResult';
  accounts: Array<Account>;
};

export type MergedContractor = {
  __typename?: 'MergedContractor';
  mergedId: Scalars['ID']['output'];
  otherContractors: Array<Contractor>;
  primaryContractor: Contractor;
};

export type MergedContractorsToConfirm = {
  contractorIds: Array<Scalars['ContractorID']['input']>;
  mergedId: Scalars['MergedContractorMergedID']['input'];
};

export type MergedEmployee = {
  __typename?: 'MergedEmployee';
  mergedId: Scalars['ID']['output'];
  otherEmployees: Array<Employee>;
  primaryEmployee: Employee;
};

export type MergedEmployeesToConfirm = {
  employeeIds: Array<Scalars['EmployeeID']['input']>;
  mergedId: Scalars['MergedEmployeeMergedID']['input'];
};

export type MergedWorker = MergedContractor | MergedEmployee;

export type MessageSetting = {
  __typename?: 'MessageSetting';
  key: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type MessageSettingInput = {
  key: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type Metric = {
  __typename?: 'Metric';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['Currency']['output'];
  dataFromRange: InclusiveDateRange;
};

export enum MetricCard {
  AccountsPayable = 'AccountsPayable',
  AccountsReceivable = 'AccountsReceivable',
  BurnMtd = 'BurnMtd',
  Cash = 'Cash',
  GrossProfitMargin = 'GrossProfitMargin',
  NetBurn = 'NetBurn',
  NetBurnMoM = 'NetBurnMoM',
  NetProfitMargin = 'NetProfitMargin',
  Revenue = 'Revenue',
  Runway = 'Runway',
  Spend = 'Spend',
  TotalExpenses = 'TotalExpenses'
}

export type MetricCardPreference = {
  __typename?: 'MetricCardPreference';
  enabled: Scalars['Boolean']['output'];
  metricCard: MetricCard;
};

export type MetricCardPreferenceInput = {
  enabled: Scalars['Boolean']['input'];
  metricCard: MetricCard;
};

export type MetricCardPreferences = {
  __typename?: 'MetricCardPreferences';
  companyId: Scalars['CompanyID']['output'];
  metricCardPreferences: Array<MetricCardPreference>;
  userId: Scalars['UserID']['output'];
};

export type MetricDescription = {
  __typename?: 'MetricDescription';
  averageCostPerEmployee: Scalars['String']['output'];
  averageRevenuePerEmployee: Scalars['String']['output'];
  currentToFutureEmployeeRatio: Scalars['String']['output'];
  employeeCostAsAPercentageOfExpense: Scalars['String']['output'];
  employeeCosts: Scalars['String']['output'];
  expenses: Scalars['String']['output'];
  headcount: Scalars['String']['output'];
  revenue: Scalars['String']['output'];
  yearlyEmployeeCost: Scalars['String']['output'];
};

export type MetricOnDate = {
  __typename?: 'MetricOnDate';
  date: Scalars['InclusiveDay']['output'];
  metric: Money;
};

export type MetricsByMonth = {
  __typename?: 'MetricsByMonth';
  metrics: Array<MetricOnDate>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ModifyChecklistItemInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  shouldUpdateChildren?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModifyFirmUserCompanyEntityInput = {
  companyId: Scalars['CompanyID']['input'];
  firmGroupId?: InputMaybe<Scalars['FirmGroupID']['input']>;
  firmId: Scalars['FirmID']['input'];
  firmMembershipId: Scalars['FirmMembershipID']['input'];
  role?: InputMaybe<MembershipRole>;
};

export type ModifyFirmUserCompanyEntityResult = {
  __typename?: 'ModifyFirmUserCompanyEntityResult';
  companyMembership: CompanyMembership;
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['Currency']['output'];
};

export type MoneyInput = {
  amount: Scalars['Decimal']['input'];
  currency: Scalars['Currency']['input'];
};

export type MonthValue = {
  __typename?: 'MonthValue';
  month: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type MonthlyChecklist = ChecklistV2 & {
  __typename?: 'MonthlyChecklist';
  id: Scalars['ID']['output'];
  items: Array<MonthlyChecklistItem>;
  month: Scalars['Month']['output'];
};

export type MonthlyChecklistInfo = {
  __typename?: 'MonthlyChecklistInfo';
  latestChecklist: MonthlyChecklist;
  months: Array<Scalars['Month']['output']>;
};

export type MonthlyChecklistItem = {
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<ChecklistItemKey>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<User>;
  month: Scalars['Month']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  removedBy?: Maybe<User>;
};

export type MonthlyCost = {
  __typename?: 'MonthlyCost';
  month: Scalars['String']['output'];
  value: Scalars['Decimal']['output'];
};

export enum MonthlyExpenses {
  Between10kAnd50k = 'Between10kAnd50k',
  Between50kAnd100k = 'Between50kAnd100k',
  Between100kAnd250k = 'Between100kAnd250k',
  Between250kAnd500k = 'Between250kAnd500k',
  Between500kAnd1m = 'Between500kAnd1m',
  GreaterThan1m = 'GreaterThan1m',
  LessThan10k = 'LessThan10k'
}

export type MonthlySpendingInput = {
  companyId: Scalars['CompanyID']['input'];
  month?: InputMaybe<Scalars['Month']['input']>;
};

export type MonthlySpendingResult = {
  __typename?: 'MonthlySpendingResult';
  id: Scalars['CompanyID']['output'];
  month?: Maybe<Scalars['Month']['output']>;
  threeMonthAverage?: Maybe<Scalars['Decimal']['output']>;
};

export type MoveDateForTransactionInput = {
  accrualDate?: InputMaybe<Scalars['LocalDate']['input']>;
  transactionId: Scalars['ID']['input'];
};

export type MtdBankBurnMetricWithComparison = {
  __typename?: 'MtdBankBurnMetricWithComparison';
  currentMonthBurn: Money;
  currentMonthDate: Scalars['InclusiveDay']['output'];
  prevMonthBurn: Money;
  prevMonthDate: Scalars['InclusiveDay']['output'];
};

export type MtdBankBurnMetrics = {
  __typename?: 'MtdBankBurnMetrics';
  metrics: Array<MtdBankBurnMetricWithComparison>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptPendingInvitations?: Maybe<AcceptInvitationsResult>;
  activateContractRevenueSchedule: ContractRevenueSchedule;
  activatePrepaid: Prepaid;
  addAccountingRecordComment: AccountingRecordComment;
  addClientToFirm: AddClientToFirmResult;
  addCustomChecklistItem: Array<CustomChecklistItem>;
  addFirm: AddFirmResult;
  addGroupToFirm: AddGroupToFirmResult;
  addItemsToStripeSubscription: StripeSubscription;
  addOAuthSupportToApiConnection: ApiConnection;
  addTransactionMessage: UpdateTransactionResult;
  addUserToFirm: AddUserToFirmResult;
  addUserToFirmGroup: AddUserToFirmGroupResult;
  applyClassToEntity: WithReportingClasses;
  applyRevenueRecognitionConfiguration: ApplyRevenueRecognitionConfigurationResponse;
  approveLedgerReconciliation: LedgerReconciliationResult;
  askAIFreeformPrompt: AskAiPromptResponse;
  askAIPrompt: AskAiPromptResponse;
  assignMeToDemoCompany: AssignMeToDemoCompanyResult;
  assignUserToTransaction: UpdateTransactionResult;
  /** @deprecated No longer supported */
  authenticateWithToken: AuthenticateWithTokenResult;
  bulkApplyClassification: BulkApplyClassificationResult;
  bulkUpdateFinalizedState: BulkUpdateFinalizedStateResult;
  bulkUpdateFinalizedStateByFilters: BulkUpdateFinalizedStateResult;
  bulkUpdateTransactions: BulkUpdateTransactionsResult;
  bulkUpsertUserTransactions: BulkTransactionsResult;
  cancelAssignment: UpdateTransactionResult;
  clearCookies: ClearCookiesResult;
  closeContractRevenueSchedule: ContractRevenueSchedule;
  confirmContractLine: ContractLine;
  confirmContractLines: ConfirmContractLinesResult;
  confirmEmailVerification: ConfirmEmailVerificationResult;
  confirmMergedWorkers: ConfirmMergedWorkersResult;
  connectBillDotCom: ConnectBillDotComResult;
  connectBrex: ConnectBrexResult;
  connectDeel: ConnectDeelResult;
  connectFinicity: ConnectFinicityResult;
  connectGusto: ConnectGustoResult;
  connectMeow: ConnectMeowResult;
  connectMercury: ConnectMercuryResult;
  connectPartnerUserToPuzzleUser: ConnectPartnerUserToPuzzleUserResult;
  connectPlaid: ConnectPlaidResult;
  connectQuickbooks: ConnectQuickbooksResult;
  connectRamp: ConnectRampResult;
  connectRippling: ConnectRipplingResult;
  connectStripe: ConnectStripeResult;
  connectSvbOfx: ConnectSvbOfxResult;
  connectToPuzzleSlackApp: ConnectToPuzzleSlackAppResponse;
  connectTrinet: ConnectTrinetResult;
  consentToAI: Company;
  createAccountingConfigurationRule: AccountingConfigurationRule;
  createAdminCategorizationRule: CreateAdminCategorizationRuleResult;
  createAffiliateAttribution: AffiliateAttribution;
  createApiConnection: ApiConnection;
  createClassSegment: Company;
  createCoa: CreateCoaResult;
  createCompany: CreateCompanyResult;
  createCompanyFromPrefilledData: CreateCompanyFromPrefilledDataResult;
  createCompanySpendingReset: CreateCompanySpendingResetResult;
  createContract: Contract;
  createContractLines: CreateContractLinesResult;
  createContractRevenueSchedule: ContractRevenueSchedule;
  createCustomer: CreateCustomerResult;
  createDirectIngestFileCoaKeys: CreateDirectIngestFileCoaKeysResult;
  createDirectIngestFileCoaMapper: CreateDirectIngestFileCoaMapperResult;
  createDirectIngestFileManualJournalEntries: CreateDirectIngestFileManualJournalEntriesResult;
  createFixedAsset: FixedAsset;
  createFixedAssetRule: FixedAssetRule;
  createFixedAssets: CreateFixedAssetsResult;
  createInvoice: Invoice;
  createManualAccount: CreateManualAccountResult;
  createManualCreditCardOffsetTransaction: TransactionResult;
  createManualTransactions: BulkTransactionsResult;
  createNewTestCompany: CreateCompanyResult;
  createPartnerAd: PartnerAd;
  createPayroll: Payroll;
  createPrepaid: Prepaid;
  createProduct: CreateProductResult;
  /** Grants a Puzzle Employee access to the Admin page. */
  createPuzzleAdminUser: CreatePuzzleAdminUserResult;
  createRecurringForFixedAsset: RecurringTemplate;
  createRecurringManualJournalEntryTemplate: ManualJournalEntry;
  createRecurringTemplate: RecurringTemplate;
  createReportingClass: Company;
  createStripeCheckoutSession: StripeCheckoutSession;
  /** @deprecated No longer supported */
  createSurveyResponse?: Maybe<SurveyResponse>;
  createUserCategorizationRule: CreateUserCategorizationRuleResult;
  createVendor: CreateVendorResult;
  deactivateCategorizationRule: DeactivateCategorizationRuleResult;
  deleteBillLink: DeleteBillLinkResult;
  deleteCompanyData?: Maybe<DeleteCompanyDataResult>;
  deleteContractRevenueSchedule: DeleteContractRevenueScheduleResult;
  deleteContractRevenueSchedules: DeleteContractRevenueSchedulesResult;
  deleteCustomChecklistItem: Array<CustomChecklistItem>;
  deleteFile: DeleteFileResult;
  deleteFixedAsset: DeleteFixedAssetResult;
  deleteFixedAssetRule: DeleteFixedAssetRuleResult;
  deleteLedgerReconciliation: DeleteLedgerReconciliationResult;
  deleteLink: DeleteLinkResult;
  deleteManualJournalEntry?: Maybe<Scalars['Boolean']['output']>;
  deletePayroll: DeletePayrollResult;
  deletePrepaid: DeletePrepaidResult;
  /** Removes access to the Admin page. */
  deletePuzzleAdminUser: DeletePuzzleAdminUserResult;
  deleteSplit: DeleteSplitResult;
  deleteTransaction?: Maybe<DeleteTransactionResult>;
  deleteTransactions?: Maybe<DeleteTransactionsResult>;
  deleteTransactionsAdminOnly?: Maybe<DeleteTransactionsResult>;
  deleteUserTransaction: TransactionResult;
  directIngestBills: DirectIngestBillsResult;
  directIngestLedgerHistory: DirectIngestLedgerHistoryResult;
  directIngestManualJournalEntries: DirectIngestManualJournalEntriesResult;
  directIngestTransactions: DirectIngestResult;
  disconnectIntegration: DisconnectResult;
  disconnectUserFromPartner: SuccessResult;
  disposeFixedAsset: FixedAsset;
  editManualJournalEntryGroup: ManualJournalEntryGroup;
  enableRevenueRecognition: EnableRevenueRecognitionResponse;
  finalizeChecklistItem: ChecklistItem;
  grantFirmUserCompanyAccess: GrantFirmUserCompanyAccessResult;
  handleCompanyCompletedOnboarding: HandleCompanyCompletedOnboardingResult;
  handleFileUploaded: HandleFileUploadedResult;
  holdFixedAsset: FixedAsset;
  inServiceFixedAsset: FixedAsset;
  ingestDirectIngestFile: IngestDirectIngestFileResult;
  inviteToCompany: InviteToCompanyResult;
  kickCompanyIngestion: KickCompanyIngestionResult;
  linkBillsToTransaction: LinkBillsToTransactionResult;
  /** @deprecated No longer supported */
  linkExistingAccount: LinkExistingAccountResult;
  linkStoredFileToEntity: LinkStoredFileToEntityResult;
  logout: LogoutResult;
  manuallyMergeContractors: ManuallyMergeContractorsResult;
  manuallyMergeEmployees: ManuallyMergeEmployeesResult;
  markAssignmentAsComplete: UpdateTransactionResult;
  matchCustomerBalanceTransaction: MatchCustomerBalanceTransactionResult;
  matchVendorBalanceTransaction: MatchVendorBalanceTransactionResult;
  mergeAccounts: MergeAccountsResult;
  mergeVendors: MergeVendorResult;
  modifyFirmUserCompanyEntity: ModifyFirmUserCompanyEntityResult;
  moveDateForTransaction: UpdateTransactionResult;
  paidBill: Bill;
  patchSplits: PatchSplitResult;
  pauseContractRevenueSchedule: ContractRevenueSchedule;
  postTransaction: UpdateTransactionResult;
  processPrefilledOnboardingDataForCompany: ProcessPrefilledOnboardingDataForCompanyResult;
  provideAdditionalContextForTransaction: ProvideAdditionalContextForTransactionResponse;
  publishLedgerHistory: PublishLedgerHistoryResult;
  recategorizeMultipleTransactions: UpdateMultipleTransactionsResult;
  recategorizeMultipleTransactionsAdminOnly: UpdateMultipleTransactionsResult;
  recategorizePostedBill: Bill;
  recategorizePostedInvoice: Invoice;
  recategorizeTransaction: UpdateTransactionResult;
  removeAccount: RemoveAccountResult;
  removeBill: RemoveBillResult;
  removeClass: Company;
  removeClassFromEntity: WithReportingClasses;
  removeClassSegment: Company;
  removeClientFromFirm: RemoveClientFromFirmResult;
  removeCompanyInvitation: SuccessResult;
  removeCompanyMembership: SuccessResult;
  removeCustomerBalanceMatch: RemoveCustomerBalanceMatchResult;
  removeCustomerBalanceTransactions: RemoveCustomerBalanceTransactionsResult;
  removeDirectIngestFile: RemoveDirectIngestFileResult;
  removeDirectIngestFileRows: RemoveDirectIngestFileRowsResult;
  removeFirm: RemoveFirmResult;
  removeGroupFromFirm: RemoveGroupFromFirmResult;
  removeInvoice: RemoveInvoiceResult;
  removePartnerAd: Scalars['Boolean']['output'];
  removeSetBalanceEvents: RemoveSetBalanceEventsResult;
  removeUserFromFirm: RemoveUserFromFirmResult;
  removeUserFromFirmGroup: RemoveUserFromFirmGroupResult;
  removeVendorBalanceMatch: RemoveVendorBalanceMatchResult;
  removeVendorBalanceTransactions: RemoveVendorBalanceTransactionsResult;
  requestAdditionalServices: Array<AdditionalServices>;
  requestBusinessInformationFromAI: RequestBusinessInformationResponse;
  requestFinancialInsightsFromAI: FinancialInsightsFromAiResult;
  requestTransactionInformationFromAI: RequestTransactionInformationResponse;
  resendCompanyInvitation: SuccessResult;
  resetAccount: ResetAccountResult;
  resetDirectIngestFile: ResetDirectIngestFileResult;
  resetLedgerReconciliation: LedgerReconciliationResult;
  resolveAccuracyCheck: AccuracyCheck;
  restoreTransactions?: Maybe<RestoreTransactionsResult>;
  reverseManualJournalEntry: ManualJournalEntry;
  revokeFirmUserCompanyAccess: RevokeFirmUserCompanyAccessResult;
  runSquash: RunSquashResult;
  runStripeValidation: StripeValidationRun;
  seedWithTestData: SeedWithTestDataResult;
  sendEmailVerificationCode: SuccessResult;
  setAccountArchived: UpdateAccountResult;
  setAccountEpoch: SetAccountEpochResult;
  setAccountSyncStatus: SetAccountSyncStatusResult;
  setCategorizationConfidence: SetCategorizationConfidenceResult;
  setEpochsForAccounts: SetEpochsForAccountsResult;
  setLockedPeriod: LockedPeriod;
  setSplits: SetSplitResult;
  setSubLedgerSquashingPolicy: CompanySquashingPolicy;
  startLedgerReconciliation: LedgerReconciliationResult;
  submitFeedback: FeedbackResponse;
  subscribeToCompanySlackChannel: SubscribeToCompanySlackChannelResponse;
  syncDataFrom: SyncDataFromResult;
  toggleFirmGroupAnonymization: ToggleFirmGroupAnonymizationResult;
  toggleSubledgers: ToggleSubledgersResult;
  unapproveLedgerReconciliation: LedgerReconciliationResult;
  unconfirmContractLine: ContractLine;
  unconfirmContractLines: UnconfirmContractLinesResult;
  unfinalizeChecklistItem: ChecklistItem;
  unholdFixedAsset: FixedAsset;
  unlinkStoredFileFromEntity: UnlinkStoredFileFromEntityResult;
  unmergeContractors: UnmergeContractorsResult;
  unmergeEmployees: UnmergeEmployeesResult;
  unsubscribeFromCompanySlackChannel: UnsubscribeFromCompanySlackChannelResponse;
  updateAIWorkflowSettings: AiWorkflowSettingsResult;
  updateAccountingConfigurationRule: UpdateAccountingConfigurationRuleResponse;
  updateAccuracyCheckConfig: UpdateAccuracyCheckConfigResult;
  updateApiConnection: ApiConnection;
  updateCard: UpdateTransactionResult;
  updateCashAccrualView: UpdateCashAccrualViewResult;
  updateCoa: UpdateCoaResult;
  updateCompany: CreateCompanyResult;
  updateCompanyFeature: UpdateCompanyFeatureResult;
  updateCompanyFreeTrial: CompanyPricingPlan;
  updateCompanyInvitation?: Maybe<CompanyInvitation>;
  updateCompanyMembership?: Maybe<CompanyMembership>;
  updateCompanyMembershipAsUser?: Maybe<CompanyMembership>;
  updateConfigurationStatus: UpdateAccountingConfigurationStatusResponse;
  updateContractLine: ContractLine;
  updateContractLinesAccountingPolicy: UpdateContractLinesAccountingPolicyResult;
  updateContractRevenueSchedule: ContractRevenueSchedule;
  updateCustomer: UpdateCustomerResult;
  updateDescriptor: UpdateTransactionResult;
  updateDirectIngestFileRows: UpdateDirectIngestFileRowsResult;
  updateEmailPreferences: UserEmailPreferences;
  updateFinalizedTransactionState: UpdateTransactionResult;
  updateFirmGroup: UpdateFirmGroupResult;
  updateFixedAsset: FixedAsset;
  updateFixedAssetRule: FixedAssetRule;
  updateInvoice: UpdateInvoiceResult;
  updateIsBillPayment: UpdateTransactionDetailResult;
  updateIsInvoicePayment: UpdateTransactionDetailResult;
  updateLedgerReconciliation: LedgerReconciliationResult;
  updateLedgerReconciliationCompanySettings: LedgerReconciliationCompanySettingsResult;
  updateMetricCardPreferences: UpdateMetricCardPreferencesResult;
  updateNotificationPreferences?: Maybe<UpdateNotificationPreferencesResponse>;
  updateNotificationWorkflow?: Maybe<UpdateNotificationWorkflowResponse>;
  /** @deprecated No longer supported */
  updateOnboardingStep: UpdateOnboardingStepResult;
  updateOnboardingStepV2: UpdateOnboardingStepV2Result;
  updatePartnerAd: PartnerAd;
  updatePayroll: Payroll;
  updatePostedBill: Bill;
  updatePrepaid: Prepaid;
  updateProduct: UpdateProductResult;
  updateRecurrence: UpdateTransactionResult;
  updateRecurringTemplate: RecurringTemplate;
  updateTransactionCustomer: UpdateTransactionResult;
  updateTransactionMemo: UpdateTransactionResult;
  updateTransactionProduct: UpdateTransactionResult;
  updateTransactionVendor: UpdateTransactionResult;
  updateUserAttributes: UpdateUserAttributesResult;
  updateVendor: UpdateVendorResult;
  upsertBill: Bill;
  upsertFixedAssetForBillLine: FixedAsset;
  upsertFixedAssetForDetail: FixedAsset;
  upsertInitialUserAccountBalance: UpsertInitialUserAccountBalanceResult;
  upsertInitialUserLedgerAccountBalance: UpsertInitialUserAccountBalanceResult;
  upsertLedgerHistory: LedgerHistory;
  upsertManualJournalEntry: Array<ManualJournalEntry>;
  upsertManualRevenueScheduleEntries: UpsertManualRevenueScheduleEntriesResult;
  upsertMessageSettings?: Maybe<User>;
  upsertPaymentFromManual: UpsertPaymentFromManualResult;
  upsertPaymentsFromTransactions: UpsertPaymentsFromTransactionsResult;
  upsertPrepaidForBillLine: Prepaid;
  upsertPrepaidForDetail: Prepaid;
  upsertRevenueRecognitionConfiguration: UpsertAccountingConfigurationResponse;
  /** @deprecated not used - use createManualTransactions */
  upsertUserTransaction: TransactionResult;
  upsertVendorPaymentFromManual: UpsertVendorPaymentFromManualResult;
  upsertVendorPaymentsFromTransactions: UpsertVendorPaymentsFromTransactionsResult;
  validateDirectIngestFile: ValidateDirectIngestFileResult;
  validateLinkToken: ValidateLinkTokenResult;
  voidBill: Bill;
  voidFixedAsset: FixedAsset;
  voidInvoice: Invoice;
  voidManualJournalEntry: ManualJournalEntry;
  voidPrepaid: Prepaid;
};


export type MutationActivateContractRevenueScheduleArgs = {
  input: ActivateContractRevenueScheduleInput;
};


export type MutationActivatePrepaidArgs = {
  id: Scalars['PrepaidID']['input'];
};


export type MutationAddAccountingRecordCommentArgs = {
  input: AddAccountingRecordCommentInput;
};


export type MutationAddClientToFirmArgs = {
  input: AddClientToFirmInput;
};


export type MutationAddCustomChecklistItemArgs = {
  input: CustomChecklistItemInput;
};


export type MutationAddFirmArgs = {
  input: AddFirmInput;
};


export type MutationAddGroupToFirmArgs = {
  input: AddGroupToFirmInput;
};


export type MutationAddItemsToStripeSubscriptionArgs = {
  input: AddItemsToStripeSubscriptionInput;
};


export type MutationAddOAuthSupportToApiConnectionArgs = {
  input: AddOAuthSupportToApiConnectionInput;
};


export type MutationAddTransactionMessageArgs = {
  input: AddTransactionMessageInput;
};


export type MutationAddUserToFirmArgs = {
  input: AddUserToFirmInput;
};


export type MutationAddUserToFirmGroupArgs = {
  input: AddUserToFirmGroupInput;
};


export type MutationApplyClassToEntityArgs = {
  input: ApplyClassToEntityInput;
};


export type MutationApplyRevenueRecognitionConfigurationArgs = {
  input: ApplyRevenueRecognitionConfigurationInput;
};


export type MutationApproveLedgerReconciliationArgs = {
  input: ApproveLedgerReconciliationInput;
};


export type MutationAskAiFreeformPromptArgs = {
  input: AskAiFreeformPromptInput;
};


export type MutationAskAiPromptArgs = {
  input: AskAiPromptInput;
};


export type MutationAssignUserToTransactionArgs = {
  input: AssignUserToTransactionInput;
};


export type MutationAuthenticateWithTokenArgs = {
  input: AuthenticateWithTokenInput;
};


export type MutationBulkApplyClassificationArgs = {
  input: BulkApplyClassificationInput;
};


export type MutationBulkUpdateFinalizedStateArgs = {
  input: BulkUpdateFinalizedStateInput;
};


export type MutationBulkUpdateFinalizedStateByFiltersArgs = {
  input: BulkUpdateFinalizedStateByFiltersInput;
};


export type MutationBulkUpdateTransactionsArgs = {
  input: BulkUpdateTransactionsInput;
};


export type MutationBulkUpsertUserTransactionsArgs = {
  input: BulkUpsertUserTransactionsInput;
};


export type MutationCancelAssignmentArgs = {
  input: CancelAssignmentInput;
};


export type MutationCloseContractRevenueScheduleArgs = {
  input: CloseContractRevenueScheduleInput;
};


export type MutationConfirmContractLineArgs = {
  input: ConfirmContractLineInput;
};


export type MutationConfirmContractLinesArgs = {
  input: ConfirmContractLinesInput;
};


export type MutationConfirmEmailVerificationArgs = {
  input: ConfirmEmailVerificationInput;
};


export type MutationConfirmMergedWorkersArgs = {
  input: ConfirmMergedWorkersInput;
};


export type MutationConnectBillDotComArgs = {
  input: ConnectBillDotComInput;
};


export type MutationConnectBrexArgs = {
  input: ConnectBrexInput;
};


export type MutationConnectDeelArgs = {
  input: ConnectDeelInput;
};


export type MutationConnectFinicityArgs = {
  input: ConnectFinicityInput;
};


export type MutationConnectGustoArgs = {
  input: ConnectGustoInput;
};


export type MutationConnectMeowArgs = {
  input: ConnectMeowInput;
};


export type MutationConnectMercuryArgs = {
  input: ConnectMercuryInput;
};


export type MutationConnectPartnerUserToPuzzleUserArgs = {
  input: ConnectPartnerUserToPuzzleUserInput;
};


export type MutationConnectPlaidArgs = {
  input: ConnectPlaidInput;
};


export type MutationConnectQuickbooksArgs = {
  input: ConnectQuickbooksInput;
};


export type MutationConnectRampArgs = {
  input: ConnectRampInput;
};


export type MutationConnectRipplingArgs = {
  input: ConnectRipplingInput;
};


export type MutationConnectStripeArgs = {
  input: ConnectStripeInput;
};


export type MutationConnectSvbOfxArgs = {
  input: ConnectSvbOfxInput;
};


export type MutationConnectToPuzzleSlackAppArgs = {
  input: ConnectToPuzzleSlackAppInput;
};


export type MutationConnectTrinetArgs = {
  input: ConnectTrinetInput;
};


export type MutationConsentToAiArgs = {
  input: ConsentToAiInput;
};


export type MutationCreateAccountingConfigurationRuleArgs = {
  input: CreateAccountingConfigurationRuleInput;
};


export type MutationCreateAdminCategorizationRuleArgs = {
  input: CreateAdminCategorizationRuleInput;
};


export type MutationCreateAffiliateAttributionArgs = {
  input: CreateAffiliateAttributionInput;
};


export type MutationCreateApiConnectionArgs = {
  input: CreateApiConnectionInput;
};


export type MutationCreateClassSegmentArgs = {
  input: CreateClassSegmentInput;
};


export type MutationCreateCoaArgs = {
  input: CreateCoaInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateCompanyFromPrefilledDataArgs = {
  input: CreateCompanyFromPrefilledDataInput;
};


export type MutationCreateCompanySpendingResetArgs = {
  input: CreateCompanySpendingResetInput;
};


export type MutationCreateContractArgs = {
  input: CreateContractInput;
};


export type MutationCreateContractLinesArgs = {
  input: CreateContractLinesInput;
};


export type MutationCreateContractRevenueScheduleArgs = {
  input: CreateContractRevenueScheduleInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreateDirectIngestFileCoaKeysArgs = {
  input: CreateDirectIngestFileCoaKeysInput;
};


export type MutationCreateDirectIngestFileCoaMapperArgs = {
  input: CreateDirectIngestFileCoaMapperInput;
};


export type MutationCreateDirectIngestFileManualJournalEntriesArgs = {
  input: CreateDirectIngestFileManualJournalEntriesInput;
};


export type MutationCreateFixedAssetArgs = {
  input: CreateFixedAssetInput;
};


export type MutationCreateFixedAssetRuleArgs = {
  input: CreateFixedAssetRuleInput;
};


export type MutationCreateFixedAssetsArgs = {
  input: CreateFixedAssetsInput;
};


export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
};


export type MutationCreateManualAccountArgs = {
  input: CreateManualAccountInput;
};


export type MutationCreateManualCreditCardOffsetTransactionArgs = {
  input: ManualCreditCardOffsetTransactionInput;
};


export type MutationCreateManualTransactionsArgs = {
  input: CreateManualTransactionsInput;
};


export type MutationCreateNewTestCompanyArgs = {
  input: CreateNewTestCompanyInput;
};


export type MutationCreatePartnerAdArgs = {
  input: CreatePartnerAdInput;
};


export type MutationCreatePayrollArgs = {
  input: CreatePayrollInput;
};


export type MutationCreatePrepaidArgs = {
  input: CreatePrepaidInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreatePuzzleAdminUserArgs = {
  input: CreatePuzzleAdminUserInput;
};


export type MutationCreateRecurringForFixedAssetArgs = {
  input: CreateRecurringForFixedAssetInput;
};


export type MutationCreateRecurringManualJournalEntryTemplateArgs = {
  input: CreateRecurringManualJournalEntryTemplateInput;
};


export type MutationCreateRecurringTemplateArgs = {
  input: CreateRecurringTemplateInput;
};


export type MutationCreateReportingClassArgs = {
  input: CreateReportingClassInput;
};


export type MutationCreateStripeCheckoutSessionArgs = {
  input: CreateStripeCheckoutSessionInput;
};


export type MutationCreateSurveyResponseArgs = {
  input: SurveyResponseInput;
};


export type MutationCreateUserCategorizationRuleArgs = {
  input: CreateUserCategorizationRuleInput;
};


export type MutationCreateVendorArgs = {
  input: CreateVendorInput;
};


export type MutationDeactivateCategorizationRuleArgs = {
  input: DeactivateCategorizationRuleInput;
};


export type MutationDeleteBillLinkArgs = {
  input: DeleteBillLinkInput;
};


export type MutationDeleteCompanyDataArgs = {
  companyId: Scalars['ID']['input'];
};


export type MutationDeleteContractRevenueScheduleArgs = {
  input: DeleteContractRevenueScheduleInput;
};


export type MutationDeleteContractRevenueSchedulesArgs = {
  input: DeleteContractRevenueSchedulesInput;
};


export type MutationDeleteCustomChecklistItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFileArgs = {
  input: DeleteFileInput;
};


export type MutationDeleteFixedAssetArgs = {
  input: DeleteFixedAssetInput;
};


export type MutationDeleteFixedAssetRuleArgs = {
  input: DeleteFixedAssetRuleInput;
};


export type MutationDeleteLedgerReconciliationArgs = {
  input: DeleteLedgerReconciliationInput;
};


export type MutationDeleteLinkArgs = {
  input: DeleteLinkInput;
};


export type MutationDeleteManualJournalEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePayrollArgs = {
  input: DeletePayrollInput;
};


export type MutationDeletePrepaidArgs = {
  input: DeletePrepaidInput;
};


export type MutationDeletePuzzleAdminUserArgs = {
  input: DeletePuzzleAdminUserInput;
};


export type MutationDeleteSplitArgs = {
  input: DeleteSplitInput;
};


export type MutationDeleteTransactionArgs = {
  input: DeleteTransactionInput;
};


export type MutationDeleteTransactionsArgs = {
  input: DeleteTransactionsInput;
};


export type MutationDeleteTransactionsAdminOnlyArgs = {
  input: DeleteTransactionsInput;
};


export type MutationDeleteUserTransactionArgs = {
  input: DeleteUserTransactionInput;
};


export type MutationDirectIngestBillsArgs = {
  input: DirectIngestBillsInput;
};


export type MutationDirectIngestLedgerHistoryArgs = {
  input: DirectIngestLedgerHistoryInput;
};


export type MutationDirectIngestManualJournalEntriesArgs = {
  input: DirectIngestManualJournalEntriesInput;
};


export type MutationDirectIngestTransactionsArgs = {
  input: DirectIngestTransactionsInput;
};


export type MutationDisconnectIntegrationArgs = {
  input: DisconnectIntegrationInput;
};


export type MutationDisconnectUserFromPartnerArgs = {
  apiConnectionId: Scalars['ID']['input'];
};


export type MutationDisposeFixedAssetArgs = {
  input: DisposeFixedAssetInput;
};


export type MutationEditManualJournalEntryGroupArgs = {
  input: EditManualJournalEntryGroupInput;
};


export type MutationEnableRevenueRecognitionArgs = {
  input: EnableRevenueRecognitionInput;
};


export type MutationFinalizeChecklistItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGrantFirmUserCompanyAccessArgs = {
  input: GrantFirmUserCompanyAccessInput;
};


export type MutationHandleCompanyCompletedOnboardingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationHandleFileUploadedArgs = {
  input: HandleFileUploadedInput;
};


export type MutationHoldFixedAssetArgs = {
  input: HoldFixedAssetInput;
};


export type MutationInServiceFixedAssetArgs = {
  id: Scalars['FixedAssetID']['input'];
};


export type MutationIngestDirectIngestFileArgs = {
  input: IngestDirectIngestFileInput;
};


export type MutationInviteToCompanyArgs = {
  input: InviteToCompanyInput;
};


export type MutationKickCompanyIngestionArgs = {
  input: KickCompanyIngestionInput;
};


export type MutationLinkBillsToTransactionArgs = {
  input: LinkBillsToTransactionInput;
};


export type MutationLinkExistingAccountArgs = {
  input: LinkExistingAccountInput;
};


export type MutationLinkStoredFileToEntityArgs = {
  input: LinkStoredFileToEntityInput;
};


export type MutationManuallyMergeContractorsArgs = {
  input: ManuallyMergeContractorsInput;
};


export type MutationManuallyMergeEmployeesArgs = {
  input: ManuallyMergeEmployeesInput;
};


export type MutationMarkAssignmentAsCompleteArgs = {
  input: MarkAssignmentAsCompleteInput;
};


export type MutationMatchCustomerBalanceTransactionArgs = {
  input: MatchCustomerBalanceTransactionsInput;
};


export type MutationMatchVendorBalanceTransactionArgs = {
  input: MatchVendorBalanceTransactionsInput;
};


export type MutationMergeAccountsArgs = {
  input: MergeAccountsInput;
};


export type MutationMergeVendorsArgs = {
  input: MergeVendorInput;
};


export type MutationModifyFirmUserCompanyEntityArgs = {
  input: ModifyFirmUserCompanyEntityInput;
};


export type MutationMoveDateForTransactionArgs = {
  input: MoveDateForTransactionInput;
};


export type MutationPaidBillArgs = {
  input: PaidBillInput;
};


export type MutationPatchSplitsArgs = {
  input: PatchSplitInput;
};


export type MutationPauseContractRevenueScheduleArgs = {
  input: PauseContractRevenueScheduleInput;
};


export type MutationPostTransactionArgs = {
  input: PostTransactionInput;
};


export type MutationProcessPrefilledOnboardingDataForCompanyArgs = {
  input: ProcessPrefilledOnboardingDataForCompanyInput;
};


export type MutationProvideAdditionalContextForTransactionArgs = {
  input: ProvideAdditionalContextForTransactionInput;
};


export type MutationPublishLedgerHistoryArgs = {
  input: PublishLedgerHistoryInput;
};


export type MutationRecategorizeMultipleTransactionsArgs = {
  input: RecategorizeMultipleTransactionsInput;
};


export type MutationRecategorizeMultipleTransactionsAdminOnlyArgs = {
  input: RecategorizeMultipleTransactionsAdminOnlyInput;
};


export type MutationRecategorizePostedBillArgs = {
  input: RecategorizePostedBillInput;
};


export type MutationRecategorizePostedInvoiceArgs = {
  input: RecategorizePostedInvoiceInput;
};


export type MutationRecategorizeTransactionArgs = {
  input: RecategorizeTransactionInput;
};


export type MutationRemoveAccountArgs = {
  input: RemoveAccountInput;
};


export type MutationRemoveBillArgs = {
  input: RemoveBillInput;
};


export type MutationRemoveClassArgs = {
  input: RemoveClassInput;
};


export type MutationRemoveClassFromEntityArgs = {
  input: RemoveClassFromEntityInput;
};


export type MutationRemoveClassSegmentArgs = {
  input: RemoveClassSegmentInput;
};


export type MutationRemoveClientFromFirmArgs = {
  input: RemoveClientFromFirmInput;
};


export type MutationRemoveCompanyInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCompanyMembershipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCustomerBalanceMatchArgs = {
  input: RemoveCustomerBalanceMatchInput;
};


export type MutationRemoveCustomerBalanceTransactionsArgs = {
  input: RemoveCustomerBalanceTransactionsInput;
};


export type MutationRemoveDirectIngestFileArgs = {
  input: RemoveDirectIngestFileInput;
};


export type MutationRemoveDirectIngestFileRowsArgs = {
  input: RemoveDirectIngestFileRowsInput;
};


export type MutationRemoveFirmArgs = {
  input: RemoveFirmInput;
};


export type MutationRemoveGroupFromFirmArgs = {
  input: RemoveGroupFromFirmInput;
};


export type MutationRemoveInvoiceArgs = {
  input: RemoveInvoiceInput;
};


export type MutationRemovePartnerAdArgs = {
  id: Scalars['PartnerAdID']['input'];
};


export type MutationRemoveSetBalanceEventsArgs = {
  input: RemoveSetBalanceEventsInput;
};


export type MutationRemoveUserFromFirmArgs = {
  input: RemoveUserFromFirmInput;
};


export type MutationRemoveUserFromFirmGroupArgs = {
  input: RemoveUserFromFirmGroupInput;
};


export type MutationRemoveVendorBalanceMatchArgs = {
  input: RemoveVendorBalanceMatchInput;
};


export type MutationRemoveVendorBalanceTransactionsArgs = {
  input: RemoveVendorBalanceTransactionsInput;
};


export type MutationRequestAdditionalServicesArgs = {
  input: AdditionalServicesInput;
};


export type MutationRequestBusinessInformationFromAiArgs = {
  input: RequestBusinessInformationFromAiInput;
};


export type MutationRequestFinancialInsightsFromAiArgs = {
  input: RequestFinancialInsightsFromAiInput;
};


export type MutationRequestTransactionInformationFromAiArgs = {
  input: RequestTransactionInformationFromAiInput;
};


export type MutationResendCompanyInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetAccountArgs = {
  input: ResetAccountInput;
};


export type MutationResetDirectIngestFileArgs = {
  input: ResetDirectIngestFileInput;
};


export type MutationResetLedgerReconciliationArgs = {
  input: ResetLedgerReconciliationInput;
};


export type MutationResolveAccuracyCheckArgs = {
  input: ResolveAccuracyCheckInput;
};


export type MutationRestoreTransactionsArgs = {
  input: RestoreTransactionsInput;
};


export type MutationReverseManualJournalEntryArgs = {
  input: ReverseManualJournalEntryInput;
};


export type MutationRevokeFirmUserCompanyAccessArgs = {
  input: RevokeFirmUserCompanyAccessInput;
};


export type MutationRunSquashArgs = {
  input: RunSquashInput;
};


export type MutationRunStripeValidationArgs = {
  input: RunStripeValidationInput;
};


export type MutationSeedWithTestDataArgs = {
  input: SeedWithTestDataInput;
};


export type MutationSetAccountArchivedArgs = {
  input: SetAccountArchivedInput;
};


export type MutationSetAccountEpochArgs = {
  input: SetAccountEpochInput;
};


export type MutationSetAccountSyncStatusArgs = {
  input: SetAccountSyncStatusInput;
};


export type MutationSetCategorizationConfidenceArgs = {
  input: SetCategorizationConfidenceInput;
};


export type MutationSetEpochsForAccountsArgs = {
  input: SetEpochsForAccountsInput;
};


export type MutationSetLockedPeriodArgs = {
  input: LockedPeriodInput;
};


export type MutationSetSplitsArgs = {
  input: SetSplitInput;
};


export type MutationSetSubLedgerSquashingPolicyArgs = {
  input: SetSubLedgerSquashingPolicyInput;
};


export type MutationStartLedgerReconciliationArgs = {
  input: StartLedgerReconciliationInput;
};


export type MutationSubmitFeedbackArgs = {
  input: FeedbackInput;
};


export type MutationSubscribeToCompanySlackChannelArgs = {
  input: SubscribeToCompanySlackChannelInput;
};


export type MutationSyncDataFromArgs = {
  input: SyncIntegrationConnectionInput;
};


export type MutationToggleFirmGroupAnonymizationArgs = {
  input: ToggleFirmGroupAnonymizationInput;
};


export type MutationToggleSubledgersArgs = {
  input: ToggleSubledgersInput;
};


export type MutationUnapproveLedgerReconciliationArgs = {
  input: UnapproveLedgerReconciliationInput;
};


export type MutationUnconfirmContractLineArgs = {
  input: UnconfirmContractLineInput;
};


export type MutationUnconfirmContractLinesArgs = {
  input: UnconfirmContractLinesInput;
};


export type MutationUnfinalizeChecklistItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnholdFixedAssetArgs = {
  input: UnholdFixedAssetInput;
};


export type MutationUnlinkStoredFileFromEntityArgs = {
  input: UnlinkStoredFileFromEntityInput;
};


export type MutationUnmergeContractorsArgs = {
  input: UnmergeContractorsInput;
};


export type MutationUnmergeEmployeesArgs = {
  input: UnmergeEmployeesInput;
};


export type MutationUnsubscribeFromCompanySlackChannelArgs = {
  input: UnsubscribeFromCompanySlackChannelInput;
};


export type MutationUpdateAiWorkflowSettingsArgs = {
  input: UpdateAiWorkflowSettingsInput;
};


export type MutationUpdateAccountingConfigurationRuleArgs = {
  input: UpdateAccountingConfigurationRuleInput;
};


export type MutationUpdateAccuracyCheckConfigArgs = {
  input: UpdateAccuracyCheckConfigInput;
};


export type MutationUpdateApiConnectionArgs = {
  input: UpdateApiConnectionInput;
};


export type MutationUpdateCardArgs = {
  input: UpdateCardInput;
};


export type MutationUpdateCashAccrualViewArgs = {
  input: UpdateCashAccrualViewInput;
};


export type MutationUpdateCoaArgs = {
  input: UpdateCoaInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyFeatureArgs = {
  input: UpdateCompanyFeatureInput;
};


export type MutationUpdateCompanyFreeTrialArgs = {
  input: UpdateCompanyFreeTrialInput;
};


export type MutationUpdateCompanyInvitationArgs = {
  input: UpdateCompanyInvitationInput;
};


export type MutationUpdateCompanyMembershipArgs = {
  input: UpdateCompanyMembershipInput;
};


export type MutationUpdateCompanyMembershipAsUserArgs = {
  input: UpdateCompanyMembershipAsUserInput;
};


export type MutationUpdateConfigurationStatusArgs = {
  input: UpdateAccountingConfigurationStatusInput;
};


export type MutationUpdateContractLineArgs = {
  input: UpdateContractLineInput;
};


export type MutationUpdateContractLinesAccountingPolicyArgs = {
  input: UpdateContractLinesAccountingPolicyInput;
};


export type MutationUpdateContractRevenueScheduleArgs = {
  input: UpdateContractRevenueScheduleInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateDescriptorArgs = {
  input: UpdateDescriptorInput;
};


export type MutationUpdateDirectIngestFileRowsArgs = {
  input: UpdateDirectIngestFileRowsInput;
};


export type MutationUpdateEmailPreferencesArgs = {
  input: UpdateEmailPreferencesInput;
};


export type MutationUpdateFinalizedTransactionStateArgs = {
  input: UpdateFinalizedTransactionStateInput;
};


export type MutationUpdateFirmGroupArgs = {
  input: UpdateFirmGroupInput;
};


export type MutationUpdateFixedAssetArgs = {
  input: UpdateFixedAssetInput;
};


export type MutationUpdateFixedAssetRuleArgs = {
  input: UpdateFixedAssetRuleInput;
};


export type MutationUpdateInvoiceArgs = {
  input: UpdateInvoiceInput;
};


export type MutationUpdateIsBillPaymentArgs = {
  input: UpdateIsBillPaymentInput;
};


export type MutationUpdateIsInvoicePaymentArgs = {
  input: UpdateIsInvoicePaymentInput;
};


export type MutationUpdateLedgerReconciliationArgs = {
  input: UpdateLedgerReconciliationInput;
};


export type MutationUpdateLedgerReconciliationCompanySettingsArgs = {
  input: UpdateLedgerReconciliationCompanySettingsInput;
};


export type MutationUpdateMetricCardPreferencesArgs = {
  input: UpdateMetricCardPreferencesInput;
};


export type MutationUpdateNotificationPreferencesArgs = {
  input?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationUpdateNotificationWorkflowArgs = {
  input?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationUpdateOnboardingStepArgs = {
  input: UpdateOnboardingStepInput;
};


export type MutationUpdateOnboardingStepV2Args = {
  input: UpdateOnboardingStepInput;
};


export type MutationUpdatePartnerAdArgs = {
  id: Scalars['PartnerAdID']['input'];
  input: UpdatePartnerAdInput;
};


export type MutationUpdatePayrollArgs = {
  input: UpdatePayrollInput;
};


export type MutationUpdatePostedBillArgs = {
  input: UpdatePostedBillInput;
};


export type MutationUpdatePrepaidArgs = {
  input: UpdatePrepaidInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationUpdateRecurrenceArgs = {
  input: UpdateRecurrenceInput;
};


export type MutationUpdateRecurringTemplateArgs = {
  input: UpdateRecurringTemplateInput;
};


export type MutationUpdateTransactionCustomerArgs = {
  input: UpdateTransactionCustomerInput;
};


export type MutationUpdateTransactionMemoArgs = {
  input: UpdateTransactionMemoInput;
};


export type MutationUpdateTransactionProductArgs = {
  input: UpdateTransactionProductInput;
};


export type MutationUpdateTransactionVendorArgs = {
  input: UpdateTransactionVendorInput;
};


export type MutationUpdateUserAttributesArgs = {
  input: UserAttributesInput;
};


export type MutationUpdateVendorArgs = {
  input: UpdateVendorInput;
};


export type MutationUpsertBillArgs = {
  input: UpsertBillInput;
};


export type MutationUpsertFixedAssetForBillLineArgs = {
  input: UpsertFixedAssetForBillLineInput;
};


export type MutationUpsertFixedAssetForDetailArgs = {
  input: UpsertFixedAssetForDetailInput;
};


export type MutationUpsertInitialUserAccountBalanceArgs = {
  input: UpsertInitialUserAccountBalanceInput;
};


export type MutationUpsertInitialUserLedgerAccountBalanceArgs = {
  input: UpsertInitialUserLedgerAccountBalanceInput;
};


export type MutationUpsertLedgerHistoryArgs = {
  input: UpsertLedgerHistoryInput;
};


export type MutationUpsertManualJournalEntryArgs = {
  input: UpsertManualJournalEntryInput;
};


export type MutationUpsertManualRevenueScheduleEntriesArgs = {
  input: UpsertManualRevenueScheduleEntriesInput;
};


export type MutationUpsertMessageSettingsArgs = {
  input: Array<MessageSettingInput>;
};


export type MutationUpsertPaymentFromManualArgs = {
  input: UpsertPaymentFromManualInput;
};


export type MutationUpsertPaymentsFromTransactionsArgs = {
  input: UpsertPaymentsFromTransactionsInput;
};


export type MutationUpsertPrepaidForBillLineArgs = {
  input: UpsertPrepaidForBillLineInput;
};


export type MutationUpsertPrepaidForDetailArgs = {
  input: UpsertPrepaidForDetailInput;
};


export type MutationUpsertRevenueRecognitionConfigurationArgs = {
  input: UpsertRevenueRecognitionConfigurationInput;
};


export type MutationUpsertUserTransactionArgs = {
  input: UpsertUserTransactionInput;
};


export type MutationUpsertVendorPaymentFromManualArgs = {
  input: UpsertVendorPaymentFromManualInput;
};


export type MutationUpsertVendorPaymentsFromTransactionsArgs = {
  input: UpsertVendorPaymentsFromTransactionsInput;
};


export type MutationValidateDirectIngestFileArgs = {
  input: ValidateDirectIngestFileInput;
};


export type MutationValidateLinkTokenArgs = {
  input: ValidateLinkTokenInput;
};


export type MutationVoidBillArgs = {
  input: VoidBillInput;
};


export type MutationVoidFixedAssetArgs = {
  id: Scalars['FixedAssetID']['input'];
};


export type MutationVoidInvoiceArgs = {
  input: VoidInvoiceInput;
};


export type MutationVoidManualJournalEntryArgs = {
  input: VoidManualJournalEntryInput;
};


export type MutationVoidPrepaidArgs = {
  input: VoidPrepaidInput;
};

export type NetMargin = {
  __typename?: 'NetMargin';
  amount?: Maybe<Scalars['Decimal']['output']>;
  month: Scalars['Month']['output'];
};

export type NonPayrollSpendingTrend = {
  __typename?: 'NonPayrollSpendingTrend';
  amount: Money;
  period: Scalars['Period']['output'];
  periodRange: InclusiveDateRange;
};

export type NotificationMessage = {
  __typename?: 'NotificationMessage';
  companyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  integrationConnectionId?: Maybe<Scalars['ID']['output']>;
  isRemoteArchived?: Maybe<Scalars['Boolean']['output']>;
  messageId?: Maybe<Scalars['ID']['output']>;
  notificationType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  targetUserId: Scalars['ID']['output'];
  transactionId?: Maybe<Scalars['ID']['output']>;
  transactionMemoId?: Maybe<Scalars['ID']['output']>;
};

export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  notificationWorkflows?: Maybe<Scalars['JSON']['output']>;
  preferences?: Maybe<Scalars['JSON']['output']>;
};

export type NotificationPreferencesToManage = {
  __typename?: 'NotificationPreferencesToManage';
  channels: Array<Maybe<Scalars['String']['output']>>;
  notificationTypes: Array<Maybe<Scalars['String']['output']>>;
  notificationWorkflows: Array<Maybe<NotificationWorkflow>>;
};

export type NotificationToken = {
  __typename?: 'NotificationToken';
  notificationWorkflows: Array<NotificationWorkflow>;
  token: Scalars['String']['output'];
};

export type NotificationWorkflow = {
  __typename?: 'NotificationWorkflow';
  changesDisallowedForChannels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isVisibleToUser: Scalars['Boolean']['output'];
  notificationType: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

export enum NumberOfEmployees {
  Between1And10 = 'Between1And10',
  Between10And50 = 'Between10And50',
  Between50And100 = 'Between50And100',
  GreaterThan100 = 'GreaterThan100'
}

export type OfficeLocation = {
  __typename?: 'OfficeLocation';
  city: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  state: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type OnboardingProgress = {
  __typename?: 'OnboardingProgress';
  configureAccountSettings?: Maybe<OnboardingStepStatus>;
  connectFinancialAccounts?: Maybe<OnboardingStepStatus>;
  getPuzzleCertified?: Maybe<OnboardingStepStatus>;
  inviteTeam?: Maybe<OnboardingStepStatus>;
  reviewMonthEndChecklist?: Maybe<OnboardingStepStatus>;
  reviewSpotlightVariances?: Maybe<OnboardingStepStatus>;
  reviewTransactions?: Maybe<OnboardingStepStatus>;
  setBookkeepingPlan?: Maybe<OnboardingStepStatus>;
  startHistoricalTransferProcess?: Maybe<OnboardingStepStatus>;
  verifyBankBalances?: Maybe<OnboardingStepStatus>;
};

export type OnboardingProgressInfoInput = {
  companyId: Scalars['CompanyID']['input'];
};

export type OnboardingProgressV2 = {
  __typename?: 'OnboardingProgressV2';
  companyOnboardingProgress?: Maybe<CompanyOnboardingProgress>;
  userOnboardingProgress?: Maybe<UserOnboardingProgress>;
};

export enum OnboardingStage {
  Completed = 'Completed',
  Initiated = 'Initiated'
}

export enum OnboardingStep {
  ConfigureAccountSettings = 'configureAccountSettings',
  ConfigureAutomationSettings = 'configureAutomationSettings',
  ConfigureClassesAndDepartments = 'configureClassesAndDepartments',
  ConnectFinancialAccounts = 'connectFinancialAccounts',
  CreateCustomRules = 'createCustomRules',
  CreateRevenueRecognitionPolicies = 'createRevenueRecognitionPolicies',
  CustomizeChartOfAccounts = 'customizeChartOfAccounts',
  GetPuzzleCertified = 'getPuzzleCertified',
  InviteClientsToConnectFinancialAccounts = 'inviteClientsToConnectFinancialAccounts',
  InviteFirmsTeamMembers = 'inviteFirmsTeamMembers',
  InviteTeam = 'inviteTeam',
  ReviewMonthEndChecklist = 'reviewMonthEndChecklist',
  ReviewSpotlightVariances = 'reviewSpotlightVariances',
  ReviewTransactions = 'reviewTransactions',
  SetBookkeepingPlan = 'setBookkeepingPlan',
  StartHistoricalTransferProcess = 'startHistoricalTransferProcess',
  VerifyBankBalances = 'verifyBankBalances'
}

export enum OnboardingStepStatus {
  Completed = 'Completed',
  NotCompleted = 'NotCompleted',
  Skipped = 'Skipped'
}

export type OpenEndedDateRangeInput = {
  fromInclusive?: InputMaybe<Scalars['InclusiveDay']['input']>;
  toInclusive?: InputMaybe<Scalars['InclusiveDay']['input']>;
};

export type OpenEndedDateTimeRange = {
  __typename?: 'OpenEndedDateTimeRange';
  fromInclusive?: Maybe<Scalars['DateTime']['output']>;
  toInclusive?: Maybe<Scalars['DateTime']['output']>;
};

export type OpenEndedInclusiveDateRange = {
  __typename?: 'OpenEndedInclusiveDateRange';
  fromInclusive?: Maybe<Scalars['InclusiveDay']['output']>;
  toInclusive?: Maybe<Scalars['InclusiveDay']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

export type PageInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  count: Scalars['Int']['input'];
};

export type PagedVendorExpenseListInput = {
  companyId: Scalars['CompanyID']['input'];
  ledgerCoaKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  newVendorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page: PageInput;
  periods: Array<Scalars['Period']['input']>;
  /** @deprecated No longer supported */
  sort?: InputMaybe<PagedVendorListSort>;
  sortBy?: InputMaybe<PagedVendorListSortInput>;
  vendorList?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum PagedVendorListSort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum PagedVendorListSortBy {
  PeriodExpenseAmount = 'PeriodExpenseAmount',
  VendorName = 'VendorName'
}

export type PagedVendorListSortInput = {
  direction?: InputMaybe<PagedVendorListSort>;
  period?: InputMaybe<Scalars['Period']['input']>;
  sortField?: InputMaybe<PagedVendorListSortBy>;
};

export type PaidBillInput = {
  billId: Scalars['BillID']['input'];
  isPaid: Scalars['Boolean']['input'];
};

export type PartnerAd = {
  __typename?: 'PartnerAd';
  affiliateUrl?: Maybe<Scalars['String']['output']>;
  bookkeepingCriteria?: Maybe<PartnerAdBookkeepingCriteria>;
  calendarUrl?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['PartnerAdID']['output'];
  isActive: Scalars['Boolean']['output'];
  isFeatured: Scalars['Boolean']['output'];
  logoDarkId: Scalars['ID']['output'];
  logoDarkUrl: Scalars['String']['output'];
  logoLightId: Scalars['ID']['output'];
  logoLightUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  removedAt?: Maybe<Scalars['Date']['output']>;
  type: PartnerAdType;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type PartnerAdBookkeepingCriteria = {
  __typename?: 'PartnerAdBookkeepingCriteria';
  id: Scalars['PartnerAdBookkeepingCriteriaID']['output'];
  maxCashBalance?: Maybe<Scalars['Int']['output']>;
  maxMonthlyExpenses?: Maybe<Scalars['Int']['output']>;
  maxMonthlyRevenue?: Maybe<Scalars['Int']['output']>;
  minCashBalance?: Maybe<Scalars['Int']['output']>;
  minMonthlyExpenses?: Maybe<Scalars['Int']['output']>;
  minMonthlyRevenue?: Maybe<Scalars['Int']['output']>;
  orgType?: Maybe<CompanyOrgType>;
  partnerAdId: Scalars['PartnerAdID']['output'];
  removedAt?: Maybe<Scalars['Date']['output']>;
};

export enum PartnerAdFilter {
  Active = 'active',
  All = 'all',
  Featured = 'featured'
}

export enum PartnerAdType {
  Bookkeeping = 'bookkeeping',
  CreditCard = 'credit_card',
  Payroll = 'payroll',
  Taxes = 'taxes'
}

export type PatchPerSplitInput = {
  accrualDate?: InputMaybe<Scalars['LocalDate']['input']>;
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  capitalizable?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['CustomerID']['input']>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isBillPayment?: InputMaybe<Scalars['Boolean']['input']>;
  isInvoicePayment?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerCoaKey?: InputMaybe<Scalars['String']['input']>;
  vendorPermaName?: InputMaybe<Scalars['VendorPermaName']['input']>;
};

export type PatchSplitInput = {
  splits: Array<PatchPerSplitInput>;
  transactionId: Scalars['ID']['input'];
};

export type PatchSplitResult = {
  __typename?: 'PatchSplitResult';
  transaction: Transaction;
};

export type PauseContractRevenueScheduleInput = {
  contractRevenueScheduleId: Scalars['ContractRevenueScheduleID']['input'];
};

export enum PayFrequency {
  Day = 'Day',
  Hour = 'Hour',
  Month = 'Month',
  Paycheck = 'Paycheck',
  Week = 'Week',
  Year = 'Year'
}

export type PayPeriod = {
  __typename?: 'PayPeriod';
  from: Scalars['InclusiveDay']['output'];
  to: Scalars['InclusiveDay']['output'];
};

export type PayableBalance = {
  __typename?: 'PayableBalance';
  appliedBalance: Money;
  remainingBalance: Money;
  unpaidCount: Scalars['Int']['output'];
};

export enum PaymentMethod {
  Check = 'Check',
  Correction = 'Correction',
  DirectDeposit = 'DirectDeposit',
  HistoricalPayment = 'HistoricalPayment'
}

export type PaymentProcessingAccountChecklistItem = ChecklistItem & MonthlyChecklistItem & {
  __typename?: 'PaymentProcessingAccountChecklistItem';
  account: Account;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<ChecklistItemKey>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<User>;
  month: Scalars['Month']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  removedBy?: Maybe<User>;
  status: PaymentProcessingAccountChecklistItemStatus;
};

export enum PaymentProcessingAccountChecklistItemStatus {
  Ok = 'Ok',
  ReconciliationDifferencesIdentified = 'ReconciliationDifferencesIdentified',
  ReportsNotAvailable = 'ReportsNotAvailable'
}

export type PaymentProcessorSubLedger = {
  __typename?: 'PaymentProcessorSubLedger';
  account: Account;
  date: Scalars['LocalDate']['output'];
  id: Scalars['SquashBucketID']['output'];
  isFinalized: Scalars['Boolean']['output'];
  status: SquashBucketStatus;
  summary: PaymentProcessorSubLedgerSummary;
};

export type PaymentProcessorSubLedgerSummary = {
  __typename?: 'PaymentProcessorSubLedgerSummary';
  fees: SquashBucketSummaryItem;
  gross: SquashBucketSummaryItem;
  net: SquashBucketSummaryItem;
  others: SquashBucketSummaryItem;
  refunds: SquashBucketSummaryItem;
  subLedgerType: SubLedgerType;
};

export type Payroll = {
  __typename?: 'Payroll';
  benefitDetails: Array<BenefitDetail>;
  benefits: Scalars['Decimal']['output'];
  checkDate: Scalars['Date']['output'];
  companyBenefits: Array<CompanyBenefit>;
  currency: Scalars['Currency']['output'];
  dataSourceType: DataSourceType;
  employeeBenefitsDeductions: Scalars['Decimal']['output'];
  employeeTaxes: Scalars['Decimal']['output'];
  employerTaxes: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  journalMapping: PayrollJournalMap;
  journals: Array<LedgerJournal>;
  netPay: Scalars['Decimal']['output'];
  payPeriod?: Maybe<PayPeriod>;
  providerName: Scalars['String']['output'];
  withdrawalDate: Scalars['Date']['output'];
};


export type PayrollJournalMappingArgs = {
  input?: InputMaybe<PayrollJournalInput>;
};


export type PayrollJournalsArgs = {
  input?: InputMaybe<PayrollJournalInput>;
};

export type PayrollFilterBy = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export enum PayrollFrequency {
  BiWeekly = 'BiWeekly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  SemiMonthly = 'SemiMonthly',
  Weekly = 'Weekly',
  Yearly = 'Yearly'
}

export type PayrollJournalInput = {
  ledgerType?: InputMaybe<LedgerType>;
  ledgerView?: InputMaybe<LedgerView>;
};

export type PayrollJournalMap = {
  __typename?: 'PayrollJournalMap';
  items: Array<PayrollJournalMapItem>;
  memoLines: Array<PayrollJournalMapItem>;
  posted: Scalars['Boolean']['output'];
  relatedTransactions: Array<PayrollLinkedTransaction>;
  summaryItems: Array<PayrollSummaryItem>;
};

export type PayrollJournalMapItem = {
  __typename?: 'PayrollJournalMapItem';
  amount?: Maybe<Scalars['Decimal']['output']>;
  category?: Maybe<PayrollJournalMapItemCategory>;
  currency?: Maybe<Scalars['Currency']['output']>;
  groupId?: Maybe<Scalars['Int']['output']>;
  hasMemoLine?: Maybe<Scalars['Boolean']['output']>;
  itemName?: Maybe<Scalars['String']['output']>;
  journalCredit?: Maybe<Scalars['Decimal']['output']>;
  journalCurrency?: Maybe<Scalars['Currency']['output']>;
  journalDebit?: Maybe<Scalars['Decimal']['output']>;
  journalName?: Maybe<Scalars['String']['output']>;
};

export enum PayrollJournalMapItemCategory {
  Contractor = 'Contractor',
  Employee = 'Employee',
  Employer = 'Employer'
}

export type PayrollLinkedTransaction = {
  __typename?: 'PayrollLinkedTransaction';
  amount: Scalars['Decimal']['output'];
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
};

export type PayrollNumericSummary = {
  __typename?: 'PayrollNumericSummary';
  benefits: Money;
  contractorNetPay: Money;
  employeeBenefitsDeductions: Money;
  employeeTaxes: Money;
  employerTaxes: Money;
  netPay: Money;
};

export type PayrollPaginator = {
  __typename?: 'PayrollPaginator';
  nodes: Array<Payroll>;
  pageInfo: PageInfo;
};

export type PayrollProvider = {
  __typename?: 'PayrollProvider';
  accountId: Scalars['ID']['output'];
  dataSourceTypeId: Scalars['ID']['output'];
  institutionId: Scalars['ID']['output'];
  institutionName: Scalars['String']['output'];
};

export enum PayrollProviderType {
  Adp = 'ADP',
  Central = 'Central',
  Deel = 'Deel',
  Gusto = 'Gusto',
  Justworks = 'Justworks',
  Other = 'Other',
  Papaya = 'Papaya',
  Paychex = 'Paychex',
  Plane = 'Plane',
  Remote = 'Remote',
  Rippling = 'Rippling',
  Square = 'Square',
  SurePayroll = 'SurePayroll',
  TriNet = 'TriNet',
  Wagepoint = 'Wagepoint',
  Wave = 'Wave',
  Zenefits = 'Zenefits'
}

export enum PayrollSortOrder {
  CheckDateOrderAsc = 'CHECK_DATE_ORDER_ASC',
  CheckDateOrderDesc = 'CHECK_DATE_ORDER_DESC',
  NetPayAsc = 'NET_PAY_ASC',
  NetPayDesc = 'NET_PAY_DESC',
  WithdrawalDateOrderAsc = 'WITHDRAWAL_DATE_ORDER_ASC',
  WithdrawalDateOrderDesc = 'WITHDRAWAL_DATE_ORDER_DESC'
}

export type PayrollSummaryItem = {
  __typename?: 'PayrollSummaryItem';
  amount?: Maybe<Scalars['Decimal']['output']>;
  itemName: Scalars['String']['output'];
  itemSplits?: Maybe<Array<PayrollSummaryItemSplit>>;
};

export type PayrollSummaryItemSplit = {
  __typename?: 'PayrollSummaryItemSplit';
  amount: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PercentageBasedEntryConfig = {
  __typename?: 'PercentageBasedEntryConfig';
  percentage: Scalars['Int']['output'];
};

export type PercentageBasedEntryConfigInput = {
  percentage: Scalars['Int']['input'];
};

export enum PercentageDenominator {
  LastMonthBurnrate = 'LAST_MONTH_BURNRATE',
  LastMonthRevenue = 'LAST_MONTH_REVENUE',
  PreviousMonth = 'PREVIOUS_MONTH',
  PreviousWeek = 'PREVIOUS_WEEK'
}

export type PlaidAccount = {
  __typename?: 'PlaidAccount';
  availableAmount?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentAmount: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  isIgnored?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  officialName?: Maybe<Scalars['String']['output']>;
  type: PlaidAccountType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PlaidAccountSetting = {
  __typename?: 'PlaidAccountSetting';
  id: Scalars['String']['output'];
  shouldIncludeBalance: Scalars['Boolean']['output'];
  shouldIncludeTransactions: Scalars['Boolean']['output'];
  shouldSync: Scalars['Boolean']['output'];
};

export enum PlaidAccountType {
  Credit = 'CREDIT',
  Depository = 'DEPOSITORY',
  Investment = 'INVESTMENT',
  Loan = 'LOAN',
  Other = 'OTHER'
}

export type PlaidConnectInfo = {
  __typename?: 'PlaidConnectInfo';
  linkToken: Scalars['String']['output'];
  webhookUrl: Scalars['String']['output'];
};

export enum PlaidHistoricalStatus {
  Completed = 'Completed',
  InitialUpdate = 'InitialUpdate',
  None = 'None'
}

export type PlaidInitializationInfo = {
  __typename?: 'PlaidInitializationInfo';
  connectInfo: PlaidConnectInfo;
};


export type PlaidInitializationInfoConnectInfoArgs = {
  companyId: Scalars['ID']['input'];
  financialInstitutionId?: InputMaybe<Scalars['ID']['input']>;
};

export type PlaidIntegration = {
  __typename?: 'PlaidIntegration';
  initializationInfo: PlaidInitializationInfo;
};

export type PlaidItem = {
  __typename?: 'PlaidItem';
  connection: Connection;
  createdAt: Scalars['DateTime']['output'];
  historicalStatus: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  institutionName: Scalars['String']['output'];
  linkedByUserId: Scalars['String']['output'];
  plaidAccounts: Array<PlaidAccount>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PlaidItemConnection = {
  __typename?: 'PlaidItemConnection';
  pageInfo: PageInfo;
  plaidItems: Array<PlaidItem>;
};

export type PostTransactionInput = {
  transactionId: Scalars['ID']['input'];
};

export type Prepaid = {
  __typename?: 'Prepaid';
  billLine?: Maybe<BillLine>;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['LocalDate']['output'];
  description?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<TransactionDetail>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  expenseRecognitionMethod?: Maybe<ExpenseRecognitionMethod>;
  id: Scalars['PrepaidID']['output'];
  ledgerCoaKey: Scalars['String']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  status: PrepaidStatus;
  total?: Maybe<Money>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  vendor?: Maybe<Vendor>;
};

export type PrepaidExpenseRecognitionSchedulePreview = {
  __typename?: 'PrepaidExpenseRecognitionSchedulePreview';
  amount: Money;
  method: ExpenseRecognitionMethod;
  range: InclusiveDateRange;
  scheduleItems: Array<PrepaidExpenseRecognitionSchedulePreviewItems>;
};

export type PrepaidExpenseRecognitionSchedulePreviewByCriteriaInput = {
  amount: MoneyInput;
  companyId: Scalars['CompanyID']['input'];
  initialAmortizationPeriod?: InputMaybe<Scalars['String']['input']>;
  method: ExpenseRecognitionMethod;
  openingAmortization?: InputMaybe<Scalars['String']['input']>;
  range: InclusiveLocalDateRangeInput;
};

export type PrepaidExpenseRecognitionSchedulePreviewInput = {
  amount: MoneyInput;
  id: Scalars['ID']['input'];
  initialAmortizationPeriod?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<ExpenseRecognitionMethod>;
  openingAmortization?: InputMaybe<Scalars['String']['input']>;
  range: InclusiveLocalDateRangeInput;
};

export type PrepaidExpenseRecognitionSchedulePreviewItems = {
  __typename?: 'PrepaidExpenseRecognitionSchedulePreviewItems';
  cumulativeExpense: Scalars['Decimal']['output'];
  expenseIncurred: Scalars['Decimal']['output'];
  period: Scalars['Month']['output'];
  prepaidExpense: Scalars['Decimal']['output'];
};

export enum PrepaidExpenseRecognitionStatus {
  Draft = 'Draft',
  Future = 'Future',
  InProcess = 'InProcess',
  Posted = 'Posted'
}

export type PrepaidFilterBy = {
  statuses?: InputMaybe<Array<PrepaidStatus>>;
};

export type PrepaidPaginator = {
  __typename?: 'PrepaidPaginator';
  items: Array<Prepaid>;
  pageInfo: PageInfo;
};

export type PrepaidRollforwardData = {
  __typename?: 'PrepaidRollforwardData';
  prepaid: Prepaid;
  totals: PrepaidRollforwardDataTotals;
};

export type PrepaidRollforwardDataByCoa = {
  __typename?: 'PrepaidRollforwardDataByCoa';
  ledgerCoaKey: Scalars['String']['output'];
  totals: PrepaidRollforwardDataTotals;
};

export type PrepaidRollforwardDataFilterBy = {
  coas?: InputMaybe<Array<Scalars['String']['input']>>;
  periodRange: InclusivePeriodRangeInput;
};

export type PrepaidRollforwardDataInput = {
  companyId: Scalars['CompanyID']['input'];
  filterBy: PrepaidRollforwardDataFilterBy;
};

export type PrepaidRollforwardDataPaginator = {
  __typename?: 'PrepaidRollforwardDataPaginator';
  coaTotals: Array<Maybe<PrepaidRollforwardDataByCoa>>;
  items: Array<PrepaidRollforwardData>;
  totals: PrepaidRollforwardDataTotals;
};

export type PrepaidRollforwardDataPeriod = {
  __typename?: 'PrepaidRollforwardDataPeriod';
  period: Scalars['Period']['output'];
  total: Money;
};

export type PrepaidRollforwardDataTotals = {
  __typename?: 'PrepaidRollforwardDataTotals';
  amount: Money;
  closing: Money;
  opening: Money;
  prepaid: Money;
  recognized: Money;
  recognizedEndPeriod: PrepaidRollforwardDataPeriod;
};

export enum PrepaidSortOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC'
}

export enum PrepaidStatus {
  Active = 'Active',
  Closed = 'Closed',
  Draft = 'Draft',
  Paused = 'Paused',
  Void = 'Void'
}

export type PreviewContractRevenueSchedule = {
  __typename?: 'PreviewContractRevenueSchedule';
  endDay?: Maybe<Scalars['LocalDate']['output']>;
  periods?: Maybe<Array<RevenueSchedulePeriod>>;
  startDay?: Maybe<Scalars['LocalDate']['output']>;
};

export type PreviewContractRevenueScheduleInput = {
  amortizationMethod?: InputMaybe<ContractRevenueScheduleAmortizationMethod>;
  amount: MoneyInput;
  companyId: Scalars['CompanyID']['input'];
  dateRange: InclusiveLocalDateRangeInput;
  firstPeriodConvention?: InputMaybe<ContractRevenueScheduleAmortizationFirstPeriodConvention>;
};

export type PreviousPeriodSpendingMetric = {
  __typename?: 'PreviousPeriodSpendingMetric';
  allOtherCategories: Money;
  allOtherVendors: Money;
  categories: Array<Maybe<CategoryMetric>>;
  payrollAmount: Money;
  range: InclusiveDateRange;
  totalAmount: Money;
  vendors: Array<Maybe<VendorMetric>>;
};

export type PricingPlanFeatureResult = {
  __typename?: 'PricingPlanFeatureResult';
  expenseExceededDate?: Maybe<Scalars['LocalDate']['output']>;
  featureNames?: Maybe<Array<Scalars['String']['output']>>;
  premiumFeatureNames: Array<Scalars['String']['output']>;
};

export type ProcessPrefilledOnboardingDataForCompanyInput = {
  companyId: Scalars['CompanyID']['input'];
  prefilledOnboardingId: Scalars['ID']['input'];
};

export type ProcessPrefilledOnboardingDataForCompanyResult = {
  __typename?: 'ProcessPrefilledOnboardingDataForCompanyResult';
  errors: Array<Error>;
};

export type Product = {
  __typename?: 'Product';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceStats: InvoiceStatsResult;
  /** @deprecated No longer supported */
  invoices?: Maybe<InvoicePaginator>;
  name?: Maybe<Scalars['String']['output']>;
  priceRate?: Maybe<Scalars['Decimal']['output']>;
  serviceType?: Maybe<ProductServiceType>;
  sku?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ProductStatus>;
};


export type ProductInvoiceStatsArgs = {
  filterBy?: InputMaybe<InvoiceFilterBy>;
};

export type ProductFilterBy = {
  name?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<ProductServiceType>;
  status?: InputMaybe<ProductStatus>;
};

export type ProductPaginator = {
  __typename?: 'ProductPaginator';
  items: Array<Product>;
  pageInfo: PageInfo;
};

export enum ProductServiceType {
  Inventory = 'Inventory',
  NonInventory = 'NonInventory',
  Service = 'Service',
  Unknown = 'Unknown'
}

export enum ProductSortOrder {
  InsertOrderAsc = 'INSERT_ORDER_ASC',
  InsertOrderDesc = 'INSERT_ORDER_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum ProductStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Unknown = 'Unknown'
}

export enum ProgrammaticRuleType {
  BillLink = 'BILL_LINK',
  BrexCardTransactionMatcher = 'BREX_CARD_TRANSACTION_MATCHER',
  BrexCashTransactionMatcher = 'BREX_CASH_TRANSACTION_MATCHER',
  BrexPaymentMatcher = 'BREX_PAYMENT_MATCHER',
  CategoryDeprecated = 'CATEGORY_DEPRECATED',
  CompanyPreviouslyCategorized = 'COMPANY_PREVIOUSLY_CATEGORIZED',
  DisputeLink = 'DISPUTE_LINK',
  GloballyPreviouslyCategorized = 'GLOBALLY_PREVIOUSLY_CATEGORIZED',
  InvoiceLink = 'INVOICE_LINK',
  MatchedMatchRule = 'MATCHED_MATCH_RULE',
  MatchedSuggestRule = 'MATCHED_SUGGEST_RULE',
  MatchedTransfersRule = 'MATCHED_TRANSFERS_RULE',
  MatchedVentureSignifiers = 'MATCHED_VENTURE_SIGNIFIERS',
  MercuryInternalTransferKind = 'MERCURY_INTERNAL_TRANSFER_KIND',
  MercuryTreasuryTransferKind = 'MERCURY_TREASURY_TRANSFER_KIND',
  MercuryWireFeeKind = 'MERCURY_WIRE_FEE_KIND',
  PaymentFaliureLink = 'PAYMENT_FALIURE_LINK',
  PlaidTransactionMatcher = 'PLAID_TRANSACTION_MATCHER',
  RampTransactionMatcher = 'RAMP_TRANSACTION_MATCHER',
  RefundLink = 'REFUND_LINK',
  ReimbursementLink = 'REIMBURSEMENT_LINK',
  StripeDefaultCategory = 'STRIPE_DEFAULT_CATEGORY',
  StripePayout = 'STRIPE_PAYOUT',
  WithinWindowOfOtherVenture = 'WITHIN_WINDOW_OF_OTHER_VENTURE'
}

export type ProgressChecklistItem = ChecklistItem & MonthlyChecklistItem & {
  __typename?: 'ProgressChecklistItem';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<ChecklistItemKey>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<User>;
  month: Scalars['Month']['output'];
  progress: Scalars['Int']['output'];
  progressType: ProgressChecklistItemType;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  removedBy?: Maybe<User>;
};

export enum ProgressChecklistItemType {
  TransactionsCategorized = 'TransactionsCategorized',
  TransactionsFinalized = 'TransactionsFinalized'
}

export type ProvideAdditionalContextForTransactionInput = {
  assignmentId: Scalars['ID']['input'];
  context: Scalars['String']['input'];
  transactionId: Scalars['ID']['input'];
};

export type ProvideAdditionalContextForTransactionResponse = {
  __typename?: 'ProvideAdditionalContextForTransactionResponse';
  transaction: Transaction;
};

export type PublishLedgerHistoryInput = {
  id: Scalars['LedgerHistoryID']['input'];
};

export type PublishLedgerHistoryResult = {
  __typename?: 'PublishLedgerHistoryResult';
  ledgerHistory: LedgerHistory;
};

export type PushIntegration = {
  __typename?: 'PushIntegration';
  connectUrl?: Maybe<Scalars['String']['output']>;
  connection?: Maybe<IntegrationConnection>;
  type: IntegrationType;
};


export type PushIntegrationConnectionArgs = {
  companyId: Scalars['ID']['input'];
};

export type PuzzleAddon = {
  __typename?: 'PuzzleAddon';
  annualPrice?: Maybe<Money>;
  annualStripePriceId?: Maybe<Scalars['String']['output']>;
  contentBullets: Array<Scalars['String']['output']>;
  contentHeading: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['PuzzlePricingPlanID']['output'];
  interval: PuzzlePriceBillingInterval;
  monthlyPrice: Money;
  monthlyStripePriceId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  specialPrice?: Maybe<Scalars['String']['output']>;
};

export type PuzzleAdminUser = {
  __typename?: 'PuzzleAdminUser';
  addedBy: User;
  user: User;
};

export type PuzzleAdminUsersInput = {
  page?: InputMaybe<PageInput>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type PuzzleAdminUsersPaginator = {
  __typename?: 'PuzzleAdminUsersPaginator';
  items: Array<PuzzleAdminUser>;
  pageInfo: PageInfo;
};

export type PuzzlePlan = {
  __typename?: 'PuzzlePlan';
  annualPrice?: Maybe<Money>;
  annualStripePriceId?: Maybe<Scalars['String']['output']>;
  availableAddons: Array<PuzzleAddon>;
  badges?: Maybe<Array<Scalars['String']['output']>>;
  description: Scalars['String']['output'];
  displayInformation?: Maybe<PuzzlePricingPlanDisplayInformation>;
  displayName: Scalars['String']['output'];
  expenseLimit?: Maybe<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  helpText?: Maybe<Scalars['String']['output']>;
  hidePaymentInfo: Scalars['Boolean']['output'];
  id: Scalars['PuzzlePricingPlanID']['output'];
  isCustom: Scalars['Boolean']['output'];
  isFree: Scalars['Boolean']['output'];
  isMostPopular: Scalars['Boolean']['output'];
  isSignatureOffer: Scalars['Boolean']['output'];
  isTrial: Scalars['Boolean']['output'];
  monthlyPrice?: Maybe<Money>;
  monthlyStripePriceId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  seats?: Maybe<Scalars['String']['output']>;
  showTrialInfoAs?: Maybe<PuzzlePlan>;
  specialPrice?: Maybe<Scalars['String']['output']>;
  tier: Scalars['Int']['output'];
};

export enum PuzzlePlanModalVersion {
  V1 = 'v1',
  V2 = 'v2'
}

export type PuzzlePrice = {
  __typename?: 'PuzzlePrice';
  id: Scalars['PuzzlePriceID']['output'];
  interval: Scalars['String']['output'];
  plan: PuzzlePricingPlan;
  planId: Scalars['PuzzlePricingPlanID']['output'];
  price: Money;
  stripePriceId?: Maybe<Scalars['String']['output']>;
};

export enum PuzzlePriceBillingInterval {
  Month = 'Month',
  NonRecurring = 'NonRecurring',
  Year = 'Year'
}

export type PuzzlePriceEstimate = {
  __typename?: 'PuzzlePriceEstimate';
  displayName: Scalars['String']['output'];
  interval: PuzzlePriceBillingInterval;
  isApproximate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  price: Money;
  stripePriceId: Scalars['String']['output'];
  unknown: Scalars['Boolean']['output'];
};

export type PuzzlePricingPlan = {
  __typename?: 'PuzzlePricingPlan';
  id: Scalars['PuzzlePricingPlanID']['output'];
  isAddon: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type PuzzlePricingPlanDisplayInformation = {
  __typename?: 'PuzzlePricingPlanDisplayInformation';
  contentBullets?: Maybe<Array<Scalars['String']['output']>>;
  contentHeading?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  expenseLimit?: Maybe<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  helpText?: Maybe<Scalars['String']['output']>;
  isCustom: Scalars['Boolean']['output'];
  isMostPopular: Scalars['Boolean']['output'];
  isSignatureOffer: Scalars['Boolean']['output'];
  seats?: Maybe<Scalars['String']['output']>;
  specialPrice?: Maybe<Scalars['String']['output']>;
};

export type PuzzleSubscription = {
  __typename?: 'PuzzleSubscription';
  addons: Array<PuzzleAddon>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['CompanyPricingPlanID']['output'];
  interval?: Maybe<PuzzlePriceBillingInterval>;
  plan: PuzzlePlan;
  price?: Maybe<Money>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type PuzzleSubscriptionPriceEstimate = {
  __typename?: 'PuzzleSubscriptionPriceEstimate';
  addons: Array<PuzzlePriceEstimate>;
  isApproximate: Scalars['Boolean']['output'];
  monthlyEstimate: Money;
  plan?: Maybe<PuzzlePriceEstimate>;
  totalDue: Money;
  unknown: Scalars['Boolean']['output'];
};

export type PuzzleSubscriptionPriceEstimateInput = {
  companyId: Scalars['CompanyID']['input'];
  stripePriceIds: Array<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  account: Account;
  accountTransactionDetail: AccountTransactionDetails;
  accountTransactionDetailForCSV: FileDownloadInfo;
  accountingConfiguration: AccountingConfiguration;
  accountingConfigurationRule: AccountingConfigurationRule;
  accountingConfigurations: AccountingConfigurationResponse;
  accounts: Array<Account>;
  accrualRevenueReport: Report;
  adminCategorizationRules: Array<AdminCategorizationRule>;
  affiliateAttribution: AffiliateAttributionsResponse;
  aiLastMilePreferences: AiLastMilePreferencesResult;
  aiPrompts: AiPromptsResult;
  allCompaniesPaged: AllCompaniesPaginator;
  allFirms: Array<Maybe<Firm>>;
  apiConnectionByLoginKey?: Maybe<ApiConnectionConfig>;
  apiConnectionCredentials: ApiConnectionCredentialsResult;
  apiConnections: ApiConnectionPaginator;
  auditLogs: AuditLogPaginator;
  balances: BalancesResult;
  bill: Bill;
  cachedPrefilledOnboardingData: CachedPrefilledOnboardingData;
  canBulkUpdateTransactions: CanBulkUpdateTransactionsResult;
  cards: CardPaginator;
  categories: Array<LedgerCategory>;
  categoriesReport: Report;
  categorizationModelMetrics: CategorizationModelMetrics;
  categorizationReport: InlineReport;
  categorizationSummaryReport: InlineReport;
  coaAccountTypes?: Maybe<Array<Scalars['String']['output']>>;
  coaReport: Report;
  companies: Array<Company>;
  company?: Maybe<Company>;
  companyArr: CompanyArr;
  companyFinancialSummary: CompanyFinancialSummary;
  companyHealthCheck: CompanyHealthCheckResult;
  connectionRequestContext: ConnectionRequestContextResult;
  contractRevenueSchedule: ContractRevenueSchedule;
  contractor?: Maybe<Report>;
  customer?: Maybe<Customer>;
  customerMapping: CustomerMappingResult;
  customers: CustomerPaginator;
  dataAnomalyReview: DataAnomalyReviewResult;
  departmentCounts: Array<DepartmentCount>;
  employee?: Maybe<Report>;
  employeeChange?: Maybe<Report>;
  feedbackForm: FeedbackForm;
  file: File;
  financialInstitutionsFor: Array<FinancialInstitution>;
  firm?: Maybe<Firm>;
  firmBookkeepers: Array<User>;
  firmClients: Array<Company>;
  fixedAsset: FixedAsset;
  fixedAssetCapitalization: FixedAssetCapitalizationPaginator;
  fixedAssetDepreciationSchedulePreview: FixedAssetDepreciationSchedulePreview;
  fixedAssetRegistryCsvReport: AsyncReportResult;
  fixedAssetRegistryExcelReport: AsyncReportResult;
  generateGeneralLedgerCsv: AsyncReportResult;
  generateYearEndTaxPackage: ReportPackage;
  getCalId: Scalars['ID']['output'];
  getCategoryMatchConflicts: CategorizationRuleConflictsResult;
  getCoaMapperFile: GetCoaMapperFileResult;
  /**
   * Generates a temporary signed url for file download.
   * Deprecated in favor of File.downloadInfo.
   * @deprecated No longer supported
   */
  getDownloadInfo: FileDownloadInfo;
  getEmailFromSecret: GetEmailFromSecretResult;
  getEmailPreferences: UserEmailPreferences;
  getFileUploadInfo: GetUploadInfoResult;
  getFirmClients: Array<FirmClient>;
  getFirmCompanyUsers: Array<User>;
  getFixedAssetAutomationSettings: FixedAssetAutomationSettings;
  getMetricCardPreferences: MetricCardPreferences;
  getNotificationPreferences?: Maybe<NotificationPreferences>;
  getNotificationPreferencesToManage?: Maybe<NotificationPreferencesToManage>;
  getNotificationToken: NotificationToken;
  getProvisionGustoAccountUrl: GustoAccountClaimUrl;
  getRecurringRevenueMetrics: RecurringRevenueMetricsResult;
  getReportById: Report;
  getReportPackageById: ReportPackage;
  getSpendingPayrollSummary: GetSpendingPayrollSummaryResult;
  getSpendingTrends: GetSpendingTrendsResult;
  getTopSpending: GetTopSpendingResult;
  /** @deprecated No longer supported */
  getUploadInfo: GetUploadInfoResult;
  getUserAttributes: UserAttributes;
  globalSettings: GlobalConfigResult;
  historicalBooksChecklist?: Maybe<HistoricalBooksChecklist>;
  implicitRules: ImplicitRulePaginator;
  integrationConnectionsFor: Array<IntegrationConnection>;
  integrations: Integrations;
  intercomHash?: Maybe<Scalars['String']['output']>;
  invoice: Invoice;
  invoiceEvents: Array<Maybe<InvoiceEvent>>;
  ledgerExcelMultiReportDownloadByPeriod: LedgerExcelReportDownloadByPeriod;
  ledgerExcelReportDownloadByPeriod: LedgerExcelReportDownloadByPeriod;
  ledgerReconciliation: LedgerReconciliation;
  ledgerReport: LedgerReport;
  ledgerReportBreakoutByPeriod: LedgerReportBreakoutByPeriod;
  ledgerReportDownloadByPeriod: LedgerReportDownloadByPeriod;
  manualJournalEntry: ManualJournalEntry;
  manualJournalEntryGroup: ManualJournalEntryGroup;
  manualJournalEntryGroupEditPreview: ManualJournalEntryGroupEditPreview;
  mergeableAccounts: MergeableAccountsResult;
  monthlyChecklist: MonthlyChecklist;
  monthlyChecklistInfo: MonthlyChecklistInfo;
  monthlySpending: MonthlySpendingResult;
  onboardingProgress: OnboardingProgressV2;
  pagedVendorExpenseList: VendorTimePeriodExpenseListPaginator;
  pagedVendors: VendorPaginator;
  partner: ApiPartner;
  partnerAds: Array<PartnerAd>;
  payroll: Payroll;
  plaidItems: Array<PlaidItem>;
  prepaid: Prepaid;
  prepaidExpenseRecognitionSchedulePreview: PrepaidExpenseRecognitionSchedulePreview;
  prepaidExpenseRecognitionSchedulePreviewByCriteria: PrepaidExpenseRecognitionSchedulePreview;
  prepaidRollforwardData: PrepaidRollforwardDataPaginator;
  previewContractRevenueSchedule: PreviewContractRevenueSchedule;
  pricingPlanFeatures?: Maybe<PricingPlanFeatureResult>;
  product?: Maybe<Product>;
  products: ProductPaginator;
  /** Returns a list of Puzzle Employees with access to the Admin page. */
  puzzleAdminUsers: PuzzleAdminUsersPaginator;
  puzzleSubscriptionPriceEstimate: PuzzleSubscriptionPriceEstimate;
  quickBooksReport?: Maybe<Report>;
  recurringTemplate: RecurringTemplate;
  /** @deprecated No longer supported */
  reportBreakout?: Maybe<ReportBreakout>;
  ripplingEmployeeCountFor?: Maybe<Scalars['Int']['output']>;
  ripplingProvisionedEmployeeCountFor?: Maybe<Scalars['Int']['output']>;
  schedulerFetchRevenueAllocation: SchedulerFetchRevenueAllocationResult;
  self?: Maybe<User>;
  sendMobileContinueOnDesktopEmail: SuccessResult;
  siteStatusMessage?: Maybe<SiteStatusMessage>;
  siteStatusMessages: Array<SiteStatusMessage>;
  slackConnectInfo: SlackConnectInfoResponse;
  sourceCountsFor: Array<SourceCount>;
  statementBalances?: Maybe<StatementBalances>;
  statements: Array<Statement>;
  stripeTransactionReportCsv: AsyncReportResult;
  stripeValidationRun: StripeValidationRun;
  subLedgerBySquashBucketId?: Maybe<SubLedger>;
  subscriptionCustomerReport: Report;
  subscriptionEvents: Array<Maybe<SubscriptionEvent>>;
  transaction?: Maybe<Transaction>;
  transactions: TransactionPaginator;
  transactionsForCompanies: TransactionPaginator;
  transactionsReport: AsyncReportResult;
  unconfirmedMergedWorkers: Array<MergedWorker>;
  userCategorizationRule: UserCategorizationRule;
  userCategorizationRules: UserCategorizationRulesPaginator;
  vendor1099TrackingReport: AsyncReportResult;
  vendorReport: Report;
  vendorSecrets: GetVendorSecretsResult;
  vendorSpendingReport: Report;
  vendorsEligibleFor1099: Get1099EligibleVendorsResult;
  workerCosts: WorkerCostStats;
  workers: Array<Worker>;
};


export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountTransactionDetailArgs = {
  input: AccountTransactionDetailInput;
};


export type QueryAccountTransactionDetailForCsvArgs = {
  input: AccountTransactionDetailInput;
};


export type QueryAccountingConfigurationArgs = {
  id: Scalars['AccountingConfigurationID']['input'];
};


export type QueryAccountingConfigurationRuleArgs = {
  id: Scalars['AccountingConfigurationRuleID']['input'];
};


export type QueryAccountingConfigurationsArgs = {
  input: AccountingConfigurationsQueryInput;
};


export type QueryAccountsArgs = {
  filter: AccountFilterInput;
};


export type QueryAccrualRevenueReportArgs = {
  input: AccrualRevenueReportInput;
};


export type QueryAdminCategorizationRulesArgs = {
  input: AdminCategorizationRulesInput;
};


export type QueryAffiliateAttributionArgs = {
  input: AffiliateAttributionQueryInput;
};


export type QueryAiLastMilePreferencesArgs = {
  id: Scalars['CompanyID']['input'];
};


export type QueryAiPromptsArgs = {
  input: AiPromptsInput;
};


export type QueryAllCompaniesPagedArgs = {
  page?: InputMaybe<PageInput>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryApiConnectionByLoginKeyArgs = {
  loginKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryApiConnectionCredentialsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApiConnectionsArgs = {
  page?: InputMaybe<PageInput>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAuditLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  filterBy: AuditLogFilterBy;
  sortBy?: InputMaybe<AuditLogSortOrder>;
};


export type QueryBalancesArgs = {
  input: BalancesInput;
};


export type QueryBillArgs = {
  id: Scalars['BillID']['input'];
};


export type QueryCachedPrefilledOnboardingDataArgs = {
  input: GetCachedPrefilledOnboardingDataInput;
};


export type QueryCanBulkUpdateTransactionsArgs = {
  input: BulkUpdateTransactionsInput;
};


export type QueryCardsArgs = {
  companyId: Scalars['ID']['input'];
  filterBy?: InputMaybe<CardFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<CardSortOrder>;
};


export type QueryCategoriesArgs = {
  input?: InputMaybe<CategoryQueryInput>;
};


export type QueryCategoriesReportArgs = {
  input: CategoriesReportInput;
};


export type QueryCategorizationModelMetricsArgs = {
  input: CategorizationModelMetricsInput;
};


export type QueryCategorizationReportArgs = {
  input: CategorizationReportInput;
};


export type QueryCategorizationSummaryReportArgs = {
  input: CategorizationSummaryReportInput;
};


export type QueryCoaAccountTypesArgs = {
  input: CoaAccountTypeQueryInput;
};


export type QueryCoaReportArgs = {
  input: CoaReportInput;
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyArrArgs = {
  input: CompanyArrInput;
};


export type QueryCompanyFinancialSummaryArgs = {
  input: CompanyFinancialSummaryInput;
};


export type QueryCompanyHealthCheckArgs = {
  companyId: Scalars['CompanyID']['input'];
};


export type QueryConnectionRequestContextArgs = {
  input: ConnectionRequestContextInput;
};


export type QueryContractRevenueScheduleArgs = {
  id: Scalars['ContractRevenueScheduleID']['input'];
};


export type QueryContractorArgs = {
  input: ReportInput;
};


export type QueryCustomerArgs = {
  input: CustomerQueryInput;
};


export type QueryCustomerMappingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomersArgs = {
  companyId: Scalars['ID']['input'];
  filterBy?: InputMaybe<CustomerFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<CustomerSortOrder>;
};


export type QueryDataAnomalyReviewArgs = {
  input: DataAnomalyReviewInput;
};


export type QueryDepartmentCountsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryEmployeeArgs = {
  input: ReportInput;
};


export type QueryEmployeeChangeArgs = {
  input: ReportInput;
};


export type QueryFeedbackFormArgs = {
  form: FeedbackFormName;
};


export type QueryFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFinancialInstitutionsForArgs = {
  companyId: Scalars['ID']['input'];
  integrationType?: InputMaybe<IntegrationType>;
};


export type QueryFirmArgs = {
  id: Scalars['FirmID']['input'];
};


export type QueryFixedAssetArgs = {
  id: Scalars['FixedAssetID']['input'];
};


export type QueryFixedAssetCapitalizationArgs = {
  input: FixedAssetCapitalizationDataInput;
};


export type QueryFixedAssetDepreciationSchedulePreviewArgs = {
  input: FixedAssetDepreciationSchedulePreviewInput;
};


export type QueryFixedAssetRegistryCsvReportArgs = {
  input: FixedAssetRegistryReportInput;
};


export type QueryFixedAssetRegistryExcelReportArgs = {
  input: FixedAssetRegistryReportInput;
};


export type QueryGenerateGeneralLedgerCsvArgs = {
  input: AccountTransactionDetailInput;
};


export type QueryGenerateYearEndTaxPackageArgs = {
  input: GenerateYearEndTaxPackageInput;
};


export type QueryGetCalIdArgs = {
  input: CalIdInput;
};


export type QueryGetCategoryMatchConflictsArgs = {
  input: CreateAdminCategorizationRuleInput;
};


export type QueryGetCoaMapperFileArgs = {
  input: GetCoaMapperFileInput;
};


export type QueryGetDownloadInfoArgs = {
  input: GetDownloadInfoInput;
};


export type QueryGetEmailFromSecretArgs = {
  input?: InputMaybe<GetEmailFromSecretInput>;
};


export type QueryGetEmailPreferencesArgs = {
  input: GetNotificationsInput;
};


export type QueryGetFileUploadInfoArgs = {
  input: GetFileUploadInfoInput;
};


export type QueryGetFirmClientsArgs = {
  input: GetFirmClientsInput;
};


export type QueryGetFirmCompanyUsersArgs = {
  input: GetFirmCompanyUsersInput;
};


export type QueryGetFixedAssetAutomationSettingsArgs = {
  companyId: Scalars['CompanyID']['input'];
};


export type QueryGetMetricCardPreferencesArgs = {
  companyId: Scalars['CompanyID']['input'];
};


export type QueryGetProvisionGustoAccountUrlArgs = {
  input: GetProvisionGustoAccountUrlInput;
};


export type QueryGetRecurringRevenueMetricsArgs = {
  companyId: Scalars['ID']['input'];
  endMonth: Scalars['Month']['input'];
  loadAllCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  startMonth: Scalars['Month']['input'];
};


export type QueryGetReportByIdArgs = {
  reportId?: InputMaybe<Scalars['ReportID']['input']>;
};


export type QueryGetReportPackageByIdArgs = {
  reportPackageId?: InputMaybe<Scalars['ReportPackageID']['input']>;
};


export type QueryGetSpendingPayrollSummaryArgs = {
  input: GetSpendingPayrollSummaryInput;
};


export type QueryGetSpendingTrendsArgs = {
  input: GetSpendingTrendsInput;
};


export type QueryGetTopSpendingArgs = {
  input: GetTopSpendingInput;
};


export type QueryGetUploadInfoArgs = {
  input: GetUploadInfoInput;
};


export type QueryHistoricalBooksChecklistArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryImplicitRulesArgs = {
  input: ImplicitRuleInput;
};


export type QueryIntegrationConnectionsForArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  integrationType: IntegrationType;
};


export type QueryIntegrationsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryInvoiceArgs = {
  id: Scalars['InvoiceID']['input'];
};


export type QueryInvoiceEventsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryLedgerExcelMultiReportDownloadByPeriodArgs = {
  input: LedgerExcelMultiReportDownloadByPeriodInput;
};


export type QueryLedgerExcelReportDownloadByPeriodArgs = {
  input: LedgerExcelReportDownloadByPeriodInput;
};


export type QueryLedgerReconciliationArgs = {
  id: Scalars['ID']['input'];
  transactionsPage?: InputMaybe<PageInput>;
};


export type QueryLedgerReportArgs = {
  input: LedgerReportInput;
};


export type QueryLedgerReportBreakoutByPeriodArgs = {
  input: LedgerReportBreakoutByPeriodInput;
};


export type QueryLedgerReportDownloadByPeriodArgs = {
  input: LedgerReportDownloadByPeriodInput;
};


export type QueryManualJournalEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryManualJournalEntryGroupArgs = {
  id: Scalars['ManualJournalEntryGroupID']['input'];
};


export type QueryManualJournalEntryGroupEditPreviewArgs = {
  input: ManualJournalEntryGroupEditPreviewInput;
};


export type QueryMergeableAccountsArgs = {
  input: MergeableAccountsInput;
};


export type QueryMonthlyChecklistArgs = {
  companyId: Scalars['ID']['input'];
  month: Scalars['Month']['input'];
};


export type QueryMonthlyChecklistInfoArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryMonthlySpendingArgs = {
  input: MonthlySpendingInput;
};


export type QueryOnboardingProgressArgs = {
  input: OnboardingProgressInfoInput;
};


export type QueryPagedVendorExpenseListArgs = {
  input: PagedVendorExpenseListInput;
};


export type QueryPagedVendorsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  filterBy?: InputMaybe<VendorFilterBy>;
  page?: InputMaybe<PageInput>;
};


export type QueryPartnerArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryPartnerAdsArgs = {
  filter?: InputMaybe<PartnerAdFilter>;
  type: PartnerAdType;
};


export type QueryPayrollArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlaidItemsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryPrepaidArgs = {
  id: Scalars['PrepaidID']['input'];
};


export type QueryPrepaidExpenseRecognitionSchedulePreviewArgs = {
  input: PrepaidExpenseRecognitionSchedulePreviewInput;
};


export type QueryPrepaidExpenseRecognitionSchedulePreviewByCriteriaArgs = {
  input: PrepaidExpenseRecognitionSchedulePreviewByCriteriaInput;
};


export type QueryPrepaidRollforwardDataArgs = {
  input: PrepaidRollforwardDataInput;
};


export type QueryPreviewContractRevenueScheduleArgs = {
  input: PreviewContractRevenueScheduleInput;
};


export type QueryPricingPlanFeaturesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductArgs = {
  companyId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  companyId: Scalars['ID']['input'];
  filterBy?: InputMaybe<ProductFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<ProductSortOrder>;
};


export type QueryPuzzleAdminUsersArgs = {
  input?: InputMaybe<PuzzleAdminUsersInput>;
};


export type QueryPuzzleSubscriptionPriceEstimateArgs = {
  input: PuzzleSubscriptionPriceEstimateInput;
};


export type QueryQuickBooksReportArgs = {
  input: QuickBooksReportInput;
};


export type QueryRecurringTemplateArgs = {
  id: Scalars['RecurringTemplateID']['input'];
};


export type QueryReportBreakoutArgs = {
  input: ReportBreakoutInput;
};


export type QueryRipplingEmployeeCountForArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRipplingProvisionedEmployeeCountForArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySchedulerFetchRevenueAllocationArgs = {
  companyId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  groupBy?: InputMaybe<RevenueAllocationGroupBy>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QuerySendMobileContinueOnDesktopEmailArgs = {
  input: SendMobileContinueOnDesktopEmailInput;
};


export type QuerySlackConnectInfoArgs = {
  input: SlackConnectInfoInput;
};


export type QuerySourceCountsForArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryStatementBalancesArgs = {
  input: GetStatementBalancesInput;
};


export type QueryStatementsArgs = {
  input: GetStatementsInput;
};


export type QueryStripeTransactionReportCsvArgs = {
  input: StripeTransactionReportInput;
};


export type QueryStripeValidationRunArgs = {
  id: Scalars['StripeValidationRunID']['input'];
};


export type QuerySubLedgerBySquashBucketIdArgs = {
  id: Scalars['SquashBucketID']['input'];
};


export type QuerySubscriptionCustomerReportArgs = {
  input: SubscriptionCustomerReportInput;
};


export type QuerySubscriptionEventsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  filterBy?: InputMaybe<TransactionFilterBy>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeStripe?: InputMaybe<Scalars['Boolean']['input']>;
  noTestCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<TransactionSortOrder>;
};


export type QueryTransactionsForCompaniesArgs = {
  input: TransactionsForCompaniesInput;
};


export type QueryTransactionsReportArgs = {
  input: TransactionReportInput;
};


export type QueryUnconfirmedMergedWorkersArgs = {
  input: GetUnconfirmedMergedWorkersInput;
};


export type QueryUserCategorizationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserCategorizationRulesArgs = {
  input: UserCategorizationRulesInput;
};


export type QueryVendor1099TrackingReportArgs = {
  input: Vendor1099TrackingReportInput;
};


export type QueryVendorReportArgs = {
  input: VendorReportInput;
};


export type QueryVendorSecretsArgs = {
  input: GetVendorSecretsInput;
};


export type QueryVendorSpendingReportArgs = {
  input: VendorSpendingReportInput;
};


export type QueryVendorsEligibleFor1099Args = {
  input: Get1099EligibleVendorsInput;
};


export type QueryWorkerCostsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryWorkersArgs = {
  companyId: Scalars['ID']['input'];
  filter?: InputMaybe<WorkerFilter>;
};

export enum QuickBooksReportAccountingMethod {
  Accrual = 'Accrual',
  Cash = 'Cash'
}

export type QuickBooksReportDateRangeInput = {
  endDateInclusive?: InputMaybe<Scalars['LocalDate']['input']>;
  startDateInclusive?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type QuickBooksReportInput = {
  accountId?: InputMaybe<Scalars['AccountID']['input']>;
  accountingMethod?: InputMaybe<QuickBooksReportAccountingMethod>;
  companyId: Scalars['ID']['input'];
  dateRange: QuickBooksReportDateRangeInput;
  reportKind: QuickBooksReportKind;
};

export enum QuickBooksReportKind {
  AgedPayableDetail = 'AgedPayableDetail',
  AgedReceivableDetail = 'AgedReceivableDetail',
  BalanceSheet = 'BalanceSheet',
  CashFlow = 'CashFlow',
  GeneralLedger = 'GeneralLedger',
  ProfitAndLoss = 'ProfitAndLoss',
  ProfitAndLossDetail = 'ProfitAndLossDetail',
  TrialBalance = 'TrialBalance'
}

export type QuickbooksInitializationInfo = {
  __typename?: 'QuickbooksInitializationInfo';
  connectUrl: Scalars['String']['output'];
};


export type QuickbooksInitializationInfoConnectUrlArgs = {
  companyId: Scalars['ID']['input'];
};

export type QuickbooksIntegration = {
  __typename?: 'QuickbooksIntegration';
  connection?: Maybe<IntegrationConnection>;
  connections?: Maybe<Array<IntegrationConnection>>;
  initializationInfo: QuickbooksInitializationInfo;
};


export type QuickbooksIntegrationConnectionArgs = {
  companyId: Scalars['ID']['input'];
};


export type QuickbooksIntegrationConnectionsArgs = {
  companyId: Scalars['ID']['input'];
};

export type RampInitializationInfo = {
  __typename?: 'RampInitializationInfo';
  connectUrl: Scalars['String']['output'];
};


export type RampInitializationInfoConnectUrlArgs = {
  companyId: Scalars['ID']['input'];
};

export type RampIntegration = {
  __typename?: 'RampIntegration';
  connection?: Maybe<IntegrationConnection>;
  connections?: Maybe<Array<IntegrationConnection>>;
  initializationInfo: RampInitializationInfo;
};


export type RampIntegrationConnectionArgs = {
  companyId: Scalars['ID']['input'];
};


export type RampIntegrationConnectionsArgs = {
  companyId: Scalars['ID']['input'];
};

export type RecategorizeMultipleTransactionsAdminOnlyInput = {
  updates: Array<RecategorizeTransactionInput>;
};

export type RecategorizeMultipleTransactionsInput = {
  companyId: Scalars['ID']['input'];
  updates: Array<RecategorizeTransactionInput>;
};

export type RecategorizePostedBillInput = {
  billId: Scalars['BillID']['input'];
  bypassFinalizedTransactions: Scalars['Boolean']['input'];
  bypassLockedPeriods: Scalars['Boolean']['input'];
  companyId: Scalars['CompanyID']['input'];
  lines: Array<RecategorizePostedBillLineInput>;
  regeneratePrepaids?: InputMaybe<Scalars['Boolean']['input']>;
  removeDraftFixedAssets?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecategorizePostedBillLineInput = {
  coaKey: Scalars['LedgerCoaKey']['input'];
  id: Scalars['BillLineID']['input'];
};

export type RecategorizePostedInvoiceDiscountLineInput = {
  coaKey: Scalars['String']['input'];
  id: Scalars['InvoiceDiscountLineID']['input'];
};

export type RecategorizePostedInvoiceInput = {
  bypassLockedPeriods?: InputMaybe<Scalars['Boolean']['input']>;
  discountLines?: InputMaybe<Array<RecategorizePostedInvoiceDiscountLineInput>>;
  invoiceId: Scalars['InvoiceID']['input'];
  lines?: InputMaybe<Array<RecategorizePostedInvoiceLineInput>>;
  resetRevenueSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLines?: InputMaybe<Array<RecategorizePostedInvoiceShippingLineInput>>;
  taxLines?: InputMaybe<Array<RecategorizePostedInvoiceTaxLineInput>>;
};

export type RecategorizePostedInvoiceLineInput = {
  coaKey: Scalars['String']['input'];
  id: Scalars['InvoiceLineItemID']['input'];
};

export type RecategorizePostedInvoiceShippingLineInput = {
  coaKey: Scalars['String']['input'];
  id: Scalars['InvoiceShippingLineID']['input'];
};

export type RecategorizePostedInvoiceTaxLineInput = {
  coaKey: Scalars['String']['input'];
  id: Scalars['InvoiceTaxLineID']['input'];
};

export type RecategorizeTransactionInput = {
  id: Scalars['ID']['input'];
  ledgerCoaKey: Scalars['String']['input'];
};

export type ReceivableBalance = {
  __typename?: 'ReceivableBalance';
  appliedBalance: Money;
  overdueBalance: Money;
  remainingBalance: Money;
  unpaidCount: Scalars['Int']['output'];
};

export type ReconciliationFilterBy = {
  accountId?: InputMaybe<Scalars['AccountID']['input']>;
  accountTypes?: InputMaybe<Array<AccountType>>;
  startRange?: InputMaybe<DateTimeRangeInput>;
  status?: InputMaybe<ReconciliationStatus>;
  views?: InputMaybe<Array<InputMaybe<LedgerView>>>;
};

export enum ReconciliationSortOrder {
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC'
}

export enum ReconciliationStatus {
  InProgress = 'InProgress',
  Reconciled = 'Reconciled',
  SystemDrafted = 'SystemDrafted'
}

export type ReconciliationTotals = {
  __typename?: 'ReconciliationTotals';
  moneyIn: Scalars['Decimal']['output'];
  moneyOut: Scalars['Decimal']['output'];
  remaining: Scalars['Decimal']['output'];
};

export type RecurrenceMetric = {
  __typename?: 'RecurrenceMetric';
  amount: Money;
  count: Scalars['Int']['output'];
  recurrence?: Maybe<RecurrencePeriod>;
};

export enum RecurrencePeriod {
  Monthly = 'MONTHLY',
  None = 'NONE',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

export type RecurringRevenueMetricNormalizedPhase = {
  __typename?: 'RecurringRevenueMetricNormalizedPhase';
  endDate: Scalars['LocalDate']['output'];
  startDate: Scalars['LocalDate']['output'];
  view: RecurringRevenueMetricView;
};

export type RecurringRevenueMetricSubaggregate = {
  __typename?: 'RecurringRevenueMetricSubaggregate';
  aggregateName: Scalars['String']['output'];
  aggregation: RevenueAllocationGroupBy;
  externalAggregateId: Scalars['String']['output'];
  normalizedPhases: Array<RecurringRevenueMetricNormalizedPhase>;
};

export enum RecurringRevenueMetricType {
  BeginningOfPeriod = 'BEGINNING_OF_PERIOD',
  Contraction = 'CONTRACTION',
  EndOfPeriod = 'END_OF_PERIOD',
  Expansion = 'EXPANSION',
  GrossChurnRate = 'GROSS_CHURN_RATE',
  GrossRetentionRate = 'GROSS_RETENTION_RATE',
  Lost = 'LOST',
  NetChurnRate = 'NET_CHURN_RATE',
  NetRetentionRate = 'NET_RETENTION_RATE',
  New = 'NEW',
  Reactivation = 'REACTIVATION'
}

export type RecurringRevenueMetricView = {
  __typename?: 'RecurringRevenueMetricView';
  arr?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['String']['output']>;
  mrr?: Maybe<Scalars['String']['output']>;
};

export enum RecurringRevenueMetricViewType {
  Arr = 'ARR',
  Mrr = 'MRR'
}

export type RecurringRevenueMetrics = {
  __typename?: 'RecurringRevenueMetrics';
  metricName: Scalars['String']['output'];
  metricType: RecurringRevenueMetricType;
  normalizedPhases: Array<RecurringRevenueMetricNormalizedPhase>;
  subaggregates?: Maybe<Array<Maybe<RecurringRevenueMetricSubaggregate>>>;
};

export type RecurringRevenueMetricsResult = {
  __typename?: 'RecurringRevenueMetricsResult';
  companyId: Scalars['ID']['output'];
  endMonth: Scalars['Month']['output'];
  metrics: Array<Maybe<RecurringRevenueMetrics>>;
  showAllMetrics?: Maybe<Scalars['Boolean']['output']>;
  startMonth: Scalars['Month']['output'];
};

export type RecurringTemplate = {
  __typename?: 'RecurringTemplate';
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  endAfterOccurrences?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['RecurringTemplateID']['output'];
  intervalCount: Scalars['Int']['output'];
  intervalDay?: Maybe<Scalars['Int']['output']>;
  intervalMonth?: Maybe<Scalars['Int']['output']>;
  intervalUnit: RecurringTemplateIntervalUnit;
  intervalWeek?: Maybe<Scalars['Int']['output']>;
  intervalWeekday?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `linkedJournal.id`. */
  linkedId: Scalars['ID']['output'];
  linkedJournal?: Maybe<ManualJournalEntry>;
  linkedType: RecurringTemplateLinkedType;
  name: Scalars['String']['output'];
  nextOccurrenceAt?: Maybe<Scalars['DateTime']['output']>;
  post: Scalars['Boolean']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  startDate: Scalars['LocalDate']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type RecurringTemplateFilterBy = {
  intervalUnit?: InputMaybe<RecurringTemplateIntervalUnit>;
};

export enum RecurringTemplateIntervalUnit {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

export enum RecurringTemplateLinkedType {
  ManualJournalEntry = 'ManualJournalEntry'
}

export type RecurringTemplatePaginator = {
  __typename?: 'RecurringTemplatePaginator';
  items: Array<RecurringTemplate>;
  pageInfo: PageInfo;
};

export enum RecurringTemplateSortOrder {
  CreatedAtAsc = 'CreatedAtAsc',
  CreatedAtDesc = 'CreatedAtDesc'
}

export type Reimbursement = {
  __typename?: 'Reimbursement';
  accountId: Scalars['AccountID']['output'];
  coaKey?: Maybe<Scalars['String']['output']>;
  company: Company;
  dataSourceType: DataSourceType;
  id: Scalars['ReimbursementID']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  merchant?: Maybe<Scalars['String']['output']>;
  reimbursementAmount: Scalars['Decimal']['output'];
  reimbursementCurrency: Scalars['Currency']['output'];
  transactionDate: Scalars['LocalDate']['output'];
};

export type RemoveAccountInput = {
  accountId: Scalars['ID']['input'];
  companyId: Scalars['CompanyID']['input'];
};

export type RemoveAccountResult = {
  __typename?: 'RemoveAccountResult';
  success: Scalars['Boolean']['output'];
};

export type RemoveBillInput = {
  billId: Scalars['BillID']['input'];
};

export type RemoveBillResult = {
  __typename?: 'RemoveBillResult';
  success: Scalars['Boolean']['output'];
};

export type RemoveClassFromEntityInput = {
  companyId: Scalars['CompanyID']['input'];
  entityId: Scalars['TaggableEntityID']['input'];
  entityType: ClassAwareType;
  reportingClassSegmentId: Scalars['TagValueID']['input'];
};

export type RemoveClassInput = {
  companyId: Scalars['CompanyID']['input'];
  reportingClassId: Scalars['TagNameID']['input'];
};

export type RemoveClassSegmentInput = {
  companyId: Scalars['CompanyID']['input'];
  reportingClassId: Scalars['TagNameID']['input'];
  reportingClassSegmentId: Scalars['TagValueID']['input'];
};

export type RemoveClientFromFirmInput = {
  companyId: Scalars['CompanyID']['input'];
  firmId: Scalars['FirmID']['input'];
};

export type RemoveClientFromFirmResult = {
  __typename?: 'RemoveClientFromFirmResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveCustomerBalanceMatchInput = {
  companyId: Scalars['CompanyID']['input'];
  groupId?: InputMaybe<Scalars['CustomerBalanceMatchGroupID']['input']>;
  id?: InputMaybe<Scalars['CustomerBalanceMatchID']['input']>;
};

export type RemoveCustomerBalanceMatchResult = {
  __typename?: 'RemoveCustomerBalanceMatchResult';
  count: Scalars['Int']['output'];
};

export type RemoveCustomerBalanceTransactionsInput = {
  companyId: Scalars['CompanyID']['input'];
  customerBalanceTransactionIds: Array<Scalars['CustomerBalanceTransactionID']['input']>;
};

export type RemoveCustomerBalanceTransactionsResult = {
  __typename?: 'RemoveCustomerBalanceTransactionsResult';
  removed: Array<Scalars['CustomerBalanceTransactionID']['output']>;
};

export type RemoveDirectIngestFileInput = {
  id: Scalars['DirectIngestFileID']['input'];
};

export type RemoveDirectIngestFileResult = {
  __typename?: 'RemoveDirectIngestFileResult';
  success: Scalars['Boolean']['output'];
};

export type RemoveDirectIngestFileRowInput = {
  coaKeyRowIds?: InputMaybe<Array<Scalars['DirectIngestCoaKeyRowID']['input']>>;
  journalEntryRowIds?: InputMaybe<Array<Scalars['DirectIngestJournalEntryRowID']['input']>>;
};

export type RemoveDirectIngestFileRowsInput = {
  data: RemoveDirectIngestFileRowInput;
  id: Scalars['DirectIngestFileID']['input'];
};

export type RemoveDirectIngestFileRowsResult = {
  __typename?: 'RemoveDirectIngestFileRowsResult';
  coaKeys?: Maybe<Scalars['Int']['output']>;
  journalEntries?: Maybe<Scalars['Int']['output']>;
};

export type RemoveFirmInput = {
  firmId: Scalars['FirmID']['input'];
};

export type RemoveFirmResult = {
  __typename?: 'RemoveFirmResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveGroupFromFirmInput = {
  firmGroupId: Scalars['FirmGroupID']['input'];
  firmId: Scalars['FirmID']['input'];
};

export type RemoveGroupFromFirmResult = {
  __typename?: 'RemoveGroupFromFirmResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveInvoiceInput = {
  invoiceId: Scalars['InvoiceID']['input'];
};

export type RemoveInvoiceResult = {
  __typename?: 'RemoveInvoiceResult';
  success: Scalars['Boolean']['output'];
};

export type RemoveSetBalanceEventsInput = {
  accountId: Scalars['AccountID']['input'];
  companyId: Scalars['CompanyID']['input'];
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  range: InclusiveLocalDateRangeInput;
};

export type RemoveSetBalanceEventsResult = {
  __typename?: 'RemoveSetBalanceEventsResult';
  numRemoved: Scalars['Int']['output'];
};

export type RemoveUserFromFirmGroupInput = {
  firmGroupId: Scalars['FirmGroupID']['input'];
  firmId: Scalars['FirmID']['input'];
  userId: Scalars['UserID']['input'];
};

export type RemoveUserFromFirmGroupResult = {
  __typename?: 'RemoveUserFromFirmGroupResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveUserFromFirmInput = {
  firmId: Scalars['FirmID']['input'];
  userId: Scalars['UserID']['input'];
};

export type RemoveUserFromFirmResult = {
  __typename?: 'RemoveUserFromFirmResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveVendorBalanceMatchInput = {
  companyId: Scalars['CompanyID']['input'];
  groupId?: InputMaybe<Scalars['VendorBalanceMatchGroupID']['input']>;
  id?: InputMaybe<Scalars['VendorBalanceMatchID']['input']>;
};

export type RemoveVendorBalanceMatchResult = {
  __typename?: 'RemoveVendorBalanceMatchResult';
  count: Scalars['Int']['output'];
};

export type RemoveVendorBalanceTransactionsInput = {
  companyId: Scalars['CompanyID']['input'];
  vendorBalanceTransactionIds: Array<Scalars['VendorBalanceTransactionID']['input']>;
};

export type RemoveVendorBalanceTransactionsResult = {
  __typename?: 'RemoveVendorBalanceTransactionsResult';
  removed: Array<Scalars['VendorBalanceTransactionID']['output']>;
};

export type Report = {
  __typename?: 'Report';
  file?: Maybe<File>;
  reportId?: Maybe<Scalars['ReportID']['output']>;
  status: ReportStatus;
  timePeriod?: Maybe<ReportTimePeriod>;
  title: Scalars['String']['output'];
};

export type ReportBreakout = {
  __typename?: 'ReportBreakout';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  hasMore: Scalars['Boolean']['output'];
  highWatermarkToken?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  lines: Array<ReportBreakoutLine>;
  nextPageStartingAfter?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ReportBreakoutInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['CompanyID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  pathToken: Scalars['String']['input'];
  reportType: DynamicReportType;
  timePeriod: ReportTimePeriodInput;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type ReportBreakoutLine = {
  __typename?: 'ReportBreakoutLine';
  balance?: Maybe<Scalars['Decimal']['output']>;
  detail?: Maybe<TransactionDetail>;
  highWatermarkToken?: Maybe<Scalars['ID']['output']>;
  lineKey?: Maybe<Scalars['String']['output']>;
  lineType?: Maybe<LedgerReportLineType>;
  metadata: LedgerReportEventMetadata;
  pathToken?: Maybe<Scalars['String']['output']>;
  relatedObjectId?: Maybe<Scalars['ID']['output']>;
  tags: Array<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  transaction?: Maybe<Transaction>;
};

export enum ReportFormat {
  Csv = 'CSV',
  Excel = 'Excel',
  Json = 'JSON'
}

export type ReportInput = {
  companyId: Scalars['ID']['input'];
};

export enum ReportLineTag {
  Burn = 'burn',
  Cash = 'cash',
  Expenses = 'expenses',
  Fundraising = 'fundraising',
  Revenue = 'revenue',
  TotalAssets = 'total_assets',
  TotalAvailableCashBalance = 'total_available_cash_balance',
  TotalBurn = 'total_burn',
  TotalCashIn = 'total_cash_in',
  TotalCostOfRevenue = 'total_cost_of_revenue',
  TotalEquityFunding = 'total_equity_funding',
  TotalExpenses = 'total_expenses',
  TotalGrossProfit = 'total_gross_profit',
  TotalLiabilities = 'total_liabilities',
  TotalNetIncome = 'total_net_income',
  TotalNonOperatingExpenses = 'total_non_operating_expenses',
  TotalNonOperatingIncome = 'total_non_operating_income',
  TotalOperatingExpenses = 'total_operating_expenses',
  TotalOperatingIncome = 'total_operating_income',
  TotalOtherIncomeAndExpenses = 'total_other_income_and_expenses',
  TotalRevenue = 'total_revenue'
}

export type ReportPackage = {
  __typename?: 'ReportPackage';
  file?: Maybe<File>;
  filename: Scalars['String']['output'];
  id: Scalars['ReportPackageID']['output'];
  status: ReportPackageStatus;
};

export enum ReportPackageStatus {
  Pending = 'Pending',
  Ready = 'Ready'
}

export enum ReportStatus {
  Pending = 'Pending',
  Ready = 'Ready'
}

export type ReportTimePeriod = {
  __typename?: 'ReportTimePeriod';
  end: Scalars['InclusiveDay']['output'];
  start: Scalars['InclusiveDay']['output'];
  timePeriodKey: Scalars['String']['output'];
};

export type ReportTimePeriodInput = {
  end: Scalars['InclusiveDay']['input'];
  start: Scalars['InclusiveDay']['input'];
  timePeriodKey: Scalars['String']['input'];
};

export enum ReportingClassType {
  Department = 'Department',
  Location = 'Location',
  UserCreated = 'UserCreated'
}

export type RequestBusinessInformationFromAiInput = {
  companyId: Scalars['ID']['input'];
  forceJson?: InputMaybe<Scalars['Boolean']['input']>;
  promptName: Scalars['String']['input'];
  promptSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type RequestBusinessInformationResponse = {
  __typename?: 'RequestBusinessInformationResponse';
  response: Scalars['String']['output'];
  threadId: Scalars['String']['output'];
};

export type RequestFinancialInsightsFromAiInput = {
  companyId: Scalars['CompanyID']['input'];
  forceJson?: InputMaybe<Scalars['Boolean']['input']>;
  promptName: Scalars['String']['input'];
  promptSuffix?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['UserID']['input'];
};

export type RequestTransactionInformationFromAiInput = {
  companyId: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
};

export type RequestTransactionInformationResponse = {
  __typename?: 'RequestTransactionInformationResponse';
  thread: LlmMessageThread;
  transaction: Transaction;
};

export type ResetAccountInput = {
  accountId: Scalars['AccountID']['input'];
  companyId: Scalars['CompanyID']['input'];
};

export type ResetAccountResult = {
  __typename?: 'ResetAccountResult';
  success: Scalars['Boolean']['output'];
};

export type ResetDirectIngestFileInput = {
  id: Scalars['DirectIngestFileID']['input'];
};

export type ResetDirectIngestFileResult = {
  __typename?: 'ResetDirectIngestFileResult';
  /** @deprecated Use ingestFile instead */
  directIngestFile: DirectIngestFileManualJournalEntries;
  ingestFile: DirectIngestFile;
};

export type ResetLedgerReconciliationInput = {
  bufferDayCount?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['LedgerReconciliationID']['input'];
  statementBalance?: InputMaybe<Scalars['Decimal']['input']>;
  statementDay?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type ResolveAccuracyCheckConditions = {
  dateRange?: InputMaybe<OpenEndedDateRangeInput>;
  mapping?: InputMaybe<ResolveAccuracyCheckMapping>;
};

export type ResolveAccuracyCheckInput = {
  conditions?: InputMaybe<ResolveAccuracyCheckConditions>;
  id: Scalars['AccuracyCheckID']['input'];
  status: AccuracyCheckStatus;
};

export type ResolveAccuracyCheckMapping = {
  ledgerCoaKey?: InputMaybe<Array<LedgerCoaKeyMapping>>;
  vendor?: InputMaybe<Array<VendorMapping>>;
};

export type RestoreTransactionsInput = {
  companyId: Scalars['ID']['input'];
  transactionIds: Array<Scalars['ID']['input']>;
};

export type RestoreTransactionsResult = {
  __typename?: 'RestoreTransactionsResult';
  failedIds: Array<Maybe<Scalars['ID']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type ResyncPlaidItemInput = {
  institutionName: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
};

export type ResyncPlaidItemResult = {
  __typename?: 'ResyncPlaidItemResult';
  plaidItem?: Maybe<PlaidItem>;
};

export type RevenueAllocation = {
  __typename?: 'RevenueAllocation';
  aggregate: Array<RevenueAllocationAggregate>;
  aggregateId: Scalars['String']['output'];
  aggregateName: Scalars['String']['output'];
  aggregationLevel: RevenueAllocationGroupBy;
  normalizedPhases: Array<RevenueAllocationNormalizedPhase>;
  total: Scalars['String']['output'];
  totalDeferred: Scalars['String']['output'];
  totalRecognized: Scalars['String']['output'];
};

export type RevenueAllocationAggregate = {
  __typename?: 'RevenueAllocationAggregate';
  aggregateId: Scalars['String']['output'];
  aggregateName: Scalars['String']['output'];
  aggregationLevel: RevenueAllocationGroupBy;
  normalizedPhases: Array<RevenueAllocationNormalizedPhase>;
  schedules: Array<RevenueAllocationSchedule>;
  total: Scalars['String']['output'];
  totalDeferred: Scalars['String']['output'];
  totalRecognized: Scalars['String']['output'];
};

export enum RevenueAllocationGroupBy {
  Customer = 'CUSTOMER',
  Product = 'PRODUCT'
}

export type RevenueAllocationNormalizedPhase = {
  __typename?: 'RevenueAllocationNormalizedPhase';
  endDate: Scalars['DateTime']['output'];
  schedules: Array<RevenueAllocationNormalizedPhaseSchedule>;
  startDate: Scalars['DateTime']['output'];
  total: Scalars['String']['output'];
};

export type RevenueAllocationNormalizedPhaseSchedule = {
  __typename?: 'RevenueAllocationNormalizedPhaseSchedule';
  scheduleId: Scalars['String']['output'];
  total: Scalars['String']['output'];
};

export type RevenueAllocationPhaseTransaction = {
  __typename?: 'RevenueAllocationPhaseTransaction';
  accrued: Scalars['String']['output'];
  amount: Scalars['String']['output'];
  event?: Maybe<RevenueAllocationPhaseTransactionEvent>;
  phaseTransactionId: Scalars['String']['output'];
  postingDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
};

export type RevenueAllocationPhaseTransactionEvent = {
  __typename?: 'RevenueAllocationPhaseTransactionEvent';
  eventId: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  eventVersion: Scalars['Int']['output'];
};

export type RevenueAllocationSchedule = {
  __typename?: 'RevenueAllocationSchedule';
  arr: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  mrr: Scalars['String']['output'];
  phaseTransactions: Array<Maybe<RevenueAllocationPhaseTransaction>>;
  scheduleEditRecord: RevenueAllocationScheduleEditRecord;
  scheduleId: Scalars['String']['output'];
  sourceType: Scalars['String']['output'];
  total: Scalars['String']['output'];
  totalDeferred: Scalars['String']['output'];
  totalRecognized: Scalars['String']['output'];
};

export type RevenueAllocationScheduleEditRecord = {
  __typename?: 'RevenueAllocationScheduleEditRecord';
  createdAt: Scalars['DateTime']['output'];
  eventId: Scalars['String']['output'];
  scheduleEditRecordId: Scalars['String']['output'];
};

export enum RevenueFacet {
  Accounts = 'Accounts',
  Customers = 'Customers',
  Products = 'Products'
}

export enum RevenueFormula {
  AccrualbasedArr = 'AccrualbasedArr',
  AnnualizedRevenue = 'AnnualizedRevenue',
  StripeArr = 'StripeArr'
}

export type RevenueItem = {
  __typename?: 'RevenueItem';
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  periods: Array<RevenuePeriod>;
  total: Scalars['Decimal']['output'];
};

export enum RevenueModel {
  AddOns = 'AddOns',
  /** @deprecated No longer supported */
  AnnualSubscription = 'AnnualSubscription',
  Commission = 'Commission',
  Contracts = 'Contracts',
  HourlyBilling = 'HourlyBilling',
  Marketplace = 'Marketplace',
  /** @deprecated No longer supported */
  MonthlySubscription = 'MonthlySubscription',
  /** @deprecated No longer supported */
  MultipleRevenueModels = 'MultipleRevenueModels',
  /** @deprecated No longer supported */
  NotSure = 'NotSure',
  PreRevenue = 'PreRevenue',
  ServiceBased = 'ServiceBased',
  Subscription = 'Subscription',
  /** @deprecated No longer supported */
  TransactionBased = 'TransactionBased',
  TransactionBasedOther = 'TransactionBasedOther',
  TransactionBasedPhysical = 'TransactionBasedPhysical',
  UsageBased = 'UsageBased'
}

export type RevenuePeriod = {
  __typename?: 'RevenuePeriod';
  key: Scalars['String']['output'];
  total: Scalars['Decimal']['output'];
};

export type RevenueRecognitionConfiguration = AccountingConfiguration & {
  __typename?: 'RevenueRecognitionConfiguration';
  activePolicies: Array<RevenueRecognitionPolicy>;
  config?: Maybe<RevenueRecognitionConfigurationConfig>;
  description: Scalars['String']['output'];
  hasBeenApplied: Scalars['Boolean']['output'];
  id: Scalars['AccountingConfigurationID']['output'];
  name: Scalars['String']['output'];
  status: AccountingConfigurationStatus;
  type: AccountingConfigurationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RevenueRecognitionConfigurationConfig = {
  __typename?: 'RevenueRecognitionConfigurationConfig';
  calculation?: Maybe<AccountingRecognitionCalculation>;
  discountAccount: Scalars['LedgerCoaKey']['output'];
  firstPeriodAllocation?: Maybe<FirstPeriodAllocation>;
  method: AccountingRecognitionTiming;
  percentageBasedEntries?: Maybe<Array<PercentageBasedEntryConfig>>;
  refundAccount: Scalars['LedgerCoaKey']['output'];
  revenueAccount: Scalars['LedgerCoaKey']['output'];
  revenueDeferralAccount?: Maybe<Scalars['LedgerCoaKey']['output']>;
};

export type RevenueRecognitionPolicy = AccountingPolicy & {
  __typename?: 'RevenueRecognitionPolicy';
  effectiveRange: OpenEndedInclusiveDateRange;
  id: Scalars['AccountingPolicyID']['output'];
};

export type RevenueRecognitionPolicyInput = {
  effectiveRange: OpenEndedDateRangeInput;
};

export type RevenueSchedulePeriod = {
  __typename?: 'RevenueSchedulePeriod';
  cumulativeRevenue: Money;
  deferredRevenue: Money;
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  period: Scalars['Period']['output'];
  revenue: Money;
  state?: Maybe<RevenueSchedulePeriodState>;
  type?: Maybe<RevenueSchedulePeriodType>;
};

export enum RevenueSchedulePeriodState {
  Draft = 'draft',
  Future = 'future',
  InProcess = 'inProcess',
  Posted = 'posted'
}

export enum RevenueSchedulePeriodType {
  Adjustment = 'adjustment',
  Amortization = 'amortization',
  Closing = 'closing',
  Opening = 'opening'
}

export type RevenueSubLedger = {
  __typename?: 'RevenueSubLedger';
  accrualEvents: AccrualEventPaginator;
  date: Scalars['LocalDate']['output'];
  id: Scalars['SquashBucketID']['output'];
  isFinalized: Scalars['Boolean']['output'];
  status: SquashBucketStatus;
  summary: RevenueSubLedgerSummary;
};


export type RevenueSubLedgerAccrualEventsArgs = {
  filterBy?: InputMaybe<AccrualEventFilterBy>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<SubLedgerAccrualEventsSortOrder>;
};

export type RevenueSubLedgerSummary = {
  __typename?: 'RevenueSubLedgerSummary';
  fees: SquashBucketSummaryItem;
  net: SquashBucketSummaryItem;
  others: SquashBucketSummaryItem;
  refunds: SquashBucketSummaryItem;
  revenueBooked: SquashBucketSummaryItem;
  revenueDeferred: SquashBucketSummaryItem;
  revenueRecognized: SquashBucketSummaryItem;
  subLedgerType: SubLedgerType;
};

export type ReverseManualJournalEntryInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  /** The journal to copy and reverse. */
  journalId: Scalars['ID']['input'];
  postingDate: Scalars['LocalDate']['input'];
};

export type ReviewChecklistItem = ChecklistItem & MonthlyChecklistItem & {
  __typename?: 'ReviewChecklistItem';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<ChecklistItemKey>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<User>;
  month: Scalars['Month']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  removedBy?: Maybe<User>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  reviewType: ReviewChecklistItemType;
};

export enum ReviewChecklistItemType {
  ReviewLockedPeriod = 'ReviewLockedPeriod',
  ReviewNewVendors = 'ReviewNewVendors'
}

export type RevokeFirmUserCompanyAccessInput = {
  companyId: Scalars['CompanyID']['input'];
  firmId: Scalars['FirmID']['input'];
  userId: Scalars['UserID']['input'];
};

export type RevokeFirmUserCompanyAccessResult = {
  __typename?: 'RevokeFirmUserCompanyAccessResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RipplingInitializationInfo = {
  __typename?: 'RipplingInitializationInfo';
  connectUrl: Scalars['String']['output'];
};


export type RipplingInitializationInfoConnectUrlArgs = {
  companyId: Scalars['ID']['input'];
};

export type RipplingIntegration = {
  __typename?: 'RipplingIntegration';
  connection?: Maybe<IntegrationConnection>;
  connections?: Maybe<Array<IntegrationConnection>>;
  initializationInfo: RipplingInitializationInfo;
};


export type RipplingIntegrationConnectionArgs = {
  companyId: Scalars['ID']['input'];
};


export type RipplingIntegrationConnectionsArgs = {
  companyId: Scalars['ID']['input'];
};

export type RowError = {
  __typename?: 'RowError';
  column: Scalars['String']['output'];
  error: Scalars['String']['output'];
};

export type RowErrors = {
  __typename?: 'RowErrors';
  column: Scalars['String']['output'];
  error: Scalars['String']['output'];
  header?: Maybe<Scalars['String']['output']>;
  rowsCount: Scalars['Int']['output'];
};

export type RunRateData = {
  __typename?: 'RunRateData';
  burnAverage?: Maybe<BurnAverage>;
  historicalStatus: HistoricalStatus;
  last30DaysBurn?: Maybe<Scalars['Decimal']['output']>;
  last30DaysCashlikeAmount?: Maybe<CashlikeAmount>;
  recentMonthlyBurn: Array<DateAmount>;
  runway?: Maybe<Runway>;
};

export type RunSquashInput = {
  companyId: Scalars['CompanyID']['input'];
  subLedgerType?: InputMaybe<SubLedgerType>;
};

export type RunSquashResult = {
  __typename?: 'RunSquashResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RunStripeValidationInput = {
  accountId?: InputMaybe<Scalars['AccountID']['input']>;
  companyId: Scalars['CompanyID']['input'];
  forceRun?: InputMaybe<Scalars['Boolean']['input']>;
  month: Scalars['Month']['input'];
  type?: InputMaybe<StripeValidationRunType>;
  view?: InputMaybe<LedgerView>;
};

export type Runway = {
  __typename?: 'Runway';
  cashOutDate: Scalars['String']['output'];
  cashOutMonths: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  fundraisingWindowDate: Scalars['String']['output'];
  fundraisingWindowMonths: Scalars['Int']['output'];
  months: Scalars['Int']['output'];
};

export type SchedulerFetchRevenueAllocationResult = {
  __typename?: 'SchedulerFetchRevenueAllocationResult';
  endDate: Scalars['DateTime']['output'];
  revenueAllocation: Array<Maybe<RevenueAllocation>>;
  startDate: Scalars['DateTime']['output'];
  total: Scalars['String']['output'];
  totalDeferred: Scalars['String']['output'];
  totalRecognized: Scalars['String']['output'];
};

export type SeedWithTestDataInput = {
  companyId: Scalars['CompanyID']['input'];
  options?: InputMaybe<SeedWithTestDataOptions>;
};

export type SeedWithTestDataOptions = {
  autoConfirmContractLinesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  baseDate?: InputMaybe<Scalars['LocalDate']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataModules?: InputMaybe<Array<GoldDataModule>>;
  dateCalculationMethod?: InputMaybe<GoldDataDateCalculationMethod>;
  emitSquashing?: InputMaybe<Scalars['Boolean']['input']>;
  enableSquashing?: InputMaybe<Scalars['Boolean']['input']>;
  includeBills?: InputMaybe<Scalars['Boolean']['input']>;
  includeDataSourceTypes?: InputMaybe<Array<IntegrationType>>;
  includeEquity?: InputMaybe<Scalars['Boolean']['input']>;
  includeInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  includeMje?: InputMaybe<Scalars['Boolean']['input']>;
  includePaymentProcessorTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  includePayroll?: InputMaybe<Scalars['Boolean']['input']>;
  includeTags?: InputMaybe<Scalars['Boolean']['input']>;
  includeTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  maxTransactionsCountPerDataSource?: InputMaybe<Scalars['Int']['input']>;
  monthsBack?: InputMaybe<Scalars['Int']['input']>;
  revenueRecognitionConfigurationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SeedWithTestDataResult = {
  __typename?: 'SeedWithTestDataResult';
  company: Company;
};

export type SendMobileContinueOnDesktopEmailInput = {
  companyId: Scalars['ID']['input'];
};

export type SetAccountArchivedInput = {
  accountId: Scalars['ID']['input'];
  isArchived: Scalars['Boolean']['input'];
};

export type SetAccountEpochInput = {
  accountId: Scalars['AccountID']['input'];
  cutoffAtOrAfter?: InputMaybe<Scalars['ExclusiveDay']['input']>;
  cutoffBefore?: InputMaybe<Scalars['InclusiveDay']['input']>;
  shouldUpdateHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetAccountEpochResult = {
  __typename?: 'SetAccountEpochResult';
  account: Account;
};

export type SetAccountSyncStatusInput = {
  accountId: Scalars['ID']['input'];
  shouldSync: Scalars['Boolean']['input'];
};

export type SetAccountSyncStatusResult = {
  __typename?: 'SetAccountSyncStatusResult';
  account: Account;
};

export type SetCategorizationConfidenceInput = {
  confidence: CategoryConfidence;
  transactionId: Scalars['ID']['input'];
};

export type SetCategorizationConfidenceResult = {
  __typename?: 'SetCategorizationConfidenceResult';
  transaction: Transaction;
};

export type SetEpochsForAccountsInput = {
  connectionId: Scalars['ID']['input'];
  epochs: Array<SetAccountEpochInput>;
};

export type SetEpochsForAccountsResult = {
  __typename?: 'SetEpochsForAccountsResult';
  accounts: Array<Account>;
  connection: IntegrationConnection;
};

export type SetSplitInput = {
  splits: Array<SplitInput>;
  transactionId: Scalars['ID']['input'];
};

export type SetSplitResult = {
  __typename?: 'SetSplitResult';
  transaction: Transaction;
};

export type SetSubLedgerSquashingPolicyInput = {
  accountId?: InputMaybe<Scalars['AccountID']['input']>;
  companyId: Scalars['CompanyID']['input'];
  effectiveDate?: InputMaybe<Scalars['InclusiveDay']['input']>;
  subLedgerType: SubLedgerType;
  value: Scalars['Boolean']['input'];
};

export type SiteStatusMessage = {
  __typename?: 'SiteStatusMessage';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  priority: SiteStatusMessagePriority;
  type: SiteStatusMessageType;
};

export enum SiteStatusMessagePriority {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export enum SiteStatusMessageType {
  Error = 'Error',
  Info = 'Info',
  Neutral = 'Neutral',
  Warning = 'Warning'
}

export type SlackConnectInfoInput = {
  companyId: Scalars['ID']['input'];
};

export type SlackConnectInfoResponse = {
  __typename?: 'SlackConnectInfoResponse';
  authorizeAppUrl: Scalars['String']['output'];
  authorizeWebhookUrl: Scalars['String']['output'];
};

export type SourceCount = {
  __typename?: 'SourceCount';
  count: Scalars['Int']['output'];
  type: SourceType;
};

export enum SourceType {
  CreditCard = 'CreditCard',
  Depository = 'Depository',
  PaymentProcessor = 'PaymentProcessor',
  Payroll = 'Payroll'
}

export type SplitInput = {
  accrualDate?: InputMaybe<Scalars['LocalDate']['input']>;
  amount: Scalars['Decimal']['input'];
  capitalizable?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['CustomerID']['input']>;
  descriptor: Scalars['String']['input'];
  isBillPayment?: InputMaybe<Scalars['Boolean']['input']>;
  isInvoicePayment?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerCoaKey: Scalars['String']['input'];
  updateOfSplitId?: InputMaybe<Scalars['DetailID']['input']>;
  vendorPermaName?: InputMaybe<Scalars['VendorPermaName']['input']>;
};

export enum SquashBucketStatus {
  Compiled = 'Compiled',
  Compiling = 'Compiling',
  Posted = 'Posted'
}

export type SquashBucketSummaryItem = {
  __typename?: 'SquashBucketSummaryItem';
  amount: Money;
  transactionsCount: Scalars['Int']['output'];
};

export type SquashJournalsFilterBy = {
  dateRange?: InputMaybe<OpenEndedDateRangeInput>;
  subLedgerType?: InputMaybe<SubLedgerType>;
  view: LedgerView;
};

export type SquashSummariesFilterBy = {
  accountId?: InputMaybe<Scalars['AccountID']['input']>;
  dateRange?: InputMaybe<OpenEndedDateRangeInput>;
  subLedgerType?: InputMaybe<SubLedgerType>;
  view: LedgerView;
};

export type SquashSummariesResult = {
  __typename?: 'SquashSummariesResult';
  lastPostedAt?: Maybe<Scalars['DateTime']['output']>;
  summaries: Array<SquashSummary>;
};

export type SquashSummary = {
  __typename?: 'SquashSummary';
  ledgerCategory: LedgerCategory;
  squashedAmount: Money;
  unsquashedAmount: Money;
};

export type StartLedgerReconciliationInput = {
  bufferDayCount?: InputMaybe<Scalars['Int']['input']>;
  companyId: Scalars['CompanyID']['input'];
  ledgerAccountId: Scalars['ID']['input'];
  statementBalance: Scalars['Decimal']['input'];
  statementDay: Scalars['LocalDate']['input'];
  view: LedgerView;
};

export type Statement = {
  __typename?: 'Statement';
  accountId: Scalars['ID']['output'];
  companyId: Scalars['ID']['output'];
  endDate: Scalars['LocalDate']['output'];
  endingBalance: Money;
  file?: Maybe<File>;
  id: Scalars['ID']['output'];
  startDate: Scalars['LocalDate']['output'];
};

export type StatementBalances = {
  __typename?: 'StatementBalances';
  accountId: Scalars['ID']['output'];
  companyId: Scalars['ID']['output'];
  endDate: Scalars['LocalDate']['output'];
  endingBalance?: Maybe<Money>;
  startDate: Scalars['LocalDate']['output'];
  startingBalance?: Maybe<Money>;
};

export type StatementChecklistItem = ChecklistItem & MonthlyChecklistItem & {
  __typename?: 'StatementChecklistItem';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<ChecklistItemKey>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<User>;
  month: Scalars['Month']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  removedBy?: Maybe<User>;
  statementType: StatementChecklistItemType;
};

export enum StatementChecklistItemType {
  BalanceSheet = 'BalanceSheet',
  ProfitAndLoss = 'ProfitAndLoss'
}

export type StripeCheckoutSession = {
  __typename?: 'StripeCheckoutSession';
  cancelUrl: Scalars['String']['output'];
  clientReferenceId?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  successUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type StripeInitializationInfo = {
  __typename?: 'StripeInitializationInfo';
  connectUrl: Scalars['String']['output'];
};


export type StripeInitializationInfoConnectUrlArgs = {
  companyId: Scalars['ID']['input'];
};

export type StripeIntegration = {
  __typename?: 'StripeIntegration';
  connection?: Maybe<IntegrationConnection>;
  connections?: Maybe<Array<IntegrationConnection>>;
  initializationInfo: StripeInitializationInfo;
};


export type StripeIntegrationConnectionArgs = {
  companyId: Scalars['ID']['input'];
};


export type StripeIntegrationConnectionsArgs = {
  companyId: Scalars['ID']['input'];
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  stripePriceIds?: Maybe<Array<Scalars['String']['output']>>;
  subscriptions: Array<CompanyPricingPlan>;
};

export type StripeTransactionReportInput = {
  availableOnRange?: InputMaybe<ReportTimePeriodInput>;
  companyId: Scalars['ID']['input'];
  dateRange?: InputMaybe<ReportTimePeriodInput>;
};

export type StripeValidationRun = {
  __typename?: 'StripeValidationRun';
  account?: Maybe<Account>;
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<File>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['StripeValidationRunID']['output'];
  month: Scalars['Month']['output'];
  status: StripeValidationRunStatus;
  type: StripeValidationRunType;
  view?: Maybe<LedgerView>;
};

export type StripeValidationRunFilterBy = {
  accountIds?: InputMaybe<Array<Scalars['AccountID']['input']>>;
  months?: InputMaybe<Array<Scalars['Month']['input']>>;
  onlyNullView?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<StripeValidationRunType>>;
  view?: InputMaybe<LedgerView>;
};

export type StripeValidationRunPaginator = {
  __typename?: 'StripeValidationRunPaginator';
  nodes: Array<StripeValidationRun>;
  pageInfo: PageInfo;
};

export enum StripeValidationRunSortOrder {
  InsertOrderOrderAsc = 'INSERT_ORDER_ORDER_ASC',
  InsertOrderOrderDesc = 'INSERT_ORDER_ORDER_DESC',
  MonthOrderAsc = 'MONTH_ORDER_ASC',
  MonthOrderDesc = 'MONTH_ORDER_DESC'
}

export enum StripeValidationRunStatus {
  Error = 'Error',
  Failed = 'Failed',
  Passed = 'Passed',
  ReportsUnavailable = 'ReportsUnavailable',
  Started = 'Started'
}

export enum StripeValidationRunType {
  BalanceTransactionsReconciliation = 'BalanceTransactionsReconciliation',
  ProcessorReceivableReconciliation = 'ProcessorReceivableReconciliation'
}

export type SubLedger = PaymentProcessorSubLedger | RevenueSubLedger;

export enum SubLedgerAccrualEventsSortOrder {
  EffectiveAtOrderAsc = 'EFFECTIVE_AT_ORDER_ASC',
  EffectiveAtOrderDesc = 'EFFECTIVE_AT_ORDER_DESC'
}

export type SubLedgerFilterBy = {
  accountIds?: InputMaybe<Array<Scalars['AccountID']['input']>>;
  dateRange: InclusiveLocalDateRangeInput;
  subLedgerType?: InputMaybe<SubLedgerType>;
};

export type SubLedgerPaginator = {
  __typename?: 'SubLedgerPaginator';
  metadata: SubLedgerSummary;
  nodes: Array<SubLedger>;
  pageInfo: PageInfo;
};

export enum SubLedgerSortOrder {
  DateOrderAsc = 'DATE_ORDER_ASC',
  DateOrderDesc = 'DATE_ORDER_DESC'
}

export type SubLedgerSquashingPoliciesFilterBy = {
  accountId?: InputMaybe<Scalars['AccountID']['input']>;
  dateRange?: InputMaybe<InclusiveLocalDateRangeInput>;
  subLedgerType: SubLedgerType;
};

export type SubLedgerSquashingPoliciesInput = {
  filterBy: SubLedgerSquashingPoliciesFilterBy;
  page?: InputMaybe<PageInput>;
};

export type SubLedgerSquashingPoliciesResult = {
  __typename?: 'SubLedgerSquashingPoliciesResult';
  current?: Maybe<CompanySquashingPolicy>;
  latest?: Maybe<CompanySquashingPolicy>;
  pageInfo: PageInfo;
  policies: Array<CompanySquashingPolicy>;
};

export type SubLedgerSummary = PaymentProcessorSubLedgerSummary | RevenueSubLedgerSummary;

export enum SubLedgerType {
  FixedAssets = 'fixed_assets',
  PaymentProcessor = 'payment_processor',
  Revenue = 'revenue'
}

export type SubledgerEventLine = {
  __typename?: 'SubledgerEventLine';
  amount: Money;
  ledgerCoaKey: Scalars['String']['output'];
  squashed?: Maybe<Scalars['Boolean']['output']>;
  views?: Maybe<Array<LedgerView>>;
};

export type SubledgerEventSummary = {
  __typename?: 'SubledgerEventSummary';
  eventId: Scalars['ID']['output'];
  lines: Array<SubledgerEventLine>;
  status: Scalars['String']['output'];
};

export type SubscribeToCompanySlackChannelInput = {
  code: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  knockChannelKey: CompanyKnockChannelKey;
};

export type SubscribeToCompanySlackChannelResponse = {
  __typename?: 'SubscribeToCompanySlackChannelResponse';
  company: Company;
};

export type SubscriptionCustomerReportInput = {
  companyId: Scalars['ID']['input'];
  endMonth: Scalars['Month']['input'];
  metricType: RecurringRevenueMetricType;
  metricView: RecurringRevenueMetricViewType;
  startMonth: Scalars['Month']['input'];
};

export type SubscriptionEvent = {
  __typename?: 'SubscriptionEvent';
  accountId: Scalars['ID']['output'];
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceSubscription?: Maybe<Scalars['JSONObject']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SuccessResult = {
  __typename?: 'SuccessResult';
  success: Scalars['Boolean']['output'];
};

export enum SummaryColumn {
  AllColumnSum = 'AllColumnSum',
  FinalPeriodsAbsoluteAndPercentChange = 'FinalPeriodsAbsoluteAndPercentChange'
}

export enum Survey {
  ChartOfAccounts = 'ChartOfAccounts',
  Ltse = 'LTSE'
}

export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  answers: Array<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SurveyQuestionInput = {
  answers: Array<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  questions: Array<SurveyQuestion>;
  survey: Survey;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type SurveyResponseInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  questions: Array<SurveyQuestionInput>;
  survey: Survey;
};

export type SvbOfxInitializationInfo = {
  __typename?: 'SvbOfxInitializationInfo';
  connectUrl: Scalars['String']['output'];
};


export type SvbOfxInitializationInfoConnectUrlArgs = {
  companyId: Scalars['ID']['input'];
};

export type SvbOfxIntegration = {
  __typename?: 'SvbOfxIntegration';
  connection?: Maybe<IntegrationConnection>;
  connections?: Maybe<Array<IntegrationConnection>>;
  initializationInfo: SvbOfxInitializationInfo;
};


export type SvbOfxIntegrationConnectionArgs = {
  companyId: Scalars['ID']['input'];
};


export type SvbOfxIntegrationConnectionsArgs = {
  companyId: Scalars['ID']['input'];
};

export type SyncDataFromResult = {
  __typename?: 'SyncDataFromResult';
  connection: IntegrationConnection;
};

export type SyncFinancialInstitutionInput = {
  financialInstitutionId: Scalars['ID']['input'];
};

export type SyncFinancialInstitutionResult = {
  __typename?: 'SyncFinancialInstitutionResult';
  financialInstitution: FinancialInstitution;
};

export type SyncGustoInput = {
  companyId: Scalars['String']['input'];
};

export type SyncGustoResult = {
  __typename?: 'SyncGustoResult';
  contractorsSynced: Scalars['Int']['output'];
  employeesSynced: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  payrollsSynced: Scalars['Int']['output'];
};

export type SyncIntegrationConnectionInput = {
  integrationConnectionId: Scalars['ID']['input'];
  resyncRange?: InputMaybe<InclusiveLocalDateRangeInput>;
};

export type SyncResult = {
  __typename?: 'SyncResult';
  success: Scalars['Boolean']['output'];
};

export type SyncRun = {
  __typename?: 'SyncRun';
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['SyncRunID']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: SyncRunStatus;
};

export enum SyncRunStatus {
  Failed = 'Failed',
  HasWarnings = 'HasWarnings',
  InProgress = 'InProgress',
  Succeeded = 'Succeeded'
}

export type SystemCategorizationRule = CategorizationRule & {
  __typename?: 'SystemCategorizationRule';
  category: Category;
  confidence: CategoryConfidence;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: CategorizationRuleType;
  vendor?: Maybe<Vendor>;
};

export enum TaxIdType {
  Ein = 'EIN',
  Itin = 'ITIN',
  Ssn = 'SSN'
}

export enum TaxPreparerPlan {
  DoItMyself = 'DoItMyself',
  HasTaxPreparer = 'HasTaxPreparer',
  Unknown = 'Unknown',
  WantsTaxPreparer = 'WantsTaxPreparer'
}

export type TaxRate = {
  __typename?: 'TaxRate';
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['TaxRateID']['output'];
  percentage: Scalars['Decimal']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum TemplateType {
  ExplainAccounting = 'ExplainAccounting',
  MyBusinessInformation = 'MyBusinessInformation',
  TaxReadiness = 'TaxReadiness',
  TransactionInformation = 'TransactionInformation'
}

export type TimePeriodExpense = {
  __typename?: 'TimePeriodExpense';
  money: Money;
  timePeriod: Scalars['Period']['output'];
};

export type ToggleFirmGroupAnonymizationInput = {
  firmGroupId: Scalars['FirmGroupID']['input'];
  firmId: Scalars['FirmID']['input'];
  isAnonymized: Scalars['Boolean']['input'];
};

export type ToggleFirmGroupAnonymizationResult = {
  __typename?: 'ToggleFirmGroupAnonymizationResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ToggleSubledgersInput = {
  companyId: Scalars['CompanyID']['input'];
  value: Scalars['Boolean']['input'];
};

export type ToggleSubledgersResult = {
  __typename?: 'ToggleSubledgersResult';
  result: Scalars['Boolean']['output'];
};

export type Transaction = ITransaction & {
  __typename?: 'Transaction';
  account: Account;
  activity: TransactionActivityDetails;
  amount: Scalars['Decimal']['output'];
  amountAsMoney: Money;
  availableOn?: Maybe<Scalars['LocalDate']['output']>;
  basis?: Maybe<AccountingBasis>;
  company: Company;
  date: Scalars['LocalDate']['output'];
  descriptor: Scalars['String']['output'];
  detail: TransactionDetail;
  documentation: Array<TransactionDocument>;
  entries: Array<LedgerEntry>;
  eventViews: TransactionEventViews;
  /** @deprecated Use entries and eventViews */
  events: Array<LedgerEvent>;
  fixedAsset?: Maybe<FixedAsset>;
  hasDocumentation: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  integrationType: IntegrationType;
  isCapitalizable: Scalars['Boolean']['output'];
  isHistorical: Scalars['Boolean']['output'];
  linkToSourceTransaction?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use vendorPayment instead */
  linkedBills: Array<Bill>;
  links: Array<TransactionLink>;
  parent?: Maybe<Transaction>;
  payment?: Maybe<CustomerBalanceTransaction>;
  pending: Scalars['Boolean']['output'];
  revenue?: Maybe<TransactionRevenue>;
  sourceTransactionNativeId?: Maybe<Scalars['String']['output']>;
  splits: Array<TransactionDetail>;
  timestamp: Scalars['DateTime']['output'];
  vendorPayment?: Maybe<VendorBalanceTransaction>;
};

export type TransactionAiComment = TransactionActivity & {
  __typename?: 'TransactionAIComment';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  llmMessageThread?: Maybe<LlmMessageThread>;
  message?: Maybe<Scalars['String']['output']>;
  type: TransactionMemoType;
};

export type TransactionAccuracyCheck = AccuracyCheck & {
  __typename?: 'TransactionAccuracyCheck';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  displayMetadata?: Maybe<AccuracyCheckDisplayMetadata>;
  group: AccuracyCheckGroup;
  id: Scalars['AccuracyCheckID']['output'];
  outcomeOptions?: Maybe<TransactionOutcomeOptions>;
  query: TransactionQuery;
  status: AccuracyCheckStatus;
  type: AccuracyCheckType;
  uniqueKey: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TransactionAccuracyCheckConfig = AccuracyCheckConfig & {
  __typename?: 'TransactionAccuracyCheckConfig';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['AccuracyCheckID']['output'];
  query: TransactionQuery;
  type: AccuracyCheckType;
  updatedAt: Scalars['DateTime']['output'];
};

export type TransactionActivity = {
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionActivityDetails = {
  __typename?: 'TransactionActivityDetails';
  activity: Array<TransactionActivity>;
  assignmentsByType?: Maybe<TransactionAssignmentsByType>;
  /** @deprecated use assignmentsByType */
  currentAssignment?: Maybe<TransactionAssignment>;
};

export type TransactionAssignment = TransactionActivity & {
  __typename?: 'TransactionAssignment';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  llmMessageThread?: Maybe<LlmMessageThread>;
  request: Scalars['String']['output'];
  targetUser: User;
  type: TransactionMemoType;
};

export type TransactionAssignmentCanceled = TransactionActivity & {
  __typename?: 'TransactionAssignmentCanceled';
  actor: Actor;
  assignment: TransactionAssignment;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionAssignmentCompleted = TransactionActivity & {
  __typename?: 'TransactionAssignmentCompleted';
  actor: Actor;
  assignment: TransactionAssignment;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionAssignmentsByType = {
  __typename?: 'TransactionAssignmentsByType';
  CATEGORY_REVIEW: Array<TransactionAssignment>;
  CONTEXT: Array<TransactionAssignment>;
  DOCUMENTATION: Array<TransactionAssignment>;
};

export type TransactionCapitalizable = TransactionActivity & {
  __typename?: 'TransactionCapitalizable';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail: TransactionDetail;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionCategorized = TransactionActivity & {
  __typename?: 'TransactionCategorized';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail: TransactionDetail;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionCategoryMetrics = {
  __typename?: 'TransactionCategoryMetrics';
  totalDollarsInThisCategory?: Maybe<Scalars['Decimal']['output']>;
  totalNumberInThisCategory?: Maybe<Scalars['Float']['output']>;
};

export type TransactionCoaKeyOption = {
  __typename?: 'TransactionCoaKeyOption';
  count: Scalars['Int']['output'];
  ledgerCategory: LedgerCategory;
  resolvedCategory?: Maybe<LedgerCategory>;
  resolvedCount?: Maybe<Scalars['Int']['output']>;
};

export type TransactionConfigInput = {
  query: TransactionQueryInput;
  type: AccuracyCheckType;
};

export type TransactionContextProvided = TransactionActivity & {
  __typename?: 'TransactionContextProvided';
  actor: Actor;
  context: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
  viaMedium: CommunicationMedium;
};

export type TransactionDescriptorUpdate = TransactionActivity & {
  __typename?: 'TransactionDescriptorUpdate';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail: TransactionDetail;
  id: Scalars['ID']['output'];
  previousValue: Scalars['String']['output'];
  type: TransactionMemoType;
};

export type TransactionDetail = WithReportingClasses & {
  __typename?: 'TransactionDetail';
  accrualDate?: Maybe<Scalars['LocalDate']['output']>;
  actorType?: Maybe<TransactionDetailActorType>;
  amount: Scalars['Decimal']['output'];
  capitalizable?: Maybe<Scalars['Boolean']['output']>;
  card?: Maybe<Card>;
  categorizedByUser?: Maybe<User>;
  category: Category;
  categoryConfidence?: Maybe<CategoryConfidence>;
  categoryIsLocked: Scalars['Boolean']['output'];
  categoryMatchRuleDescription?: Maybe<Scalars['String']['output']>;
  classAwareType: ClassAwareType;
  classSegments: Array<AvailableClassSegment>;
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedState?: Maybe<DetailConfirmedState>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['CustomerID']['output']>;
  deletable?: Maybe<Scalars['Boolean']['output']>;
  descriptor: Scalars['String']['output'];
  fixedAsset?: Maybe<FixedAsset>;
  id: Scalars['ID']['output'];
  invoiceLineItem?: Maybe<InvoiceLine>;
  isBillPayment?: Maybe<Scalars['Boolean']['output']>;
  isInvoicePayment?: Maybe<Scalars['Boolean']['output']>;
  ledgerCoaKey: Scalars['String']['output'];
  linkedTransaction?: Maybe<Transaction>;
  memo?: Maybe<Scalars['String']['output']>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  prepaid?: Maybe<Prepaid>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ProductID']['output']>;
  programmaticRuleSource?: Maybe<Scalars['String']['output']>;
  programmaticRuleType?: Maybe<ProgrammaticRuleType>;
  recurrence?: Maybe<RecurrencePeriod>;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  rule?: Maybe<CategorizationRule>;
  schedule?: Maybe<ContractRevenueSchedule>;
  squashBucket?: Maybe<SubLedger>;
  squashBucketId?: Maybe<Scalars['SquashBucketID']['output']>;
  transactionId: Scalars['ID']['output'];
  vendor?: Maybe<Vendor>;
};

export enum TransactionDetailActorType {
  AdminActor = 'ADMIN_ACTOR',
  AiActor = 'AI_ACTOR',
  SystemActor = 'SYSTEM_ACTOR',
  TrainActor = 'TRAIN_ACTOR',
  UserActor = 'USER_ACTOR'
}

export type TransactionDocument = {
  __typename?: 'TransactionDocument';
  file: File;
  uploadActorType: TransactionDetailActorType;
};

export type TransactionEventView = {
  __typename?: 'TransactionEventView';
  status: LedgerEventStatus;
};

export type TransactionEventViews = {
  __typename?: 'TransactionEventViews';
  accrual: TransactionEventView;
  cash: TransactionEventView;
};

export type TransactionFileDeleted = TransactionActivity & {
  __typename?: 'TransactionFileDeleted';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail?: Maybe<TransactionDetail>;
  file: File;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionFileUploaded = TransactionActivity & {
  __typename?: 'TransactionFileUploaded';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail?: Maybe<TransactionDetail>;
  file: File;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionFilterBy = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  accountTypes?: InputMaybe<Array<AccountType>>;
  accrualDates?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  accuracyCheckId?: InputMaybe<Scalars['AccuracyCheckID']['input']>;
  actorType?: InputMaybe<TransactionDetailActorType>;
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  assignedToOthers?: InputMaybe<Scalars['ID']['input']>;
  availableOnEndDate?: InputMaybe<Scalars['InclusiveDay']['input']>;
  availableOnStartDate?: InputMaybe<Scalars['InclusiveDay']['input']>;
  capitalizable?: InputMaybe<Capitalizable>;
  cardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  cashFlow?: InputMaybe<CashFlow>;
  categorizedByUserRule?: InputMaybe<Scalars['Boolean']['input']>;
  classesFilter?: InputMaybe<FilterByClassesInput>;
  confidence?: InputMaybe<CategoryConfidence>;
  customerIds?: InputMaybe<Array<Scalars['CustomerID']['input']>>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  descriptorExact?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['InclusiveDay']['input']>;
  excludingCoaKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  finalized?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentation?: InputMaybe<Scalars['Boolean']['input']>;
  hasMismatchedTimestamp?: InputMaybe<Scalars['Boolean']['input']>;
  hasSplits?: InputMaybe<Scalars['Boolean']['input']>;
  includeLinkedToFixedAsset?: InputMaybe<Scalars['Boolean']['input']>;
  includeLinkedToPrepaid?: InputMaybe<Scalars['Boolean']['input']>;
  includePending?: InputMaybe<Scalars['Boolean']['input']>;
  includeRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  integrationConnectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  integrationTypes?: InputMaybe<Array<IntegrationType>>;
  invoiceId?: InputMaybe<Scalars['InvoiceID']['input']>;
  isBillPayment?: InputMaybe<Scalars['Boolean']['input']>;
  isInvoicePayment?: InputMaybe<Scalars['Boolean']['input']>;
  isLinked?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerCoaKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  matchRuleId?: InputMaybe<Scalars['ID']['input']>;
  maxAmount?: InputMaybe<Scalars['Decimal']['input']>;
  minAmount?: InputMaybe<Scalars['Decimal']['input']>;
  onlySquashed?: InputMaybe<Scalars['Boolean']['input']>;
  posted?: InputMaybe<Scalars['Boolean']['input']>;
  programmaticRuleTypes?: InputMaybe<Array<ProgrammaticRuleType>>;
  /** @deprecated No longer supported */
  recurrence?: InputMaybe<RecurrencePeriod>;
  recurrences?: InputMaybe<Array<InputMaybe<RecurrencePeriod>>>;
  squashBucketId?: InputMaybe<Scalars['SquashBucketID']['input']>;
  startDate?: InputMaybe<Scalars['InclusiveDay']['input']>;
  state?: InputMaybe<DetailConfirmedState>;
  vendorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TransactionFinalized = TransactionActivity & {
  __typename?: 'TransactionFinalized';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionImplicitlyCategorized = TransactionActivity & {
  __typename?: 'TransactionImplicitlyCategorized';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail: TransactionDetail;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionLink = {
  __typename?: 'TransactionLink';
  bill?: Maybe<Bill>;
  bundleId: Scalars['TransactionLinkBundleID']['output'];
  id: Scalars['ID']['output'];
  receivedTransaction?: Maybe<Transaction>;
  reimbursement?: Maybe<Reimbursement>;
  sentTransaction: Transaction;
};

export type TransactionMarkedAsBillPayment = TransactionActivity & {
  __typename?: 'TransactionMarkedAsBillPayment';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail: TransactionDetail;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionMarkedAsInvoicePayment = TransactionActivity & {
  __typename?: 'TransactionMarkedAsInvoicePayment';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail: TransactionDetail;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export enum TransactionMemoAssignmentType {
  CategoryReview = 'CATEGORY_REVIEW',
  Context = 'CONTEXT',
  Documentation = 'DOCUMENTATION'
}

export type TransactionMemoChanged = TransactionActivity & {
  __typename?: 'TransactionMemoChanged';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail: TransactionDetail;
  id: Scalars['ID']['output'];
  previousValue?: Maybe<Scalars['String']['output']>;
  type: TransactionMemoType;
};

export enum TransactionMemoType {
  AiComment = 'AI_COMMENT',
  Assignment = 'ASSIGNMENT',
  AssignmentComplete = 'ASSIGNMENT_COMPLETE',
  CancelAssignment = 'CANCEL_ASSIGNMENT',
  Capitalizable = 'CAPITALIZABLE',
  DescriptorUpdate = 'DESCRIPTOR_UPDATE',
  FileDeleted = 'FILE_DELETED',
  FileUploaded = 'FILE_UPLOADED',
  Finalized = 'FINALIZED',
  MarkedAsBillPayment = 'MARKED_AS_BILL_PAYMENT',
  MarkedAsInvoicePayment = 'MARKED_AS_INVOICE_PAYMENT',
  MemoChanged = 'MEMO_CHANGED',
  Message = 'MESSAGE',
  MoveDate = 'MOVE_DATE',
  Posted = 'POSTED',
  Recurrence = 'RECURRENCE',
  TransactionCategorized = 'TRANSACTION_CATEGORIZED',
  TransactionImplicitlyCategorized = 'TRANSACTION_IMPLICITLY_CATEGORIZED',
  Uncapitalizable = 'UNCAPITALIZABLE',
  Unfinalized = 'UNFINALIZED',
  UnmarkedAsBillPayment = 'UNMARKED_AS_BILL_PAYMENT',
  UnmarkedAsInvoicePayment = 'UNMARKED_AS_INVOICE_PAYMENT',
  UserProvidedContext = 'USER_PROVIDED_CONTEXT',
  VendorChanged = 'VENDOR_CHANGED',
  VendorImplicitlyChanged = 'VENDOR_IMPLICITLY_CHANGED'
}

export type TransactionMessage = TransactionActivity & {
  __typename?: 'TransactionMessage';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  type: TransactionMemoType;
};

export type TransactionMetric = {
  __typename?: 'TransactionMetric';
  amount: Money;
  descriptor?: Maybe<Scalars['String']['output']>;
  ledgerCoaKey?: Maybe<Scalars['String']['output']>;
  recurrence?: Maybe<RecurrencePeriod>;
  split: TransactionDetail;
  vendor?: Maybe<Vendor>;
};

export type TransactionMoveDate = TransactionActivity & {
  __typename?: 'TransactionMoveDate';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail: TransactionDetail;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionOutcomeOptions = {
  __typename?: 'TransactionOutcomeOptions';
  ledgerCoaKeys?: Maybe<Array<TransactionCoaKeyOption>>;
  vendors?: Maybe<Array<TransactionVendorOption>>;
};

export type TransactionPaginator = {
  __typename?: 'TransactionPaginator';
  nodes: Array<Transaction>;
  pageInfo: PageInfo;
  /** @deprecated No longer supported */
  transactions: Array<Transaction>;
};

export type TransactionPosted = TransactionActivity & {
  __typename?: 'TransactionPosted';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail: TransactionDetail;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionQuery = {
  __typename?: 'TransactionQuery';
  accounts?: Maybe<Array<Account>>;
  accuracyCheckId?: Maybe<Scalars['AccuracyCheckID']['output']>;
  amountMax?: Maybe<Scalars['Decimal']['output']>;
  amountMin?: Maybe<Scalars['Decimal']['output']>;
  descriptorExact?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['InclusiveDay']['output']>;
  hasMismatchedTimestamp?: Maybe<Scalars['Boolean']['output']>;
  hasSplits?: Maybe<Scalars['Boolean']['output']>;
  integrationTypes?: Maybe<Array<IntegrationType>>;
  ledgerCategories?: Maybe<Array<LedgerCategory>>;
  startDate?: Maybe<Scalars['InclusiveDay']['output']>;
  vendors?: Maybe<Array<Vendor>>;
};

export type TransactionQueryInput = {
  accountIds?: InputMaybe<Array<Scalars['AccountID']['input']>>;
  accuracyCheckId?: InputMaybe<Scalars['AccuracyCheckID']['input']>;
  amountMax?: InputMaybe<Scalars['Decimal']['input']>;
  amountMin?: InputMaybe<Scalars['Decimal']['input']>;
  descriptorExact?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['InclusiveDay']['input']>;
  hasMismatchedTimestamp?: InputMaybe<Scalars['Boolean']['input']>;
  hasSplits?: InputMaybe<Scalars['Boolean']['input']>;
  integrationTypes?: InputMaybe<Array<IntegrationType>>;
  ledgerCoaKeys?: InputMaybe<Array<Scalars['LedgerCoaKey']['input']>>;
  startDate?: InputMaybe<Scalars['InclusiveDay']['input']>;
  vendorIds?: InputMaybe<Array<Scalars['CompanyVendorID']['input']>>;
};

export type TransactionRecurrence = TransactionActivity & {
  __typename?: 'TransactionRecurrence';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail: TransactionDetail;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionReportInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  companyId: Scalars['ID']['input'];
  range: ReportTimePeriodInput;
};

export type TransactionResult = {
  __typename?: 'TransactionResult';
  transaction: UserTransaction;
};

export type TransactionRevenue = {
  __typename?: 'TransactionRevenue';
  /** @deprecated No longer supported */
  customer?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  invoice?: Maybe<TransactionRevenueInvoice>;
  /** @deprecated No longer supported */
  product?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  sourceAccount: Scalars['String']['output'];
};

export type TransactionRevenueInvoice = {
  __typename?: 'TransactionRevenueInvoice';
  nativeId?: Maybe<Scalars['String']['output']>;
  nativeUrl?: Maybe<Scalars['String']['output']>;
};

export enum TransactionSortOrder {
  AbsAmountAsc = 'ABS_AMOUNT_ASC',
  AbsAmountDesc = 'ABS_AMOUNT_DESC',
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  NameAsc = 'NAME_ASC',
  UncategorizedAmountDesc = 'UNCATEGORIZED_AMOUNT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC'
}

export enum TransactionType {
  Charge = 'CHARGE',
  Fee = 'FEE',
  Payout = 'PAYOUT',
  Refund = 'REFUND'
}

export type TransactionUnFinalized = TransactionActivity & {
  __typename?: 'TransactionUnFinalized';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionUncapitalizable = TransactionActivity & {
  __typename?: 'TransactionUncapitalizable';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail: TransactionDetail;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionUnmarkedAsBillPayment = TransactionActivity & {
  __typename?: 'TransactionUnmarkedAsBillPayment';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail: TransactionDetail;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionUnmarkedAsInvoicePayment = TransactionActivity & {
  __typename?: 'TransactionUnmarkedAsInvoicePayment';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail: TransactionDetail;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionVendorChanged = TransactionActivity & {
  __typename?: 'TransactionVendorChanged';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail: TransactionDetail;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionVendorImplicitlyChanged = TransactionActivity & {
  __typename?: 'TransactionVendorImplicitlyChanged';
  actor: Actor;
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  detail: TransactionDetail;
  id: Scalars['ID']['output'];
  type: TransactionMemoType;
};

export type TransactionVendorOption = {
  __typename?: 'TransactionVendorOption';
  count: Scalars['Int']['output'];
  resolvedCount?: Maybe<Scalars['Int']['output']>;
  resolvedVendor?: Maybe<Vendor>;
  vendor: Vendor;
};

export type TransactionsForCompaniesInput = {
  companyIds: Array<Scalars['ID']['input']>;
  filterBy?: InputMaybe<TransactionFilterBy>;
  includeStripe?: InputMaybe<Scalars['Boolean']['input']>;
  noTestCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<PageInput>;
  sortBy?: InputMaybe<TransactionSortOrder>;
};

export type TrinetIntegration = {
  __typename?: 'TrinetIntegration';
  connections?: Maybe<Array<IntegrationConnection>>;
};

export type UnapproveLedgerReconciliationInput = {
  id: Scalars['LedgerReconciliationID']['input'];
};

export type UnconfirmContractLineInput = {
  companyId: Scalars['CompanyID']['input'];
  contractLineId: Scalars['ContractLineID']['input'];
};

export type UnconfirmContractLinesInput = {
  companyId: Scalars['CompanyID']['input'];
  criteria: ContractLinesFilter;
};

export type UnconfirmContractLinesResult = {
  __typename?: 'UnconfirmContractLinesResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UnholdFixedAssetInput = {
  id: Scalars['FixedAssetID']['input'];
};

export type UnlinkStoredFileFromEntityInput = {
  entityId: Scalars['ID']['input'];
  entityType: AssociatedEntity;
  fileId: Scalars['StoredFileID']['input'];
};

export type UnlinkStoredFileFromEntityResult = {
  __typename?: 'UnlinkStoredFileFromEntityResult';
  entityId: Scalars['ID']['output'];
  entityType: AssociatedEntity;
  fileId: Scalars['ID']['output'];
};

export type UnmergeContractorsInput = {
  companyId: Scalars['CompanyID']['input'];
  mergedId: Scalars['MergedContractorMergedID']['input'];
};

export type UnmergeContractorsResult = {
  __typename?: 'UnmergeContractorsResult';
  success: Scalars['Boolean']['output'];
};

export type UnmergeEmployeesInput = {
  companyId: Scalars['CompanyID']['input'];
  mergedId: Scalars['MergedEmployeeMergedID']['input'];
};

export type UnmergeEmployeesResult = {
  __typename?: 'UnmergeEmployeesResult';
  success: Scalars['Boolean']['output'];
};

export type UnsubscribeFromCompanySlackChannelInput = {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type UnsubscribeFromCompanySlackChannelResponse = {
  __typename?: 'UnsubscribeFromCompanySlackChannelResponse';
  company: Company;
};

export type UpdateAiWorkflowSettingsInput = {
  assistedCategorizationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  automaticAssignmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autonomousAccountingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['ID']['input'];
  lastMilePreference?: InputMaybe<LastMilePreferenceInput>;
};

export type UpdateAccountResult = {
  __typename?: 'UpdateAccountResult';
  account: Account;
};

export type UpdateAccountSettingInput = {
  id: Scalars['String']['input'];
  shouldIncludeBalance: Scalars['Boolean']['input'];
  shouldIncludeTransactions: Scalars['Boolean']['input'];
  shouldSync: Scalars['Boolean']['input'];
};

export type UpdateAccountSettingResult = {
  __typename?: 'UpdateAccountSettingResult';
  id: Scalars['String']['output'];
  shouldIncludeBalance: Scalars['Boolean']['output'];
  shouldIncludeTransactions: Scalars['Boolean']['output'];
  shouldSync: Scalars['Boolean']['output'];
};

export type UpdateAccountingConfigurationRuleInput = {
  /** @deprecated unused */
  companyId?: InputMaybe<Scalars['CompanyID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['AccountingConfigurationRuleID']['input'];
  isAutoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAccountingConfigurationRuleResponse = {
  __typename?: 'UpdateAccountingConfigurationRuleResponse';
  rule: AccountingConfigurationRule;
};

export type UpdateAccountingConfigurationStatusInput = {
  /** @deprecated unused */
  companyId?: InputMaybe<Scalars['CompanyID']['input']>;
  id: Scalars['AccountingConfigurationID']['input'];
  status: AccountingConfigurationStatus;
};

export type UpdateAccountingConfigurationStatusResponse = {
  __typename?: 'UpdateAccountingConfigurationStatusResponse';
  configuration: AccountingConfiguration;
};

export type UpdateAccuracyCheckConfigInput = {
  companyId: Scalars['CompanyID']['input'];
  config: ConfigsInputs;
  enabled: Scalars['Boolean']['input'];
};

export type UpdateAccuracyCheckConfigResult = {
  __typename?: 'UpdateAccuracyCheckConfigResult';
  config: AccuracyCheckConfig;
};

export type UpdateApiConnectionInput = {
  dataSourceTypeId?: InputMaybe<Scalars['Int']['input']>;
  hasWebhooksEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  loginKey?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiresFitTest?: InputMaybe<Scalars['Boolean']['input']>;
  supportsRedirect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCardInput = {
  cardId?: InputMaybe<Scalars['ID']['input']>;
  detailId: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
};

export type UpdateCashAccrualViewInput = {
  companyId: Scalars['CompanyID']['input'];
  viewPreference?: InputMaybe<LedgerView>;
};

export type UpdateCashAccrualViewResult = {
  __typename?: 'UpdateCashAccrualViewResult';
  company: Company;
};

export type UpdateCoaInput = {
  companyId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  keywords?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Array<LedgerView>>;
};

export type UpdateCoaResult = {
  __typename?: 'UpdateCoaResult';
  account: LedgerAccount;
};

export type UpdateCompanyFeatureInput = {
  companyId: Scalars['CompanyID']['input'];
  featureName: CompanySettingFeatureName;
  value: Scalars['Boolean']['input'];
};

export type UpdateCompanyFeatureResult = {
  __typename?: 'UpdateCompanyFeatureResult';
  company: Company;
};

export type UpdateCompanyFreeTrialInput = {
  companyId: Scalars['CompanyID']['input'];
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type UpdateCompanyInput = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  attributes?: InputMaybe<CompanyAttributesInput>;
  bookkeeperPlan?: InputMaybe<BookkeeperPlan>;
  currentUserRole?: InputMaybe<UserPosition>;
  email?: InputMaybe<Scalars['String']['input']>;
  hasHistoricalData?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated No longer supported */
  howDidYouHearAboutUs?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated No longer supported */
  howDidYouHearAboutUsOther?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated No longer supported */
  howDidYouHearAboutUsReferer?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isFreshStart?: InputMaybe<Scalars['Boolean']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  mfaRequired?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referBookkeeper?: InputMaybe<Scalars['Boolean']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  referralUrl?: InputMaybe<Scalars['String']['input']>;
  revenueModel?: InputMaybe<RevenueModel>;
  startIngestionDate?: InputMaybe<Scalars['InclusiveDay']['input']>;
  taxPreparerPlan?: InputMaybe<TaxPreparerPlan>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated  */
  type?: InputMaybe<CompanyType>;
  userProposedStartIngestionDate?: InputMaybe<Scalars['InclusiveDay']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyInvitationInput = {
  id: Scalars['ID']['input'];
  mfaRequired?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<MembershipRole>;
};

export type UpdateCompanyMembershipAsUserInput = {
  id: Scalars['ID']['input'];
  position?: InputMaybe<UserPosition>;
};

export type UpdateCompanyMembershipInput = {
  id: Scalars['ID']['input'];
  mfaRequired?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<UserPosition>;
  role?: InputMaybe<MembershipRole>;
  status?: InputMaybe<MembershipStatus>;
};

export type UpdateContractLineInput = {
  accountingConfigurationId?: InputMaybe<Scalars['AccountingConfigurationID']['input']>;
  contractLineId: Scalars['ContractLineID']['input'];
  customerId?: InputMaybe<Scalars['CustomerID']['input']>;
  productId?: InputMaybe<Scalars['ProductID']['input']>;
  recognitionPeriod?: InputMaybe<ContractLineRecognitionPeriod>;
};

export type UpdateContractLinesAccountingPolicyInput = {
  accountingConfigurationId: Scalars['AccountingConfigurationID']['input'];
  companyId: Scalars['CompanyID']['input'];
  filter: ContractLinesFilter;
  recognitionPeriod?: InputMaybe<ContractLineRecognitionPeriod>;
};

export type UpdateContractLinesAccountingPolicyResult = {
  __typename?: 'UpdateContractLinesAccountingPolicyResult';
  success: Scalars['Boolean']['output'];
};

export type UpdateContractRevenueScheduleInput = {
  dateRange?: InputMaybe<InclusiveLocalDateRangeInput>;
  id: Scalars['ContractRevenueScheduleID']['input'];
  manualEntries?: InputMaybe<Array<ManualRevenueScheduleEntryInput>>;
  postingMethod?: InputMaybe<ContractRevenueSchedulePostingMethod>;
};

export type UpdateCustomerInput = {
  billingAddressJson?: InputMaybe<Scalars['JSON']['input']>;
  companyId: Scalars['ID']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CustomerStatus>;
  type?: InputMaybe<CustomerType>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerResult = {
  __typename?: 'UpdateCustomerResult';
  customer: Customer;
};

export type UpdateDescriptorInput = {
  descriptor: Scalars['String']['input'];
  transactionId: Scalars['TransactionID']['input'];
};

export type UpdateDirectIngestFileRowsInput = {
  data: DirectIngestFileRowInput;
  id: Scalars['DirectIngestFileID']['input'];
};

export type UpdateDirectIngestFileRowsResult = {
  __typename?: 'UpdateDirectIngestFileRowsResult';
  coaKeys?: Maybe<DirectIngestCoaKeyRowsResult>;
  journalEntries?: Maybe<DirectIngestJournalEntryRowsResult>;
};

export type UpdateEmailPreferencesInput = {
  preferences: Array<UserEmailSettingInput>;
  secret: Scalars['String']['input'];
};

export type UpdateFinalizedTransactionStateInput = {
  isFinalized: Scalars['Boolean']['input'];
  transactionId: Scalars['ID']['input'];
};

export type UpdateFirmGroupInput = {
  alias: Scalars['String']['input'];
  firmGroupId: Scalars['FirmGroupID']['input'];
  firmId: Scalars['FirmID']['input'];
  isAnonymized: Scalars['Boolean']['input'];
  userIds: Array<Scalars['UserID']['input']>;
};

export type UpdateFirmGroupResult = {
  __typename?: 'UpdateFirmGroupResult';
  firmGroup: FirmGroup;
};

export type UpdateFixedAssetInput = {
  capitalizedAt?: InputMaybe<Scalars['LocalDate']['input']>;
  currency?: InputMaybe<Scalars['Currency']['input']>;
  depreciationMethod?: InputMaybe<FixedAssetDepreciationMethod>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['FixedAssetID']['input'];
  inServiceAt?: InputMaybe<Scalars['LocalDate']['input']>;
  originalValue?: InputMaybe<Scalars['Decimal']['input']>;
  salvageValue?: InputMaybe<Scalars['Decimal']['input']>;
  type?: InputMaybe<FixedAssetType>;
  usefulLifeMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFixedAssetRuleCategoryInput = {
  coaKey: Scalars['String']['input'];
  id?: InputMaybe<Scalars['FixedAssetRuleCategoryID']['input']>;
};

export type UpdateFixedAssetRuleInput = {
  categories?: InputMaybe<Array<UpdateFixedAssetRuleCategoryInput>>;
  depreciationMethod: FixedAssetDepreciationMethod;
  firstMonthConvention: FirstMonthConvention;
  id: Scalars['FixedAssetRuleID']['input'];
  minimumQualifyingAmount: MoneyInput;
  type: FixedAssetType;
  usefulLifeMonths: Scalars['Int']['input'];
  vendors?: InputMaybe<Array<UpdateFixedAssetRuleVendorInput>>;
};

export type UpdateFixedAssetRuleVendorInput = {
  id?: InputMaybe<Scalars['FixedAssetRuleVendorID']['input']>;
  vendorId: Scalars['CompanyVendorID']['input'];
};

export type UpdateIntroStepInput = {
  introStep?: InputMaybe<IntroStep>;
};

export type UpdateInvoiceDiscountLineInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  coaKey?: InputMaybe<Scalars['LedgerCoaKey']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['InvoiceDiscountLineID']['input'];
  schedule?: InputMaybe<CreateInvoiceLineSchedule>;
  segments?: InputMaybe<Array<UpsertClassSegmentInput>>;
};

export type UpdateInvoiceInput = {
  customerId: Scalars['CustomerID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discountLines?: InputMaybe<Array<UpdateInvoiceDiscountLineInput>>;
  dueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['InvoiceID']['input'];
  issueDate: Scalars['LocalDate']['input'];
  lines: Array<UpdateInvoiceLineInput>;
  shippingLines?: InputMaybe<Array<UpdateInvoiceShippingLineInput>>;
  status: InvoiceStatus;
};

export type UpdateInvoiceLineInput = {
  amount: Scalars['Decimal']['input'];
  coaKey?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['InvoiceLineItemID']['input']>;
  productId?: InputMaybe<Scalars['ProductID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  revRecOptions?: InputMaybe<InvoiceLineRevRecOptionsInput>;
  schedule?: InputMaybe<CreateInvoiceLineSchedule>;
  segments?: InputMaybe<Array<UpsertClassSegmentInput>>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateInvoiceResult = {
  __typename?: 'UpdateInvoiceResult';
  invoice: Invoice;
};

export type UpdateInvoiceShippingLineInput = {
  coaKey?: InputMaybe<Scalars['LedgerCoaKey']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['InvoiceShippingLineID']['input'];
  segments?: InputMaybe<Array<UpsertClassSegmentInput>>;
  subtotal?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateIsBillPaymentInput = {
  companyId: Scalars['ID']['input'];
  detailId: Scalars['ID']['input'];
  isBillPayment: Scalars['Boolean']['input'];
};

export type UpdateIsInvoicePaymentInput = {
  companyId: Scalars['ID']['input'];
  detailId: Scalars['ID']['input'];
  isInvoicePayment: Scalars['Boolean']['input'];
};

export type UpdateLedgerReconciliationCompanySettingsInput = {
  companyId: Scalars['ID']['input'];
  ledgerReconciliationCashView?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLedgerReconciliationInput = {
  addLedgerEntryIds?: InputMaybe<Array<Scalars['LedgerReconciliationEntryID']['input']>>;
  id: Scalars['LedgerReconciliationID']['input'];
  removeLedgerEntryIds?: InputMaybe<Array<Scalars['LedgerReconciliationEntryID']['input']>>;
};

export type UpdateMetricCardPreferencesInput = {
  companyId: Scalars['CompanyID']['input'];
  metricCardPreferences: Array<MetricCardPreferenceInput>;
};

export type UpdateMetricCardPreferencesResult = {
  __typename?: 'UpdateMetricCardPreferencesResult';
  companyId: Scalars['CompanyID']['output'];
  metricCardPreferences: Array<MetricCardPreference>;
  userId: Scalars['UserID']['output'];
};

export type UpdateMultipleTransactionsResult = {
  __typename?: 'UpdateMultipleTransactionsResult';
  updated: Array<Maybe<Transaction>>;
};

export type UpdateNotificationPreferencesResponse = {
  __typename?: 'UpdateNotificationPreferencesResponse';
  preferences?: Maybe<Scalars['JSON']['output']>;
};

export type UpdateNotificationWorkflowResponse = {
  __typename?: 'UpdateNotificationWorkflowResponse';
  updated?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateOnboardingStepInput = {
  companyId: Scalars['CompanyID']['input'];
  status: OnboardingStepStatus;
  step: OnboardingStep;
};

export type UpdateOnboardingStepResult = {
  __typename?: 'UpdateOnboardingStepResult';
  company: Company;
};

export type UpdateOnboardingStepV2Result = {
  __typename?: 'UpdateOnboardingStepV2Result';
  success: Scalars['Boolean']['output'];
};

export type UpdatePartnerAdBookkeepingCriteriaInput = {
  maxCashBalance?: InputMaybe<Scalars['Int']['input']>;
  maxMonthlyExpenses?: InputMaybe<Scalars['Int']['input']>;
  maxMonthlyRevenue?: InputMaybe<Scalars['Int']['input']>;
  minCashBalance?: InputMaybe<Scalars['Int']['input']>;
  minMonthlyExpenses?: InputMaybe<Scalars['Int']['input']>;
  minMonthlyRevenue?: InputMaybe<Scalars['Int']['input']>;
  orgType?: InputMaybe<CompanyOrgType>;
};

export type UpdatePartnerAdInput = {
  affiliateUrl?: InputMaybe<Scalars['String']['input']>;
  bookkeepingCriteria?: InputMaybe<UpdatePartnerAdBookkeepingCriteriaInput>;
  calendarUrl?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  logoDarkId?: InputMaybe<Scalars['ID']['input']>;
  logoDarkUrl?: InputMaybe<Scalars['String']['input']>;
  logoLightId?: InputMaybe<Scalars['ID']['input']>;
  logoLightUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePayrollInput = {
  benefits: Array<BenefitInput>;
  companyId: Scalars['ID']['input'];
  contractorPaymentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  employeeTaxes: Scalars['Decimal']['input'];
  employerTaxes: Scalars['Decimal']['input'];
  netPay: Scalars['Decimal']['input'];
  payrollId: Scalars['ID']['input'];
  salaries: Scalars['Decimal']['input'];
};

export type UpdatePostedBillInput = {
  billId: Scalars['BillID']['input'];
  companyId: Scalars['CompanyID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  issueDate: Scalars['LocalDate']['input'];
  lines: Array<UpdatePostedBillLineInput>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePostedBillLineInput = {
  amount: Scalars['Decimal']['input'];
  coaKey: Scalars['LedgerCoaKey']['input'];
  currency: Scalars['Currency']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  fixedAsset?: InputMaybe<UpsertFixedAssetForUpsertBillLineInput>;
  id?: InputMaybe<Scalars['BillLineID']['input']>;
  prepaid?: InputMaybe<UpsertPrepaidInput>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  segments?: InputMaybe<Array<UpsertClassSegmentInput>>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdatePrepaidInput = {
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  expenseRecognitionMethod?: InputMaybe<ExpenseRecognitionMethod>;
  id: Scalars['PrepaidID']['input'];
  ledgerCoaKey?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  total?: InputMaybe<MoneyInput>;
};

export type UpdateProductInput = {
  companyId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  priceRate?: InputMaybe<Scalars['Decimal']['input']>;
  serviceType?: InputMaybe<ProductServiceType>;
  sku?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductStatus>;
};

export type UpdateProductResult = {
  __typename?: 'UpdateProductResult';
  product: Product;
};

export type UpdateRecurrenceInput = {
  recurrence?: InputMaybe<RecurrencePeriod>;
  transactionId: Scalars['TransactionID']['input'];
};

export type UpdateRecurringTemplateInput = {
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  id: Scalars['RecurringTemplateID']['input'];
};

export type UpdateTransactionCustomerInput = {
  companyId: Scalars['CompanyID']['input'];
  id?: InputMaybe<Scalars['CustomerID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['TransactionID']['input'];
};

export type UpdateTransactionDetailResult = {
  __typename?: 'UpdateTransactionDetailResult';
  activity: TransactionActivityDetails;
  detail: TransactionDetail;
};

export type UpdateTransactionMemoInput = {
  companyId: Scalars['ID']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['ID']['input'];
};

export type UpdateTransactionProductInput = {
  companyId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['ID']['input'];
};

export type UpdateTransactionResult = {
  __typename?: 'UpdateTransactionResult';
  task?: Maybe<NotificationMessage>;
  transaction: Transaction;
};

export type UpdateTransactionVendorInput = {
  companyId: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserAttributesResult = {
  __typename?: 'UpdateUserAttributesResult';
  success: Scalars['Boolean']['output'];
};

export enum UpdateUserErrorCode {
  BadData = 'BAD_DATA'
}

export type UpdateUserResult = {
  __typename?: 'UpdateUserResult';
  errorCode?: Maybe<UpdateUserErrorCode>;
  errorDetails?: Maybe<Array<ErrorDetail>>;
  user?: Maybe<User>;
};

export type UpdateVendorInput = {
  addressJson?: InputMaybe<Scalars['JSON']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['Currency']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  is1099Vendor?: InputMaybe<YesNoUnknown>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<VendorStatus>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxIdType?: InputMaybe<TaxIdType>;
  type?: InputMaybe<VendorType>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVendorResult = {
  __typename?: 'UpdateVendorResult';
  vendor: Vendor;
};

export type UpsertAccountingConfigurationResponse = {
  __typename?: 'UpsertAccountingConfigurationResponse';
  configuration: AccountingConfiguration;
};

export type UpsertBillInput = {
  companyId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueDate: Scalars['LocalDate']['input'];
  lines: Array<UpsertBillLineInput>;
  shouldPost?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertBillLineInput = {
  amount: Scalars['Decimal']['input'];
  coaKey?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  currency: Scalars['Currency']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  fixedAsset?: InputMaybe<UpsertFixedAssetForUpsertBillLineInput>;
  id?: InputMaybe<Scalars['BillLineID']['input']>;
  prepaid?: InputMaybe<UpsertPrepaidInput>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  segments?: InputMaybe<Array<UpsertClassSegmentInput>>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpsertClassSegmentInput = {
  class: Scalars['TagNameDisplayName']['input'];
  reportingClassType: ReportingClassType;
  segment: Scalars['TagValueDisplayName']['input'];
};

export type UpsertFixedAssetForBillLineInput = {
  billLineId: Scalars['BillLineID']['input'];
  capitalizedAt: Scalars['LocalDate']['input'];
  companyId: Scalars['CompanyID']['input'];
  depreciationMethod?: InputMaybe<FixedAssetDepreciationMethod>;
  description?: InputMaybe<Scalars['String']['input']>;
  inServiceAt: Scalars['LocalDate']['input'];
  salvageValue?: InputMaybe<Scalars['Decimal']['input']>;
  status?: InputMaybe<FixedAssetStatus>;
  type?: InputMaybe<FixedAssetType>;
  usefulLifeMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertFixedAssetForDetailInput = {
  capitalizedAt?: InputMaybe<Scalars['LocalDate']['input']>;
  companyId: Scalars['CompanyID']['input'];
  depreciationMethod?: InputMaybe<FixedAssetDepreciationMethod>;
  description?: InputMaybe<Scalars['String']['input']>;
  detailId: Scalars['DetailID']['input'];
  inServiceAt: Scalars['LocalDate']['input'];
  salvageValue?: InputMaybe<Scalars['Decimal']['input']>;
  status?: InputMaybe<FixedAssetStatus>;
  type?: InputMaybe<FixedAssetType>;
  usefulLifeMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertFixedAssetForUpsertBillLineInput = {
  capitalizedAt?: InputMaybe<Scalars['Date']['input']>;
  companyId: Scalars['CompanyID']['input'];
  depreciationMethod?: InputMaybe<FixedAssetDepreciationMethod>;
  description?: InputMaybe<Scalars['String']['input']>;
  inServiceAt: Scalars['LocalDate']['input'];
  salvageValue?: InputMaybe<Scalars['Decimal']['input']>;
  type: FixedAssetType;
  usefulLifeMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertInitialUserAccountBalanceInput = {
  accountId: Scalars['ID']['input'];
  amount: Scalars['Decimal']['input'];
  balanceDay: Scalars['LocalDate']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  splits?: InputMaybe<Array<BalanceSplitInput>>;
};

export type UpsertInitialUserAccountBalanceResult = {
  __typename?: 'UpsertInitialUserAccountBalanceResult';
  accountBalance?: Maybe<AccountBalance>;
};

export type UpsertInitialUserLedgerAccountBalanceInput = {
  amount: Scalars['Decimal']['input'];
  balanceDay: Scalars['LocalDate']['input'];
  companyId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  ledgerAccountId: Scalars['ID']['input'];
  splits?: InputMaybe<Array<BalanceSplitInput>>;
};

export type UpsertLedgerHistoryBalanceInput = {
  endingDate: Scalars['LocalDate']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  lines: Array<UpsertLedgerHistoryBalanceLineInput>;
};

export type UpsertLedgerHistoryBalanceLineInput = {
  accountDisplayId: Scalars['String']['input'];
  amount: Scalars['Decimal']['input'];
  currency?: InputMaybe<Scalars['Currency']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ledgerCoaKey: Scalars['String']['input'];
};

export type UpsertLedgerHistoryInput = {
  balances: Array<UpsertLedgerHistoryBalanceInput>;
  companyId: Scalars['CompanyID']['input'];
  currency?: InputMaybe<Scalars['Currency']['input']>;
  id?: InputMaybe<Scalars['LedgerHistoryID']['input']>;
  storedFileId: Scalars['ID']['input'];
  views: Array<LedgerView>;
};

export type UpsertManualJournalEntryInput = {
  autoReversalDate?: InputMaybe<Scalars['LocalDate']['input']>;
  companyId: Scalars['ID']['input'];
  createdFor?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['Currency']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<UpsertManualJournalEntryItemInput>;
  memo: Scalars['String']['input'];
  /** Whether or not to post the journal. False creates a draft. */
  posted?: InputMaybe<Scalars['Boolean']['input']>;
  postingDate?: InputMaybe<Scalars['LocalDate']['input']>;
  views: Array<Scalars['String']['input']>;
};

export type UpsertManualJournalEntryItemInput = {
  amount: Scalars['Decimal']['input'];
  coaKey: Scalars['String']['input'];
  /** @deprecated not used */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  currency: Scalars['Currency']['input'];
  customerId?: InputMaybe<Scalars['CustomerID']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  manualJournalEntryId?: InputMaybe<Scalars['ID']['input']>;
  segments?: InputMaybe<Array<UpsertClassSegmentInput>>;
  userDefinedMetadata?: InputMaybe<Scalars['JSONObject']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertManualRevenueScheduleEntriesInput = {
  contractRevenueScheduleId: Scalars['ContractRevenueScheduleID']['input'];
  manualEntries: Array<ManualRevenueScheduleEntryInput>;
  manualEntriesToDelete?: InputMaybe<Array<Scalars['ManualRevenueScheduleEntryID']['input']>>;
};

export type UpsertManualRevenueScheduleEntriesResult = {
  __typename?: 'UpsertManualRevenueScheduleEntriesResult';
  manualEntries: Array<ManualRevenueScheduleEntry>;
};

export type UpsertPaymentFromManualInput = {
  amount: Scalars['Decimal']['input'];
  companyId: Scalars['CompanyID']['input'];
  customerId?: InputMaybe<Scalars['CustomerID']['input']>;
  date: Scalars['LocalDate']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['CustomerBalanceTransactionID']['input']>;
  matches: Array<CustomerBalanceTransactionMatchesInput>;
  method: CustomerBalanceTransactionMethod;
  type: CustomerBalanceTransactionType;
};

export type UpsertPaymentFromManualResult = {
  __typename?: 'UpsertPaymentFromManualResult';
  customerBalanceTransaction: CustomerBalanceTransaction;
};

export type UpsertPaymentsFromTransactionsInput = {
  companyId: Scalars['CompanyID']['input'];
  customerId?: InputMaybe<Scalars['CustomerID']['input']>;
  matches: Array<CustomerBalanceTransactionMatchesInput>;
  transactionIds: Array<Scalars['TransactionID']['input']>;
};

export type UpsertPaymentsFromTransactionsResult = {
  __typename?: 'UpsertPaymentsFromTransactionsResult';
  customerBalanceTransactions: Array<CustomerBalanceTransaction>;
};

export type UpsertPrepaidForBillLineInput = {
  billLineId: Scalars['BillLineID']['input'];
  companyId: Scalars['CompanyID']['input'];
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  expenseRecognitionMethod: ExpenseRecognitionMethod;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type UpsertPrepaidForDetailInput = {
  companyId: Scalars['CompanyID']['input'];
  detailId: Scalars['DetailID']['input'];
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  expenseRecognitionMethod: ExpenseRecognitionMethod;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type UpsertPrepaidInput = {
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  expenseRecognitionMethod: ExpenseRecognitionMethod;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type UpsertRevenueRecognitionConfigurationInput = {
  calculation?: InputMaybe<AccountingRecognitionCalculation>;
  companyId: Scalars['CompanyID']['input'];
  description: Scalars['String']['input'];
  discountAccount: Scalars['LedgerCoaKey']['input'];
  firstPeriodAllocation?: InputMaybe<FirstPeriodAllocation>;
  id?: InputMaybe<Scalars['AccountingConfigurationID']['input']>;
  method: AccountingRecognitionTiming;
  name: Scalars['String']['input'];
  percentageBasedEntries?: InputMaybe<Array<PercentageBasedEntryConfigInput>>;
  refundAccount: Scalars['LedgerCoaKey']['input'];
  revenueAccount: Scalars['LedgerCoaKey']['input'];
  revenueDeferralAccount?: InputMaybe<Scalars['LedgerCoaKey']['input']>;
};

export type UpsertUserTransactionInput = {
  accountId: Scalars['AccountID']['input'];
  amount: Scalars['Decimal']['input'];
  companyId: Scalars['CompanyID']['input'];
  date: Scalars['LocalDate']['input'];
  descriptor: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  ledgerCoaKey: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  offsetTransactionId?: InputMaybe<Scalars['TransactionID']['input']>;
  reconciliationId?: InputMaybe<Scalars['ID']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertVendorPaymentFromManualInput = {
  amount: Scalars['Decimal']['input'];
  companyId: Scalars['CompanyID']['input'];
  date: Scalars['LocalDate']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['VendorBalanceTransactionID']['input']>;
  matches: Array<VendorBalanceTransactionMatchesInput>;
  method: VendorBalanceTransactionMethod;
  type: VendorBalanceTransactionType;
  vendorId?: InputMaybe<Scalars['CompanyVendorID']['input']>;
};

export type UpsertVendorPaymentFromManualResult = {
  __typename?: 'UpsertVendorPaymentFromManualResult';
  vendorBalanceTransaction: VendorBalanceTransaction;
};

export type UpsertVendorPaymentsFromTransactionsInput = {
  companyId: Scalars['CompanyID']['input'];
  matches: Array<VendorBalanceTransactionMatchesInput>;
  transactions: Array<VendorPaymentTransactionInput>;
  vendorId?: InputMaybe<Scalars['CompanyVendorID']['input']>;
};

export type UpsertVendorPaymentsFromTransactionsResult = {
  __typename?: 'UpsertVendorPaymentsFromTransactionsResult';
  vendorBalanceTransactions: Array<VendorBalanceTransaction>;
};

export type User = {
  __typename?: 'User';
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['ID']['output']>;
  companyMemberships: Array<CompanyMembership>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  firmGroup?: Maybe<FirmGroup>;
  firmMembership?: Maybe<FirmMembership>;
  id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated use introStep on the company membership */
  introStep?: Maybe<IntroStep>;
  invitedBy?: Maybe<User>;
  invitedById?: Maybe<Scalars['ID']['output']>;
  isTemporary?: Maybe<Scalars['Boolean']['output']>;
  lastIp?: Maybe<Scalars['String']['output']>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  loginsCount: Scalars['Int']['output'];
  messageSettings: Array<MessageSetting>;
  name?: Maybe<Scalars['String']['output']>;
  pendingInvitations: Array<CompanyInvitation>;
  permittedDataSources: Array<IntegrationType>;
  /** @deprecated use position on the company membership */
  position?: Maybe<UserPosition>;
  updatedAt: Scalars['DateTime']['output'];
  /** @deprecated No longer supported */
  whitelisted: Scalars['Boolean']['output'];
};

export type UserAttributes = {
  __typename?: 'UserAttributes';
  howDidYouHearAboutUs?: Maybe<HowDidYouHearAboutUs>;
};

export type UserAttributesInput = {
  howDidYouHearAboutUs?: InputMaybe<HowDidYouHearAboutUsInput>;
};

export type UserCategorizationRule = CategorizationRule & {
  __typename?: 'UserCategorizationRule';
  accountTypes?: Maybe<Array<AccountType>>;
  accounts?: Maybe<Array<Scalars['AccountID']['output']>>;
  appliesTo?: Maybe<Array<CategorizationRuleApplicationType>>;
  category: Category;
  classifications: Array<CategorizationRuleClassSegment>;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedBy?: Maybe<User>;
  effectiveAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  matchEntireString: Scalars['Boolean']['output'];
  maxAmountInclusive?: Maybe<Scalars['Decimal']['output']>;
  minAmountInclusive?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numTransactionsCategorizedBy: Scalars['Int']['output'];
  rule: Scalars['String']['output'];
  type: CategorizationRuleType;
  vendor?: Maybe<Vendor>;
};

export type UserCategorizationRulesInput = {
  companyId: Scalars['ID']['input'];
  filter?: InputMaybe<MatchRulesFilter>;
  page: PageInput;
};

export type UserCategorizationRulesPaginator = {
  __typename?: 'UserCategorizationRulesPaginator';
  pageInfo: PageInfo;
  rules: Array<UserCategorizationRule>;
};

export type UserEmailPreferences = {
  __typename?: 'UserEmailPreferences';
  preferences?: Maybe<Array<UserEmailSetting>>;
};

export type UserEmailSetting = {
  __typename?: 'UserEmailSetting';
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

export type UserEmailSettingInput = {
  enabled: Scalars['Boolean']['input'];
  workflowId: Scalars['String']['input'];
};

export type UserOnboardingProgress = {
  __typename?: 'UserOnboardingProgress';
  configureClassesAndDepartments?: Maybe<OnboardingStepStatus>;
  connectFinancialAccounts?: Maybe<OnboardingStepStatus>;
  getPuzzleCertified?: Maybe<OnboardingStepStatus>;
  inviteClientsToConnectFinancialAccounts?: Maybe<OnboardingStepStatus>;
  inviteFirmsTeamMembers?: Maybe<OnboardingStepStatus>;
  reviewMonthEndChecklist?: Maybe<OnboardingStepStatus>;
  reviewSpotlightVariances?: Maybe<OnboardingStepStatus>;
  reviewTransactions?: Maybe<OnboardingStepStatus>;
};

export enum UserPosition {
  CompanyEmployee = 'CompanyEmployee',
  Founder = 'Founder',
  OutsourcedAccountantOrCfo = 'OutsourcedAccountantOrCFO'
}

export type UserTransaction = ITransaction & {
  __typename?: 'UserTransaction';
  account: Account;
  activity: TransactionActivityDetails;
  amount: Scalars['Decimal']['output'];
  basis?: Maybe<AccountingBasis>;
  company: Company;
  customer?: Maybe<Customer>;
  date: Scalars['LocalDate']['output'];
  descriptor: Scalars['String']['output'];
  detail: TransactionDetail;
  documentation: Array<TransactionDocument>;
  fixedAsset?: Maybe<FixedAsset>;
  hasDocumentation: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  integrationType: IntegrationType;
  /** @deprecated Use vendorPayment instead */
  linkedBills: Array<Bill>;
  links: Array<TransactionLink>;
  parent?: Maybe<Transaction>;
  payment?: Maybe<CustomerBalanceTransaction>;
  pending: Scalars['Boolean']['output'];
  product?: Maybe<Product>;
  revenue?: Maybe<TransactionRevenue>;
  splits: Array<TransactionDetail>;
  userFields?: Maybe<UserTransactionFields>;
  vendorPayment?: Maybe<VendorBalanceTransaction>;
};

export type UserTransactionFields = {
  __typename?: 'UserTransactionFields';
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type ValidateDirectIngestFileInput = {
  id: Scalars['DirectIngestFileID']['input'];
};

export type ValidateDirectIngestFileResult = {
  __typename?: 'ValidateDirectIngestFileResult';
  /** @deprecated Use ingestFile instead */
  directIngestFile: DirectIngestFileManualJournalEntries;
  ingestFile: DirectIngestFile;
};

export type ValidateLinkTokenInput = {
  token: Scalars['String']['input'];
};

export type ValidateLinkTokenResult = {
  __typename?: 'ValidateLinkTokenResult';
  apiUser?: Maybe<ApiUser>;
  error?: Maybe<AuthenticationError>;
};

export type Vendor = {
  __typename?: 'Vendor';
  addressJson?: Maybe<Scalars['JSON']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['Currency']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<VendorDocument>;
  email?: Maybe<Scalars['String']['output']>;
  firstSpendingUse?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['ID']['output'];
  is1099Vendor: YesNoUnknown;
  name: Scalars['String']['output'];
  payableBalance: PayableBalance;
  permaName: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<VendorStatus>;
  taxIdType?: Maybe<TaxIdType>;
  type?: Maybe<VendorType>;
  website?: Maybe<Scalars['String']['output']>;
};

export type Vendor1099TrackingReportInput = {
  companyId: Scalars['ID']['input'];
  year: Scalars['Period']['input'];
};

export type VendorBalanceMatch = {
  __typename?: 'VendorBalanceMatch';
  amount: Money;
  bill?: Maybe<Bill>;
  groupId: Scalars['VendorBalanceMatchGroupID']['output'];
  id: Scalars['VendorBalanceMatchID']['output'];
  vendorBalanceTransaction?: Maybe<VendorBalanceTransaction>;
};

export type VendorBalanceTransaction = {
  __typename?: 'VendorBalanceTransaction';
  amount: Money;
  date: Scalars['LocalDate']['output'];
  description: Scalars['String']['output'];
  events: Array<LedgerEvent>;
  id: Scalars['VendorBalanceTransactionID']['output'];
  matches: Array<VendorBalanceMatch>;
  method: VendorBalanceTransactionMethod;
  payableBalance: PayableBalance;
  transaction?: Maybe<Transaction>;
  type: VendorBalanceTransactionType;
  vendor?: Maybe<Vendor>;
};

export type VendorBalanceTransactionFilter = {
  amountMax?: InputMaybe<Scalars['Decimal']['input']>;
  amountMin?: InputMaybe<Scalars['Decimal']['input']>;
  currency?: InputMaybe<Scalars['Currency']['input']>;
  dateRange?: InputMaybe<OpenEndedDateRangeInput>;
  isCleared?: InputMaybe<Scalars['Boolean']['input']>;
  methods?: InputMaybe<Array<VendorBalanceTransactionMethod>>;
  types?: InputMaybe<Array<VendorBalanceTransactionType>>;
};

export type VendorBalanceTransactionListResult = {
  __typename?: 'VendorBalanceTransactionListResult';
  items: Array<VendorBalanceTransaction>;
  pageInfo: PageInfo;
};

export type VendorBalanceTransactionMatchInput = {
  id: Scalars['VendorBalanceTransactionID']['input'];
  transaction?: InputMaybe<VendorPaymentTransactionInput>;
};

export enum VendorBalanceTransactionMatchType {
  Bill = 'BILL'
}

export type VendorBalanceTransactionMatchesInput = {
  amount: Scalars['Decimal']['input'];
  relatedId: Scalars['ID']['input'];
  relatedType: VendorBalanceTransactionMatchType;
};

export enum VendorBalanceTransactionMethod {
  BankPayment = 'BANK_PAYMENT',
  Cash = 'CASH',
  Check = 'CHECK',
  CreditCard = 'CREDIT_CARD',
  Other = 'OTHER',
  PaymentProcessor = 'PAYMENT_PROCESSOR'
}

export enum VendorBalanceTransactionSort {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC'
}

export enum VendorBalanceTransactionType {
  Payment = 'PAYMENT'
}

export type VendorBalanceTransactionsToMatchesInput = {
  balanceTransactions: Array<VendorBalanceTransactionMatchInput>;
  matches: Array<VendorBalanceTransactionMatchesInput>;
};

export type VendorDocument = {
  __typename?: 'VendorDocument';
  file: File;
};

export type VendorFilterBy = {
  hasBills?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  is1099Vendor?: InputMaybe<YesNoUnknown>;
  name?: InputMaybe<Scalars['String']['input']>;
  permaNames?: InputMaybe<Array<Scalars['String']['input']>>;
  source?: InputMaybe<VendorSource>;
  status?: InputMaybe<VendorStatus>;
  type?: InputMaybe<VendorType>;
};

export type VendorMapping = {
  from: Scalars['CompanyVendorID']['input'];
  to?: InputMaybe<Scalars['CompanyVendorID']['input']>;
};

export type VendorMetric = {
  __typename?: 'VendorMetric';
  amount: Money;
  count: Scalars['Int']['output'];
  vendor?: Maybe<Vendor>;
};

export type VendorPaginator = {
  __typename?: 'VendorPaginator';
  items: Array<Vendor>;
  pageInfo: PageInfo;
};

export type VendorPaymentTransactionInput = {
  id: Scalars['TransactionID']['input'];
  overpaymentSplit?: InputMaybe<SplitInput>;
};

export type VendorReportInput = {
  companyId: Scalars['CompanyID']['input'];
  integration: IntegrationType;
};

export type VendorSecrets = {
  __typename?: 'VendorSecrets';
  taxId?: Maybe<Scalars['String']['output']>;
};

export enum VendorSortOrder {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PopularityAsc = 'POPULARITY_ASC',
  PopularityDesc = 'POPULARITY_DESC'
}

export enum VendorSource {
  System = 'System',
  User = 'User'
}

export type VendorSpendingReportInput = {
  companyId: Scalars['ID']['input'];
  periods: Array<Scalars['Period']['input']>;
};

export type VendorSpendingTrend = {
  __typename?: 'VendorSpendingTrend';
  amount: Money;
  period: Scalars['Period']['output'];
  periodRange: InclusiveDateRange;
  vendor?: Maybe<Vendor>;
};

export enum VendorStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Unknown = 'Unknown'
}

export type VendorTimePeriodExpense = {
  __typename?: 'VendorTimePeriodExpense';
  expenses: Array<TimePeriodExpense>;
  /** @deprecated No longer supported */
  name: Scalars['String']['output'];
  /** @deprecated No longer supported */
  permaName: Scalars['String']['output'];
  rowNum: Scalars['Int']['output'];
  vendor: Vendor;
};

export type VendorTimePeriodExpenseListPaginator = {
  __typename?: 'VendorTimePeriodExpenseListPaginator';
  items: Array<VendorTimePeriodExpense>;
  pageInfo: PageInfo;
};

export enum VendorType {
  Business = 'Business',
  Individual = 'Individual',
  Unknown = 'Unknown'
}

export type VendorWith1099Spending = {
  __typename?: 'VendorWith1099Spending';
  eligibleFor1099Spending: Money;
  totalYearSpending: Money;
  vendor: Vendor;
};

export enum View {
  Accrual = 'accrual',
  Cash = 'cash'
}

export type VoidBillInput = {
  billId: Scalars['BillID']['input'];
};

export type VoidInvoiceInput = {
  invoiceId: Scalars['InvoiceID']['input'];
};

export type VoidManualJournalEntryInput = {
  journalId: Scalars['ManualJournalEntryID']['input'];
};

export type VoidPrepaidInput = {
  id: Scalars['PrepaidID']['input'];
};

export enum WhitelistStage {
  AccessDashboard = 'AccessDashboard',
  AccessSite = 'AccessSite'
}

export type WithReportingClasses = {
  classAwareType: ClassAwareType;
  classSegments: Array<AvailableClassSegment>;
};

export type Worker = Contractor | Employee;

export type WorkerCostMonth = {
  __typename?: 'WorkerCostMonth';
  cost: Scalars['Decimal']['output'];
  month: Scalars['String']['output'];
};

export type WorkerCostStats = {
  __typename?: 'WorkerCostStats';
  averageAnnualFullyLoadedSalary: Scalars['Decimal']['output'];
  averageAnnualSalary: Scalars['Decimal']['output'];
  averageFullyLoadedSalaries: Array<WorkerCostMonth>;
  averageSalaries: Array<WorkerCostMonth>;
  totals: Array<WorkerCostMonth>;
};

export type WorkerFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
  startDateMax?: InputMaybe<Scalars['LocalDate']['input']>;
  startDateMin?: InputMaybe<Scalars['LocalDate']['input']>;
  subset?: InputMaybe<WorkerSubset>;
};

export type WorkerStatsFilter = {
  startDateMax?: InputMaybe<Scalars['Date']['input']>;
  startDateMin?: InputMaybe<Scalars['Date']['input']>;
  subset?: InputMaybe<WorkerSubset>;
};

export enum WorkerSubset {
  Active = 'Active',
  Contractor = 'Contractor',
  Terminated = 'Terminated'
}

export enum YesNoUnknown {
  No = 'No',
  Unknown = 'Unknown',
  Yes = 'Yes'
}

export type FixedAssetDepreciationSchedulePreview = {
  __typename?: 'fixedAssetDepreciationSchedulePreview';
  endDateInclusive: Scalars['LocalDate']['output'];
  firstMonthConvention: FirstMonthConvention;
  method: FixedAssetDepreciationMethod;
  scheduleItems: Array<FixedAssetDepreciationSchedulePreviewItems>;
  startDate: Scalars['LocalDate']['output'];
};

export type FixedAssetDepreciationSchedulePreviewItems = {
  __typename?: 'fixedAssetDepreciationSchedulePreviewItems';
  accumulatedDepreciation: Scalars['Decimal']['output'];
  depreciationExpense: Scalars['Decimal']['output'];
  depreciationExpenseEffectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  depreciationExpenseStatus?: Maybe<FixedAssetDepreciationScheduleEntryStatus>;
  fixedAssetBookValue: Scalars['Decimal']['output'];
  openingBookValue: Scalars['Decimal']['output'];
  period: Scalars['Month']['output'];
};

export type AccountFragment = { __typename?: 'Account', id: string, manuallyAdded: boolean, name: string, subType?: AccountSubType | null, type: AccountType, mask?: string | null, status: IntegrationConnectionStatus, updatedAt: CalendarDateTimeString, lastImportedAt?: CalendarDateTimeString | null, archivedAt?: CalendarDateTimeString | null, connections: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }>, financialInstitution: { __typename?: 'FinancialInstitution', id: string, name: string }, initialAccountBalance: { __typename?: 'AccountBalance', balance: string, date: CalendarDateTimeString, setByActorType?: ActorType | null, splits: Array<{ __typename?: 'AccountBalanceSplit', amount: string, description: string, category: { __typename?: 'GatewayCategory', permaKey: string, name: string, displayName?: string | null } | { __typename?: 'LedgerCategory', permaKey: string, name: string, displayName: string } }> }, todaysBalance: { __typename?: 'AccountBalance', balance: string }, epoch?: { __typename?: 'AccountEpoch', cutoffBefore?: CalendarDateString | null, cutoffAtOrAfter?: CalendarDateString | null } | null };

export type AccountWithIntegrationFragment = { __typename?: 'Account', id: string, manuallyAdded: boolean, name: string, subType?: AccountSubType | null, type: AccountType, mask?: string | null, status: IntegrationConnectionStatus, updatedAt: CalendarDateTimeString, lastImportedAt?: CalendarDateTimeString | null, archivedAt?: CalendarDateTimeString | null, connections: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }>, financialInstitution: { __typename?: 'FinancialInstitution', id: string, name: string }, todaysBalance: { __typename?: 'AccountBalance', balance: string }, epoch?: { __typename?: 'AccountEpoch', cutoffBefore?: CalendarDateString | null, cutoffAtOrAfter?: CalendarDateString | null, shouldCorrectHistory: boolean } | null, epochs: Array<{ __typename?: 'AccountEpoch', cutoffBefore?: CalendarDateString | null, cutoffAtOrAfter?: CalendarDateString | null, shouldCorrectHistory: boolean }> };

export type CardFragment = { __typename?: 'Card', id: any, accountId: any, holderName: string, lastFour: string };

type Category_GatewayCategory_Fragment = { __typename: 'GatewayCategory', name: string, permaKey: string, examples?: string | null, description?: string | null, coaDisplayId?: string | null, coaKey?: string | null, deprecated?: boolean | null, ruleType?: string | null, displayName?: string | null, displayId?: string | null, shortName?: string | null, companyId?: string | null, id?: string | null };

type Category_LedgerCategory_Fragment = { __typename: 'LedgerCategory', defaultCashlike: Cashlike, accountType?: LedgerAccountType | null, views?: Array<string | null> | null, name: string, permaKey: string, examples?: string | null, description?: string | null, coaDisplayId?: string | null, coaKey: string, deprecated?: boolean | null, ruleType?: string | null, displayName: string, displayId: string, shortName: string, companyId: string, id?: string | null };

export type CategoryFragment = Category_GatewayCategory_Fragment | Category_LedgerCategory_Fragment;

export type ChecklistUserFragment = { __typename?: 'User', id?: string | null, name?: string | null };

type ChecklistItem_AccountChecklistItem_Fragment = { __typename: 'AccountChecklistItem', id: string, month: CalendarMonthString, completedAt?: CalendarDateTimeString | null, removedAt?: CalendarDateTimeString | null, key?: ChecklistItemKey | null, description?: string | null, account: { __typename?: 'Account', name: string, mask?: string | null, financialInstitution: { __typename?: 'FinancialInstitution', name: string }, ledgerAccount?: { __typename?: 'LedgerAccount', id: string, ledgerReconciliationSummary?: { __typename?: 'LedgerReconciliationSummary', lastReconciled?: { __typename?: 'LedgerReconciliation', id: string, statementDate?: CalendarDateString | null } | null, active?: { __typename?: 'LedgerReconciliation', id: string } | null } | null } | null }, dataAnomalyReview: { __typename?: 'AccountEndingBalanceReview', name: DataAnomalyReviewName, grade: DataAnomalyReviewGrade, context: { __typename?: 'AccountEndingBalanceReviewContext', reconciledThrough?: CalendarDateString | null, ledgerMinusBestGuessBalance: { __typename?: 'Money', amount: string, currency: any } } }, completedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null, removedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

type ChecklistItem_AmountsChecklistItem_Fragment = { __typename: 'AmountsChecklistItem', amountsType: AmountsChecklistItemType, id: string, month: CalendarMonthString, completedAt?: CalendarDateTimeString | null, removedAt?: CalendarDateTimeString | null, key?: ChecklistItemKey | null, description?: string | null, amounts: Array<{ __typename?: 'AmountChecklistItemData', type: AmountChecklistItemDataType, amount: { __typename?: 'Money', amount: string, currency: any } }>, completedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null, removedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

type ChecklistItem_BalanceChecklistItem_Fragment = { __typename: 'BalanceChecklistItem', balanceType: BalanceChecklistItemType, id: string, month: CalendarMonthString, completedAt?: CalendarDateTimeString | null, removedAt?: CalendarDateTimeString | null, key?: ChecklistItemKey | null, description?: string | null, balance: { __typename?: 'Money', amount: string, currency: any }, completedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null, removedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

type ChecklistItem_BasicChecklistItem_Fragment = { __typename: 'BasicChecklistItem', id: string, month?: CalendarMonthString | null, completedAt?: CalendarDateTimeString | null, removedAt?: CalendarDateTimeString | null, key?: ChecklistItemKey | null, description?: string | null, completedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null, removedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

type ChecklistItem_CustomChecklistItem_Fragment = { __typename: 'CustomChecklistItem', repeat: boolean, id: string, month: CalendarMonthString, completedAt?: CalendarDateTimeString | null, removedAt?: CalendarDateTimeString | null, key?: ChecklistItemKey | null, description: string, completedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null, removedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

type ChecklistItem_PaymentProcessingAccountChecklistItem_Fragment = { __typename: 'PaymentProcessingAccountChecklistItem', modifiedAt?: CalendarDateTimeString | null, status: PaymentProcessingAccountChecklistItemStatus, id: string, month: CalendarMonthString, completedAt?: CalendarDateTimeString | null, removedAt?: CalendarDateTimeString | null, key?: ChecklistItemKey | null, description?: string | null, modifiedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null, account: { __typename?: 'Account', name: string, mask?: string | null, financialInstitution: { __typename?: 'FinancialInstitution', name: string }, ledgerAccount?: { __typename?: 'LedgerAccount', id: string, ledgerReconciliationSummary?: { __typename?: 'LedgerReconciliationSummary', lastReconciled?: { __typename?: 'LedgerReconciliation', id: string, statementDate?: CalendarDateString | null } | null, active?: { __typename?: 'LedgerReconciliation', id: string } | null } | null } | null }, completedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null, removedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

type ChecklistItem_ProgressChecklistItem_Fragment = { __typename: 'ProgressChecklistItem', progressType: ProgressChecklistItemType, progress: number, id: string, month: CalendarMonthString, completedAt?: CalendarDateTimeString | null, removedAt?: CalendarDateTimeString | null, key?: ChecklistItemKey | null, description?: string | null, completedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null, removedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

type ChecklistItem_ReviewChecklistItem_Fragment = { __typename: 'ReviewChecklistItem', reviewType: ReviewChecklistItemType, reviewCount?: number | null, id: string, month: CalendarMonthString, completedAt?: CalendarDateTimeString | null, removedAt?: CalendarDateTimeString | null, key?: ChecklistItemKey | null, description?: string | null, completedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null, removedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

type ChecklistItem_StatementChecklistItem_Fragment = { __typename: 'StatementChecklistItem', statementType: StatementChecklistItemType, id: string, month: CalendarMonthString, completedAt?: CalendarDateTimeString | null, removedAt?: CalendarDateTimeString | null, key?: ChecklistItemKey | null, description?: string | null, completedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null, removedBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type ChecklistItemFragment = ChecklistItem_AccountChecklistItem_Fragment | ChecklistItem_AmountsChecklistItem_Fragment | ChecklistItem_BalanceChecklistItem_Fragment | ChecklistItem_BasicChecklistItem_Fragment | ChecklistItem_CustomChecklistItem_Fragment | ChecklistItem_PaymentProcessingAccountChecklistItem_Fragment | ChecklistItem_ProgressChecklistItem_Fragment | ChecklistItem_ReviewChecklistItem_Fragment | ChecklistItem_StatementChecklistItem_Fragment;

export type CompanyFragment = { __typename?: 'Company', id: string, name: string, type: CompanyType, createdAt: CalendarDateTimeString, onboardingStage: OnboardingStage, uniquePathname: string, timeZone?: string | null, trackingId?: string | null, revenueModel?: RevenueModel | null };

export type AccountsReceivableFragment = { __typename?: 'AccountsReceivable', month: CalendarMonthString, amount: { __typename?: 'Money', amount: string, currency: any } };

export type AccountsPayableFragment = { __typename?: 'AccountsPayable', month: CalendarMonthString, amount: { __typename?: 'Money', amount: string, currency: any } };

export type NetMarginFragment = { __typename?: 'NetMargin', month: CalendarMonthString, amount?: string | null };

export type GrossMarginFragment = { __typename?: 'GrossMargin', month: CalendarMonthString, amount?: string | null };

export type MonthlyBankBurnFragment = { __typename?: 'CompanyFinancialSummary', status: CompanyFinancialMetricsStatus, metrics?: { __typename?: 'CompanyFinancialSummaryMetrics', monthlyBankBurn: { __typename?: 'MetricsByMonth', updatedAt?: CalendarDateTimeString | null, metrics: Array<{ __typename?: 'MetricOnDate', date: CalendarDateString, metric: { __typename?: 'Money', amount: string, currency: any } }> } } | null };

export type DailyCashFragment = { __typename?: 'CompanyFinancialSummary', status: CompanyFinancialMetricsStatus, metrics?: { __typename?: 'CompanyFinancialSummaryMetrics', dailyTotalCash: { __typename?: 'CompanyTotalCashByDay', updatedAt?: CalendarDateTimeString | null, metrics: Array<{ __typename?: 'AmountOnDateMetric', date: CalendarDateString, updatedAt?: CalendarDateTimeString | null, totalCash: { __typename?: 'Money', amount: string, currency: any } }> } } | null };

export type MtdBankBurnFragment = { __typename?: 'CompanyFinancialSummary', status: CompanyFinancialMetricsStatus, metrics?: { __typename?: 'CompanyFinancialSummaryMetrics', mtdBankBurn: { __typename?: 'MtdBankBurnMetrics', updatedAt?: CalendarDateTimeString | null, metrics: Array<{ __typename?: 'MtdBankBurnMetricWithComparison', currentMonthDate: CalendarDateString, prevMonthDate: CalendarDateString, currentMonthBurn: { __typename?: 'Money', amount: string, currency: any }, prevMonthBurn: { __typename?: 'Money', amount: string, currency: any } }> } } | null };

export type CompanyFinancialSummaryFragment = { __typename?: 'CompanyFinancialSummary', status: CompanyFinancialMetricsStatus, updatedAt?: CalendarDateTimeString | null, metrics?: { __typename?: 'CompanyFinancialSummaryMetrics', runway?: number | null, runwayUsingThreeMonthAverageTotalBurn?: number | null, runwayUsingLastMonthBankBurn?: number | null, runwayUsingThreeMonthAverageBankBurn?: number | null, runwayUsingLastMonthAccrualOperatingIncomeBurn?: number | null, runwayUsingThreeMonthAverageAccrualOperatingIncomeBurn?: number | null, fundraiseDate?: string | null, fundraiseDateUsingLastMonthBankBurn?: CalendarDateString | null, fundraiseDateUsingLastMonthAccrualOperatingIncomeBurn?: CalendarDateString | null, fundraiseDateUsingThreeMonthAverageTotalBurn?: CalendarDateString | null, fundraiseDateUsingThreeMonthAverageBankBurn?: CalendarDateString | null, fundraiseDateUsingThreeMonthAverageAccrualOperatingIncomeBurn?: CalendarDateString | null, cashOutDate?: string | null, cashOutDateUsingThreeMonthAverageTotalBurn?: string | null, cashOutDateUsingThreeMonthAverageBankBurn?: CalendarDateString | null, cashOutDateUsingThreeMonthAverageAccrualOperatingIncomeBurn?: CalendarDateString | null, cashOutDateUsingLastMonthBankBurn?: CalendarDateString | null, cashOutDateUsingLastMonthAccrualOperatingIncomeBurn?: CalendarDateString | null, totalCash: { __typename?: 'Money', amount: string, currency: any }, lastMonthBankBurn: { __typename?: 'Money', amount: string, currency: any }, lastMonthOperatingBurn: { __typename?: 'Money', amount: string, currency: any }, lastMonthTotalBurn: { __typename?: 'Money', amount: string, currency: any }, lastMonthAccrualOperatingIncomeBurn: { __typename?: 'Money', amount: string, currency: any }, threeMonthAverageOperatingBurn: { __typename?: 'Money', amount: string, currency: any }, threeMonthAverageTotalBurn: { __typename?: 'Money', amount: string, currency: any }, threeMonthAverageBankBurn: { __typename?: 'Money', amount: string, currency: any }, threeMonthAverageAccrualOperatingIncomeBurn: { __typename?: 'Money', amount: string, currency: any }, sixMonthsAccountsReceivable: Array<{ __typename?: 'AccountsReceivable', month: CalendarMonthString, amount: { __typename?: 'Money', amount: string, currency: any } }>, sixMonthsAccountsPayable: Array<{ __typename?: 'AccountsPayable', month: CalendarMonthString, amount: { __typename?: 'Money', amount: string, currency: any } }>, sixMonthsGrossMargin: Array<{ __typename?: 'GrossMargin', month: CalendarMonthString, amount?: string | null }>, sixMonthsNetMargin: Array<{ __typename?: 'NetMargin', month: CalendarMonthString, amount?: string | null }> } | null };

export type CompanySlackChannelFragment = { __typename?: 'CompanySlackChannel', id: string, knockChannelKey: CompanyKnockChannelKey, subscribed: boolean, channelId?: string | null, channelName?: string | null };

export type CustomerFragment = { __typename?: 'Customer', id: string, name?: string | null, email?: string | null, type?: CustomerType | null, status?: CustomerStatus | null, description?: string | null, invoiceStats: { __typename?: 'InvoiceStatsResult', total: number } };

export type FileFragment = { __typename?: 'File', id: string, filename?: string | null, contentType: string, size: number, isDeleted: boolean, downloadInfo: { __typename?: 'FileDownloadInfo', signedUrl: string, urlExpiresAt: CalendarDateTimeString } };

export type FinancialInstitutionFragment = { __typename?: 'FinancialInstitution', id: string, name: string, nativeInstitutionId?: string | null, accounts: Array<{ __typename?: 'Account', id: string, manuallyAdded: boolean, name: string, subType?: AccountSubType | null, type: AccountType, mask?: string | null, status: IntegrationConnectionStatus, updatedAt: CalendarDateTimeString, lastImportedAt?: CalendarDateTimeString | null, archivedAt?: CalendarDateTimeString | null, connections: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }>, financialInstitution: { __typename?: 'FinancialInstitution', id: string, name: string }, initialAccountBalance: { __typename?: 'AccountBalance', balance: string, date: CalendarDateTimeString, setByActorType?: ActorType | null, splits: Array<{ __typename?: 'AccountBalanceSplit', amount: string, description: string, category: { __typename?: 'GatewayCategory', permaKey: string, name: string, displayName?: string | null } | { __typename?: 'LedgerCategory', permaKey: string, name: string, displayName: string } }> }, todaysBalance: { __typename?: 'AccountBalance', balance: string }, epoch?: { __typename?: 'AccountEpoch', cutoffBefore?: CalendarDateString | null, cutoffAtOrAfter?: CalendarDateString | null } | null }> };

export type IntegrationConnectionFragment = { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null };

export type IntegrationConnectionWithAccountStatsFragment = { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, accountStats: { __typename?: 'DataSourceTypeAccountStats', activeCount: number, deletedCount: number, archivedCount: number, hiddenCount: number }, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null };

export type MetricFragment = { __typename?: 'Metric', amount: string, currency: any, dataFromRange: { __typename?: 'InclusiveDateRange', fromInclusive: CalendarDateString, toInclusive: CalendarDateString } };

export type MoneyFragment = { __typename?: 'Money', amount: string, currency: any };

export type PageInfoFragment = { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total?: number | null };

export type PendingInvitationFragment = { __typename?: 'CompanyInvitation', id: string, email: string, companyId: string, mfaRequired?: boolean | null, role: MembershipRole, createdAt: CalendarDateTimeString, updatedAt: CalendarDateTimeString };

export type ProductFragment = { __typename?: 'Product', id: string, name?: string | null };

export type ProductWithDetailsFragment = { __typename?: 'Product', id: string, name?: string | null, serviceType?: ProductServiceType | null, status?: ProductStatus | null, sku?: string | null, description?: string | null, priceRate?: string | null, invoiceStats: { __typename?: 'InvoiceStatsResult', total: number } };

export type SourceCountFragment = { __typename?: 'SourceCount', type: SourceType, count: number };

export type SurveyResponseFragment = { __typename?: 'SurveyResponse', id: string, survey: Survey, notes?: string | null, userId?: string | null, questions: Array<{ __typename?: 'SurveyQuestion', name?: string | null, answers: Array<string> }> };

export type UserFragment = { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, emailVerified?: boolean | null, permittedDataSources: Array<IntegrationType>, invitedBy?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null, company?: { __typename?: 'Company', id: string, name: string, type: CompanyType, createdAt: CalendarDateTimeString, onboardingStage: OnboardingStage, uniquePathname: string, timeZone?: string | null, trackingId?: string | null, revenueModel?: RevenueModel | null } | null };

export type VendorFragment = { __typename?: 'Vendor', id: string, permaName: string, name: string, description?: string | null, is1099Vendor: YesNoUnknown, status?: VendorStatus | null, type?: VendorType | null };

export type VendorWithDetailsFragment = { __typename?: 'Vendor', id: string, name: string, addressJson?: any | null, companyName?: string | null, contactName?: string | null, currency?: any | null, description?: string | null, email?: string | null, is1099Vendor: YesNoUnknown, phoneNumber?: string | null, status?: VendorStatus | null, taxIdType?: TaxIdType | null, type?: VendorType | null, website?: string | null, documents: Array<{ __typename?: 'VendorDocument', file: { __typename?: 'File', id: string, filename?: string | null, contentType: string, size: number, isDeleted: boolean, downloadInfo: { __typename?: 'FileDownloadInfo', signedUrl: string, urlExpiresAt: CalendarDateTimeString } } }> };

export type AcceptPendingInvitationsMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptPendingInvitationsMutation = { __typename?: 'Mutation', acceptPendingInvitations?: { __typename?: 'AcceptInvitationsResult', errorMessages?: Array<string> | null } | null };

export type CreateAffiliateAttributionMutationVariables = Exact<{
  input: CreateAffiliateAttributionInput;
}>;


export type CreateAffiliateAttributionMutation = { __typename?: 'Mutation', createAffiliateAttribution: { __typename: 'AffiliateAttribution', companyId: any, name: string, token: string } };

export type AuthenticateWithTokenMutationVariables = Exact<{
  input: AuthenticateWithTokenInput;
}>;


export type AuthenticateWithTokenMutation = { __typename?: 'Mutation', authenticateWithToken: { __typename?: 'AuthenticateWithTokenResult', error?: AuthenticationError | null, needsAuthentication?: boolean | null, companyId?: string | null, isUpdate?: boolean | null, apiUser?: { __typename?: 'ApiUser', externalId: string } | null, self?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, emailVerified?: boolean | null, permittedDataSources: Array<IntegrationType>, invitedBy?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null, company?: { __typename?: 'Company', id: string, name: string, type: CompanyType, createdAt: CalendarDateTimeString, onboardingStage: OnboardingStage, uniquePathname: string, timeZone?: string | null, trackingId?: string | null, revenueModel?: RevenueModel | null } | null } | null } };

export type ConfirmEmailVerificationMutationVariables = Exact<{
  input: ConfirmEmailVerificationInput;
}>;


export type ConfirmEmailVerificationMutation = { __typename?: 'Mutation', confirmEmailVerification: { __typename?: 'ConfirmEmailVerificationResult', success: boolean, error?: ConfirmEmailVerificationError | null } };

export type ConnectBillDotComMutationVariables = Exact<{
  input: ConnectBillDotComInput;
}>;


export type ConnectBillDotComMutation = { __typename?: 'Mutation', connectBillDotCom: { __typename?: 'ConnectBillDotComResult', connection: { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null } } };

export type ConnectBrexMutationVariables = Exact<{
  input: ConnectBrexInput;
}>;


export type ConnectBrexMutation = { __typename?: 'Mutation', connectBrex: { __typename?: 'ConnectBrexResult', connection: { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null } } };

export type ConnectDeelMutationVariables = Exact<{
  input: ConnectDeelInput;
}>;


export type ConnectDeelMutation = { __typename?: 'Mutation', connectDeel: { __typename?: 'ConnectDeelResult', connection: { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null } } };

export type ConnectFinicityMutationVariables = Exact<{
  input: ConnectFinicityInput;
}>;


export type ConnectFinicityMutation = { __typename?: 'Mutation', connectFinicity: { __typename?: 'ConnectFinicityResult', connection: { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null } } };

export type ConnectGustoMutationVariables = Exact<{
  input: ConnectGustoInput;
}>;


export type ConnectGustoMutation = { __typename?: 'Mutation', connectGusto: { __typename?: 'ConnectGustoResult', connection: { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null } } };

export type ConnectMeowMutationVariables = Exact<{
  input: ConnectMeowInput;
}>;


export type ConnectMeowMutation = { __typename?: 'Mutation', connectMeow: { __typename?: 'ConnectMeowResult', connection: { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null } } };

export type ConnectMercuryMutationVariables = Exact<{
  input: ConnectMercuryInput;
}>;


export type ConnectMercuryMutation = { __typename?: 'Mutation', connectMercury: { __typename?: 'ConnectMercuryResult', connection: { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null } } };

export type ConnectPlaidMutationVariables = Exact<{
  input: ConnectPlaidInput;
}>;


export type ConnectPlaidMutation = { __typename?: 'Mutation', connectPlaid: { __typename?: 'ConnectPlaidResult', financialInstitution: { __typename?: 'FinancialInstitution', id: string, name: string, nativeInstitutionId?: string | null, accounts: Array<{ __typename?: 'Account', id: string, manuallyAdded: boolean, name: string, subType?: AccountSubType | null, type: AccountType, mask?: string | null, status: IntegrationConnectionStatus, updatedAt: CalendarDateTimeString, lastImportedAt?: CalendarDateTimeString | null, archivedAt?: CalendarDateTimeString | null, connections: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }>, financialInstitution: { __typename?: 'FinancialInstitution', id: string, name: string }, initialAccountBalance: { __typename?: 'AccountBalance', balance: string, date: CalendarDateTimeString, setByActorType?: ActorType | null, splits: Array<{ __typename?: 'AccountBalanceSplit', amount: string, description: string, category: { __typename?: 'GatewayCategory', permaKey: string, name: string, displayName?: string | null } | { __typename?: 'LedgerCategory', permaKey: string, name: string, displayName: string } }> }, todaysBalance: { __typename?: 'AccountBalance', balance: string }, epoch?: { __typename?: 'AccountEpoch', cutoffBefore?: CalendarDateString | null, cutoffAtOrAfter?: CalendarDateString | null } | null }> } } };

export type ConnectQuickbooksMutationVariables = Exact<{
  input: ConnectQuickbooksInput;
}>;


export type ConnectQuickbooksMutation = { __typename?: 'Mutation', connectQuickbooks: { __typename?: 'ConnectQuickbooksResult', connection: { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null } } };

export type ConnectRampMutationVariables = Exact<{
  input: ConnectRampInput;
}>;


export type ConnectRampMutation = { __typename?: 'Mutation', connectRamp: { __typename?: 'ConnectRampResult', connection: { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null } } };

export type ConnectRipplingMutationVariables = Exact<{
  input: ConnectRipplingInput;
}>;


export type ConnectRipplingMutation = { __typename?: 'Mutation', connectRippling: { __typename?: 'ConnectRipplingResult', connection: { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null } } };

export type ConnectStripeMutationVariables = Exact<{
  input: ConnectStripeInput;
}>;


export type ConnectStripeMutation = { __typename?: 'Mutation', connectStripe: { __typename?: 'ConnectStripeResult', connection: { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null } } };

export type ConnectSvbOfxMutationVariables = Exact<{
  input: ConnectSvbOfxInput;
}>;


export type ConnectSvbOfxMutation = { __typename?: 'Mutation', connectSvbOfx: { __typename?: 'ConnectSvbOfxResult', connection: { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null } } };

export type ConnectTrinetMutationVariables = Exact<{
  input: ConnectTrinetInput;
}>;


export type ConnectTrinetMutation = { __typename?: 'Mutation', connectTrinet: { __typename?: 'ConnectTrinetResult', connection: { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null } } };

export type CreateManualAccountMutationVariables = Exact<{
  input: CreateManualAccountInput;
}>;


export type CreateManualAccountMutation = { __typename?: 'Mutation', createManualAccount: { __typename?: 'CreateManualAccountResult', error?: CreateManualAccountError | null, account?: { __typename?: 'Account', id: string, manuallyAdded: boolean, name: string, subType?: AccountSubType | null, type: AccountType, mask?: string | null, status: IntegrationConnectionStatus, updatedAt: CalendarDateTimeString, lastImportedAt?: CalendarDateTimeString | null, archivedAt?: CalendarDateTimeString | null, connections: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }>, financialInstitution: { __typename?: 'FinancialInstitution', id: string, name: string }, initialAccountBalance: { __typename?: 'AccountBalance', balance: string, date: CalendarDateTimeString, setByActorType?: ActorType | null, splits: Array<{ __typename?: 'AccountBalanceSplit', amount: string, description: string, category: { __typename?: 'GatewayCategory', permaKey: string, name: string, displayName?: string | null } | { __typename?: 'LedgerCategory', permaKey: string, name: string, displayName: string } }> }, todaysBalance: { __typename?: 'AccountBalance', balance: string }, epoch?: { __typename?: 'AccountEpoch', cutoffBefore?: CalendarDateString | null, cutoffAtOrAfter?: CalendarDateString | null } | null } | null } };

export type CreateSurveyResponseMutationVariables = Exact<{
  input: SurveyResponseInput;
}>;


export type CreateSurveyResponseMutation = { __typename?: 'Mutation', createSurveyResponse?: { __typename?: 'SurveyResponse', id: string, survey: Survey, notes?: string | null, userId?: string | null, questions: Array<{ __typename?: 'SurveyQuestion', name?: string | null, answers: Array<string> }> } | null };

export type DisconnectIntegrationMutationVariables = Exact<{
  input: DisconnectIntegrationInput;
}>;


export type DisconnectIntegrationMutation = { __typename?: 'Mutation', disconnectIntegration: { __typename?: 'DisconnectResult', disconnected: boolean } };

export type HandleCompanyCompletedOnboardingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type HandleCompanyCompletedOnboardingMutation = { __typename?: 'Mutation', handleCompanyCompletedOnboarding: { __typename?: 'HandleCompanyCompletedOnboardingResult', company: { __typename?: 'Company', id: string, onboardingStage: OnboardingStage } } };

export type LinkExistingAccountMutationVariables = Exact<{
  input: LinkExistingAccountInput;
}>;


export type LinkExistingAccountMutation = { __typename?: 'Mutation', linkExistingAccount: { __typename?: 'LinkExistingAccountResult', error?: LinkExistingAccountError | null, apiUser?: { __typename?: 'ApiUser', externalId: string } | null, self?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, emailVerified?: boolean | null, permittedDataSources: Array<IntegrationType>, invitedBy?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null, company?: { __typename?: 'Company', id: string, name: string, type: CompanyType, createdAt: CalendarDateTimeString, onboardingStage: OnboardingStage, uniquePathname: string, timeZone?: string | null, trackingId?: string | null, revenueModel?: RevenueModel | null } | null } | null } };

export type RemoveAccountMutationVariables = Exact<{
  input: RemoveAccountInput;
}>;


export type RemoveAccountMutation = { __typename?: 'Mutation', removeAccount: { __typename?: 'RemoveAccountResult', success: boolean } };

export type ResetAccountMutationVariables = Exact<{
  input: ResetAccountInput;
}>;


export type ResetAccountMutation = { __typename?: 'Mutation', resetAccount: { __typename?: 'ResetAccountResult', success: boolean } };

export type SendEmailVerificationCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type SendEmailVerificationCodeMutation = { __typename?: 'Mutation', sendEmailVerificationCode: { __typename?: 'SuccessResult', success: boolean } };

export type SetAccountArchivedMutationVariables = Exact<{
  input: SetAccountArchivedInput;
}>;


export type SetAccountArchivedMutation = { __typename?: 'Mutation', setAccountArchived: { __typename?: 'UpdateAccountResult', account: { __typename?: 'Account', id: string, manuallyAdded: boolean, name: string, subType?: AccountSubType | null, type: AccountType, mask?: string | null, status: IntegrationConnectionStatus, updatedAt: CalendarDateTimeString, lastImportedAt?: CalendarDateTimeString | null, archivedAt?: CalendarDateTimeString | null, connections: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }>, financialInstitution: { __typename?: 'FinancialInstitution', id: string, name: string }, initialAccountBalance: { __typename?: 'AccountBalance', balance: string, date: CalendarDateTimeString, setByActorType?: ActorType | null, splits: Array<{ __typename?: 'AccountBalanceSplit', amount: string, description: string, category: { __typename?: 'GatewayCategory', permaKey: string, name: string, displayName?: string | null } | { __typename?: 'LedgerCategory', permaKey: string, name: string, displayName: string } }> }, todaysBalance: { __typename?: 'AccountBalance', balance: string }, epoch?: { __typename?: 'AccountEpoch', cutoffBefore?: CalendarDateString | null, cutoffAtOrAfter?: CalendarDateString | null } | null } } };

export type SetAccountEpochMutationVariables = Exact<{
  input: SetAccountEpochInput;
}>;


export type SetAccountEpochMutation = { __typename?: 'Mutation', setAccountEpoch: { __typename?: 'SetAccountEpochResult', account: { __typename?: 'Account', id: string, manuallyAdded: boolean, name: string, subType?: AccountSubType | null, type: AccountType, mask?: string | null, status: IntegrationConnectionStatus, updatedAt: CalendarDateTimeString, lastImportedAt?: CalendarDateTimeString | null, archivedAt?: CalendarDateTimeString | null, connections: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }>, financialInstitution: { __typename?: 'FinancialInstitution', id: string, name: string }, initialAccountBalance: { __typename?: 'AccountBalance', balance: string, date: CalendarDateTimeString, setByActorType?: ActorType | null, splits: Array<{ __typename?: 'AccountBalanceSplit', amount: string, description: string, category: { __typename?: 'GatewayCategory', permaKey: string, name: string, displayName?: string | null } | { __typename?: 'LedgerCategory', permaKey: string, name: string, displayName: string } }> }, todaysBalance: { __typename?: 'AccountBalance', balance: string }, epoch?: { __typename?: 'AccountEpoch', cutoffBefore?: CalendarDateString | null, cutoffAtOrAfter?: CalendarDateString | null } | null } } };

export type SetAccountSyncStatusMutationVariables = Exact<{
  input: SetAccountSyncStatusInput;
}>;


export type SetAccountSyncStatusMutation = { __typename?: 'Mutation', setAccountSyncStatus: { __typename?: 'SetAccountSyncStatusResult', account: { __typename?: 'Account', id: string, manuallyAdded: boolean, name: string, subType?: AccountSubType | null, type: AccountType, mask?: string | null, status: IntegrationConnectionStatus, updatedAt: CalendarDateTimeString, lastImportedAt?: CalendarDateTimeString | null, archivedAt?: CalendarDateTimeString | null, connections: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }>, financialInstitution: { __typename?: 'FinancialInstitution', id: string, name: string }, initialAccountBalance: { __typename?: 'AccountBalance', balance: string, date: CalendarDateTimeString, setByActorType?: ActorType | null, splits: Array<{ __typename?: 'AccountBalanceSplit', amount: string, description: string, category: { __typename?: 'GatewayCategory', permaKey: string, name: string, displayName?: string | null } | { __typename?: 'LedgerCategory', permaKey: string, name: string, displayName: string } }> }, todaysBalance: { __typename?: 'AccountBalance', balance: string }, epoch?: { __typename?: 'AccountEpoch', cutoffBefore?: CalendarDateString | null, cutoffAtOrAfter?: CalendarDateString | null } | null } } };

export type SetEpochsForAccountsMutationVariables = Exact<{
  input: SetEpochsForAccountsInput;
}>;


export type SetEpochsForAccountsMutation = { __typename?: 'Mutation', setEpochsForAccounts: { __typename?: 'SetEpochsForAccountsResult', accounts: Array<{ __typename?: 'Account', id: string, manuallyAdded: boolean, name: string, subType?: AccountSubType | null, type: AccountType, mask?: string | null, status: IntegrationConnectionStatus, updatedAt: CalendarDateTimeString, lastImportedAt?: CalendarDateTimeString | null, archivedAt?: CalendarDateTimeString | null, connections: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }>, financialInstitution: { __typename?: 'FinancialInstitution', id: string, name: string }, initialAccountBalance: { __typename?: 'AccountBalance', balance: string, date: CalendarDateTimeString, setByActorType?: ActorType | null, splits: Array<{ __typename?: 'AccountBalanceSplit', amount: string, description: string, category: { __typename?: 'GatewayCategory', permaKey: string, name: string, displayName?: string | null } | { __typename?: 'LedgerCategory', permaKey: string, name: string, displayName: string } }> }, todaysBalance: { __typename?: 'AccountBalance', balance: string }, epoch?: { __typename?: 'AccountEpoch', cutoffBefore?: CalendarDateString | null, cutoffAtOrAfter?: CalendarDateString | null } | null }>, connection: { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null } } };

export type SubscribeToCompanySlackChannelMutationVariables = Exact<{
  input: SubscribeToCompanySlackChannelInput;
}>;


export type SubscribeToCompanySlackChannelMutation = { __typename?: 'Mutation', subscribeToCompanySlackChannel: { __typename?: 'SubscribeToCompanySlackChannelResponse', company: { __typename?: 'Company', id: string, slackChannels: Array<{ __typename?: 'CompanySlackChannel', id: string, knockChannelKey: CompanyKnockChannelKey, subscribed: boolean, channelId?: string | null, channelName?: string | null }> } } };

export type SyncDataFromMutationVariables = Exact<{
  input: SyncIntegrationConnectionInput;
}>;


export type SyncDataFromMutation = { __typename?: 'Mutation', syncDataFrom: { __typename?: 'SyncDataFromResult', connection: { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null } } };

export type UnsubscribeFromCompanySlackChannelMutationVariables = Exact<{
  input: UnsubscribeFromCompanySlackChannelInput;
}>;


export type UnsubscribeFromCompanySlackChannelMutation = { __typename?: 'Mutation', unsubscribeFromCompanySlackChannel: { __typename?: 'UnsubscribeFromCompanySlackChannelResponse', company: { __typename?: 'Company', id: string, slackChannels: Array<{ __typename?: 'CompanySlackChannel', id: string, knockChannelKey: CompanyKnockChannelKey, subscribed: boolean, channelId?: string | null, channelName?: string | null }> } } };

export type UpdateNotificationPreferencesMutationVariables = Exact<{
  input: Scalars['JSON']['input'];
}>;


export type UpdateNotificationPreferencesMutation = { __typename?: 'Mutation', updateNotificationPreferences?: { __typename?: 'UpdateNotificationPreferencesResponse', preferences?: any | null } | null };

export type UpdateUserAttributesMutationVariables = Exact<{
  input: UserAttributesInput;
}>;


export type UpdateUserAttributesMutation = { __typename?: 'Mutation', updateUserAttributes: { __typename?: 'UpdateUserAttributesResult', success: boolean } };

export type ValidateLinkTokenMutationVariables = Exact<{
  input: ValidateLinkTokenInput;
}>;


export type ValidateLinkTokenMutation = { __typename?: 'Mutation', validateLinkToken: { __typename?: 'ValidateLinkTokenResult', error?: AuthenticationError | null, apiUser?: { __typename?: 'ApiUser', externalId: string } | null } };

export type AccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, manuallyAdded: boolean, name: string, subType?: AccountSubType | null, type: AccountType, mask?: string | null, status: IntegrationConnectionStatus, updatedAt: CalendarDateTimeString, lastImportedAt?: CalendarDateTimeString | null, archivedAt?: CalendarDateTimeString | null, financialInstitution: { __typename?: 'FinancialInstitution', id: string, name: string, nativeInstitutionId?: string | null, linkedByUser: { __typename?: 'User', email?: string | null }, accounts: Array<{ __typename?: 'Account', id: string, manuallyAdded: boolean, name: string, subType?: AccountSubType | null, type: AccountType, mask?: string | null, status: IntegrationConnectionStatus, updatedAt: CalendarDateTimeString, lastImportedAt?: CalendarDateTimeString | null, archivedAt?: CalendarDateTimeString | null, connections: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }>, financialInstitution: { __typename?: 'FinancialInstitution', id: string, name: string }, initialAccountBalance: { __typename?: 'AccountBalance', balance: string, date: CalendarDateTimeString, setByActorType?: ActorType | null, splits: Array<{ __typename?: 'AccountBalanceSplit', amount: string, description: string, category: { __typename?: 'GatewayCategory', permaKey: string, name: string, displayName?: string | null } | { __typename?: 'LedgerCategory', permaKey: string, name: string, displayName: string } }> }, todaysBalance: { __typename?: 'AccountBalance', balance: string }, epoch?: { __typename?: 'AccountEpoch', cutoffBefore?: CalendarDateString | null, cutoffAtOrAfter?: CalendarDateString | null } | null }> }, connections: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }>, initialAccountBalance: { __typename?: 'AccountBalance', balance: string, date: CalendarDateTimeString, setByActorType?: ActorType | null, splits: Array<{ __typename?: 'AccountBalanceSplit', amount: string, description: string, category: { __typename?: 'GatewayCategory', permaKey: string, name: string, displayName?: string | null } | { __typename?: 'LedgerCategory', permaKey: string, name: string, displayName: string } }> }, todaysBalance: { __typename?: 'AccountBalance', balance: string }, epoch?: { __typename?: 'AccountEpoch', cutoffBefore?: CalendarDateString | null, cutoffAtOrAfter?: CalendarDateString | null } | null } };

export type AccountsQueryVariables = Exact<{
  filter: AccountFilterInput;
}>;


export type AccountsQuery = { __typename?: 'Query', accounts: Array<{ __typename?: 'Account', id: string, manuallyAdded: boolean, name: string, subType?: AccountSubType | null, type: AccountType, mask?: string | null, status: IntegrationConnectionStatus, updatedAt: CalendarDateTimeString, lastImportedAt?: CalendarDateTimeString | null, archivedAt?: CalendarDateTimeString | null, connections: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }>, financialInstitution: { __typename?: 'FinancialInstitution', id: string, name: string }, initialAccountBalance: { __typename?: 'AccountBalance', balance: string, date: CalendarDateTimeString, setByActorType?: ActorType | null, splits: Array<{ __typename?: 'AccountBalanceSplit', amount: string, description: string, category: { __typename?: 'GatewayCategory', permaKey: string, name: string, displayName?: string | null } | { __typename?: 'LedgerCategory', permaKey: string, name: string, displayName: string } }> }, todaysBalance: { __typename?: 'AccountBalance', balance: string }, epoch?: { __typename?: 'AccountEpoch', cutoffBefore?: CalendarDateString | null, cutoffAtOrAfter?: CalendarDateString | null } | null }> };

export type AccountsWithIntegrationsQueryVariables = Exact<{
  filter: AccountFilterInput;
}>;


export type AccountsWithIntegrationsQuery = { __typename?: 'Query', accounts: Array<{ __typename?: 'Account', id: string, manuallyAdded: boolean, name: string, subType?: AccountSubType | null, type: AccountType, mask?: string | null, status: IntegrationConnectionStatus, updatedAt: CalendarDateTimeString, lastImportedAt?: CalendarDateTimeString | null, archivedAt?: CalendarDateTimeString | null, connections: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }>, financialInstitution: { __typename?: 'FinancialInstitution', id: string, name: string }, todaysBalance: { __typename?: 'AccountBalance', balance: string }, epoch?: { __typename?: 'AccountEpoch', cutoffBefore?: CalendarDateString | null, cutoffAtOrAfter?: CalendarDateString | null, shouldCorrectHistory: boolean } | null, epochs: Array<{ __typename?: 'AccountEpoch', cutoffBefore?: CalendarDateString | null, cutoffAtOrAfter?: CalendarDateString | null, shouldCorrectHistory: boolean }> }> };

export type ApiConnectionQueryVariables = Exact<{
  loginKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApiConnectionQuery = { __typename?: 'Query', apiConnectionByLoginKey?: { __typename?: 'ApiConnectionConfig', name: string, requiresFitTest: boolean, hasWebhooksEnabled: boolean, supportsRedirect: boolean } | null };

export type CompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompaniesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'Company', id: string, name: string, type: CompanyType, createdAt: CalendarDateTimeString, onboardingStage: OnboardingStage, uniquePathname: string, timeZone?: string | null, trackingId?: string | null, revenueModel?: RevenueModel | null }> };

export type CompanyFinancialSummaryQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type CompanyFinancialSummaryQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, financialSummary?: { __typename?: 'CompanyFinancialSummary', status: CompanyFinancialMetricsStatus, updatedAt?: CalendarDateTimeString | null, metrics?: { __typename?: 'CompanyFinancialSummaryMetrics', runway?: number | null, runwayUsingThreeMonthAverageTotalBurn?: number | null, runwayUsingLastMonthBankBurn?: number | null, runwayUsingThreeMonthAverageBankBurn?: number | null, runwayUsingLastMonthAccrualOperatingIncomeBurn?: number | null, runwayUsingThreeMonthAverageAccrualOperatingIncomeBurn?: number | null, fundraiseDate?: string | null, fundraiseDateUsingLastMonthBankBurn?: CalendarDateString | null, fundraiseDateUsingLastMonthAccrualOperatingIncomeBurn?: CalendarDateString | null, fundraiseDateUsingThreeMonthAverageTotalBurn?: CalendarDateString | null, fundraiseDateUsingThreeMonthAverageBankBurn?: CalendarDateString | null, fundraiseDateUsingThreeMonthAverageAccrualOperatingIncomeBurn?: CalendarDateString | null, cashOutDate?: string | null, cashOutDateUsingThreeMonthAverageTotalBurn?: string | null, cashOutDateUsingThreeMonthAverageBankBurn?: CalendarDateString | null, cashOutDateUsingThreeMonthAverageAccrualOperatingIncomeBurn?: CalendarDateString | null, cashOutDateUsingLastMonthBankBurn?: CalendarDateString | null, cashOutDateUsingLastMonthAccrualOperatingIncomeBurn?: CalendarDateString | null, totalCash: { __typename?: 'Money', amount: string, currency: any }, lastMonthBankBurn: { __typename?: 'Money', amount: string, currency: any }, lastMonthOperatingBurn: { __typename?: 'Money', amount: string, currency: any }, lastMonthTotalBurn: { __typename?: 'Money', amount: string, currency: any }, lastMonthAccrualOperatingIncomeBurn: { __typename?: 'Money', amount: string, currency: any }, threeMonthAverageOperatingBurn: { __typename?: 'Money', amount: string, currency: any }, threeMonthAverageTotalBurn: { __typename?: 'Money', amount: string, currency: any }, threeMonthAverageBankBurn: { __typename?: 'Money', amount: string, currency: any }, threeMonthAverageAccrualOperatingIncomeBurn: { __typename?: 'Money', amount: string, currency: any }, sixMonthsAccountsReceivable: Array<{ __typename?: 'AccountsReceivable', month: CalendarMonthString, amount: { __typename?: 'Money', amount: string, currency: any } }>, sixMonthsAccountsPayable: Array<{ __typename?: 'AccountsPayable', month: CalendarMonthString, amount: { __typename?: 'Money', amount: string, currency: any } }>, sixMonthsGrossMargin: Array<{ __typename?: 'GrossMargin', month: CalendarMonthString, amount?: string | null }>, sixMonthsNetMargin: Array<{ __typename?: 'NetMargin', month: CalendarMonthString, amount?: string | null }> } | null } | null } | null };

export type MonthlyBankBurnQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type MonthlyBankBurnQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, financialSummary?: { __typename?: 'CompanyFinancialSummary', status: CompanyFinancialMetricsStatus, metrics?: { __typename?: 'CompanyFinancialSummaryMetrics', monthlyBankBurn: { __typename?: 'MetricsByMonth', updatedAt?: CalendarDateTimeString | null, metrics: Array<{ __typename?: 'MetricOnDate', date: CalendarDateString, metric: { __typename?: 'Money', amount: string, currency: any } }> } } | null } | null } | null };

export type DailyCashQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type DailyCashQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, financialSummary?: { __typename?: 'CompanyFinancialSummary', status: CompanyFinancialMetricsStatus, metrics?: { __typename?: 'CompanyFinancialSummaryMetrics', dailyTotalCash: { __typename?: 'CompanyTotalCashByDay', updatedAt?: CalendarDateTimeString | null, metrics: Array<{ __typename?: 'AmountOnDateMetric', date: CalendarDateString, updatedAt?: CalendarDateTimeString | null, totalCash: { __typename?: 'Money', amount: string, currency: any } }> } } | null } | null } | null };

export type MtdBankBurnQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type MtdBankBurnQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, financialSummary?: { __typename?: 'CompanyFinancialSummary', status: CompanyFinancialMetricsStatus, metrics?: { __typename?: 'CompanyFinancialSummaryMetrics', mtdBankBurn: { __typename?: 'MtdBankBurnMetrics', updatedAt?: CalendarDateTimeString | null, metrics: Array<{ __typename?: 'MtdBankBurnMetricWithComparison', currentMonthDate: CalendarDateString, prevMonthDate: CalendarDateString, currentMonthBurn: { __typename?: 'Money', amount: string, currency: any }, prevMonthBurn: { __typename?: 'Money', amount: string, currency: any } }> } } | null } | null } | null };

export type FinancialInstitutionsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  integrationType?: InputMaybe<IntegrationType>;
}>;


export type FinancialInstitutionsQuery = { __typename?: 'Query', financialInstitutionsFor: Array<{ __typename?: 'FinancialInstitution', id: string, name: string, nativeInstitutionId?: string | null, accounts: Array<{ __typename?: 'Account', id: string, manuallyAdded: boolean, name: string, subType?: AccountSubType | null, type: AccountType, mask?: string | null, status: IntegrationConnectionStatus, updatedAt: CalendarDateTimeString, lastImportedAt?: CalendarDateTimeString | null, archivedAt?: CalendarDateTimeString | null, connections: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }>, financialInstitution: { __typename?: 'FinancialInstitution', id: string, name: string }, initialAccountBalance: { __typename?: 'AccountBalance', balance: string, date: CalendarDateTimeString, setByActorType?: ActorType | null, splits: Array<{ __typename?: 'AccountBalanceSplit', amount: string, description: string, category: { __typename?: 'GatewayCategory', permaKey: string, name: string, displayName?: string | null } | { __typename?: 'LedgerCategory', permaKey: string, name: string, displayName: string } }> }, todaysBalance: { __typename?: 'AccountBalance', balance: string }, epoch?: { __typename?: 'AccountEpoch', cutoffBefore?: CalendarDateString | null, cutoffAtOrAfter?: CalendarDateString | null } | null }> }> };

export type GetEmailFromSecretQueryVariables = Exact<{
  input: GetEmailFromSecretInput;
}>;


export type GetEmailFromSecretQuery = { __typename?: 'Query', getEmailFromSecret: { __typename?: 'GetEmailFromSecretResult', email: string } };

export type IntegrationConnectionsForCompanyQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type IntegrationConnectionsForCompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, integrationConnections?: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, accountStats: { __typename?: 'DataSourceTypeAccountStats', activeCount: number, deletedCount: number, archivedCount: number, hiddenCount: number }, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }> | null } | null };

export type BillDotComIntegrationQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type BillDotComIntegrationQuery = { __typename?: 'Query', integrations: { __typename?: 'Integrations', billDotCom: { __typename?: 'BillDotComIntegration', connections?: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }> | null } } };

export type BrexIntegrationQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type BrexIntegrationQuery = { __typename?: 'Query', integrations: { __typename?: 'Integrations', brex: { __typename?: 'BrexIntegration', connections?: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }> | null, initializationInfo: { __typename?: 'BrexInitializationInfo', connectUrl: string } } } };

export type DeelIntegrationQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type DeelIntegrationQuery = { __typename?: 'Query', integrations: { __typename?: 'Integrations', deel: { __typename?: 'DeelIntegration', connections?: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }> | null, initializationInfo: { __typename?: 'DeelInitializationInfo', connectUrl: string } } } };

export type EveryIntegrationQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type EveryIntegrationQuery = { __typename?: 'Query', integrations: { __typename?: 'Integrations', every: { __typename?: 'EveryIntegration', connections?: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }> | null, initializationInfo: { __typename?: 'EveryInitializationInfo', connectUrl: string } } } };

export type FinicityIntegrationQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  institutionName?: InputMaybe<Scalars['String']['input']>;
}>;


export type FinicityIntegrationQuery = { __typename?: 'Query', integrations: { __typename?: 'Integrations', finicity: { __typename?: 'FinicityIntegration', connections?: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }> | null, initializationInfo: { __typename?: 'FinicityInitializationInfo', connectInfo: { __typename?: 'FinicityConnectInfo', connectUrl: string, customerId: string } } } } };

export type GustoIntegrationQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type GustoIntegrationQuery = { __typename?: 'Query', integrations: { __typename?: 'Integrations', gusto: { __typename?: 'GustoIntegration', connections?: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }> | null, initializationInfo: { __typename?: 'GustoInitializationInfo', connectUrl: string } } } };

export type IntegrationConnectionsForQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  integrationType: IntegrationType;
}>;


export type IntegrationConnectionsForQuery = { __typename?: 'Query', integrationConnectionsFor: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }> };

export type MeowIntegrationQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type MeowIntegrationQuery = { __typename?: 'Query', integrations: { __typename?: 'Integrations', meow: { __typename?: 'MeowIntegration', connections?: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }> | null, initializationInfo: { __typename?: 'MeowInitializationInfo', connectUrl: string } } } };

export type MercuryIntegrationQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type MercuryIntegrationQuery = { __typename?: 'Query', integrations: { __typename?: 'Integrations', mercury: { __typename?: 'MercuryIntegration', connections?: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }> | null, initializationInfo: { __typename?: 'MercuryInitializationInfo', connectUrl: string } } } };

export type PlaidIntegrationQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  financialInstitutionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PlaidIntegrationQuery = { __typename?: 'Query', integrations: { __typename?: 'Integrations', plaid: { __typename?: 'PlaidIntegration', initializationInfo: { __typename?: 'PlaidInitializationInfo', connectInfo: { __typename?: 'PlaidConnectInfo', webhookUrl: string, linkToken: string } } } } };

export type PushIntegrationsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type PushIntegrationsQuery = { __typename?: 'Query', integrations: { __typename?: 'Integrations', pushIntegrations: Array<{ __typename?: 'PushIntegration', type: IntegrationType, connectUrl?: string | null, connection?: { __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null } | null }> } };

export type QuickbooksIntegrationQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type QuickbooksIntegrationQuery = { __typename?: 'Query', integrations: { __typename?: 'Integrations', quickbooks: { __typename?: 'QuickbooksIntegration', connections?: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }> | null, initializationInfo: { __typename?: 'QuickbooksInitializationInfo', connectUrl: string } } } };

export type RampIntegrationQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type RampIntegrationQuery = { __typename?: 'Query', integrations: { __typename?: 'Integrations', ramp: { __typename?: 'RampIntegration', connections?: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }> | null, initializationInfo: { __typename?: 'RampInitializationInfo', connectUrl: string } } } };

export type RipplingIntegrationQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type RipplingIntegrationQuery = { __typename?: 'Query', integrations: { __typename?: 'Integrations', rippling: { __typename?: 'RipplingIntegration', connections?: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }> | null, initializationInfo: { __typename?: 'RipplingInitializationInfo', connectUrl: string } } } };

export type SourceCountsForQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type SourceCountsForQuery = { __typename?: 'Query', sourceCountsFor: Array<{ __typename?: 'SourceCount', type: SourceType, count: number }> };

export type StripeIntegrationQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type StripeIntegrationQuery = { __typename?: 'Query', integrations: { __typename?: 'Integrations', stripe: { __typename?: 'StripeIntegration', connections?: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }> | null, initializationInfo: { __typename?: 'StripeInitializationInfo', connectUrl: string } } } };

export type SvbOfxIntegrationQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type SvbOfxIntegrationQuery = { __typename?: 'Query', integrations: { __typename?: 'Integrations', svbOfx: { __typename?: 'SvbOfxIntegration', connections?: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }> | null, initializationInfo: { __typename?: 'SvbOfxInitializationInfo', connectUrl: string } } } };

export type TrinetIntegrationQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type TrinetIntegrationQuery = { __typename?: 'Query', integrations: { __typename?: 'Integrations', trinet: { __typename?: 'TrinetIntegration', connections?: Array<{ __typename?: 'IntegrationConnection', id: string, createdAt: CalendarDateTimeString, type: IntegrationType, ingressType: IngressType, status: IntegrationConnectionStatus, message?: string | null, errorCode?: DisconnectionErrorCode | null, lastSyncedAt?: CalendarDateTimeString | null, condition?: IntegrationConnectionCondition | null, latestSync?: { __typename?: 'SyncRun', id: any, status: SyncRunStatus } | null }> | null } } };

export type LedgerReportLineFragment = { __typename?: 'LedgerReportLine', id: string, nodeTags: Array<ReportLineTag>, parentId?: string | null, childIds: Array<string>, lineType: LedgerReportLineType, accountNumber?: string | null, relatedObjectId?: string | null, title: string, balanceByColumn: Array<{ __typename?: 'BalanceByReportColumn', columnKey: string, pathToken?: string | null, balance: { __typename?: 'Money', amount: string, currency: any }, dateRange: { __typename?: 'OpenEndedInclusiveDateRange', fromInclusive?: CalendarDateString | null, toInclusive?: CalendarDateString | null } }>, formatting: { __typename?: 'LedgerReportFormatting', indentChildren: boolean, header: { __typename?: 'LedgerHeaderConfig', type: LedgerHeaderType, prefix?: string | null, modifiers: Array<LedgerHeaderModifier> }, footer: { __typename?: 'LedgerFooterConfig', type: LedgerFooterType, prefix?: string | null, modifiers: Array<LedgerHeaderModifier> } }, metadata?: { __typename?: 'LedgerReportLineMetadata', counterpartyType?: LedgerReportCounterpartyType | null, counterpartyName?: string | null, revenueSourceType?: LedgerReportRevenueSourceType | null } | null };

export type LedgerReportQueryVariables = Exact<{
  input: LedgerReportInput;
}>;


export type LedgerReportQuery = { __typename?: 'Query', ledgerReport: { __typename: 'LedgerReportByInterval', highWatermarkToken?: string | null, timestamp: CalendarDateTimeString, columnBy: LedgerReportColumnBy, intervalMetadata: Array<{ __typename?: 'LedgerReportIntervalMetadata', uncategorized: { __typename?: 'CategorizationStats', total: string, amount: string, inAmount: string, outAmount: string, percentComplete: number }, unfinalized: { __typename?: 'CategorizationStats', total: string, amount: string, inAmount: string, outAmount: string, percentComplete: number }, interval: { __typename: 'LedgerAccountingPeriodInterval', key: string, periods: Array<string> } | { __typename: 'LedgerDateRangeInterval', key: string, range: { __typename?: 'InclusiveDateRange', fromInclusive: CalendarDateString, toInclusive: CalendarDateString } } }>, lines: Array<{ __typename?: 'LedgerReportLine', id: string, nodeTags: Array<ReportLineTag>, parentId?: string | null, childIds: Array<string>, lineType: LedgerReportLineType, accountNumber?: string | null, relatedObjectId?: string | null, title: string, balanceByColumn: Array<{ __typename?: 'BalanceByReportColumn', columnKey: string, pathToken?: string | null, balance: { __typename?: 'Money', amount: string, currency: any }, dateRange: { __typename?: 'OpenEndedInclusiveDateRange', fromInclusive?: CalendarDateString | null, toInclusive?: CalendarDateString | null } }>, formatting: { __typename?: 'LedgerReportFormatting', indentChildren: boolean, header: { __typename?: 'LedgerHeaderConfig', type: LedgerHeaderType, prefix?: string | null, modifiers: Array<LedgerHeaderModifier> }, footer: { __typename?: 'LedgerFooterConfig', type: LedgerFooterType, prefix?: string | null, modifiers: Array<LedgerHeaderModifier> } }, metadata?: { __typename?: 'LedgerReportLineMetadata', counterpartyType?: LedgerReportCounterpartyType | null, counterpartyName?: string | null, revenueSourceType?: LedgerReportRevenueSourceType | null } | null }>, accounts: Array<{ __typename?: 'LedgerAccountInfo', accountId: string, displayId: string, displayName: string, externalAccountId?: string | null, integrationCounterpartyId?: string | null, integrationType?: string | null, categories: Array<{ __typename: 'GatewayCategory', name: string, permaKey: string, examples?: string | null, description?: string | null, coaDisplayId?: string | null, coaKey?: string | null, deprecated?: boolean | null, ruleType?: string | null, displayName?: string | null, displayId?: string | null, shortName?: string | null, companyId?: string | null, id?: string | null } | { __typename: 'LedgerCategory', defaultCashlike: Cashlike, accountType?: LedgerAccountType | null, views?: Array<string | null> | null, name: string, permaKey: string, examples?: string | null, description?: string | null, coaDisplayId?: string | null, coaKey: string, deprecated?: boolean | null, ruleType?: string | null, displayName: string, displayId: string, shortName: string, companyId: string, id?: string | null }> }> } | { __typename: 'LedgerReportBySegment', highWatermarkToken?: string | null, timestamp: CalendarDateTimeString, columnBy: LedgerReportColumnBy, lines: Array<{ __typename?: 'LedgerReportLine', id: string, nodeTags: Array<ReportLineTag>, parentId?: string | null, childIds: Array<string>, lineType: LedgerReportLineType, accountNumber?: string | null, relatedObjectId?: string | null, title: string, balanceByColumn: Array<{ __typename?: 'BalanceByReportColumn', columnKey: string, pathToken?: string | null, balance: { __typename?: 'Money', amount: string, currency: any }, dateRange: { __typename?: 'OpenEndedInclusiveDateRange', fromInclusive?: CalendarDateString | null, toInclusive?: CalendarDateString | null } }>, formatting: { __typename?: 'LedgerReportFormatting', indentChildren: boolean, header: { __typename?: 'LedgerHeaderConfig', type: LedgerHeaderType, prefix?: string | null, modifiers: Array<LedgerHeaderModifier> }, footer: { __typename?: 'LedgerFooterConfig', type: LedgerFooterType, prefix?: string | null, modifiers: Array<LedgerHeaderModifier> } }, metadata?: { __typename?: 'LedgerReportLineMetadata', counterpartyType?: LedgerReportCounterpartyType | null, counterpartyName?: string | null, revenueSourceType?: LedgerReportRevenueSourceType | null } | null }>, accounts: Array<{ __typename?: 'LedgerAccountInfo', accountId: string, displayId: string, displayName: string, externalAccountId?: string | null, integrationCounterpartyId?: string | null, integrationType?: string | null, categories: Array<{ __typename: 'GatewayCategory', name: string, permaKey: string, examples?: string | null, description?: string | null, coaDisplayId?: string | null, coaKey?: string | null, deprecated?: boolean | null, ruleType?: string | null, displayName?: string | null, displayId?: string | null, shortName?: string | null, companyId?: string | null, id?: string | null } | { __typename: 'LedgerCategory', defaultCashlike: Cashlike, accountType?: LedgerAccountType | null, views?: Array<string | null> | null, name: string, permaKey: string, examples?: string | null, description?: string | null, coaDisplayId?: string | null, coaKey: string, deprecated?: boolean | null, ruleType?: string | null, displayName: string, displayId: string, shortName: string, companyId: string, id?: string | null }> }> } };

export type LedgerAccountInfoFragment = { __typename?: 'LedgerAccountInfo', accountId: string, displayId: string, displayName: string, externalAccountId?: string | null, integrationCounterpartyId?: string | null, integrationType?: string | null, categories: Array<{ __typename: 'GatewayCategory', name: string, permaKey: string, examples?: string | null, description?: string | null, coaDisplayId?: string | null, coaKey?: string | null, deprecated?: boolean | null, ruleType?: string | null, displayName?: string | null, displayId?: string | null, shortName?: string | null, companyId?: string | null, id?: string | null } | { __typename: 'LedgerCategory', defaultCashlike: Cashlike, accountType?: LedgerAccountType | null, views?: Array<string | null> | null, name: string, permaKey: string, examples?: string | null, description?: string | null, coaDisplayId?: string | null, coaKey: string, deprecated?: boolean | null, ruleType?: string | null, displayName: string, displayId: string, shortName: string, companyId: string, id?: string | null }> };

export type CategorizationStatsFragment = { __typename?: 'CategorizationStats', total: string, amount: string, inAmount: string, outAmount: string, percentComplete: number };

export type ReconciliationAccountBalanceFragment = { __typename?: 'AccountBalance', createdAt: CalendarDateTimeString, date: CalendarDateTimeString, balance: string, isAutomated: boolean, dataSource?: string | null };

export type IntervalMetadataFragment = { __typename?: 'LedgerReportIntervalMetadata', uncategorized: { __typename?: 'CategorizationStats', total: string, amount: string, inAmount: string, outAmount: string, percentComplete: number }, unfinalized: { __typename?: 'CategorizationStats', total: string, amount: string, inAmount: string, outAmount: string, percentComplete: number }, interval: { __typename: 'LedgerAccountingPeriodInterval', key: string, periods: Array<string> } | { __typename: 'LedgerDateRangeInterval', key: string, range: { __typename?: 'InclusiveDateRange', fromInclusive: CalendarDateString, toInclusive: CalendarDateString } } };

export type GetNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationPreferencesQuery = { __typename?: 'Query', getNotificationPreferences?: { __typename?: 'NotificationPreferences', preferences?: any | null, notificationWorkflows?: any | null } | null };

export type SiteStatusMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteStatusMessagesQuery = { __typename?: 'Query', siteStatusMessages: Array<{ __typename?: 'SiteStatusMessage', id: string, type: SiteStatusMessageType, message: string }> };

export type GetUserAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAttributesQuery = { __typename?: 'Query', getUserAttributes: { __typename?: 'UserAttributes', howDidYouHearAboutUs?: { __typename?: 'HowDidYouHearAboutUs', howDidYouHearAboutUs?: string | null, howDidYouHearAboutUsCategory?: HowDidYouHearAboutUsCategory | null, howDidYouHearAboutUsOther?: string | null, howDidYouHearAboutUsReferer?: string | null, howDidYouHearAboutUsAcceleratorInput?: string | null, howDidYouHearAboutUsFirmInput?: string | null, howDidYouHearAboutUsEventInput?: string | null, howDidYouHearAboutUsVCInput?: string | null, howDidYouHearAboutUsAIToolsInput?: string | null } | null } };

export type GetEmailPreferencesQueryVariables = Exact<{
  input: GetNotificationsInput;
}>;


export type GetEmailPreferencesQuery = { __typename?: 'Query', getEmailPreferences: { __typename?: 'UserEmailPreferences', preferences?: Array<{ __typename?: 'UserEmailSetting', workflowId: string, description: string, enabled: boolean }> | null } };

export type UpdateEmailPreferencesMutationVariables = Exact<{
  input: UpdateEmailPreferencesInput;
}>;


export type UpdateEmailPreferencesMutation = { __typename?: 'Mutation', updateEmailPreferences: { __typename?: 'UserEmailPreferences', preferences?: Array<{ __typename?: 'UserEmailSetting', workflowId: string, enabled: boolean }> | null } };

export const IntegrationConnectionFragmentDoc = gql`
    fragment integrationConnection on IntegrationConnection {
  id
  createdAt
  type
  ingressType
  status
  message
  errorCode
  lastSyncedAt
  latestSync {
    id
    status
  }
  condition
}
    `;
export const AccountWithIntegrationFragmentDoc = gql`
    fragment accountWithIntegration on Account {
  id
  manuallyAdded
  name
  subType
  type
  mask
  status
  updatedAt
  lastImportedAt
  archivedAt
  connections {
    ...integrationConnection
  }
  financialInstitution {
    id
    name
  }
  todaysBalance {
    balance
  }
  epoch {
    cutoffBefore
    cutoffAtOrAfter
    shouldCorrectHistory
  }
  epochs {
    cutoffBefore
    cutoffAtOrAfter
    shouldCorrectHistory
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export const CardFragmentDoc = gql`
    fragment card on Card {
  id
  accountId
  holderName
  lastFour
}
    `;
export const ChecklistUserFragmentDoc = gql`
    fragment checklistUser on User {
  id
  name
}
    `;
export const ChecklistItemFragmentDoc = gql`
    fragment checklistItem on ChecklistItem {
  __typename
  id
  month
  completedAt
  completedBy {
    ...checklistUser
  }
  removedAt
  removedBy {
    ...checklistUser
  }
  key
  description
  ... on ProgressChecklistItem {
    progressType
    progress
  }
  ... on StatementChecklistItem {
    statementType
  }
  ... on AccountChecklistItem {
    account {
      name
      mask
      financialInstitution {
        name
      }
      ledgerAccount {
        id
        ledgerReconciliationSummary {
          lastReconciled {
            id
            statementDate
          }
          active {
            id
          }
        }
      }
    }
    dataAnomalyReview {
      name
      grade
      ... on AccountEndingBalanceReview {
        context {
          reconciledThrough
          ledgerMinusBestGuessBalance {
            amount
            currency
          }
        }
      }
    }
  }
  ... on BalanceChecklistItem {
    balance {
      amount
      currency
    }
    balanceType
  }
  ... on AmountsChecklistItem {
    amounts {
      type
      amount {
        amount
        currency
      }
    }
    amountsType
  }
  ... on ReviewChecklistItem {
    reviewType
    reviewCount
  }
  ... on CustomChecklistItem {
    repeat
  }
  ... on PaymentProcessingAccountChecklistItem {
    modifiedBy {
      ...checklistUser
    }
    modifiedAt
    account {
      name
      mask
      financialInstitution {
        name
      }
      ledgerAccount {
        id
        ledgerReconciliationSummary {
          lastReconciled {
            id
            statementDate
          }
          active {
            id
          }
        }
      }
    }
    status
  }
}
    ${ChecklistUserFragmentDoc}`;
export const MoneyFragmentDoc = gql`
    fragment money on Money {
  amount
  currency
}
    `;
export const MonthlyBankBurnFragmentDoc = gql`
    fragment monthlyBankBurn on CompanyFinancialSummary {
  status
  metrics {
    monthlyBankBurn {
      updatedAt
      metrics {
        date
        metric {
          ...money
        }
      }
    }
  }
}
    ${MoneyFragmentDoc}`;
export const DailyCashFragmentDoc = gql`
    fragment dailyCash on CompanyFinancialSummary {
  status
  metrics {
    dailyTotalCash {
      updatedAt
      metrics {
        date
        updatedAt
        totalCash {
          ...money
        }
      }
    }
  }
}
    ${MoneyFragmentDoc}`;
export const MtdBankBurnFragmentDoc = gql`
    fragment mtdBankBurn on CompanyFinancialSummary {
  status
  metrics {
    mtdBankBurn {
      updatedAt
      metrics {
        currentMonthDate
        prevMonthDate
        currentMonthBurn {
          ...money
        }
        prevMonthBurn {
          ...money
        }
      }
    }
  }
}
    ${MoneyFragmentDoc}`;
export const AccountsReceivableFragmentDoc = gql`
    fragment accountsReceivable on AccountsReceivable {
  month
  amount {
    ...money
  }
}
    ${MoneyFragmentDoc}`;
export const AccountsPayableFragmentDoc = gql`
    fragment accountsPayable on AccountsPayable {
  month
  amount {
    ...money
  }
}
    ${MoneyFragmentDoc}`;
export const GrossMarginFragmentDoc = gql`
    fragment grossMargin on GrossMargin {
  month
  amount
}
    `;
export const NetMarginFragmentDoc = gql`
    fragment netMargin on NetMargin {
  month
  amount
}
    `;
export const CompanyFinancialSummaryFragmentDoc = gql`
    fragment companyFinancialSummary on CompanyFinancialSummary {
  status
  updatedAt
  metrics {
    totalCash {
      ...money
    }
    lastMonthBankBurn {
      ...money
    }
    lastMonthOperatingBurn {
      ...money
    }
    lastMonthTotalBurn {
      ...money
    }
    lastMonthAccrualOperatingIncomeBurn {
      ...money
    }
    threeMonthAverageOperatingBurn {
      ...money
    }
    threeMonthAverageTotalBurn {
      ...money
    }
    threeMonthAverageBankBurn {
      ...money
    }
    threeMonthAverageAccrualOperatingIncomeBurn {
      ...money
    }
    runway
    runwayUsingThreeMonthAverageTotalBurn
    runwayUsingLastMonthBankBurn
    runwayUsingThreeMonthAverageBankBurn
    runwayUsingLastMonthAccrualOperatingIncomeBurn
    runwayUsingThreeMonthAverageAccrualOperatingIncomeBurn
    fundraiseDate
    fundraiseDateUsingLastMonthBankBurn
    fundraiseDateUsingLastMonthAccrualOperatingIncomeBurn
    fundraiseDateUsingThreeMonthAverageTotalBurn
    fundraiseDateUsingThreeMonthAverageBankBurn
    fundraiseDateUsingThreeMonthAverageAccrualOperatingIncomeBurn
    cashOutDate
    cashOutDateUsingThreeMonthAverageTotalBurn
    cashOutDateUsingThreeMonthAverageBankBurn
    cashOutDateUsingThreeMonthAverageAccrualOperatingIncomeBurn
    cashOutDateUsingLastMonthBankBurn
    cashOutDateUsingLastMonthAccrualOperatingIncomeBurn
    sixMonthsAccountsReceivable {
      ...accountsReceivable
    }
    sixMonthsAccountsPayable {
      ...accountsPayable
    }
    sixMonthsGrossMargin {
      ...grossMargin
    }
    sixMonthsNetMargin {
      ...netMargin
    }
  }
}
    ${MoneyFragmentDoc}
${AccountsReceivableFragmentDoc}
${AccountsPayableFragmentDoc}
${GrossMarginFragmentDoc}
${NetMarginFragmentDoc}`;
export const CompanySlackChannelFragmentDoc = gql`
    fragment companySlackChannel on CompanySlackChannel {
  id
  knockChannelKey
  subscribed
  channelId
  channelName
}
    `;
export const CustomerFragmentDoc = gql`
    fragment customer on Customer {
  id
  name
  email
  type
  status
  description
  invoiceStats {
    total
  }
}
    `;
export const AccountFragmentDoc = gql`
    fragment account on Account {
  id
  manuallyAdded
  name
  subType
  type
  mask
  status
  updatedAt
  lastImportedAt
  archivedAt
  connections {
    ...integrationConnection
  }
  financialInstitution {
    id
    name
  }
  initialAccountBalance {
    balance
    date
    setByActorType
    splits {
      amount
      description
      category {
        permaKey
        name
        displayName
      }
    }
  }
  todaysBalance {
    balance
  }
  epoch {
    cutoffBefore
    cutoffAtOrAfter
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export const FinancialInstitutionFragmentDoc = gql`
    fragment financialInstitution on FinancialInstitution {
  id
  name
  nativeInstitutionId
  accounts {
    ...account
  }
}
    ${AccountFragmentDoc}`;
export const IntegrationConnectionWithAccountStatsFragmentDoc = gql`
    fragment integrationConnectionWithAccountStats on IntegrationConnection {
  ...integrationConnection
  accountStats {
    activeCount
    deletedCount
    archivedCount
    hiddenCount
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export const MetricFragmentDoc = gql`
    fragment metric on Metric {
  amount
  currency
  dataFromRange {
    fromInclusive
    toInclusive
  }
}
    `;
export const PageInfoFragmentDoc = gql`
    fragment pageInfo on PageInfo {
  hasNextPage
  endCursor
  total
}
    `;
export const PendingInvitationFragmentDoc = gql`
    fragment pendingInvitation on CompanyInvitation {
  id
  email
  companyId
  mfaRequired
  role
  createdAt
  updatedAt
}
    `;
export const ProductFragmentDoc = gql`
    fragment product on Product {
  id
  name
}
    `;
export const ProductWithDetailsFragmentDoc = gql`
    fragment productWithDetails on Product {
  id
  name
  serviceType
  status
  sku
  description
  priceRate
  invoiceStats {
    total
  }
}
    `;
export const SourceCountFragmentDoc = gql`
    fragment sourceCount on SourceCount {
  type
  count
}
    `;
export const SurveyResponseFragmentDoc = gql`
    fragment surveyResponse on SurveyResponse {
  id
  survey
  notes
  userId
  questions {
    name
    answers
  }
}
    `;
export const CompanyFragmentDoc = gql`
    fragment company on Company {
  id
  name
  type
  createdAt
  onboardingStage
  uniquePathname
  timeZone
  trackingId
  revenueModel
}
    `;
export const UserFragmentDoc = gql`
    fragment user on User {
  id
  name
  email
  emailVerified
  permittedDataSources
  invitedBy {
    id
    name
    email
  }
  company {
    ...company
  }
}
    ${CompanyFragmentDoc}`;
export const VendorFragmentDoc = gql`
    fragment vendor on Vendor {
  id
  permaName
  name
  description
  is1099Vendor
  status
  type
}
    `;
export const FileFragmentDoc = gql`
    fragment file on File {
  id
  filename
  contentType
  size
  isDeleted
  downloadInfo {
    signedUrl
    urlExpiresAt
  }
}
    `;
export const VendorWithDetailsFragmentDoc = gql`
    fragment vendorWithDetails on Vendor {
  id
  name
  addressJson
  companyName
  contactName
  currency
  description
  documents {
    file {
      ...file
    }
  }
  email
  is1099Vendor
  name
  phoneNumber
  status
  taxIdType
  type
  website
}
    ${FileFragmentDoc}`;
export const LedgerReportLineFragmentDoc = gql`
    fragment ledgerReportLine on LedgerReportLine {
  id
  nodeTags
  parentId
  childIds
  lineType
  accountNumber
  relatedObjectId
  balanceByColumn {
    balance {
      amount
      currency
    }
    columnKey
    pathToken
    dateRange {
      fromInclusive
      toInclusive
    }
  }
  nodeTags
  title
  formatting {
    indentChildren
    header {
      type
      prefix
      modifiers
    }
    footer {
      type
      prefix
      modifiers
    }
  }
  metadata {
    counterpartyType
    counterpartyName
    revenueSourceType
  }
}
    `;
export const CategoryFragmentDoc = gql`
    fragment category on Category {
  __typename
  name
  permaKey
  examples
  description
  coaDisplayId
  coaKey
  deprecated
  ruleType
  displayName
  displayId
  shortName
  companyId
  id
  ... on LedgerCategory {
    defaultCashlike
    accountType
    views
  }
}
    `;
export const LedgerAccountInfoFragmentDoc = gql`
    fragment ledgerAccountInfo on LedgerAccountInfo {
  accountId
  displayId
  displayName
  externalAccountId
  integrationCounterpartyId
  integrationType
  categories {
    ...category
  }
}
    ${CategoryFragmentDoc}`;
export const ReconciliationAccountBalanceFragmentDoc = gql`
    fragment reconciliationAccountBalance on AccountBalance {
  createdAt
  date
  balance
  isAutomated
  dataSource
}
    `;
export const CategorizationStatsFragmentDoc = gql`
    fragment categorizationStats on CategorizationStats {
  total
  amount
  inAmount
  outAmount
  percentComplete
}
    `;
export const IntervalMetadataFragmentDoc = gql`
    fragment intervalMetadata on LedgerReportIntervalMetadata {
  uncategorized {
    ...categorizationStats
  }
  unfinalized {
    ...categorizationStats
  }
  interval {
    __typename
    ... on LedgerAccountingPeriodInterval {
      key
      periods
    }
    ... on LedgerDateRangeInterval {
      key
      range {
        fromInclusive
        toInclusive
      }
    }
  }
}
    ${CategorizationStatsFragmentDoc}`;
export const AcceptPendingInvitationsDocument = gql`
    mutation acceptPendingInvitations {
  acceptPendingInvitations {
    errorMessages
  }
}
    `;
export type AcceptPendingInvitationsMutationFn = Apollo.MutationFunction<AcceptPendingInvitationsMutation, AcceptPendingInvitationsMutationVariables>;

/**
 * __useAcceptPendingInvitationsMutation__
 *
 * To run a mutation, you first call `useAcceptPendingInvitationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptPendingInvitationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptPendingInvitationsMutation, { data, loading, error }] = useAcceptPendingInvitationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptPendingInvitationsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptPendingInvitationsMutation, AcceptPendingInvitationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptPendingInvitationsMutation, AcceptPendingInvitationsMutationVariables>(AcceptPendingInvitationsDocument, options);
      }
export type AcceptPendingInvitationsMutationHookResult = ReturnType<typeof useAcceptPendingInvitationsMutation>;
export type AcceptPendingInvitationsMutationResult = Apollo.MutationResult<AcceptPendingInvitationsMutation>;
export type AcceptPendingInvitationsMutationOptions = Apollo.BaseMutationOptions<AcceptPendingInvitationsMutation, AcceptPendingInvitationsMutationVariables>;
export const CreateAffiliateAttributionDocument = gql`
    mutation createAffiliateAttribution($input: CreateAffiliateAttributionInput!) {
  createAffiliateAttribution(input: $input) {
    companyId
    name
    token
    __typename
  }
}
    `;
export type CreateAffiliateAttributionMutationFn = Apollo.MutationFunction<CreateAffiliateAttributionMutation, CreateAffiliateAttributionMutationVariables>;

/**
 * __useCreateAffiliateAttributionMutation__
 *
 * To run a mutation, you first call `useCreateAffiliateAttributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAffiliateAttributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAffiliateAttributionMutation, { data, loading, error }] = useCreateAffiliateAttributionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAffiliateAttributionMutation(baseOptions?: Apollo.MutationHookOptions<CreateAffiliateAttributionMutation, CreateAffiliateAttributionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAffiliateAttributionMutation, CreateAffiliateAttributionMutationVariables>(CreateAffiliateAttributionDocument, options);
      }
export type CreateAffiliateAttributionMutationHookResult = ReturnType<typeof useCreateAffiliateAttributionMutation>;
export type CreateAffiliateAttributionMutationResult = Apollo.MutationResult<CreateAffiliateAttributionMutation>;
export type CreateAffiliateAttributionMutationOptions = Apollo.BaseMutationOptions<CreateAffiliateAttributionMutation, CreateAffiliateAttributionMutationVariables>;
export const AuthenticateWithTokenDocument = gql`
    mutation authenticateWithToken($input: AuthenticateWithTokenInput!) {
  authenticateWithToken(input: $input) {
    error
    needsAuthentication
    companyId
    isUpdate
    apiUser {
      externalId
    }
    self {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;
export type AuthenticateWithTokenMutationFn = Apollo.MutationFunction<AuthenticateWithTokenMutation, AuthenticateWithTokenMutationVariables>;

/**
 * __useAuthenticateWithTokenMutation__
 *
 * To run a mutation, you first call `useAuthenticateWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateWithTokenMutation, { data, loading, error }] = useAuthenticateWithTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticateWithTokenMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateWithTokenMutation, AuthenticateWithTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateWithTokenMutation, AuthenticateWithTokenMutationVariables>(AuthenticateWithTokenDocument, options);
      }
export type AuthenticateWithTokenMutationHookResult = ReturnType<typeof useAuthenticateWithTokenMutation>;
export type AuthenticateWithTokenMutationResult = Apollo.MutationResult<AuthenticateWithTokenMutation>;
export type AuthenticateWithTokenMutationOptions = Apollo.BaseMutationOptions<AuthenticateWithTokenMutation, AuthenticateWithTokenMutationVariables>;
export const ConfirmEmailVerificationDocument = gql`
    mutation confirmEmailVerification($input: ConfirmEmailVerificationInput!) {
  confirmEmailVerification(input: $input) {
    success
    error
  }
}
    `;
export type ConfirmEmailVerificationMutationFn = Apollo.MutationFunction<ConfirmEmailVerificationMutation, ConfirmEmailVerificationMutationVariables>;

/**
 * __useConfirmEmailVerificationMutation__
 *
 * To run a mutation, you first call `useConfirmEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmEmailVerificationMutation, { data, loading, error }] = useConfirmEmailVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmEmailVerificationMutation, ConfirmEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmEmailVerificationMutation, ConfirmEmailVerificationMutationVariables>(ConfirmEmailVerificationDocument, options);
      }
export type ConfirmEmailVerificationMutationHookResult = ReturnType<typeof useConfirmEmailVerificationMutation>;
export type ConfirmEmailVerificationMutationResult = Apollo.MutationResult<ConfirmEmailVerificationMutation>;
export type ConfirmEmailVerificationMutationOptions = Apollo.BaseMutationOptions<ConfirmEmailVerificationMutation, ConfirmEmailVerificationMutationVariables>;
export const ConnectBillDotComDocument = gql`
    mutation connectBillDotCom($input: ConnectBillDotComInput!) {
  connectBillDotCom(input: $input) {
    connection {
      ...integrationConnection
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export type ConnectBillDotComMutationFn = Apollo.MutationFunction<ConnectBillDotComMutation, ConnectBillDotComMutationVariables>;

/**
 * __useConnectBillDotComMutation__
 *
 * To run a mutation, you first call `useConnectBillDotComMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectBillDotComMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectBillDotComMutation, { data, loading, error }] = useConnectBillDotComMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectBillDotComMutation(baseOptions?: Apollo.MutationHookOptions<ConnectBillDotComMutation, ConnectBillDotComMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectBillDotComMutation, ConnectBillDotComMutationVariables>(ConnectBillDotComDocument, options);
      }
export type ConnectBillDotComMutationHookResult = ReturnType<typeof useConnectBillDotComMutation>;
export type ConnectBillDotComMutationResult = Apollo.MutationResult<ConnectBillDotComMutation>;
export type ConnectBillDotComMutationOptions = Apollo.BaseMutationOptions<ConnectBillDotComMutation, ConnectBillDotComMutationVariables>;
export const ConnectBrexDocument = gql`
    mutation connectBrex($input: ConnectBrexInput!) {
  connectBrex(input: $input) {
    connection {
      ...integrationConnection
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export type ConnectBrexMutationFn = Apollo.MutationFunction<ConnectBrexMutation, ConnectBrexMutationVariables>;

/**
 * __useConnectBrexMutation__
 *
 * To run a mutation, you first call `useConnectBrexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectBrexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectBrexMutation, { data, loading, error }] = useConnectBrexMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectBrexMutation(baseOptions?: Apollo.MutationHookOptions<ConnectBrexMutation, ConnectBrexMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectBrexMutation, ConnectBrexMutationVariables>(ConnectBrexDocument, options);
      }
export type ConnectBrexMutationHookResult = ReturnType<typeof useConnectBrexMutation>;
export type ConnectBrexMutationResult = Apollo.MutationResult<ConnectBrexMutation>;
export type ConnectBrexMutationOptions = Apollo.BaseMutationOptions<ConnectBrexMutation, ConnectBrexMutationVariables>;
export const ConnectDeelDocument = gql`
    mutation connectDeel($input: ConnectDeelInput!) {
  connectDeel(input: $input) {
    connection {
      ...integrationConnection
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export type ConnectDeelMutationFn = Apollo.MutationFunction<ConnectDeelMutation, ConnectDeelMutationVariables>;

/**
 * __useConnectDeelMutation__
 *
 * To run a mutation, you first call `useConnectDeelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectDeelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectDeelMutation, { data, loading, error }] = useConnectDeelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectDeelMutation(baseOptions?: Apollo.MutationHookOptions<ConnectDeelMutation, ConnectDeelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectDeelMutation, ConnectDeelMutationVariables>(ConnectDeelDocument, options);
      }
export type ConnectDeelMutationHookResult = ReturnType<typeof useConnectDeelMutation>;
export type ConnectDeelMutationResult = Apollo.MutationResult<ConnectDeelMutation>;
export type ConnectDeelMutationOptions = Apollo.BaseMutationOptions<ConnectDeelMutation, ConnectDeelMutationVariables>;
export const ConnectFinicityDocument = gql`
    mutation connectFinicity($input: ConnectFinicityInput!) {
  connectFinicity(input: $input) {
    connection {
      ...integrationConnection
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export type ConnectFinicityMutationFn = Apollo.MutationFunction<ConnectFinicityMutation, ConnectFinicityMutationVariables>;

/**
 * __useConnectFinicityMutation__
 *
 * To run a mutation, you first call `useConnectFinicityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectFinicityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectFinicityMutation, { data, loading, error }] = useConnectFinicityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectFinicityMutation(baseOptions?: Apollo.MutationHookOptions<ConnectFinicityMutation, ConnectFinicityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectFinicityMutation, ConnectFinicityMutationVariables>(ConnectFinicityDocument, options);
      }
export type ConnectFinicityMutationHookResult = ReturnType<typeof useConnectFinicityMutation>;
export type ConnectFinicityMutationResult = Apollo.MutationResult<ConnectFinicityMutation>;
export type ConnectFinicityMutationOptions = Apollo.BaseMutationOptions<ConnectFinicityMutation, ConnectFinicityMutationVariables>;
export const ConnectGustoDocument = gql`
    mutation connectGusto($input: ConnectGustoInput!) {
  connectGusto(input: $input) {
    connection {
      ...integrationConnection
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export type ConnectGustoMutationFn = Apollo.MutationFunction<ConnectGustoMutation, ConnectGustoMutationVariables>;

/**
 * __useConnectGustoMutation__
 *
 * To run a mutation, you first call `useConnectGustoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectGustoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectGustoMutation, { data, loading, error }] = useConnectGustoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectGustoMutation(baseOptions?: Apollo.MutationHookOptions<ConnectGustoMutation, ConnectGustoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectGustoMutation, ConnectGustoMutationVariables>(ConnectGustoDocument, options);
      }
export type ConnectGustoMutationHookResult = ReturnType<typeof useConnectGustoMutation>;
export type ConnectGustoMutationResult = Apollo.MutationResult<ConnectGustoMutation>;
export type ConnectGustoMutationOptions = Apollo.BaseMutationOptions<ConnectGustoMutation, ConnectGustoMutationVariables>;
export const ConnectMeowDocument = gql`
    mutation connectMeow($input: ConnectMeowInput!) {
  connectMeow(input: $input) {
    connection {
      ...integrationConnection
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export type ConnectMeowMutationFn = Apollo.MutationFunction<ConnectMeowMutation, ConnectMeowMutationVariables>;

/**
 * __useConnectMeowMutation__
 *
 * To run a mutation, you first call `useConnectMeowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectMeowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectMeowMutation, { data, loading, error }] = useConnectMeowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectMeowMutation(baseOptions?: Apollo.MutationHookOptions<ConnectMeowMutation, ConnectMeowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectMeowMutation, ConnectMeowMutationVariables>(ConnectMeowDocument, options);
      }
export type ConnectMeowMutationHookResult = ReturnType<typeof useConnectMeowMutation>;
export type ConnectMeowMutationResult = Apollo.MutationResult<ConnectMeowMutation>;
export type ConnectMeowMutationOptions = Apollo.BaseMutationOptions<ConnectMeowMutation, ConnectMeowMutationVariables>;
export const ConnectMercuryDocument = gql`
    mutation connectMercury($input: ConnectMercuryInput!) {
  connectMercury(input: $input) {
    connection {
      ...integrationConnection
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export type ConnectMercuryMutationFn = Apollo.MutationFunction<ConnectMercuryMutation, ConnectMercuryMutationVariables>;

/**
 * __useConnectMercuryMutation__
 *
 * To run a mutation, you first call `useConnectMercuryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectMercuryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectMercuryMutation, { data, loading, error }] = useConnectMercuryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectMercuryMutation(baseOptions?: Apollo.MutationHookOptions<ConnectMercuryMutation, ConnectMercuryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectMercuryMutation, ConnectMercuryMutationVariables>(ConnectMercuryDocument, options);
      }
export type ConnectMercuryMutationHookResult = ReturnType<typeof useConnectMercuryMutation>;
export type ConnectMercuryMutationResult = Apollo.MutationResult<ConnectMercuryMutation>;
export type ConnectMercuryMutationOptions = Apollo.BaseMutationOptions<ConnectMercuryMutation, ConnectMercuryMutationVariables>;
export const ConnectPlaidDocument = gql`
    mutation connectPlaid($input: ConnectPlaidInput!) {
  connectPlaid(input: $input) {
    financialInstitution {
      ...financialInstitution
    }
  }
}
    ${FinancialInstitutionFragmentDoc}`;
export type ConnectPlaidMutationFn = Apollo.MutationFunction<ConnectPlaidMutation, ConnectPlaidMutationVariables>;

/**
 * __useConnectPlaidMutation__
 *
 * To run a mutation, you first call `useConnectPlaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectPlaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectPlaidMutation, { data, loading, error }] = useConnectPlaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectPlaidMutation(baseOptions?: Apollo.MutationHookOptions<ConnectPlaidMutation, ConnectPlaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectPlaidMutation, ConnectPlaidMutationVariables>(ConnectPlaidDocument, options);
      }
export type ConnectPlaidMutationHookResult = ReturnType<typeof useConnectPlaidMutation>;
export type ConnectPlaidMutationResult = Apollo.MutationResult<ConnectPlaidMutation>;
export type ConnectPlaidMutationOptions = Apollo.BaseMutationOptions<ConnectPlaidMutation, ConnectPlaidMutationVariables>;
export const ConnectQuickbooksDocument = gql`
    mutation connectQuickbooks($input: ConnectQuickbooksInput!) {
  connectQuickbooks(input: $input) {
    connection {
      ...integrationConnection
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export type ConnectQuickbooksMutationFn = Apollo.MutationFunction<ConnectQuickbooksMutation, ConnectQuickbooksMutationVariables>;

/**
 * __useConnectQuickbooksMutation__
 *
 * To run a mutation, you first call `useConnectQuickbooksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectQuickbooksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectQuickbooksMutation, { data, loading, error }] = useConnectQuickbooksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectQuickbooksMutation(baseOptions?: Apollo.MutationHookOptions<ConnectQuickbooksMutation, ConnectQuickbooksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectQuickbooksMutation, ConnectQuickbooksMutationVariables>(ConnectQuickbooksDocument, options);
      }
export type ConnectQuickbooksMutationHookResult = ReturnType<typeof useConnectQuickbooksMutation>;
export type ConnectQuickbooksMutationResult = Apollo.MutationResult<ConnectQuickbooksMutation>;
export type ConnectQuickbooksMutationOptions = Apollo.BaseMutationOptions<ConnectQuickbooksMutation, ConnectQuickbooksMutationVariables>;
export const ConnectRampDocument = gql`
    mutation connectRamp($input: ConnectRampInput!) {
  connectRamp(input: $input) {
    connection {
      ...integrationConnection
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export type ConnectRampMutationFn = Apollo.MutationFunction<ConnectRampMutation, ConnectRampMutationVariables>;

/**
 * __useConnectRampMutation__
 *
 * To run a mutation, you first call `useConnectRampMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectRampMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectRampMutation, { data, loading, error }] = useConnectRampMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectRampMutation(baseOptions?: Apollo.MutationHookOptions<ConnectRampMutation, ConnectRampMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectRampMutation, ConnectRampMutationVariables>(ConnectRampDocument, options);
      }
export type ConnectRampMutationHookResult = ReturnType<typeof useConnectRampMutation>;
export type ConnectRampMutationResult = Apollo.MutationResult<ConnectRampMutation>;
export type ConnectRampMutationOptions = Apollo.BaseMutationOptions<ConnectRampMutation, ConnectRampMutationVariables>;
export const ConnectRipplingDocument = gql`
    mutation connectRippling($input: ConnectRipplingInput!) {
  connectRippling(input: $input) {
    connection {
      ...integrationConnection
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export type ConnectRipplingMutationFn = Apollo.MutationFunction<ConnectRipplingMutation, ConnectRipplingMutationVariables>;

/**
 * __useConnectRipplingMutation__
 *
 * To run a mutation, you first call `useConnectRipplingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectRipplingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectRipplingMutation, { data, loading, error }] = useConnectRipplingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectRipplingMutation(baseOptions?: Apollo.MutationHookOptions<ConnectRipplingMutation, ConnectRipplingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectRipplingMutation, ConnectRipplingMutationVariables>(ConnectRipplingDocument, options);
      }
export type ConnectRipplingMutationHookResult = ReturnType<typeof useConnectRipplingMutation>;
export type ConnectRipplingMutationResult = Apollo.MutationResult<ConnectRipplingMutation>;
export type ConnectRipplingMutationOptions = Apollo.BaseMutationOptions<ConnectRipplingMutation, ConnectRipplingMutationVariables>;
export const ConnectStripeDocument = gql`
    mutation connectStripe($input: ConnectStripeInput!) {
  connectStripe(input: $input) {
    connection {
      ...integrationConnection
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export type ConnectStripeMutationFn = Apollo.MutationFunction<ConnectStripeMutation, ConnectStripeMutationVariables>;

/**
 * __useConnectStripeMutation__
 *
 * To run a mutation, you first call `useConnectStripeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectStripeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectStripeMutation, { data, loading, error }] = useConnectStripeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectStripeMutation(baseOptions?: Apollo.MutationHookOptions<ConnectStripeMutation, ConnectStripeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectStripeMutation, ConnectStripeMutationVariables>(ConnectStripeDocument, options);
      }
export type ConnectStripeMutationHookResult = ReturnType<typeof useConnectStripeMutation>;
export type ConnectStripeMutationResult = Apollo.MutationResult<ConnectStripeMutation>;
export type ConnectStripeMutationOptions = Apollo.BaseMutationOptions<ConnectStripeMutation, ConnectStripeMutationVariables>;
export const ConnectSvbOfxDocument = gql`
    mutation connectSvbOfx($input: ConnectSvbOfxInput!) {
  connectSvbOfx(input: $input) {
    connection {
      ...integrationConnection
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export type ConnectSvbOfxMutationFn = Apollo.MutationFunction<ConnectSvbOfxMutation, ConnectSvbOfxMutationVariables>;

/**
 * __useConnectSvbOfxMutation__
 *
 * To run a mutation, you first call `useConnectSvbOfxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectSvbOfxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectSvbOfxMutation, { data, loading, error }] = useConnectSvbOfxMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectSvbOfxMutation(baseOptions?: Apollo.MutationHookOptions<ConnectSvbOfxMutation, ConnectSvbOfxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectSvbOfxMutation, ConnectSvbOfxMutationVariables>(ConnectSvbOfxDocument, options);
      }
export type ConnectSvbOfxMutationHookResult = ReturnType<typeof useConnectSvbOfxMutation>;
export type ConnectSvbOfxMutationResult = Apollo.MutationResult<ConnectSvbOfxMutation>;
export type ConnectSvbOfxMutationOptions = Apollo.BaseMutationOptions<ConnectSvbOfxMutation, ConnectSvbOfxMutationVariables>;
export const ConnectTrinetDocument = gql`
    mutation connectTrinet($input: ConnectTrinetInput!) {
  connectTrinet(input: $input) {
    connection {
      ...integrationConnection
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export type ConnectTrinetMutationFn = Apollo.MutationFunction<ConnectTrinetMutation, ConnectTrinetMutationVariables>;

/**
 * __useConnectTrinetMutation__
 *
 * To run a mutation, you first call `useConnectTrinetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectTrinetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectTrinetMutation, { data, loading, error }] = useConnectTrinetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectTrinetMutation(baseOptions?: Apollo.MutationHookOptions<ConnectTrinetMutation, ConnectTrinetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectTrinetMutation, ConnectTrinetMutationVariables>(ConnectTrinetDocument, options);
      }
export type ConnectTrinetMutationHookResult = ReturnType<typeof useConnectTrinetMutation>;
export type ConnectTrinetMutationResult = Apollo.MutationResult<ConnectTrinetMutation>;
export type ConnectTrinetMutationOptions = Apollo.BaseMutationOptions<ConnectTrinetMutation, ConnectTrinetMutationVariables>;
export const CreateManualAccountDocument = gql`
    mutation createManualAccount($input: CreateManualAccountInput!) {
  createManualAccount(input: $input) {
    account {
      ...account
    }
    error
  }
}
    ${AccountFragmentDoc}`;
export type CreateManualAccountMutationFn = Apollo.MutationFunction<CreateManualAccountMutation, CreateManualAccountMutationVariables>;

/**
 * __useCreateManualAccountMutation__
 *
 * To run a mutation, you first call `useCreateManualAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualAccountMutation, { data, loading, error }] = useCreateManualAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManualAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateManualAccountMutation, CreateManualAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManualAccountMutation, CreateManualAccountMutationVariables>(CreateManualAccountDocument, options);
      }
export type CreateManualAccountMutationHookResult = ReturnType<typeof useCreateManualAccountMutation>;
export type CreateManualAccountMutationResult = Apollo.MutationResult<CreateManualAccountMutation>;
export type CreateManualAccountMutationOptions = Apollo.BaseMutationOptions<CreateManualAccountMutation, CreateManualAccountMutationVariables>;
export const CreateSurveyResponseDocument = gql`
    mutation createSurveyResponse($input: SurveyResponseInput!) {
  createSurveyResponse(input: $input) {
    ...surveyResponse
  }
}
    ${SurveyResponseFragmentDoc}`;
export type CreateSurveyResponseMutationFn = Apollo.MutationFunction<CreateSurveyResponseMutation, CreateSurveyResponseMutationVariables>;

/**
 * __useCreateSurveyResponseMutation__
 *
 * To run a mutation, you first call `useCreateSurveyResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurveyResponseMutation, { data, loading, error }] = useCreateSurveyResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSurveyResponseMutation(baseOptions?: Apollo.MutationHookOptions<CreateSurveyResponseMutation, CreateSurveyResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSurveyResponseMutation, CreateSurveyResponseMutationVariables>(CreateSurveyResponseDocument, options);
      }
export type CreateSurveyResponseMutationHookResult = ReturnType<typeof useCreateSurveyResponseMutation>;
export type CreateSurveyResponseMutationResult = Apollo.MutationResult<CreateSurveyResponseMutation>;
export type CreateSurveyResponseMutationOptions = Apollo.BaseMutationOptions<CreateSurveyResponseMutation, CreateSurveyResponseMutationVariables>;
export const DisconnectIntegrationDocument = gql`
    mutation disconnectIntegration($input: DisconnectIntegrationInput!) {
  disconnectIntegration(input: $input) {
    disconnected
  }
}
    `;
export type DisconnectIntegrationMutationFn = Apollo.MutationFunction<DisconnectIntegrationMutation, DisconnectIntegrationMutationVariables>;

/**
 * __useDisconnectIntegrationMutation__
 *
 * To run a mutation, you first call `useDisconnectIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectIntegrationMutation, { data, loading, error }] = useDisconnectIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisconnectIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectIntegrationMutation, DisconnectIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectIntegrationMutation, DisconnectIntegrationMutationVariables>(DisconnectIntegrationDocument, options);
      }
export type DisconnectIntegrationMutationHookResult = ReturnType<typeof useDisconnectIntegrationMutation>;
export type DisconnectIntegrationMutationResult = Apollo.MutationResult<DisconnectIntegrationMutation>;
export type DisconnectIntegrationMutationOptions = Apollo.BaseMutationOptions<DisconnectIntegrationMutation, DisconnectIntegrationMutationVariables>;
export const HandleCompanyCompletedOnboardingDocument = gql`
    mutation handleCompanyCompletedOnboarding($id: ID!) {
  handleCompanyCompletedOnboarding(id: $id) {
    company {
      id
      onboardingStage
    }
  }
}
    `;
export type HandleCompanyCompletedOnboardingMutationFn = Apollo.MutationFunction<HandleCompanyCompletedOnboardingMutation, HandleCompanyCompletedOnboardingMutationVariables>;

/**
 * __useHandleCompanyCompletedOnboardingMutation__
 *
 * To run a mutation, you first call `useHandleCompanyCompletedOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleCompanyCompletedOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleCompanyCompletedOnboardingMutation, { data, loading, error }] = useHandleCompanyCompletedOnboardingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHandleCompanyCompletedOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<HandleCompanyCompletedOnboardingMutation, HandleCompanyCompletedOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleCompanyCompletedOnboardingMutation, HandleCompanyCompletedOnboardingMutationVariables>(HandleCompanyCompletedOnboardingDocument, options);
      }
export type HandleCompanyCompletedOnboardingMutationHookResult = ReturnType<typeof useHandleCompanyCompletedOnboardingMutation>;
export type HandleCompanyCompletedOnboardingMutationResult = Apollo.MutationResult<HandleCompanyCompletedOnboardingMutation>;
export type HandleCompanyCompletedOnboardingMutationOptions = Apollo.BaseMutationOptions<HandleCompanyCompletedOnboardingMutation, HandleCompanyCompletedOnboardingMutationVariables>;
export const LinkExistingAccountDocument = gql`
    mutation linkExistingAccount($input: LinkExistingAccountInput!) {
  linkExistingAccount(input: $input) {
    error
    apiUser {
      externalId
    }
    self {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;
export type LinkExistingAccountMutationFn = Apollo.MutationFunction<LinkExistingAccountMutation, LinkExistingAccountMutationVariables>;

/**
 * __useLinkExistingAccountMutation__
 *
 * To run a mutation, you first call `useLinkExistingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkExistingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkExistingAccountMutation, { data, loading, error }] = useLinkExistingAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkExistingAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkExistingAccountMutation, LinkExistingAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkExistingAccountMutation, LinkExistingAccountMutationVariables>(LinkExistingAccountDocument, options);
      }
export type LinkExistingAccountMutationHookResult = ReturnType<typeof useLinkExistingAccountMutation>;
export type LinkExistingAccountMutationResult = Apollo.MutationResult<LinkExistingAccountMutation>;
export type LinkExistingAccountMutationOptions = Apollo.BaseMutationOptions<LinkExistingAccountMutation, LinkExistingAccountMutationVariables>;
export const RemoveAccountDocument = gql`
    mutation removeAccount($input: RemoveAccountInput!) {
  removeAccount(input: $input) {
    success
  }
}
    `;
export type RemoveAccountMutationFn = Apollo.MutationFunction<RemoveAccountMutation, RemoveAccountMutationVariables>;

/**
 * __useRemoveAccountMutation__
 *
 * To run a mutation, you first call `useRemoveAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAccountMutation, { data, loading, error }] = useRemoveAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAccountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAccountMutation, RemoveAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAccountMutation, RemoveAccountMutationVariables>(RemoveAccountDocument, options);
      }
export type RemoveAccountMutationHookResult = ReturnType<typeof useRemoveAccountMutation>;
export type RemoveAccountMutationResult = Apollo.MutationResult<RemoveAccountMutation>;
export type RemoveAccountMutationOptions = Apollo.BaseMutationOptions<RemoveAccountMutation, RemoveAccountMutationVariables>;
export const ResetAccountDocument = gql`
    mutation resetAccount($input: ResetAccountInput!) {
  resetAccount(input: $input) {
    success
  }
}
    `;
export type ResetAccountMutationFn = Apollo.MutationFunction<ResetAccountMutation, ResetAccountMutationVariables>;

/**
 * __useResetAccountMutation__
 *
 * To run a mutation, you first call `useResetAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAccountMutation, { data, loading, error }] = useResetAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetAccountMutation(baseOptions?: Apollo.MutationHookOptions<ResetAccountMutation, ResetAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetAccountMutation, ResetAccountMutationVariables>(ResetAccountDocument, options);
      }
export type ResetAccountMutationHookResult = ReturnType<typeof useResetAccountMutation>;
export type ResetAccountMutationResult = Apollo.MutationResult<ResetAccountMutation>;
export type ResetAccountMutationOptions = Apollo.BaseMutationOptions<ResetAccountMutation, ResetAccountMutationVariables>;
export const SendEmailVerificationCodeDocument = gql`
    mutation sendEmailVerificationCode {
  sendEmailVerificationCode {
    success
  }
}
    `;
export type SendEmailVerificationCodeMutationFn = Apollo.MutationFunction<SendEmailVerificationCodeMutation, SendEmailVerificationCodeMutationVariables>;

/**
 * __useSendEmailVerificationCodeMutation__
 *
 * To run a mutation, you first call `useSendEmailVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailVerificationCodeMutation, { data, loading, error }] = useSendEmailVerificationCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendEmailVerificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailVerificationCodeMutation, SendEmailVerificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailVerificationCodeMutation, SendEmailVerificationCodeMutationVariables>(SendEmailVerificationCodeDocument, options);
      }
export type SendEmailVerificationCodeMutationHookResult = ReturnType<typeof useSendEmailVerificationCodeMutation>;
export type SendEmailVerificationCodeMutationResult = Apollo.MutationResult<SendEmailVerificationCodeMutation>;
export type SendEmailVerificationCodeMutationOptions = Apollo.BaseMutationOptions<SendEmailVerificationCodeMutation, SendEmailVerificationCodeMutationVariables>;
export const SetAccountArchivedDocument = gql`
    mutation setAccountArchived($input: SetAccountArchivedInput!) {
  setAccountArchived(input: $input) {
    account {
      ...account
    }
  }
}
    ${AccountFragmentDoc}`;
export type SetAccountArchivedMutationFn = Apollo.MutationFunction<SetAccountArchivedMutation, SetAccountArchivedMutationVariables>;

/**
 * __useSetAccountArchivedMutation__
 *
 * To run a mutation, you first call `useSetAccountArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAccountArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAccountArchivedMutation, { data, loading, error }] = useSetAccountArchivedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAccountArchivedMutation(baseOptions?: Apollo.MutationHookOptions<SetAccountArchivedMutation, SetAccountArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAccountArchivedMutation, SetAccountArchivedMutationVariables>(SetAccountArchivedDocument, options);
      }
export type SetAccountArchivedMutationHookResult = ReturnType<typeof useSetAccountArchivedMutation>;
export type SetAccountArchivedMutationResult = Apollo.MutationResult<SetAccountArchivedMutation>;
export type SetAccountArchivedMutationOptions = Apollo.BaseMutationOptions<SetAccountArchivedMutation, SetAccountArchivedMutationVariables>;
export const SetAccountEpochDocument = gql`
    mutation setAccountEpoch($input: SetAccountEpochInput!) {
  setAccountEpoch(input: $input) {
    account {
      ...account
    }
  }
}
    ${AccountFragmentDoc}`;
export type SetAccountEpochMutationFn = Apollo.MutationFunction<SetAccountEpochMutation, SetAccountEpochMutationVariables>;

/**
 * __useSetAccountEpochMutation__
 *
 * To run a mutation, you first call `useSetAccountEpochMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAccountEpochMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAccountEpochMutation, { data, loading, error }] = useSetAccountEpochMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAccountEpochMutation(baseOptions?: Apollo.MutationHookOptions<SetAccountEpochMutation, SetAccountEpochMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAccountEpochMutation, SetAccountEpochMutationVariables>(SetAccountEpochDocument, options);
      }
export type SetAccountEpochMutationHookResult = ReturnType<typeof useSetAccountEpochMutation>;
export type SetAccountEpochMutationResult = Apollo.MutationResult<SetAccountEpochMutation>;
export type SetAccountEpochMutationOptions = Apollo.BaseMutationOptions<SetAccountEpochMutation, SetAccountEpochMutationVariables>;
export const SetAccountSyncStatusDocument = gql`
    mutation setAccountSyncStatus($input: SetAccountSyncStatusInput!) {
  setAccountSyncStatus(input: $input) {
    account {
      ...account
    }
  }
}
    ${AccountFragmentDoc}`;
export type SetAccountSyncStatusMutationFn = Apollo.MutationFunction<SetAccountSyncStatusMutation, SetAccountSyncStatusMutationVariables>;

/**
 * __useSetAccountSyncStatusMutation__
 *
 * To run a mutation, you first call `useSetAccountSyncStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAccountSyncStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAccountSyncStatusMutation, { data, loading, error }] = useSetAccountSyncStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAccountSyncStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetAccountSyncStatusMutation, SetAccountSyncStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAccountSyncStatusMutation, SetAccountSyncStatusMutationVariables>(SetAccountSyncStatusDocument, options);
      }
export type SetAccountSyncStatusMutationHookResult = ReturnType<typeof useSetAccountSyncStatusMutation>;
export type SetAccountSyncStatusMutationResult = Apollo.MutationResult<SetAccountSyncStatusMutation>;
export type SetAccountSyncStatusMutationOptions = Apollo.BaseMutationOptions<SetAccountSyncStatusMutation, SetAccountSyncStatusMutationVariables>;
export const SetEpochsForAccountsDocument = gql`
    mutation setEpochsForAccounts($input: SetEpochsForAccountsInput!) {
  setEpochsForAccounts(input: $input) {
    accounts {
      ...account
    }
    connection {
      ...integrationConnection
    }
  }
}
    ${AccountFragmentDoc}
${IntegrationConnectionFragmentDoc}`;
export type SetEpochsForAccountsMutationFn = Apollo.MutationFunction<SetEpochsForAccountsMutation, SetEpochsForAccountsMutationVariables>;

/**
 * __useSetEpochsForAccountsMutation__
 *
 * To run a mutation, you first call `useSetEpochsForAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEpochsForAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEpochsForAccountsMutation, { data, loading, error }] = useSetEpochsForAccountsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEpochsForAccountsMutation(baseOptions?: Apollo.MutationHookOptions<SetEpochsForAccountsMutation, SetEpochsForAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEpochsForAccountsMutation, SetEpochsForAccountsMutationVariables>(SetEpochsForAccountsDocument, options);
      }
export type SetEpochsForAccountsMutationHookResult = ReturnType<typeof useSetEpochsForAccountsMutation>;
export type SetEpochsForAccountsMutationResult = Apollo.MutationResult<SetEpochsForAccountsMutation>;
export type SetEpochsForAccountsMutationOptions = Apollo.BaseMutationOptions<SetEpochsForAccountsMutation, SetEpochsForAccountsMutationVariables>;
export const SubscribeToCompanySlackChannelDocument = gql`
    mutation subscribeToCompanySlackChannel($input: SubscribeToCompanySlackChannelInput!) {
  subscribeToCompanySlackChannel(input: $input) {
    company {
      id
      slackChannels {
        ...companySlackChannel
      }
    }
  }
}
    ${CompanySlackChannelFragmentDoc}`;
export type SubscribeToCompanySlackChannelMutationFn = Apollo.MutationFunction<SubscribeToCompanySlackChannelMutation, SubscribeToCompanySlackChannelMutationVariables>;

/**
 * __useSubscribeToCompanySlackChannelMutation__
 *
 * To run a mutation, you first call `useSubscribeToCompanySlackChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToCompanySlackChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToCompanySlackChannelMutation, { data, loading, error }] = useSubscribeToCompanySlackChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeToCompanySlackChannelMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToCompanySlackChannelMutation, SubscribeToCompanySlackChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToCompanySlackChannelMutation, SubscribeToCompanySlackChannelMutationVariables>(SubscribeToCompanySlackChannelDocument, options);
      }
export type SubscribeToCompanySlackChannelMutationHookResult = ReturnType<typeof useSubscribeToCompanySlackChannelMutation>;
export type SubscribeToCompanySlackChannelMutationResult = Apollo.MutationResult<SubscribeToCompanySlackChannelMutation>;
export type SubscribeToCompanySlackChannelMutationOptions = Apollo.BaseMutationOptions<SubscribeToCompanySlackChannelMutation, SubscribeToCompanySlackChannelMutationVariables>;
export const SyncDataFromDocument = gql`
    mutation syncDataFrom($input: SyncIntegrationConnectionInput!) {
  syncDataFrom(input: $input) {
    connection {
      ...integrationConnection
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;
export type SyncDataFromMutationFn = Apollo.MutationFunction<SyncDataFromMutation, SyncDataFromMutationVariables>;

/**
 * __useSyncDataFromMutation__
 *
 * To run a mutation, you first call `useSyncDataFromMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncDataFromMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncDataFromMutation, { data, loading, error }] = useSyncDataFromMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncDataFromMutation(baseOptions?: Apollo.MutationHookOptions<SyncDataFromMutation, SyncDataFromMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncDataFromMutation, SyncDataFromMutationVariables>(SyncDataFromDocument, options);
      }
export type SyncDataFromMutationHookResult = ReturnType<typeof useSyncDataFromMutation>;
export type SyncDataFromMutationResult = Apollo.MutationResult<SyncDataFromMutation>;
export type SyncDataFromMutationOptions = Apollo.BaseMutationOptions<SyncDataFromMutation, SyncDataFromMutationVariables>;
export const UnsubscribeFromCompanySlackChannelDocument = gql`
    mutation unsubscribeFromCompanySlackChannel($input: UnsubscribeFromCompanySlackChannelInput!) {
  unsubscribeFromCompanySlackChannel(input: $input) {
    company {
      id
      slackChannels {
        ...companySlackChannel
      }
    }
  }
}
    ${CompanySlackChannelFragmentDoc}`;
export type UnsubscribeFromCompanySlackChannelMutationFn = Apollo.MutationFunction<UnsubscribeFromCompanySlackChannelMutation, UnsubscribeFromCompanySlackChannelMutationVariables>;

/**
 * __useUnsubscribeFromCompanySlackChannelMutation__
 *
 * To run a mutation, you first call `useUnsubscribeFromCompanySlackChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeFromCompanySlackChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeFromCompanySlackChannelMutation, { data, loading, error }] = useUnsubscribeFromCompanySlackChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnsubscribeFromCompanySlackChannelMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeFromCompanySlackChannelMutation, UnsubscribeFromCompanySlackChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeFromCompanySlackChannelMutation, UnsubscribeFromCompanySlackChannelMutationVariables>(UnsubscribeFromCompanySlackChannelDocument, options);
      }
export type UnsubscribeFromCompanySlackChannelMutationHookResult = ReturnType<typeof useUnsubscribeFromCompanySlackChannelMutation>;
export type UnsubscribeFromCompanySlackChannelMutationResult = Apollo.MutationResult<UnsubscribeFromCompanySlackChannelMutation>;
export type UnsubscribeFromCompanySlackChannelMutationOptions = Apollo.BaseMutationOptions<UnsubscribeFromCompanySlackChannelMutation, UnsubscribeFromCompanySlackChannelMutationVariables>;
export const UpdateNotificationPreferencesDocument = gql`
    mutation updateNotificationPreferences($input: JSON!) {
  updateNotificationPreferences(input: $input) {
    preferences
  }
}
    `;
export type UpdateNotificationPreferencesMutationFn = Apollo.MutationFunction<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>;

/**
 * __useUpdateNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationPreferencesMutation, { data, loading, error }] = useUpdateNotificationPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>(UpdateNotificationPreferencesDocument, options);
      }
export type UpdateNotificationPreferencesMutationHookResult = ReturnType<typeof useUpdateNotificationPreferencesMutation>;
export type UpdateNotificationPreferencesMutationResult = Apollo.MutationResult<UpdateNotificationPreferencesMutation>;
export type UpdateNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>;
export const UpdateUserAttributesDocument = gql`
    mutation updateUserAttributes($input: UserAttributesInput!) {
  updateUserAttributes(input: $input) {
    success
  }
}
    `;
export type UpdateUserAttributesMutationFn = Apollo.MutationFunction<UpdateUserAttributesMutation, UpdateUserAttributesMutationVariables>;

/**
 * __useUpdateUserAttributesMutation__
 *
 * To run a mutation, you first call `useUpdateUserAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAttributesMutation, { data, loading, error }] = useUpdateUserAttributesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAttributesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAttributesMutation, UpdateUserAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAttributesMutation, UpdateUserAttributesMutationVariables>(UpdateUserAttributesDocument, options);
      }
export type UpdateUserAttributesMutationHookResult = ReturnType<typeof useUpdateUserAttributesMutation>;
export type UpdateUserAttributesMutationResult = Apollo.MutationResult<UpdateUserAttributesMutation>;
export type UpdateUserAttributesMutationOptions = Apollo.BaseMutationOptions<UpdateUserAttributesMutation, UpdateUserAttributesMutationVariables>;
export const ValidateLinkTokenDocument = gql`
    mutation validateLinkToken($input: ValidateLinkTokenInput!) {
  validateLinkToken(input: $input) {
    error
    apiUser {
      externalId
    }
  }
}
    `;
export type ValidateLinkTokenMutationFn = Apollo.MutationFunction<ValidateLinkTokenMutation, ValidateLinkTokenMutationVariables>;

/**
 * __useValidateLinkTokenMutation__
 *
 * To run a mutation, you first call `useValidateLinkTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateLinkTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateLinkTokenMutation, { data, loading, error }] = useValidateLinkTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateLinkTokenMutation(baseOptions?: Apollo.MutationHookOptions<ValidateLinkTokenMutation, ValidateLinkTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateLinkTokenMutation, ValidateLinkTokenMutationVariables>(ValidateLinkTokenDocument, options);
      }
export type ValidateLinkTokenMutationHookResult = ReturnType<typeof useValidateLinkTokenMutation>;
export type ValidateLinkTokenMutationResult = Apollo.MutationResult<ValidateLinkTokenMutation>;
export type ValidateLinkTokenMutationOptions = Apollo.BaseMutationOptions<ValidateLinkTokenMutation, ValidateLinkTokenMutationVariables>;
export const AccountDocument = gql`
    query account($id: ID!) {
  account(id: $id) {
    ...account
    financialInstitution {
      ...financialInstitution
      linkedByUser {
        email
      }
    }
  }
}
    ${AccountFragmentDoc}
${FinancialInstitutionFragmentDoc}`;

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountQuery(baseOptions: Apollo.QueryHookOptions<AccountQuery, AccountQueryVariables> & ({ variables: AccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
      }
export function useAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountQuery, AccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
        }
export function useAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountQuery, AccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
        }
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>;
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>;
export type AccountSuspenseQueryHookResult = ReturnType<typeof useAccountSuspenseQuery>;
export type AccountQueryResult = Apollo.QueryResult<AccountQuery, AccountQueryVariables>;
export const AccountsDocument = gql`
    query accounts($filter: AccountFilterInput!) {
  accounts(filter: $filter) {
    ...account
  }
}
    ${AccountFragmentDoc}`;

/**
 * __useAccountsQuery__
 *
 * To run a query within a React component, call `useAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAccountsQuery(baseOptions: Apollo.QueryHookOptions<AccountsQuery, AccountsQueryVariables> & ({ variables: AccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
      }
export function useAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
        }
export function useAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
        }
export type AccountsQueryHookResult = ReturnType<typeof useAccountsQuery>;
export type AccountsLazyQueryHookResult = ReturnType<typeof useAccountsLazyQuery>;
export type AccountsSuspenseQueryHookResult = ReturnType<typeof useAccountsSuspenseQuery>;
export type AccountsQueryResult = Apollo.QueryResult<AccountsQuery, AccountsQueryVariables>;
export const AccountsWithIntegrationsDocument = gql`
    query accountsWithIntegrations($filter: AccountFilterInput!) {
  accounts(filter: $filter) {
    ...accountWithIntegration
  }
}
    ${AccountWithIntegrationFragmentDoc}`;

/**
 * __useAccountsWithIntegrationsQuery__
 *
 * To run a query within a React component, call `useAccountsWithIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsWithIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsWithIntegrationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAccountsWithIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<AccountsWithIntegrationsQuery, AccountsWithIntegrationsQueryVariables> & ({ variables: AccountsWithIntegrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountsWithIntegrationsQuery, AccountsWithIntegrationsQueryVariables>(AccountsWithIntegrationsDocument, options);
      }
export function useAccountsWithIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountsWithIntegrationsQuery, AccountsWithIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountsWithIntegrationsQuery, AccountsWithIntegrationsQueryVariables>(AccountsWithIntegrationsDocument, options);
        }
export function useAccountsWithIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountsWithIntegrationsQuery, AccountsWithIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountsWithIntegrationsQuery, AccountsWithIntegrationsQueryVariables>(AccountsWithIntegrationsDocument, options);
        }
export type AccountsWithIntegrationsQueryHookResult = ReturnType<typeof useAccountsWithIntegrationsQuery>;
export type AccountsWithIntegrationsLazyQueryHookResult = ReturnType<typeof useAccountsWithIntegrationsLazyQuery>;
export type AccountsWithIntegrationsSuspenseQueryHookResult = ReturnType<typeof useAccountsWithIntegrationsSuspenseQuery>;
export type AccountsWithIntegrationsQueryResult = Apollo.QueryResult<AccountsWithIntegrationsQuery, AccountsWithIntegrationsQueryVariables>;
export const ApiConnectionDocument = gql`
    query apiConnection($loginKey: String) {
  apiConnectionByLoginKey(loginKey: $loginKey) {
    name
    requiresFitTest
    hasWebhooksEnabled
    supportsRedirect
  }
}
    `;

/**
 * __useApiConnectionQuery__
 *
 * To run a query within a React component, call `useApiConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiConnectionQuery({
 *   variables: {
 *      loginKey: // value for 'loginKey'
 *   },
 * });
 */
export function useApiConnectionQuery(baseOptions?: Apollo.QueryHookOptions<ApiConnectionQuery, ApiConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiConnectionQuery, ApiConnectionQueryVariables>(ApiConnectionDocument, options);
      }
export function useApiConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiConnectionQuery, ApiConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiConnectionQuery, ApiConnectionQueryVariables>(ApiConnectionDocument, options);
        }
export function useApiConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiConnectionQuery, ApiConnectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiConnectionQuery, ApiConnectionQueryVariables>(ApiConnectionDocument, options);
        }
export type ApiConnectionQueryHookResult = ReturnType<typeof useApiConnectionQuery>;
export type ApiConnectionLazyQueryHookResult = ReturnType<typeof useApiConnectionLazyQuery>;
export type ApiConnectionSuspenseQueryHookResult = ReturnType<typeof useApiConnectionSuspenseQuery>;
export type ApiConnectionQueryResult = Apollo.QueryResult<ApiConnectionQuery, ApiConnectionQueryVariables>;
export const CompaniesDocument = gql`
    query companies {
  companies {
    ...company
  }
}
    ${CompanyFragmentDoc}`;

/**
 * __useCompaniesQuery__
 *
 * To run a query within a React component, call `useCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
      }
export function useCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
        }
export function useCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
        }
export type CompaniesQueryHookResult = ReturnType<typeof useCompaniesQuery>;
export type CompaniesLazyQueryHookResult = ReturnType<typeof useCompaniesLazyQuery>;
export type CompaniesSuspenseQueryHookResult = ReturnType<typeof useCompaniesSuspenseQuery>;
export type CompaniesQueryResult = Apollo.QueryResult<CompaniesQuery, CompaniesQueryVariables>;
export const CompanyFinancialSummaryDocument = gql`
    query companyFinancialSummary($companyId: ID!) {
  company(id: $companyId) {
    id
    financialSummary {
      ...companyFinancialSummary
    }
  }
}
    ${CompanyFinancialSummaryFragmentDoc}`;

/**
 * __useCompanyFinancialSummaryQuery__
 *
 * To run a query within a React component, call `useCompanyFinancialSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyFinancialSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyFinancialSummaryQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyFinancialSummaryQuery(baseOptions: Apollo.QueryHookOptions<CompanyFinancialSummaryQuery, CompanyFinancialSummaryQueryVariables> & ({ variables: CompanyFinancialSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyFinancialSummaryQuery, CompanyFinancialSummaryQueryVariables>(CompanyFinancialSummaryDocument, options);
      }
export function useCompanyFinancialSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyFinancialSummaryQuery, CompanyFinancialSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyFinancialSummaryQuery, CompanyFinancialSummaryQueryVariables>(CompanyFinancialSummaryDocument, options);
        }
export function useCompanyFinancialSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyFinancialSummaryQuery, CompanyFinancialSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyFinancialSummaryQuery, CompanyFinancialSummaryQueryVariables>(CompanyFinancialSummaryDocument, options);
        }
export type CompanyFinancialSummaryQueryHookResult = ReturnType<typeof useCompanyFinancialSummaryQuery>;
export type CompanyFinancialSummaryLazyQueryHookResult = ReturnType<typeof useCompanyFinancialSummaryLazyQuery>;
export type CompanyFinancialSummarySuspenseQueryHookResult = ReturnType<typeof useCompanyFinancialSummarySuspenseQuery>;
export type CompanyFinancialSummaryQueryResult = Apollo.QueryResult<CompanyFinancialSummaryQuery, CompanyFinancialSummaryQueryVariables>;
export const MonthlyBankBurnDocument = gql`
    query monthlyBankBurn($companyId: ID!) {
  company(id: $companyId) {
    id
    financialSummary {
      ...monthlyBankBurn
    }
  }
}
    ${MonthlyBankBurnFragmentDoc}`;

/**
 * __useMonthlyBankBurnQuery__
 *
 * To run a query within a React component, call `useMonthlyBankBurnQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthlyBankBurnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthlyBankBurnQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useMonthlyBankBurnQuery(baseOptions: Apollo.QueryHookOptions<MonthlyBankBurnQuery, MonthlyBankBurnQueryVariables> & ({ variables: MonthlyBankBurnQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MonthlyBankBurnQuery, MonthlyBankBurnQueryVariables>(MonthlyBankBurnDocument, options);
      }
export function useMonthlyBankBurnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MonthlyBankBurnQuery, MonthlyBankBurnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MonthlyBankBurnQuery, MonthlyBankBurnQueryVariables>(MonthlyBankBurnDocument, options);
        }
export function useMonthlyBankBurnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MonthlyBankBurnQuery, MonthlyBankBurnQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MonthlyBankBurnQuery, MonthlyBankBurnQueryVariables>(MonthlyBankBurnDocument, options);
        }
export type MonthlyBankBurnQueryHookResult = ReturnType<typeof useMonthlyBankBurnQuery>;
export type MonthlyBankBurnLazyQueryHookResult = ReturnType<typeof useMonthlyBankBurnLazyQuery>;
export type MonthlyBankBurnSuspenseQueryHookResult = ReturnType<typeof useMonthlyBankBurnSuspenseQuery>;
export type MonthlyBankBurnQueryResult = Apollo.QueryResult<MonthlyBankBurnQuery, MonthlyBankBurnQueryVariables>;
export const DailyCashDocument = gql`
    query dailyCash($companyId: ID!) {
  company(id: $companyId) {
    id
    financialSummary {
      ...dailyCash
    }
  }
}
    ${DailyCashFragmentDoc}`;

/**
 * __useDailyCashQuery__
 *
 * To run a query within a React component, call `useDailyCashQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyCashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyCashQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDailyCashQuery(baseOptions: Apollo.QueryHookOptions<DailyCashQuery, DailyCashQueryVariables> & ({ variables: DailyCashQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyCashQuery, DailyCashQueryVariables>(DailyCashDocument, options);
      }
export function useDailyCashLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyCashQuery, DailyCashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyCashQuery, DailyCashQueryVariables>(DailyCashDocument, options);
        }
export function useDailyCashSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DailyCashQuery, DailyCashQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyCashQuery, DailyCashQueryVariables>(DailyCashDocument, options);
        }
export type DailyCashQueryHookResult = ReturnType<typeof useDailyCashQuery>;
export type DailyCashLazyQueryHookResult = ReturnType<typeof useDailyCashLazyQuery>;
export type DailyCashSuspenseQueryHookResult = ReturnType<typeof useDailyCashSuspenseQuery>;
export type DailyCashQueryResult = Apollo.QueryResult<DailyCashQuery, DailyCashQueryVariables>;
export const MtdBankBurnDocument = gql`
    query mtdBankBurn($companyId: ID!) {
  company(id: $companyId) {
    id
    financialSummary {
      ...mtdBankBurn
    }
  }
}
    ${MtdBankBurnFragmentDoc}`;

/**
 * __useMtdBankBurnQuery__
 *
 * To run a query within a React component, call `useMtdBankBurnQuery` and pass it any options that fit your needs.
 * When your component renders, `useMtdBankBurnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMtdBankBurnQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useMtdBankBurnQuery(baseOptions: Apollo.QueryHookOptions<MtdBankBurnQuery, MtdBankBurnQueryVariables> & ({ variables: MtdBankBurnQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MtdBankBurnQuery, MtdBankBurnQueryVariables>(MtdBankBurnDocument, options);
      }
export function useMtdBankBurnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MtdBankBurnQuery, MtdBankBurnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MtdBankBurnQuery, MtdBankBurnQueryVariables>(MtdBankBurnDocument, options);
        }
export function useMtdBankBurnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MtdBankBurnQuery, MtdBankBurnQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MtdBankBurnQuery, MtdBankBurnQueryVariables>(MtdBankBurnDocument, options);
        }
export type MtdBankBurnQueryHookResult = ReturnType<typeof useMtdBankBurnQuery>;
export type MtdBankBurnLazyQueryHookResult = ReturnType<typeof useMtdBankBurnLazyQuery>;
export type MtdBankBurnSuspenseQueryHookResult = ReturnType<typeof useMtdBankBurnSuspenseQuery>;
export type MtdBankBurnQueryResult = Apollo.QueryResult<MtdBankBurnQuery, MtdBankBurnQueryVariables>;
export const FinancialInstitutionsDocument = gql`
    query financialInstitutions($companyId: ID!, $integrationType: IntegrationType) {
  financialInstitutionsFor(
    companyId: $companyId
    integrationType: $integrationType
  ) {
    ...financialInstitution
  }
}
    ${FinancialInstitutionFragmentDoc}`;

/**
 * __useFinancialInstitutionsQuery__
 *
 * To run a query within a React component, call `useFinancialInstitutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialInstitutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialInstitutionsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function useFinancialInstitutionsQuery(baseOptions: Apollo.QueryHookOptions<FinancialInstitutionsQuery, FinancialInstitutionsQueryVariables> & ({ variables: FinancialInstitutionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancialInstitutionsQuery, FinancialInstitutionsQueryVariables>(FinancialInstitutionsDocument, options);
      }
export function useFinancialInstitutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancialInstitutionsQuery, FinancialInstitutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancialInstitutionsQuery, FinancialInstitutionsQueryVariables>(FinancialInstitutionsDocument, options);
        }
export function useFinancialInstitutionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancialInstitutionsQuery, FinancialInstitutionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancialInstitutionsQuery, FinancialInstitutionsQueryVariables>(FinancialInstitutionsDocument, options);
        }
export type FinancialInstitutionsQueryHookResult = ReturnType<typeof useFinancialInstitutionsQuery>;
export type FinancialInstitutionsLazyQueryHookResult = ReturnType<typeof useFinancialInstitutionsLazyQuery>;
export type FinancialInstitutionsSuspenseQueryHookResult = ReturnType<typeof useFinancialInstitutionsSuspenseQuery>;
export type FinancialInstitutionsQueryResult = Apollo.QueryResult<FinancialInstitutionsQuery, FinancialInstitutionsQueryVariables>;
export const GetEmailFromSecretDocument = gql`
    query getEmailFromSecret($input: GetEmailFromSecretInput!) {
  getEmailFromSecret(input: $input) {
    email
  }
}
    `;

/**
 * __useGetEmailFromSecretQuery__
 *
 * To run a query within a React component, call `useGetEmailFromSecretQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailFromSecretQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailFromSecretQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEmailFromSecretQuery(baseOptions: Apollo.QueryHookOptions<GetEmailFromSecretQuery, GetEmailFromSecretQueryVariables> & ({ variables: GetEmailFromSecretQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailFromSecretQuery, GetEmailFromSecretQueryVariables>(GetEmailFromSecretDocument, options);
      }
export function useGetEmailFromSecretLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailFromSecretQuery, GetEmailFromSecretQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailFromSecretQuery, GetEmailFromSecretQueryVariables>(GetEmailFromSecretDocument, options);
        }
export function useGetEmailFromSecretSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailFromSecretQuery, GetEmailFromSecretQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailFromSecretQuery, GetEmailFromSecretQueryVariables>(GetEmailFromSecretDocument, options);
        }
export type GetEmailFromSecretQueryHookResult = ReturnType<typeof useGetEmailFromSecretQuery>;
export type GetEmailFromSecretLazyQueryHookResult = ReturnType<typeof useGetEmailFromSecretLazyQuery>;
export type GetEmailFromSecretSuspenseQueryHookResult = ReturnType<typeof useGetEmailFromSecretSuspenseQuery>;
export type GetEmailFromSecretQueryResult = Apollo.QueryResult<GetEmailFromSecretQuery, GetEmailFromSecretQueryVariables>;
export const IntegrationConnectionsForCompanyDocument = gql`
    query integrationConnectionsForCompany($companyId: ID!) {
  company(id: $companyId) {
    id
    integrationConnections {
      ...integrationConnectionWithAccountStats
    }
  }
}
    ${IntegrationConnectionWithAccountStatsFragmentDoc}`;

/**
 * __useIntegrationConnectionsForCompanyQuery__
 *
 * To run a query within a React component, call `useIntegrationConnectionsForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationConnectionsForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationConnectionsForCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useIntegrationConnectionsForCompanyQuery(baseOptions: Apollo.QueryHookOptions<IntegrationConnectionsForCompanyQuery, IntegrationConnectionsForCompanyQueryVariables> & ({ variables: IntegrationConnectionsForCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationConnectionsForCompanyQuery, IntegrationConnectionsForCompanyQueryVariables>(IntegrationConnectionsForCompanyDocument, options);
      }
export function useIntegrationConnectionsForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationConnectionsForCompanyQuery, IntegrationConnectionsForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationConnectionsForCompanyQuery, IntegrationConnectionsForCompanyQueryVariables>(IntegrationConnectionsForCompanyDocument, options);
        }
export function useIntegrationConnectionsForCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationConnectionsForCompanyQuery, IntegrationConnectionsForCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationConnectionsForCompanyQuery, IntegrationConnectionsForCompanyQueryVariables>(IntegrationConnectionsForCompanyDocument, options);
        }
export type IntegrationConnectionsForCompanyQueryHookResult = ReturnType<typeof useIntegrationConnectionsForCompanyQuery>;
export type IntegrationConnectionsForCompanyLazyQueryHookResult = ReturnType<typeof useIntegrationConnectionsForCompanyLazyQuery>;
export type IntegrationConnectionsForCompanySuspenseQueryHookResult = ReturnType<typeof useIntegrationConnectionsForCompanySuspenseQuery>;
export type IntegrationConnectionsForCompanyQueryResult = Apollo.QueryResult<IntegrationConnectionsForCompanyQuery, IntegrationConnectionsForCompanyQueryVariables>;
export const BillDotComIntegrationDocument = gql`
    query billDotComIntegration($companyId: ID!) {
  integrations(companyId: $companyId) {
    billDotCom {
      connections(companyId: $companyId) {
        ...integrationConnection
      }
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;

/**
 * __useBillDotComIntegrationQuery__
 *
 * To run a query within a React component, call `useBillDotComIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillDotComIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillDotComIntegrationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useBillDotComIntegrationQuery(baseOptions: Apollo.QueryHookOptions<BillDotComIntegrationQuery, BillDotComIntegrationQueryVariables> & ({ variables: BillDotComIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillDotComIntegrationQuery, BillDotComIntegrationQueryVariables>(BillDotComIntegrationDocument, options);
      }
export function useBillDotComIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillDotComIntegrationQuery, BillDotComIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillDotComIntegrationQuery, BillDotComIntegrationQueryVariables>(BillDotComIntegrationDocument, options);
        }
export function useBillDotComIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillDotComIntegrationQuery, BillDotComIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillDotComIntegrationQuery, BillDotComIntegrationQueryVariables>(BillDotComIntegrationDocument, options);
        }
export type BillDotComIntegrationQueryHookResult = ReturnType<typeof useBillDotComIntegrationQuery>;
export type BillDotComIntegrationLazyQueryHookResult = ReturnType<typeof useBillDotComIntegrationLazyQuery>;
export type BillDotComIntegrationSuspenseQueryHookResult = ReturnType<typeof useBillDotComIntegrationSuspenseQuery>;
export type BillDotComIntegrationQueryResult = Apollo.QueryResult<BillDotComIntegrationQuery, BillDotComIntegrationQueryVariables>;
export const BrexIntegrationDocument = gql`
    query brexIntegration($companyId: ID!) {
  integrations(companyId: $companyId) {
    brex {
      connections(companyId: $companyId) {
        ...integrationConnection
      }
      initializationInfo {
        connectUrl(companyId: $companyId)
      }
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;

/**
 * __useBrexIntegrationQuery__
 *
 * To run a query within a React component, call `useBrexIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrexIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrexIntegrationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useBrexIntegrationQuery(baseOptions: Apollo.QueryHookOptions<BrexIntegrationQuery, BrexIntegrationQueryVariables> & ({ variables: BrexIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrexIntegrationQuery, BrexIntegrationQueryVariables>(BrexIntegrationDocument, options);
      }
export function useBrexIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrexIntegrationQuery, BrexIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrexIntegrationQuery, BrexIntegrationQueryVariables>(BrexIntegrationDocument, options);
        }
export function useBrexIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrexIntegrationQuery, BrexIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrexIntegrationQuery, BrexIntegrationQueryVariables>(BrexIntegrationDocument, options);
        }
export type BrexIntegrationQueryHookResult = ReturnType<typeof useBrexIntegrationQuery>;
export type BrexIntegrationLazyQueryHookResult = ReturnType<typeof useBrexIntegrationLazyQuery>;
export type BrexIntegrationSuspenseQueryHookResult = ReturnType<typeof useBrexIntegrationSuspenseQuery>;
export type BrexIntegrationQueryResult = Apollo.QueryResult<BrexIntegrationQuery, BrexIntegrationQueryVariables>;
export const DeelIntegrationDocument = gql`
    query deelIntegration($companyId: ID!) {
  integrations(companyId: $companyId) {
    deel {
      connections(companyId: $companyId) {
        ...integrationConnection
      }
      initializationInfo {
        connectUrl(companyId: $companyId)
      }
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;

/**
 * __useDeelIntegrationQuery__
 *
 * To run a query within a React component, call `useDeelIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeelIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeelIntegrationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDeelIntegrationQuery(baseOptions: Apollo.QueryHookOptions<DeelIntegrationQuery, DeelIntegrationQueryVariables> & ({ variables: DeelIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeelIntegrationQuery, DeelIntegrationQueryVariables>(DeelIntegrationDocument, options);
      }
export function useDeelIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeelIntegrationQuery, DeelIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeelIntegrationQuery, DeelIntegrationQueryVariables>(DeelIntegrationDocument, options);
        }
export function useDeelIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeelIntegrationQuery, DeelIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeelIntegrationQuery, DeelIntegrationQueryVariables>(DeelIntegrationDocument, options);
        }
export type DeelIntegrationQueryHookResult = ReturnType<typeof useDeelIntegrationQuery>;
export type DeelIntegrationLazyQueryHookResult = ReturnType<typeof useDeelIntegrationLazyQuery>;
export type DeelIntegrationSuspenseQueryHookResult = ReturnType<typeof useDeelIntegrationSuspenseQuery>;
export type DeelIntegrationQueryResult = Apollo.QueryResult<DeelIntegrationQuery, DeelIntegrationQueryVariables>;
export const EveryIntegrationDocument = gql`
    query everyIntegration($companyId: ID!) {
  integrations(companyId: $companyId) {
    every {
      connections(companyId: $companyId) {
        ...integrationConnection
      }
      initializationInfo {
        connectUrl
      }
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;

/**
 * __useEveryIntegrationQuery__
 *
 * To run a query within a React component, call `useEveryIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEveryIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEveryIntegrationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useEveryIntegrationQuery(baseOptions: Apollo.QueryHookOptions<EveryIntegrationQuery, EveryIntegrationQueryVariables> & ({ variables: EveryIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EveryIntegrationQuery, EveryIntegrationQueryVariables>(EveryIntegrationDocument, options);
      }
export function useEveryIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EveryIntegrationQuery, EveryIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EveryIntegrationQuery, EveryIntegrationQueryVariables>(EveryIntegrationDocument, options);
        }
export function useEveryIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EveryIntegrationQuery, EveryIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EveryIntegrationQuery, EveryIntegrationQueryVariables>(EveryIntegrationDocument, options);
        }
export type EveryIntegrationQueryHookResult = ReturnType<typeof useEveryIntegrationQuery>;
export type EveryIntegrationLazyQueryHookResult = ReturnType<typeof useEveryIntegrationLazyQuery>;
export type EveryIntegrationSuspenseQueryHookResult = ReturnType<typeof useEveryIntegrationSuspenseQuery>;
export type EveryIntegrationQueryResult = Apollo.QueryResult<EveryIntegrationQuery, EveryIntegrationQueryVariables>;
export const FinicityIntegrationDocument = gql`
    query finicityIntegration($companyId: ID!, $institutionName: String) {
  integrations(companyId: $companyId) {
    finicity {
      connections(institutionName: $institutionName, companyId: $companyId) {
        ...integrationConnection
      }
      initializationInfo {
        connectInfo(institutionName: $institutionName, companyId: $companyId) {
          connectUrl
          customerId
        }
      }
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;

/**
 * __useFinicityIntegrationQuery__
 *
 * To run a query within a React component, call `useFinicityIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinicityIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinicityIntegrationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      institutionName: // value for 'institutionName'
 *   },
 * });
 */
export function useFinicityIntegrationQuery(baseOptions: Apollo.QueryHookOptions<FinicityIntegrationQuery, FinicityIntegrationQueryVariables> & ({ variables: FinicityIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinicityIntegrationQuery, FinicityIntegrationQueryVariables>(FinicityIntegrationDocument, options);
      }
export function useFinicityIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinicityIntegrationQuery, FinicityIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinicityIntegrationQuery, FinicityIntegrationQueryVariables>(FinicityIntegrationDocument, options);
        }
export function useFinicityIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinicityIntegrationQuery, FinicityIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinicityIntegrationQuery, FinicityIntegrationQueryVariables>(FinicityIntegrationDocument, options);
        }
export type FinicityIntegrationQueryHookResult = ReturnType<typeof useFinicityIntegrationQuery>;
export type FinicityIntegrationLazyQueryHookResult = ReturnType<typeof useFinicityIntegrationLazyQuery>;
export type FinicityIntegrationSuspenseQueryHookResult = ReturnType<typeof useFinicityIntegrationSuspenseQuery>;
export type FinicityIntegrationQueryResult = Apollo.QueryResult<FinicityIntegrationQuery, FinicityIntegrationQueryVariables>;
export const GustoIntegrationDocument = gql`
    query gustoIntegration($companyId: ID!) {
  integrations(companyId: $companyId) {
    gusto {
      connections(companyId: $companyId) {
        ...integrationConnection
      }
      initializationInfo {
        connectUrl
      }
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;

/**
 * __useGustoIntegrationQuery__
 *
 * To run a query within a React component, call `useGustoIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGustoIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGustoIntegrationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGustoIntegrationQuery(baseOptions: Apollo.QueryHookOptions<GustoIntegrationQuery, GustoIntegrationQueryVariables> & ({ variables: GustoIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GustoIntegrationQuery, GustoIntegrationQueryVariables>(GustoIntegrationDocument, options);
      }
export function useGustoIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GustoIntegrationQuery, GustoIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GustoIntegrationQuery, GustoIntegrationQueryVariables>(GustoIntegrationDocument, options);
        }
export function useGustoIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GustoIntegrationQuery, GustoIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GustoIntegrationQuery, GustoIntegrationQueryVariables>(GustoIntegrationDocument, options);
        }
export type GustoIntegrationQueryHookResult = ReturnType<typeof useGustoIntegrationQuery>;
export type GustoIntegrationLazyQueryHookResult = ReturnType<typeof useGustoIntegrationLazyQuery>;
export type GustoIntegrationSuspenseQueryHookResult = ReturnType<typeof useGustoIntegrationSuspenseQuery>;
export type GustoIntegrationQueryResult = Apollo.QueryResult<GustoIntegrationQuery, GustoIntegrationQueryVariables>;
export const IntegrationConnectionsForDocument = gql`
    query integrationConnectionsFor($companyId: ID!, $integrationType: IntegrationType!) {
  integrationConnectionsFor(
    integrationType: $integrationType
    companyId: $companyId
  ) {
    ...integrationConnection
  }
}
    ${IntegrationConnectionFragmentDoc}`;

/**
 * __useIntegrationConnectionsForQuery__
 *
 * To run a query within a React component, call `useIntegrationConnectionsForQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationConnectionsForQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationConnectionsForQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function useIntegrationConnectionsForQuery(baseOptions: Apollo.QueryHookOptions<IntegrationConnectionsForQuery, IntegrationConnectionsForQueryVariables> & ({ variables: IntegrationConnectionsForQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationConnectionsForQuery, IntegrationConnectionsForQueryVariables>(IntegrationConnectionsForDocument, options);
      }
export function useIntegrationConnectionsForLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationConnectionsForQuery, IntegrationConnectionsForQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationConnectionsForQuery, IntegrationConnectionsForQueryVariables>(IntegrationConnectionsForDocument, options);
        }
export function useIntegrationConnectionsForSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationConnectionsForQuery, IntegrationConnectionsForQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationConnectionsForQuery, IntegrationConnectionsForQueryVariables>(IntegrationConnectionsForDocument, options);
        }
export type IntegrationConnectionsForQueryHookResult = ReturnType<typeof useIntegrationConnectionsForQuery>;
export type IntegrationConnectionsForLazyQueryHookResult = ReturnType<typeof useIntegrationConnectionsForLazyQuery>;
export type IntegrationConnectionsForSuspenseQueryHookResult = ReturnType<typeof useIntegrationConnectionsForSuspenseQuery>;
export type IntegrationConnectionsForQueryResult = Apollo.QueryResult<IntegrationConnectionsForQuery, IntegrationConnectionsForQueryVariables>;
export const MeowIntegrationDocument = gql`
    query meowIntegration($companyId: ID!) {
  integrations(companyId: $companyId) {
    meow {
      connections(companyId: $companyId) {
        ...integrationConnection
      }
      initializationInfo {
        connectUrl(companyId: $companyId)
      }
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;

/**
 * __useMeowIntegrationQuery__
 *
 * To run a query within a React component, call `useMeowIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeowIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeowIntegrationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useMeowIntegrationQuery(baseOptions: Apollo.QueryHookOptions<MeowIntegrationQuery, MeowIntegrationQueryVariables> & ({ variables: MeowIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeowIntegrationQuery, MeowIntegrationQueryVariables>(MeowIntegrationDocument, options);
      }
export function useMeowIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeowIntegrationQuery, MeowIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeowIntegrationQuery, MeowIntegrationQueryVariables>(MeowIntegrationDocument, options);
        }
export function useMeowIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeowIntegrationQuery, MeowIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeowIntegrationQuery, MeowIntegrationQueryVariables>(MeowIntegrationDocument, options);
        }
export type MeowIntegrationQueryHookResult = ReturnType<typeof useMeowIntegrationQuery>;
export type MeowIntegrationLazyQueryHookResult = ReturnType<typeof useMeowIntegrationLazyQuery>;
export type MeowIntegrationSuspenseQueryHookResult = ReturnType<typeof useMeowIntegrationSuspenseQuery>;
export type MeowIntegrationQueryResult = Apollo.QueryResult<MeowIntegrationQuery, MeowIntegrationQueryVariables>;
export const MercuryIntegrationDocument = gql`
    query mercuryIntegration($companyId: ID!) {
  integrations(companyId: $companyId) {
    mercury {
      connections(companyId: $companyId) {
        ...integrationConnection
      }
      initializationInfo {
        connectUrl(companyId: $companyId)
      }
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;

/**
 * __useMercuryIntegrationQuery__
 *
 * To run a query within a React component, call `useMercuryIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMercuryIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMercuryIntegrationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useMercuryIntegrationQuery(baseOptions: Apollo.QueryHookOptions<MercuryIntegrationQuery, MercuryIntegrationQueryVariables> & ({ variables: MercuryIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MercuryIntegrationQuery, MercuryIntegrationQueryVariables>(MercuryIntegrationDocument, options);
      }
export function useMercuryIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MercuryIntegrationQuery, MercuryIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MercuryIntegrationQuery, MercuryIntegrationQueryVariables>(MercuryIntegrationDocument, options);
        }
export function useMercuryIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MercuryIntegrationQuery, MercuryIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MercuryIntegrationQuery, MercuryIntegrationQueryVariables>(MercuryIntegrationDocument, options);
        }
export type MercuryIntegrationQueryHookResult = ReturnType<typeof useMercuryIntegrationQuery>;
export type MercuryIntegrationLazyQueryHookResult = ReturnType<typeof useMercuryIntegrationLazyQuery>;
export type MercuryIntegrationSuspenseQueryHookResult = ReturnType<typeof useMercuryIntegrationSuspenseQuery>;
export type MercuryIntegrationQueryResult = Apollo.QueryResult<MercuryIntegrationQuery, MercuryIntegrationQueryVariables>;
export const PlaidIntegrationDocument = gql`
    query plaidIntegration($companyId: ID!, $financialInstitutionId: ID) {
  integrations(companyId: $companyId) {
    plaid {
      initializationInfo {
        connectInfo(
          companyId: $companyId
          financialInstitutionId: $financialInstitutionId
        ) {
          webhookUrl
          linkToken
        }
      }
    }
  }
}
    `;

/**
 * __usePlaidIntegrationQuery__
 *
 * To run a query within a React component, call `usePlaidIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaidIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaidIntegrationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      financialInstitutionId: // value for 'financialInstitutionId'
 *   },
 * });
 */
export function usePlaidIntegrationQuery(baseOptions: Apollo.QueryHookOptions<PlaidIntegrationQuery, PlaidIntegrationQueryVariables> & ({ variables: PlaidIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaidIntegrationQuery, PlaidIntegrationQueryVariables>(PlaidIntegrationDocument, options);
      }
export function usePlaidIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaidIntegrationQuery, PlaidIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaidIntegrationQuery, PlaidIntegrationQueryVariables>(PlaidIntegrationDocument, options);
        }
export function usePlaidIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaidIntegrationQuery, PlaidIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlaidIntegrationQuery, PlaidIntegrationQueryVariables>(PlaidIntegrationDocument, options);
        }
export type PlaidIntegrationQueryHookResult = ReturnType<typeof usePlaidIntegrationQuery>;
export type PlaidIntegrationLazyQueryHookResult = ReturnType<typeof usePlaidIntegrationLazyQuery>;
export type PlaidIntegrationSuspenseQueryHookResult = ReturnType<typeof usePlaidIntegrationSuspenseQuery>;
export type PlaidIntegrationQueryResult = Apollo.QueryResult<PlaidIntegrationQuery, PlaidIntegrationQueryVariables>;
export const PushIntegrationsDocument = gql`
    query pushIntegrations($companyId: ID!) {
  integrations(companyId: $companyId) {
    pushIntegrations {
      type
      connectUrl
      connection(companyId: $companyId) {
        ...integrationConnection
      }
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;

/**
 * __usePushIntegrationsQuery__
 *
 * To run a query within a React component, call `usePushIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePushIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushIntegrationsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function usePushIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<PushIntegrationsQuery, PushIntegrationsQueryVariables> & ({ variables: PushIntegrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PushIntegrationsQuery, PushIntegrationsQueryVariables>(PushIntegrationsDocument, options);
      }
export function usePushIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PushIntegrationsQuery, PushIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PushIntegrationsQuery, PushIntegrationsQueryVariables>(PushIntegrationsDocument, options);
        }
export function usePushIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PushIntegrationsQuery, PushIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PushIntegrationsQuery, PushIntegrationsQueryVariables>(PushIntegrationsDocument, options);
        }
export type PushIntegrationsQueryHookResult = ReturnType<typeof usePushIntegrationsQuery>;
export type PushIntegrationsLazyQueryHookResult = ReturnType<typeof usePushIntegrationsLazyQuery>;
export type PushIntegrationsSuspenseQueryHookResult = ReturnType<typeof usePushIntegrationsSuspenseQuery>;
export type PushIntegrationsQueryResult = Apollo.QueryResult<PushIntegrationsQuery, PushIntegrationsQueryVariables>;
export const QuickbooksIntegrationDocument = gql`
    query quickbooksIntegration($companyId: ID!) {
  integrations(companyId: $companyId) {
    quickbooks {
      connections(companyId: $companyId) {
        ...integrationConnection
      }
      initializationInfo {
        connectUrl(companyId: $companyId)
      }
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;

/**
 * __useQuickbooksIntegrationQuery__
 *
 * To run a query within a React component, call `useQuickbooksIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickbooksIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickbooksIntegrationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useQuickbooksIntegrationQuery(baseOptions: Apollo.QueryHookOptions<QuickbooksIntegrationQuery, QuickbooksIntegrationQueryVariables> & ({ variables: QuickbooksIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickbooksIntegrationQuery, QuickbooksIntegrationQueryVariables>(QuickbooksIntegrationDocument, options);
      }
export function useQuickbooksIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickbooksIntegrationQuery, QuickbooksIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickbooksIntegrationQuery, QuickbooksIntegrationQueryVariables>(QuickbooksIntegrationDocument, options);
        }
export function useQuickbooksIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuickbooksIntegrationQuery, QuickbooksIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuickbooksIntegrationQuery, QuickbooksIntegrationQueryVariables>(QuickbooksIntegrationDocument, options);
        }
export type QuickbooksIntegrationQueryHookResult = ReturnType<typeof useQuickbooksIntegrationQuery>;
export type QuickbooksIntegrationLazyQueryHookResult = ReturnType<typeof useQuickbooksIntegrationLazyQuery>;
export type QuickbooksIntegrationSuspenseQueryHookResult = ReturnType<typeof useQuickbooksIntegrationSuspenseQuery>;
export type QuickbooksIntegrationQueryResult = Apollo.QueryResult<QuickbooksIntegrationQuery, QuickbooksIntegrationQueryVariables>;
export const RampIntegrationDocument = gql`
    query rampIntegration($companyId: ID!) {
  integrations(companyId: $companyId) {
    ramp {
      connections(companyId: $companyId) {
        ...integrationConnection
      }
      initializationInfo {
        connectUrl(companyId: $companyId)
      }
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;

/**
 * __useRampIntegrationQuery__
 *
 * To run a query within a React component, call `useRampIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampIntegrationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useRampIntegrationQuery(baseOptions: Apollo.QueryHookOptions<RampIntegrationQuery, RampIntegrationQueryVariables> & ({ variables: RampIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RampIntegrationQuery, RampIntegrationQueryVariables>(RampIntegrationDocument, options);
      }
export function useRampIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RampIntegrationQuery, RampIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RampIntegrationQuery, RampIntegrationQueryVariables>(RampIntegrationDocument, options);
        }
export function useRampIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RampIntegrationQuery, RampIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RampIntegrationQuery, RampIntegrationQueryVariables>(RampIntegrationDocument, options);
        }
export type RampIntegrationQueryHookResult = ReturnType<typeof useRampIntegrationQuery>;
export type RampIntegrationLazyQueryHookResult = ReturnType<typeof useRampIntegrationLazyQuery>;
export type RampIntegrationSuspenseQueryHookResult = ReturnType<typeof useRampIntegrationSuspenseQuery>;
export type RampIntegrationQueryResult = Apollo.QueryResult<RampIntegrationQuery, RampIntegrationQueryVariables>;
export const RipplingIntegrationDocument = gql`
    query ripplingIntegration($companyId: ID!) {
  integrations(companyId: $companyId) {
    rippling {
      connections(companyId: $companyId) {
        ...integrationConnection
      }
      initializationInfo {
        connectUrl(companyId: $companyId)
      }
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;

/**
 * __useRipplingIntegrationQuery__
 *
 * To run a query within a React component, call `useRipplingIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRipplingIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRipplingIntegrationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useRipplingIntegrationQuery(baseOptions: Apollo.QueryHookOptions<RipplingIntegrationQuery, RipplingIntegrationQueryVariables> & ({ variables: RipplingIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RipplingIntegrationQuery, RipplingIntegrationQueryVariables>(RipplingIntegrationDocument, options);
      }
export function useRipplingIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RipplingIntegrationQuery, RipplingIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RipplingIntegrationQuery, RipplingIntegrationQueryVariables>(RipplingIntegrationDocument, options);
        }
export function useRipplingIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RipplingIntegrationQuery, RipplingIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RipplingIntegrationQuery, RipplingIntegrationQueryVariables>(RipplingIntegrationDocument, options);
        }
export type RipplingIntegrationQueryHookResult = ReturnType<typeof useRipplingIntegrationQuery>;
export type RipplingIntegrationLazyQueryHookResult = ReturnType<typeof useRipplingIntegrationLazyQuery>;
export type RipplingIntegrationSuspenseQueryHookResult = ReturnType<typeof useRipplingIntegrationSuspenseQuery>;
export type RipplingIntegrationQueryResult = Apollo.QueryResult<RipplingIntegrationQuery, RipplingIntegrationQueryVariables>;
export const SourceCountsForDocument = gql`
    query sourceCountsFor($companyId: ID!) {
  sourceCountsFor(companyId: $companyId) {
    ...sourceCount
  }
}
    ${SourceCountFragmentDoc}`;

/**
 * __useSourceCountsForQuery__
 *
 * To run a query within a React component, call `useSourceCountsForQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceCountsForQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceCountsForQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSourceCountsForQuery(baseOptions: Apollo.QueryHookOptions<SourceCountsForQuery, SourceCountsForQueryVariables> & ({ variables: SourceCountsForQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourceCountsForQuery, SourceCountsForQueryVariables>(SourceCountsForDocument, options);
      }
export function useSourceCountsForLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourceCountsForQuery, SourceCountsForQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourceCountsForQuery, SourceCountsForQueryVariables>(SourceCountsForDocument, options);
        }
export function useSourceCountsForSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SourceCountsForQuery, SourceCountsForQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SourceCountsForQuery, SourceCountsForQueryVariables>(SourceCountsForDocument, options);
        }
export type SourceCountsForQueryHookResult = ReturnType<typeof useSourceCountsForQuery>;
export type SourceCountsForLazyQueryHookResult = ReturnType<typeof useSourceCountsForLazyQuery>;
export type SourceCountsForSuspenseQueryHookResult = ReturnType<typeof useSourceCountsForSuspenseQuery>;
export type SourceCountsForQueryResult = Apollo.QueryResult<SourceCountsForQuery, SourceCountsForQueryVariables>;
export const StripeIntegrationDocument = gql`
    query stripeIntegration($companyId: ID!) {
  integrations(companyId: $companyId) {
    stripe {
      connections(companyId: $companyId) {
        ...integrationConnection
      }
      initializationInfo {
        connectUrl(companyId: $companyId)
      }
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;

/**
 * __useStripeIntegrationQuery__
 *
 * To run a query within a React component, call `useStripeIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeIntegrationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useStripeIntegrationQuery(baseOptions: Apollo.QueryHookOptions<StripeIntegrationQuery, StripeIntegrationQueryVariables> & ({ variables: StripeIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeIntegrationQuery, StripeIntegrationQueryVariables>(StripeIntegrationDocument, options);
      }
export function useStripeIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeIntegrationQuery, StripeIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeIntegrationQuery, StripeIntegrationQueryVariables>(StripeIntegrationDocument, options);
        }
export function useStripeIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StripeIntegrationQuery, StripeIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StripeIntegrationQuery, StripeIntegrationQueryVariables>(StripeIntegrationDocument, options);
        }
export type StripeIntegrationQueryHookResult = ReturnType<typeof useStripeIntegrationQuery>;
export type StripeIntegrationLazyQueryHookResult = ReturnType<typeof useStripeIntegrationLazyQuery>;
export type StripeIntegrationSuspenseQueryHookResult = ReturnType<typeof useStripeIntegrationSuspenseQuery>;
export type StripeIntegrationQueryResult = Apollo.QueryResult<StripeIntegrationQuery, StripeIntegrationQueryVariables>;
export const SvbOfxIntegrationDocument = gql`
    query svbOfxIntegration($companyId: ID!) {
  integrations(companyId: $companyId) {
    svbOfx {
      connections(companyId: $companyId) {
        ...integrationConnection
      }
      initializationInfo {
        connectUrl(companyId: $companyId)
      }
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;

/**
 * __useSvbOfxIntegrationQuery__
 *
 * To run a query within a React component, call `useSvbOfxIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSvbOfxIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSvbOfxIntegrationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSvbOfxIntegrationQuery(baseOptions: Apollo.QueryHookOptions<SvbOfxIntegrationQuery, SvbOfxIntegrationQueryVariables> & ({ variables: SvbOfxIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SvbOfxIntegrationQuery, SvbOfxIntegrationQueryVariables>(SvbOfxIntegrationDocument, options);
      }
export function useSvbOfxIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SvbOfxIntegrationQuery, SvbOfxIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SvbOfxIntegrationQuery, SvbOfxIntegrationQueryVariables>(SvbOfxIntegrationDocument, options);
        }
export function useSvbOfxIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SvbOfxIntegrationQuery, SvbOfxIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SvbOfxIntegrationQuery, SvbOfxIntegrationQueryVariables>(SvbOfxIntegrationDocument, options);
        }
export type SvbOfxIntegrationQueryHookResult = ReturnType<typeof useSvbOfxIntegrationQuery>;
export type SvbOfxIntegrationLazyQueryHookResult = ReturnType<typeof useSvbOfxIntegrationLazyQuery>;
export type SvbOfxIntegrationSuspenseQueryHookResult = ReturnType<typeof useSvbOfxIntegrationSuspenseQuery>;
export type SvbOfxIntegrationQueryResult = Apollo.QueryResult<SvbOfxIntegrationQuery, SvbOfxIntegrationQueryVariables>;
export const TrinetIntegrationDocument = gql`
    query trinetIntegration($companyId: ID!) {
  integrations(companyId: $companyId) {
    trinet {
      connections {
        ...integrationConnection
      }
    }
  }
}
    ${IntegrationConnectionFragmentDoc}`;

/**
 * __useTrinetIntegrationQuery__
 *
 * To run a query within a React component, call `useTrinetIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrinetIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrinetIntegrationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useTrinetIntegrationQuery(baseOptions: Apollo.QueryHookOptions<TrinetIntegrationQuery, TrinetIntegrationQueryVariables> & ({ variables: TrinetIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrinetIntegrationQuery, TrinetIntegrationQueryVariables>(TrinetIntegrationDocument, options);
      }
export function useTrinetIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrinetIntegrationQuery, TrinetIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrinetIntegrationQuery, TrinetIntegrationQueryVariables>(TrinetIntegrationDocument, options);
        }
export function useTrinetIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrinetIntegrationQuery, TrinetIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrinetIntegrationQuery, TrinetIntegrationQueryVariables>(TrinetIntegrationDocument, options);
        }
export type TrinetIntegrationQueryHookResult = ReturnType<typeof useTrinetIntegrationQuery>;
export type TrinetIntegrationLazyQueryHookResult = ReturnType<typeof useTrinetIntegrationLazyQuery>;
export type TrinetIntegrationSuspenseQueryHookResult = ReturnType<typeof useTrinetIntegrationSuspenseQuery>;
export type TrinetIntegrationQueryResult = Apollo.QueryResult<TrinetIntegrationQuery, TrinetIntegrationQueryVariables>;
export const LedgerReportDocument = gql`
    query ledgerReport($input: LedgerReportInput!) {
  ledgerReport(input: $input) {
    __typename
    lines {
      ...ledgerReportLine
    }
    highWatermarkToken
    timestamp
    accounts {
      ...ledgerAccountInfo
    }
    columnBy
    ... on LedgerReportByInterval {
      intervalMetadata {
        ...intervalMetadata
      }
    }
  }
}
    ${LedgerReportLineFragmentDoc}
${LedgerAccountInfoFragmentDoc}
${IntervalMetadataFragmentDoc}`;

/**
 * __useLedgerReportQuery__
 *
 * To run a query within a React component, call `useLedgerReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLedgerReportQuery(baseOptions: Apollo.QueryHookOptions<LedgerReportQuery, LedgerReportQueryVariables> & ({ variables: LedgerReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerReportQuery, LedgerReportQueryVariables>(LedgerReportDocument, options);
      }
export function useLedgerReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerReportQuery, LedgerReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerReportQuery, LedgerReportQueryVariables>(LedgerReportDocument, options);
        }
export function useLedgerReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerReportQuery, LedgerReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerReportQuery, LedgerReportQueryVariables>(LedgerReportDocument, options);
        }
export type LedgerReportQueryHookResult = ReturnType<typeof useLedgerReportQuery>;
export type LedgerReportLazyQueryHookResult = ReturnType<typeof useLedgerReportLazyQuery>;
export type LedgerReportSuspenseQueryHookResult = ReturnType<typeof useLedgerReportSuspenseQuery>;
export type LedgerReportQueryResult = Apollo.QueryResult<LedgerReportQuery, LedgerReportQueryVariables>;
export const GetNotificationPreferencesDocument = gql`
    query getNotificationPreferences {
  getNotificationPreferences {
    preferences
    notificationWorkflows
  }
}
    `;

/**
 * __useGetNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useGetNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationPreferencesQuery, GetNotificationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationPreferencesQuery, GetNotificationPreferencesQueryVariables>(GetNotificationPreferencesDocument, options);
      }
export function useGetNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationPreferencesQuery, GetNotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationPreferencesQuery, GetNotificationPreferencesQueryVariables>(GetNotificationPreferencesDocument, options);
        }
export function useGetNotificationPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationPreferencesQuery, GetNotificationPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationPreferencesQuery, GetNotificationPreferencesQueryVariables>(GetNotificationPreferencesDocument, options);
        }
export type GetNotificationPreferencesQueryHookResult = ReturnType<typeof useGetNotificationPreferencesQuery>;
export type GetNotificationPreferencesLazyQueryHookResult = ReturnType<typeof useGetNotificationPreferencesLazyQuery>;
export type GetNotificationPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetNotificationPreferencesSuspenseQuery>;
export type GetNotificationPreferencesQueryResult = Apollo.QueryResult<GetNotificationPreferencesQuery, GetNotificationPreferencesQueryVariables>;
export const SiteStatusMessagesDocument = gql`
    query siteStatusMessages {
  siteStatusMessages {
    id
    type
    message
  }
}
    `;

/**
 * __useSiteStatusMessagesQuery__
 *
 * To run a query within a React component, call `useSiteStatusMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteStatusMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteStatusMessagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteStatusMessagesQuery(baseOptions?: Apollo.QueryHookOptions<SiteStatusMessagesQuery, SiteStatusMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteStatusMessagesQuery, SiteStatusMessagesQueryVariables>(SiteStatusMessagesDocument, options);
      }
export function useSiteStatusMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteStatusMessagesQuery, SiteStatusMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteStatusMessagesQuery, SiteStatusMessagesQueryVariables>(SiteStatusMessagesDocument, options);
        }
export function useSiteStatusMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SiteStatusMessagesQuery, SiteStatusMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteStatusMessagesQuery, SiteStatusMessagesQueryVariables>(SiteStatusMessagesDocument, options);
        }
export type SiteStatusMessagesQueryHookResult = ReturnType<typeof useSiteStatusMessagesQuery>;
export type SiteStatusMessagesLazyQueryHookResult = ReturnType<typeof useSiteStatusMessagesLazyQuery>;
export type SiteStatusMessagesSuspenseQueryHookResult = ReturnType<typeof useSiteStatusMessagesSuspenseQuery>;
export type SiteStatusMessagesQueryResult = Apollo.QueryResult<SiteStatusMessagesQuery, SiteStatusMessagesQueryVariables>;
export const GetUserAttributesDocument = gql`
    query getUserAttributes {
  getUserAttributes {
    howDidYouHearAboutUs {
      howDidYouHearAboutUs
      howDidYouHearAboutUsCategory
      howDidYouHearAboutUsOther
      howDidYouHearAboutUsReferer
      howDidYouHearAboutUsAcceleratorInput
      howDidYouHearAboutUsFirmInput
      howDidYouHearAboutUsEventInput
      howDidYouHearAboutUsVCInput
      howDidYouHearAboutUsAIToolsInput
    }
  }
}
    `;

/**
 * __useGetUserAttributesQuery__
 *
 * To run a query within a React component, call `useGetUserAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAttributesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAttributesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAttributesQuery, GetUserAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAttributesQuery, GetUserAttributesQueryVariables>(GetUserAttributesDocument, options);
      }
export function useGetUserAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAttributesQuery, GetUserAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAttributesQuery, GetUserAttributesQueryVariables>(GetUserAttributesDocument, options);
        }
export function useGetUserAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAttributesQuery, GetUserAttributesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserAttributesQuery, GetUserAttributesQueryVariables>(GetUserAttributesDocument, options);
        }
export type GetUserAttributesQueryHookResult = ReturnType<typeof useGetUserAttributesQuery>;
export type GetUserAttributesLazyQueryHookResult = ReturnType<typeof useGetUserAttributesLazyQuery>;
export type GetUserAttributesSuspenseQueryHookResult = ReturnType<typeof useGetUserAttributesSuspenseQuery>;
export type GetUserAttributesQueryResult = Apollo.QueryResult<GetUserAttributesQuery, GetUserAttributesQueryVariables>;
export const GetEmailPreferencesDocument = gql`
    query getEmailPreferences($input: GetNotificationsInput!) {
  getEmailPreferences(input: $input) {
    preferences {
      workflowId
      description
      enabled
    }
  }
}
    `;

/**
 * __useGetEmailPreferencesQuery__
 *
 * To run a query within a React component, call `useGetEmailPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailPreferencesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEmailPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetEmailPreferencesQuery, GetEmailPreferencesQueryVariables> & ({ variables: GetEmailPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailPreferencesQuery, GetEmailPreferencesQueryVariables>(GetEmailPreferencesDocument, options);
      }
export function useGetEmailPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailPreferencesQuery, GetEmailPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailPreferencesQuery, GetEmailPreferencesQueryVariables>(GetEmailPreferencesDocument, options);
        }
export function useGetEmailPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailPreferencesQuery, GetEmailPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailPreferencesQuery, GetEmailPreferencesQueryVariables>(GetEmailPreferencesDocument, options);
        }
export type GetEmailPreferencesQueryHookResult = ReturnType<typeof useGetEmailPreferencesQuery>;
export type GetEmailPreferencesLazyQueryHookResult = ReturnType<typeof useGetEmailPreferencesLazyQuery>;
export type GetEmailPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetEmailPreferencesSuspenseQuery>;
export type GetEmailPreferencesQueryResult = Apollo.QueryResult<GetEmailPreferencesQuery, GetEmailPreferencesQueryVariables>;
export const UpdateEmailPreferencesDocument = gql`
    mutation updateEmailPreferences($input: UpdateEmailPreferencesInput!) {
  updateEmailPreferences(input: $input) {
    preferences {
      workflowId
      enabled
    }
  }
}
    `;
export type UpdateEmailPreferencesMutationFn = Apollo.MutationFunction<UpdateEmailPreferencesMutation, UpdateEmailPreferencesMutationVariables>;

/**
 * __useUpdateEmailPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateEmailPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailPreferencesMutation, { data, loading, error }] = useUpdateEmailPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmailPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailPreferencesMutation, UpdateEmailPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailPreferencesMutation, UpdateEmailPreferencesMutationVariables>(UpdateEmailPreferencesDocument, options);
      }
export type UpdateEmailPreferencesMutationHookResult = ReturnType<typeof useUpdateEmailPreferencesMutation>;
export type UpdateEmailPreferencesMutationResult = Apollo.MutationResult<UpdateEmailPreferencesMutation>;
export type UpdateEmailPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateEmailPreferencesMutation, UpdateEmailPreferencesMutationVariables>;